/**
 * Generated by orval v7.2.0 🍺
 * Do not edit manually.
 * Introduction
 * ## Ping Trader API
API can be accessed through [https://api.ping.exchnage](https://api.ping.exchnage)
 * OpenAPI spec version: v1
 */
import { useMutation, useQuery } from 'react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from 'react-query';
import { customInstance } from './custom-instance';
import type { ErrorType } from './custom-instance';

// https://stackoverflow.com/questions/49579094/typescript-conditional-types-filter-out-readonly-properties-pick-only-requir/49579497#49579497
type IfEquals<X, Y, A = X, B = never> = (<T>() => T extends X ? 1 : 2) extends <T>() => T extends Y ? 1 : 2 ? A : B;

type WritableKeys<T> = {
  [P in keyof T]-?: IfEquals<{ [Q in P]: T[P] }, { -readonly [Q in P]: T[P] }, P>;
}[keyof T];

type UnionToIntersection<U> = (U extends any ? (k: U) => void : never) extends (k: infer I) => void ? I : never;
type DistributeReadOnlyOverUnions<T> = T extends any ? NonReadonly<T> : never;

type Writable<T> = Pick<T, WritableKeys<T>>;
type NonReadonly<T> = [T] extends [UnionToIntersection<T>]
  ? {
      [P in keyof Writable<T>]: T[P] extends object ? NonReadonly<NonNullable<T[P]>> : T[P];
    }
  : DistributeReadOnlyOverUnions<T>;

export type GetAllTrendsV1200Three = { [key: string]: TrendResponse };

export type GetAllTrendsV1200Two = { [key: string]: TrendResponse };

export type GetAllTrendsV1200One = { [key: string]: TrendResponse };

export type GetAllTrends200Three = { [key: string]: TrendResponse };

export type GetAllTrends200Two = { [key: string]: TrendResponse };

export type GetAllTrends200One = { [key: string]: TrendResponse };

export type GetLastFairPriceV1MarketsParams = {
  /**
   * Market pair ctn_usdc or xcb_usdc
   */
  symbol: string;
};

export type TradeHistoryV1MarketsParams = {
  /**
   * Type of Order, Buy or Sell
   */
  type?: OrderSide;
  /**
   * Number of historical trades to retrieve from time of query. Default 100; max 500.
   */
  limit?: number;
  /**
   * End time for historical trades query
   */
  endDateTime?: string;
  /**
   * Cursor for pagination (optional).
   */
  cursor?: string;
};

export type OrderbookV1MarketsParams = {
  depth?: number;
};

export type TickersV1MarketsParams = {
  symbol?: string;
};

export type GetRecentHistoryV1ChartingParams = {
  /**
   * Type of Timeframe: 1m, 5m, ..., 1h, 1w, 1M
   */
  type: string;
  /**
   * The total number of history items (limit)
   */
  count: number;
  /**
   * A point in timeline when the history before that moment is requested
   */
  endDateTime?: string;
};

export type GetRecentHistoryChartingParams = {
  /**
   * Type of Timeframe: 1m, 5m, ..., 1h, 1w, 1M
   */
  type: string;
  /**
   * The total number of history items (limit)
   */
  count: number;
  /**
   * A point in timeline when the history before that moment is requested
   */
  endDateTime?: string;
};

export type GetAllUserParams = {
  /**
   * User Name, user email search filter
   */
  Search?: string;
  /**
   * User's current status
   */
  Status?: ActivityStatus;
  FromLastDepositDate?: string;
  ToLastDepositDate?: string;
  FromLastDepositAmount?: number;
  ToLastDepositAmount?: number;
  FromTradeVolume?: number;
  ToTradeVolume?: number;
  AscOrder?: string;
  DescOrder?: string;
  Sort?: string;
  Page?: number;
  PerPage?: number;
};

export type SendTestReportTreasuryParams = {
  reportCadence?: string;
};

export type GetNotificationDeliveryLogTreasuryParams = {
  limit?: number;
};

export type RunPolicyOptimizationTreasuryParams = {
  analysisDays?: number;
};

export type ListPolicyOptimizationsTreasuryParams = {
  Search?: string;
  Status?: string;
  CctpPurpose?: string;
  NormalizedSearch?: string;
  NormalizedStatus?: string;
  NormalizedCctpPurpose?: string;
  SearchPattern?: string;
  Page?: number;
  PerPage?: number;
};

export type GetSetupRecommendationsTreasuryParams = {
  analysisDays?: number;
};

export type RunLiquidityPlanCycleTreasuryParams = {
  reliefOnly?: boolean;
};

export type ListLiquidityPlansTreasuryParams = {
  Search?: string;
  Status?: string;
  CctpPurpose?: string;
  NormalizedSearch?: string;
  NormalizedStatus?: string;
  NormalizedCctpPurpose?: string;
  SearchPattern?: string;
  Page?: number;
  PerPage?: number;
};

export type ListColdAggregationsTreasuryParams = {
  Search?: string;
  Status?: string;
  CctpPurpose?: string;
  NormalizedSearch?: string;
  NormalizedStatus?: string;
  NormalizedCctpPurpose?: string;
  SearchPattern?: string;
  Page?: number;
  PerPage?: number;
};

export type ListColdReplenishmentsTreasuryParams = {
  Search?: string;
  Status?: string;
  CctpPurpose?: string;
  NormalizedSearch?: string;
  NormalizedStatus?: string;
  NormalizedCctpPurpose?: string;
  SearchPattern?: string;
  Page?: number;
  PerPage?: number;
};

export type ListExecutionsTreasuryParams = {
  Search?: string;
  Status?: string;
  CctpPurpose?: string;
  NormalizedSearch?: string;
  NormalizedStatus?: string;
  NormalizedCctpPurpose?: string;
  SearchPattern?: string;
  Page?: number;
  PerPage?: number;
};

export type ListSuggestionsTreasuryParams = {
  Search?: string;
  Status?: string;
  CctpPurpose?: string;
  NormalizedSearch?: string;
  NormalizedStatus?: string;
  NormalizedCctpPurpose?: string;
  SearchPattern?: string;
  Page?: number;
  PerPage?: number;
};

export type ListAuditLogTreasuryParams = {
  Search?: string;
  Status?: string;
  CctpPurpose?: string;
  NormalizedSearch?: string;
  NormalizedStatus?: string;
  NormalizedCctpPurpose?: string;
  SearchPattern?: string;
  Page?: number;
  PerPage?: number;
};

export type GetWithdrawalLiquidityHintTreasuryParams = {
  paymentSystem?: string;
};

export type GetAnalyticsTreasuryParams = {
  withdrawalRange?: string;
};

export type GetTransfersAsCsvParams = {
  /**
   * Filter transfers with Qodex.Account.TransferData.CreatedAt greater or equal to the given value.
   */
  From?: string;
  /**
   * Filter transfers with Qodex.Account.TransferData.CreatedAt less than the given value.
   */
  To?: string;
  /**
   * Filter by piece of a username or an email.
   */
  User?: string;
  /**
   * Filter by account.
   */
  Account?: string;
  /**
   * Filter by status.
   */
  Status?: TransferStatus;
  /**
   * Filter by asset.
   */
  Asset?: string;
  /**
   * Filter by piece of a transfer id.
   */
  TransferId?: string;
  /**
   * Filter by type.
   */
  Type?: TransferType;
  Cursor?: string;
  /**
 * A comma-separated list of expressions used to sort the items.
- For ascending sort use 'asc' suffix or nothing(default) like 'CreatedAt asc' or 'CreatedAt'.
- For descending sort use 'desc' suffix like 'CreatedAt desc'.
- Note: value is case insensitive
- Default: if nothing provided default ordering is by CreatedAt desc.
- Supported fields:
    - CreatedAt
    - Amount
 */
  OrderBy?: string;
  /**
   * Filter by account.
   */
  CorePassId?: string;
  /**
   * Filter by transaction id
   */
  TxId?: string;
};

export type GetTransfersParams = {
  /**
   * Filter transfers with Qodex.Account.TransferData.CreatedAt greater or equal to the given value.
   */
  From?: string;
  /**
   * Filter transfers with Qodex.Account.TransferData.CreatedAt less than the given value.
   */
  To?: string;
  /**
   * Filter by piece of a username or an email.
   */
  User?: string;
  /**
   * Filter by account.
   */
  Account?: string;
  /**
   * Filter by status.
   */
  Status?: TransferStatus;
  /**
   * Filter by asset.
   */
  Asset?: string;
  /**
   * Filter by piece of a transfer id.
   */
  TransferId?: string;
  /**
   * Filter by type.
   */
  Type?: TransferType;
  Cursor?: string;
  /**
 * A comma-separated list of expressions used to sort the items.
- For ascending sort use 'asc' suffix or nothing(default) like 'CreatedAt asc' or 'CreatedAt'.
- For descending sort use 'desc' suffix like 'CreatedAt desc'.
- Note: value is case insensitive
- Default: if nothing provided default ordering is by CreatedAt desc.
- Supported fields:
    - CreatedAt
    - Amount
 */
  OrderBy?: string;
  /**
   * Filter by account.
   */
  CorePassId?: string;
  /**
   * Filter by transaction id
   */
  TxId?: string;
};

export type TradesGetOrdersParams = {
  From: string;
  To?: string;
  User?: string;
  Account?: number;
  OrderId?: string;
  TradeId?: number;
  Market?: string;
  Cursor?: string;
  Sort?: string[];
};

export type ListRewardParams = {
  CoreId?: string;
  AssetId?: string;
  AmountFrom?: number;
  AmountTo?: number;
  IsClaimed?: boolean;
  Reason?: RewardReason;
  InitiationSource?: RewardInitiationSource;
  CreatedFrom?: string;
  CreatedTo?: string;
  Page?: number;
  PerPage?: number;
};

export type SendTestReportRevenueParams = {
  reportCadence?: string;
};

export type GetNotificationDeliveryLogRevenueParams = {
  limit?: number;
};

export type GetCfoInsightsRevenueParams = {
  Assets?: string[];
  AssetTypes?: string[];
  MarketTypes?: string[];
  Chains?: string[];
  RevenueSources?: string[];
  CostTypes?: string[];
  TimeRange?: string;
  AssetId?: string;
  Search?: string;
  Status?: string;
  Page?: number;
  PerPage?: number;
};

export type GetCashFlowRevenueParams = {
  Assets?: string[];
  AssetTypes?: string[];
  MarketTypes?: string[];
  Chains?: string[];
  RevenueSources?: string[];
  CostTypes?: string[];
  TimeRange?: string;
  AssetId?: string;
  Search?: string;
  Status?: string;
  Page?: number;
  PerPage?: number;
};

export type GetInvestmentsRevenueParams = {
  Assets?: string[];
  AssetTypes?: string[];
  MarketTypes?: string[];
  Chains?: string[];
  RevenueSources?: string[];
  CostTypes?: string[];
  TimeRange?: string;
  AssetId?: string;
  Search?: string;
  Status?: string;
  Page?: number;
  PerPage?: number;
};

export type GetFeeWithdrawalsRevenueParams = {
  Assets?: string[];
  AssetTypes?: string[];
  MarketTypes?: string[];
  Chains?: string[];
  RevenueSources?: string[];
  CostTypes?: string[];
  TimeRange?: string;
  AssetId?: string;
  Search?: string;
  Status?: string;
  Page?: number;
  PerPage?: number;
};

export type GetFeeBalancesRevenueParams = {
  Assets?: string[];
  AssetTypes?: string[];
  MarketTypes?: string[];
  Chains?: string[];
  RevenueSources?: string[];
  CostTypes?: string[];
  TimeRange?: string;
  AssetId?: string;
  Search?: string;
  Status?: string;
  Page?: number;
  PerPage?: number;
};

export type GetRewardRoiRevenueParams = {
  Assets?: string[];
  AssetTypes?: string[];
  MarketTypes?: string[];
  Chains?: string[];
  RevenueSources?: string[];
  CostTypes?: string[];
  TimeRange?: string;
  AssetId?: string;
  Search?: string;
  Status?: string;
  Page?: number;
  PerPage?: number;
};

export type GetCostTrendRevenueParams = {
  Assets?: string[];
  AssetTypes?: string[];
  MarketTypes?: string[];
  Chains?: string[];
  RevenueSources?: string[];
  CostTypes?: string[];
  TimeRange?: string;
  AssetId?: string;
  Search?: string;
  Status?: string;
  Page?: number;
  PerPage?: number;
};

export type GetCostBreakdownRevenueParams = {
  Assets?: string[];
  AssetTypes?: string[];
  MarketTypes?: string[];
  Chains?: string[];
  RevenueSources?: string[];
  CostTypes?: string[];
  TimeRange?: string;
  AssetId?: string;
  Search?: string;
  Status?: string;
  Page?: number;
  PerPage?: number;
};

export type GetMarketTypeProfitabilityRevenueParams = {
  Assets?: string[];
  AssetTypes?: string[];
  MarketTypes?: string[];
  Chains?: string[];
  RevenueSources?: string[];
  CostTypes?: string[];
  TimeRange?: string;
  AssetId?: string;
  Search?: string;
  Status?: string;
  Page?: number;
  PerPage?: number;
};

export type GetCostEfficiencyRevenueParams = {
  Assets?: string[];
  AssetTypes?: string[];
  MarketTypes?: string[];
  Chains?: string[];
  RevenueSources?: string[];
  CostTypes?: string[];
  TimeRange?: string;
  AssetId?: string;
  Search?: string;
  Status?: string;
  Page?: number;
  PerPage?: number;
};

export type GetWithdrawalEconomicsRevenueParams = {
  Assets?: string[];
  AssetTypes?: string[];
  MarketTypes?: string[];
  Chains?: string[];
  RevenueSources?: string[];
  CostTypes?: string[];
  TimeRange?: string;
  AssetId?: string;
  Search?: string;
  Status?: string;
  Page?: number;
  PerPage?: number;
};

export type GetByAssetTypeRevenueParams = {
  Assets?: string[];
  AssetTypes?: string[];
  MarketTypes?: string[];
  Chains?: string[];
  RevenueSources?: string[];
  CostTypes?: string[];
  TimeRange?: string;
  AssetId?: string;
  Search?: string;
  Status?: string;
  Page?: number;
  PerPage?: number;
};

export type GetByAssetRevenueParams = {
  Assets?: string[];
  AssetTypes?: string[];
  MarketTypes?: string[];
  Chains?: string[];
  RevenueSources?: string[];
  CostTypes?: string[];
  TimeRange?: string;
  AssetId?: string;
  Search?: string;
  Status?: string;
  Page?: number;
  PerPage?: number;
};

export type GetByChainRevenueParams = {
  Assets?: string[];
  AssetTypes?: string[];
  MarketTypes?: string[];
  Chains?: string[];
  RevenueSources?: string[];
  CostTypes?: string[];
  TimeRange?: string;
  AssetId?: string;
  Search?: string;
  Status?: string;
  Page?: number;
  PerPage?: number;
};

export type GetBySourceRevenueParams = {
  Assets?: string[];
  AssetTypes?: string[];
  MarketTypes?: string[];
  Chains?: string[];
  RevenueSources?: string[];
  CostTypes?: string[];
  TimeRange?: string;
  AssetId?: string;
  Search?: string;
  Status?: string;
  Page?: number;
  PerPage?: number;
};

export type GetTrendBySourceRevenueParams = {
  Assets?: string[];
  AssetTypes?: string[];
  MarketTypes?: string[];
  Chains?: string[];
  RevenueSources?: string[];
  CostTypes?: string[];
  TimeRange?: string;
  AssetId?: string;
  Search?: string;
  Status?: string;
  Page?: number;
  PerPage?: number;
};

export type GetTrendRevenueParams = {
  Assets?: string[];
  AssetTypes?: string[];
  MarketTypes?: string[];
  Chains?: string[];
  RevenueSources?: string[];
  CostTypes?: string[];
  TimeRange?: string;
  AssetId?: string;
  Search?: string;
  Status?: string;
  Page?: number;
  PerPage?: number;
};

export type GetSummaryRevenueParams = {
  Assets?: string[];
  AssetTypes?: string[];
  MarketTypes?: string[];
  Chains?: string[];
  RevenueSources?: string[];
  CostTypes?: string[];
  TimeRange?: string;
  AssetId?: string;
  Search?: string;
  Status?: string;
  Page?: number;
  PerPage?: number;
};

export type GetProfitParams = {
  CurrencyId: string;
  From?: string;
  To?: string;
};

export type GetMarketRegistrationParams = {
  corePassId?: string;
};

export type GetListMarketRegistrationParams = {
  corePassId?: string;
  Instrument?: string;
  RequestByCorePassId?: string;
  RegistrationStatus?: MarketRegistrationStatus;
  Page?: number;
  PerPage?: number;
};

export type GetUsersInternalExchangeAccessParams = {
  cursor?: number;
  pageSize?: number;
};

export type GetTransferBalanceHotWalletParams = {
  paymentSystem?: string;
  assetId?: string;
  cursor?: string;
};

export type GetInfoHotWalletParams = {
  assetType?: AssetType;
};

export type GetGeographicUsersComplianceDashboardParams = {
  Dimension?: ComplianceGeographicDimension;
  CountryCode?: string;
  Unknown?: boolean;
  Search?: string;
  OrderBy?: string;
  Page?: number;
  PerPage?: number;
  Tiers?: UserComplianceTierType[];
  Statuses?: ActivityStatus[];
  KycVerified?: boolean;
};

export type GetRegistrationTrendComplianceDashboardParams = {
  From?: string;
  To?: string;
};

export type GetGeographicComplianceDashboardParams = {
  Dimension?: ComplianceGeographicDimension;
};

export type ComplianceUsersParams = {
  Search?: string;
  Cursor?: string;
  PerPage?: number;
  Status?: UserComplianceRequestStatus;
  UserTier?: UserComplianceTier;
  /** When set, the list is only businesses or only individuals. */
  IsBusiness?: boolean;
};

export type GetDashboardCampaignAnalyticsAdminParams = {
  CampaignIds?: string;
  From?: string;
  To?: string;
  Granularity?: string;
};

export type ListParticipantsCampaignAdminParams = {
  CorePassId?: string;
  QualificationStatus?: string;
  MarketingChannelCode?: string;
  Page?: number;
  PerPage?: number;
};

export type ListCampaignAdminParams = {
  Status?: CampaignStatus;
  Statuses?: CampaignStatus[];
  Slug?: string;
  Page?: number;
  PerPage?: number;
};

export type GetUsersBotGatewayManagementParams = {
  cursor?: number;
  pageSize?: number;
};

export type GetBroadcastRequestDetailBalanceAggregatorParams = {
  Page?: number;
  PerPage?: number;
};

export type GetBroadcastRequestsBalanceAggregatorParams = {
  Page?: number;
  PerPage?: number;
};

export type GetInjectFuelDetailBalanceAggregatorParams = {
  Page?: number;
  PerPage?: number;
};

export type GetInjectFuelsBalanceAggregatorParams = {
  Page?: number;
  PerPage?: number;
};

export type SponserBalanceAggregatorParams = {
  extKeyVersion?: string;
};

export type AggregateFtCommodityBalanceAggregatorParams = {
  customFeeRate?: number;
  extKeyVersion?: string;
};

export type BalancesFtCommodityBalanceAggregatorParams = {
  extKeyVersion?: string;
};

export type BalancesNftTokensBalanceAggregatorParams = {
  extKeyVersion?: string;
  userRequested?: boolean;
};

export type BalancesBalanceAggregatorParams = {
  extKeyVersion?: string;
};

export type GetAssetRegistrationParams = {
  corePassId?: string;
};

export type GetListAssetRegistrationParams = {
  corePassId?: string;
  AssetId?: string;
  AssetName?: string;
  AssetType?: AssetType;
  Status?: AssetRegistrationStatus;
  Page?: number;
  PerPage?: number;
};

export type GetAllSignedForUserAssetContractParams = {
  userId?: string;
};

export type GetAllSignedAssetContractParams = {
  page?: number;
  perPage?: number;
};

export type GetListByAssetIdAssetContractParams = {
  page?: number;
  perPage?: number;
};

export type GetUserBalanceCheckAdminAccountingParams = {
  CorePassId?: string;
  Page?: number;
  PerPage?: number;
  Status?: ActivityStatus;
};

export type GetUserDepositInfoAdminAccountingParams = {
  user?: string;
};

export type GetNetworksWalletParams = {
  AssetId?: string;
};

export type GetNetworkFeeWalletParams = {
  PaymentSystem: string;
  AssetId?: string;
};

export type GetTransferHistoryWalletParams = {
  AssetId?: string;
  Type?: TransferType;
  /**
   * If IsReward is false returns all tranfer reason types except for reward reason
   */
  IsReward?: boolean;
  StartDate?: string;
  EndDate?: string;
  /**
 * A comma-separated list of expressions used to sort the items.
- For ascending sort use 'asc' suffix or nothing(default) like 'CreatedAt asc' or 'CreatedAt'.
- For descending sort use 'desc' suffix like 'CreatedAt desc'.
- Note: value is case insensitive
- Default: if nothing provided default ordering is by TransferId desc.
- Supported fields:
    - TransferId
    - Status
    - Amount
    - CreatedAt
    - AssetId
 */
  OrderBy?: string;
  Page?: number;
  PerPage?: number;
};

export type GetWithdrawalLiquidityHintWalletParams = {
  paymentSystem: string;
  assetId?: string;
};

export type IsWithdrawalAllowedWalletParams = {
  /**
   * The payment system to check. This is a required parameter and must only contains numbers and chars.
   */
  paymentSystem: string;
  /**
   * The withdrawal address to check. This is a required parameter and must only contains numbers and chars.
   */
  address: string;
};

export type GetWithdrawalReceiveAmountWalletParams = {
  assetId: string;
  paymentSystem: string;
  amount: number;
  address: string;
};

export type FeeTradeParams = {
  /**
   * The market instrument to calculate fee for
   */
  Instrument?: string;
  /**
   * The side of the order (buy or sell)
   */
  Type?: string;
  /**
   * The amount of the base currency
   */
  Amount?: number;
  /**
   * The price of the order (for limit orders) or estimated price (for market orders)
   */
  Price?: number;
};

export type QuoteTradeParams = {
  Instrument?: string;
  Amount?: number;
  IsBuy?: boolean;
};

export type RecentTradesParams = {
  /**
   * A string representing the market name which recent data will be collected.
   */
  Instrument?: string;
};

export type SwapTradeParams = {
  FromAssetId: string;
  ToAssetId: string;
  Amount: number;
  DefaultCurrency?: string;
};

export type GetTradeHistoryParams = {
  Market?: string;
  Side?: OrderSide;
  StartDate?: string;
  EndDate?: string;
  /**
 * A comma-separated list of expressions used to sort the items.
- For ascending sort use 'asc' suffix or nothing(default) like 'CreatedAt asc' or 'CreatedAt'.
- For descending sort use 'desc' suffix like 'CreatedAt desc'.
- Note: value is case insensitive
- Default: if nothing provided default ordering is by TradeSeq desc.
- Supported fields:
    - TradeSeq
    - TradeTime
    - Amount
    - Instrument
    - Side
    - ExecutionPrice
    - Commission
 */
  OrderBy?: string;
  Page?: number;
  PerPage?: number;
};

export type OrderHistoryTradeParams = {
  Market?: string;
  Side?: OrderSide;
  StartDate?: string;
  EndDate?: string;
  /**
 * A comma-separated list of expressions used to sort the items.
- For ascending sort use 'asc' suffix or nothing(default) like 'CreatedAt asc' or 'CreatedAt'.
- For descending sort use 'desc' suffix like 'CreatedAt desc'.
- Note: value is case insensitive
- Default: if nothing provided default ordering is by UpdatedAt desc.
- Supported fields:
    - Instrument
    - Amount
    - UnitsFilled
    - Remaining
    - Price
    - Total
    - OrderType
    - StopPrice
    - CreatedAt
    - UpdatedAt
    - Side
    - ExecutionPrice
    - Commission
    - Status
 */
  OrderBy?: string;
  IsHideCanceled?: boolean;
  Page?: number;
  PerPage?: number;
};

export type GetRewardsParams = {
  page?: number;
  perPage?: number;
};

export type GetReferralStatusParams = {
  Page?: number;
  PerPage?: number;
};

export type GetQuotesRampParams = {
  Side: RampOrderSide;
  CountryCode: string;
  'SourceAsset.Symbol': string;
  'SourceAsset.BlockchainNetwork'?: BlockchainNetwork;
  'TargetAsset.Symbol': string;
  'TargetAsset.BlockchainNetwork'?: BlockchainNetwork;
  Amount: number;
  PaymentMethod?: PaymentMethod;
};

export type GetPaymentMethodsRampParams = {
  Side: RampOrderSide;
  CountryCode: string;
  'SourceAsset.Symbol': string;
  'SourceAsset.BlockchainNetwork'?: BlockchainNetwork;
  'TargetAsset.Symbol': string;
  'TargetAsset.BlockchainNetwork'?: BlockchainNetwork;
  Amount?: number;
};

export type GetAssetsRampParams = {
  Side: RampOrderSide;
  CountryCode: string;
};

export type GetCountriesRampParams = {
  Side: RampOrderSide;
};

export type GetOrCreateProfileV2Params = {
  referralCode?: string;
};

export type GetOrCreateProfileParams = {
  /**
 * Used only on first call to this api when user is being created, 
            It indicates the user who referred this user
 */
  referralCode?: string;
};

export type NotificationProfileParams = {
  corepssId?: string;
  eventName?: string;
  data?: string;
};

export type ResetCorepassIdProfileParams = {
  corepssId?: string;
};

export type CreatePaymentRequestParams = {
  address?: string;
  amount?: string;
  currency?: string;
  digitize?: boolean;
  donate?: boolean;
  rc?: string;
  fiat?: string;
  dl?: number;
  swap?: string;
  org?: string;
  item?: string;
  photo?: string;
  'item-photo'?: string;
  'payment-id'?: string;
  'ref-code'?: string;
};

export type GetQuotePaymentQuoteParams = {
  cryptoCurrency?: string;
  blockchainNetwork?: string;
  amount?: number;
  fiatCurrency?: string;
};

export type ListExecutionsPaymentParams = {
  page?: number;
  perPage?: number;
};

export type ListPaymentsParams = {
  page?: number;
  perPage?: number;
  startDate?: string;
  endDate?: string;
  isRecurring?: boolean;
};

export type ChangeUserStatusToWaitingForDataKycParams = {
  coreId: string;
};

export type InvalidateKycParams = {
  /**
   * CorePassId
   */
  coreId: string;
};

export type UploadFileToCloudStorageFileTransferParams = {
  documentType: CorePassDocumentType;
};

export type GetMarketExchangeRateParams = {
  instrument?: string;
};

export type GetPreviousStepComplianceParams = {
  step?: ComplianceStepType;
};

export type GetNextStepComplianceParams = {
  step?: ComplianceStepType;
};

export type GetSignedAssetsContractsAssetContractParams = {
  assetId?: string;
};

export interface WithdrawalRequest {
  /** @nullable */
  address?: string | null;
  amount?: number;
  /** @nullable */
  assetId?: string | null;
  /** @nullable */
  clientWithdrawRequestId?: string | null;
  /** @nullable */
  comment?: string | null;
  /** @nullable */
  paymentSystem?: string | null;
  /** @nullable */
  provider?: string | null;
  /** @nullable */
  tokenId?: string | null;
  /** @nullable */
  transactionId?: string | null;
}

export interface WithdrawalLiquidityHintResponse {
  /** @nullable */
  alternativePaymentSystem?: string | null;
  /** @nullable */
  alternativePaymentSystemMessage?: string | null;
  enabled?: boolean;
  /** @nullable */
  estimatedLiquidityMinutes?: number | null;
  inFlightCctpInboundUsdc?: number;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  paymentSystem?: string | null;
  pendingWithdrawalsUsdc?: number;
  /** @nullable */
  status?: string | null;
  withdrawalCoverageGap?: number;
}

export interface WithdrawalLimitResponse {
  complianceTier?: UserComplianceTierType;
  currentLimit?: number;
  dailyLimit?: number;
  /**
   * The currency in which the withdrawal limits are defined.
   * @nullable
   */
  limitCurrency?: string | null;
  /** The maximum limit allowed per transaction. */
  perTransactionLimit?: number;
  /** The cumulative sum of withdrawals made by the user since the beginning of the current month. */
  totalCurrentMonthWithdrawalAmount?: number;
  /** The cumulative sum of withdrawals made by the user since the beginning of the current year. */
  totalCurrentYearWithdrawalAmount?: number;
  /** The total monthly withdrawal limit for the user. */
  totalMonthlyLimit?: number;
  /** The total yearly withdrawal limit for the user. */
  totalYearlyLimit?: number;
}

export interface WithdrawalData {
  amount?: number;
  asset?: RampingAssetData;
  /** @nullable */
  walletAddress?: string | null;
}

export type WithdrawalAllowanceStatusType =
  (typeof WithdrawalAllowanceStatusType)[keyof typeof WithdrawalAllowanceStatusType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const WithdrawalAllowanceStatusType = {
  IsAllowed: 'IsAllowed',
  VerificationRequired: 'VerificationRequired',
  ExternalCorePassWalletAddressNotAllowed: 'ExternalCorePassWalletAddressNotAllowed',
  InternalPingOwnedWalletAddressNotAllowed: 'InternalPingOwnedWalletAddressNotAllowed',
  TargetAddressIsNotAllowed: 'TargetAddressIsNotAllowed',
  VerificationRequiredWithReplace: 'VerificationRequiredWithReplace',
  VerificationRequiredLtc: 'VerificationRequiredLtc',
  InvalidatedWalletAddress: 'InvalidatedWalletAddress',
} as const;

export interface WalletConnectorVerifyAddressResponse {
  readonly isVerified?: boolean;
  qrCode?: WalletConnectorQrCodePayload;
}

export interface WalletConnectorVerifyAddressRequest {
  /** @minLength 1 */
  paymentSystem: string;
  /**
   * @minLength 0
   * @maxLength 64
   * @pattern ^[a-zA-Z0-9]{26,64}$
   */
  walletAddress: string;
}

export interface WalletConnectorQrCodePayload {
  /** @nullable */
  alreadySent?: boolean | null;
  expiration?: number;
  /** @nullable */
  link?: string | null;
  /** @nullable */
  qrcode?: string | null;
}

export interface VerifyWalletWithSignedFormRequest {
  /**
   * @minLength 1
   * @pattern ^[a-zA-Z]*$
   */
  paymentSystem: string;
  /**
   * @minLength 1
   * @pattern ^[a-zA-Z0-9]*$
   */
  walletAddress: string;
}

export interface VerifyAddressWithSignedFormResult {
  /** @nullable */
  coreId?: string | null;
  /** @nullable */
  date?: string | null;
  /** @nullable */
  dateOfBirth?: string | null;
  /** @nullable */
  fullName?: string | null;
  /** @nullable */
  fullNameEnglish?: string | null;
  /** @nullable */
  link?: string | null;
  /** @nullable */
  walletAddress?: string | null;
}

export interface VerifyAddressResponse {
  readonly isVerified?: boolean;
  qrCode?: QrCodeData;
}

export interface VerifyAddressRequest {
  /** @minLength 1 */
  paymentSystem: string;
  /**
   * @minLength 0
   * @maxLength 64
   * @pattern ^[a-zA-Z0-9]{26,64}$
   */
  walletAddress: string;
}

export type UserTotalValueType = (typeof UserTotalValueType)[keyof typeof UserTotalValueType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserTotalValueType = {
  Under1000: 'Under1000',
  Between1000And9999: 'Between1000And9999',
  Between10000And99999: 'Between10000And99999',
  Between100000And249999: 'Between100000And249999',
  Between250000And999999: 'Between250000And999999',
  Between1000000And2999999: 'Between1000000And2999999',
  Between3000000And4999999: 'Between3000000And4999999',
  Over5000000: 'Over5000000',
} as const;

export type UserReviewAlertType = (typeof UserReviewAlertType)[keyof typeof UserReviewAlertType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserReviewAlertType = {
  None: 'None',
  Info: 'Info',
  Warning: 'Warning',
} as const;

export interface UserReviewLastRequest {
  alert?: UserReviewAlertType;
  id?: string;
  status?: UserReviewStatusType;
}

export type UserPrimaryUseType = (typeof UserPrimaryUseType)[keyof typeof UserPrimaryUseType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserPrimaryUseType = {
  Investing: 'Investing',
  TradingOnPingExchange: 'TradingOnPingExchange',
  TradingOnOtherExchanges: 'TradingOnOtherExchanges',
  OnlinePurchases: 'OnlinePurchases',
  PaymentToFriends: 'PaymentToFriends',
  OnlinePayments: 'OnlinePayments',
  Business: 'Business',
} as const;

export type UserPrimarySourceType = (typeof UserPrimarySourceType)[keyof typeof UserPrimarySourceType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserPrimarySourceType = {
  Occupation: 'Occupation',
  Investments: 'Investments',
  Savings: 'Savings',
  Inheritance: 'Inheritance',
  CreditLoan: 'CreditLoan',
  FamilyOrOthers: 'FamilyOrOthers',
  CryptocurrencyMining: 'CryptocurrencyMining',
} as const;

export type UserIndustryType = (typeof UserIndustryType)[keyof typeof UserIndustryType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserIndustryType = {
  Agriculture: 'Agriculture',
  ArtsAndMedia: 'ArtsAndMedia',
  CasinosAndGaming: 'CasinosAndGaming',
  Cryptocurrency: 'Cryptocurrency',
  Defense: 'Defense',
  Education: 'Education',
  EnergyOilAndGas: 'EnergyOilAndGas',
  EnergyOther: 'EnergyOther',
  Other: 'Other',
} as const;

export type UserEmploymentStatusType = (typeof UserEmploymentStatusType)[keyof typeof UserEmploymentStatusType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserEmploymentStatusType = {
  Employed: 'Employed',
  Unemployed: 'Unemployed',
  Retired: 'Retired',
  Student: 'Student',
  SelfEmployed: 'SelfEmployed',
} as const;

export interface UserInfo {
  employmentStatus?: UserEmploymentStatusType;
  /** @nullable */
  entityType?: boolean | null;
  /** @nullable */
  formSignature?: string | null;
  /** @nullable */
  formSignatureDate?: string | null;
  industry?: UserIndustryType;
  /** @nullable */
  otherIndustry?: string | null;
  primarySource?: UserPrimarySourceType;
  primaryUse?: UserPrimaryUseType;
  /** @nullable */
  termsAccepted?: boolean | null;
  totalValue?: UserTotalValueType;
  userId?: string;
}

export interface UserDocumentDto {
  createdAt?: number;
  documentType?: DocumentTypeRpc;
  /** @nullable */
  fileName?: string | null;
  fileSize?: number;
  /** @nullable */
  id?: string | null;
  kycVersion?: number;
  /** @nullable */
  userId?: string | null;
}

export interface UserApiKeyViewModel {
  /** @nullable */
  apiKey?: string | null;
  /** @nullable */
  displayName?: string | null;
  /** @nullable */
  expiresAt?: string | null;
  isRevoked?: boolean;
  /** @nullable */
  revokedAt?: string | null;
}

export interface UpdateAddressBookRequest {
  /**
   * @minLength 0
   * @maxLength 32
   * @nullable
   */
  label?: string | null;
}

export interface TwoFactorAuthCallbackRequest {
  /** @nullable */
  coreID?: string | null;
  /** @nullable */
  signature?: string | null;
}

export interface TravelRequest {
  originatorBeneficiary: OriginatorBeneficiaryModel;
  /**
   * The Virtual Asset Provider ID.
   * @minLength 0
   * @maxLength 255
   * @pattern ^[a-zA-Z0-9-.\s]*$
   */
  vaspId: string;
}

export interface TravelOriginator {
  /**
   * Represents the customer ID.
   * @minLength 0
   * @maxLength 255
   * @pattern ^[a-zA-Z0-9-.\s]*$
   */
  customerId: string;
  /** Represents the date of birth of the originator. */
  dateOfBirth: string;
  /**
   * Represents the document number of the originator.
   * @minLength 0
   * @maxLength 64
   * @pattern ^[a-zA-Z0-9-.\s]*$
   */
  documentNumber: string;
  /**
   * Represents the name of the originator.
   * @minLength 0
   * @maxLength 255
   * @pattern ^([\p{L}\p{N}\s-/])*$
   */
  name: string;
  /**
   * Represents the physical address of the originator.
   * @minLength 0
   * @maxLength 255
   * @pattern ^[a-zA-Z0-9-,.\s]*$
   */
  physicalAddress: string;
  /**
   * Represents the place of birth of the originator.
   * @minLength 0
   * @maxLength 64
   * @pattern ^[a-zA-Z0-9-.\s]*$
   */
  placeOfBirth: string;
  /**
   * Represents the wallet address of the originator.
   * @minLength 0
   * @maxLength 255
   * @pattern ^[a-zA-Z0-9-.\s]*$
   */
  walletAddress: string;
}

export interface TravelCheckRequest {
  /**
   * The ID of the asset associated with the wallet such as ctn, xcb, btn etc. (required)
   * @minLength 3
   * @maxLength 4
   * @pattern ^[a-zA-Z0-9]*$
   */
  assetId: string;
  /**
   * The `Virtual Asset Provider` identifier (required)
   * @minLength 3
   * @maxLength 256
   * @pattern ^[a-zA-Z0-9]*$
   */
  vaspId: string;
  /**
   * The address of the wallet that requires verification to determine if it is associated with PingExchange (required)
   * @minLength 3
   * @maxLength 256
   * @pattern ^[a-zA-Z0-9]*$
   */
  walletAddress: string;
}

export interface TravelBeneficiary {
  /**
   * Represents the customer ID of the beneficiary.
   * @minLength 0
   * @maxLength 255
   * @nullable
   * @pattern ^[a-zA-Z0-9-.\s]*$
   */
  customerId?: string | null;
  /**
   * Represents the name of the beneficiary.
   * @minLength 0
   * @maxLength 255
   * @pattern ^[a-zA-Z0-9-.\s]*$
   */
  name: string;
  /**
   * Represents the wallet address of the beneficiary.
   * @minLength 0
   * @maxLength 255
   * @pattern ^[a-zA-Z0-9-.\s]*$
   */
  walletAddress: string;
}

/**
 * @nullable
 */
export type TransferHistoryResponseFilteredResponseFilters = unknown | null;

export interface TransferHistoryResponse {
  amount?: number;
  /** @nullable */
  assetId?: string | null;
  /** @nullable */
  clientWithdrawRequestId?: string | null;
  createdAt?: string;
  /** @nullable */
  explorerUrl?: string | null;
  /** @nullable */
  fee?: number | null;
  isInternal?: boolean;
  /** @nullable */
  paymentSystemId?: string | null;
  status?: TransferStatus;
  /** @nullable */
  targetAddress?: string | null;
  /** @nullable */
  tokenId?: string | null;
  /** @nullable */
  transferId?: string | null;
  transferReason?: TransferReasonType;
  /** @nullable */
  txId?: string | null;
  type?: TransferType;
  /** @nullable */
  withdrawalFeeAssetId?: string | null;
  /** @nullable */
  withdrawRequestId?: string | null;
}

export interface TransferHistoryResponseFilteredResponse {
  /** @nullable */
  data?: TransferHistoryResponse[] | null;
  /** @nullable */
  filters?: TransferHistoryResponseFilteredResponseFilters;
  paging?: Paging;
}

export interface TradeViewModel {
  rowNumber?: number;
  tradeAmount?: number;
  tradeDateUtc?: string;
  tradeFee?: number;
  /** @nullable */
  tradeFeeAsset?: string | null;
  tradePrice?: number;
  /** @nullable */
  tradeTokenIds?: string[] | null;
}

/**
 * @nullable
 */
export type TradeHistoryItemFilteredResponseFilters = unknown | null;

export interface TradeHistoryItem {
  amount?: number;
  /** @nullable */
  commission?: number | null;
  executionPrice?: number;
  /** @nullable */
  instrument?: string | null;
  /** @nullable */
  orderId?: string | null;
  quoteAmount?: number;
  remaining?: number;
  side?: OrderSide;
  status?: OrderStatus;
  tradeSeq?: number;
  tradeTime?: string;
  transactionId?: number;
}

export interface TradeHistoryItemFilteredResponse {
  /** @nullable */
  data?: TradeHistoryItem[] | null;
  /** @nullable */
  filters?: TradeHistoryItemFilteredResponseFilters;
  paging?: Paging;
}

export interface SwapResponse {
  currencyRate?: number;
  rate?: number;
  totalConversion?: number;
  /** @nullable */
  userCurrency?: string | null;
}

export interface SignedAssetContractsResponseItem {
  /** @nullable */
  assetId?: string | null;
  /** @nullable */
  assetName?: string | null;
  contractVersion?: number;
  signedAt?: string;
  signedDocumentId?: string;
}

export type SelfMatchPreventionStrategy =
  (typeof SelfMatchPreventionStrategy)[keyof typeof SelfMatchPreventionStrategy];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SelfMatchPreventionStrategy = {
  cancelAggressor: 'cancelAggressor',
  cancelResting: 'cancelResting',
  cancelBoth: 'cancelBoth',
} as const;

/**
 * Reward properties exposed to the user.
 */
export interface RewardResponse {
  /** Amount that will be rewarded to the user */
  amount?: number;
  /**
   * Asset Id
   * @nullable
   */
  assetId?: string | null;
  /**
   * UTC time when the user may claim this reward, if scheduled.
   * @nullable
   */
  claimableAt?: string | null;
  /**
   * UTC time when the reward was claimed, if applicable.
   * @nullable
   */
  claimDate?: string | null;
  /**
   * Corepass Id
   * @nullable
   */
  coreId?: string | null;
  /** UTC time when the reward was created. */
  creationDate?: string;
  /** Reward Id */
  id?: string;
  /** Whether the user has already claimed this reward. */
  isClaimed?: boolean;
  /**
   * Current reward status (Active or Cancelled).
   * @nullable
   */
  rewardStatus?: string | null;
}

/**
 * Paginated list of user rewards.
 */
export interface RewardListResponse {
  /**
   * Rewards for the requested page.
   * @nullable
   */
  items?: RewardResponse[] | null;
  /** Total number of rewards for the user. */
  totalCount?: number;
}

export interface RevokeUserApiKeyRequest {
  /** @minLength 1 */
  apiKey: string;
}

export interface ReferralResponse {
  firstLevelRefereeCount?: number;
  hasReferrer?: boolean;
  /** @nullable */
  referralCode?: string | null;
}

export interface RefereeRewardResponse {
  readonly commissionPercentage?: number;
  convertedTotalCommission?: number;
  /** @nullable */
  corePassId?: string | null;
  totalCommission?: number;
}

export interface ReferralStatusResponse {
  convertedCommission?: number;
  paging?: PagingData;
  recentEarnedCommission?: number;
  /** @nullable */
  refereesCommissionList?: RefereeRewardResponse[] | null;
  refereesCount?: number;
  totalEarnedCommission?: number;
}

export interface RecentTradesResponse {
  amount?: number;
  executionPrice?: number;
  /** @nullable */
  instrument?: string | null;
  side?: OrderSide;
  tradeId?: number;
  tradeTime?: number;
}

export type RampingProvider = (typeof RampingProvider)[keyof typeof RampingProvider];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RampingProvider = {
  MoonPay: 'MoonPay',
  CorePort: 'CorePort',
} as const;

export interface RampingProviderData {
  code?: RampingProvider;
  /** @nullable */
  name?: string | null;
}

export interface RampingCallbackResponse {
  action?: RampCallbackAction;
  /** @nullable */
  description?: string | null;
  isRampOperationSuccessful?: boolean;
  provider?: RampingProviderData;
  side?: RampOrderSide;
  withdrawalInfo?: WithdrawalData;
}

export interface RampingAssetData {
  blockchainNetwork?: BlockchainNetworkData;
  /** @nullable */
  readonly icon_url?: string | null;
  /** @nullable */
  iconUrl?: string | null;
  maxBuyAmount?: number;
  maxSellAmount?: number;
  minBuyAmount?: number;
  minSellAmount?: number;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  symbol?: string | null;
  type?: RampAssetType;
}

export type RampOrderSide = (typeof RampOrderSide)[keyof typeof RampOrderSide];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RampOrderSide = {
  Buy: 'Buy',
  Sell: 'Sell',
} as const;

export type RampCallbackAction = (typeof RampCallbackAction)[keyof typeof RampCallbackAction];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RampCallbackAction = {
  ShowStatus: 'ShowStatus',
  Withdraw: 'Withdraw',
} as const;

export type RampAssetType = (typeof RampAssetType)[keyof typeof RampAssetType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RampAssetType = {
  Crypto: 'Crypto',
  Fiat: 'Fiat',
} as const;

export interface QuoteData {
  amount?: number;
  estimatedSpendAmountInSourceAsset?: number;
  providerInfo?: RampingProviderData;
  unitPriceInTargetAsset?: number;
}

export interface QrCodeData {
  /** @nullable */
  alreadySent?: boolean | null;
  expiration?: number;
  /** @nullable */
  link?: string | null;
  /** @nullable */
  qrcode?: string | null;
}

export interface ProfileSettingsUpdateRequest {
  /**
   * @nullable
   * @pattern ^[a-zA-Z0-9-]*$
   */
  type?: string | null;
  /**
   * @nullable
   * @pattern ^[a-zA-Z0-9-/]*$
   */
  value?: string | null;
}

export interface ProfileResponse {
  /** @nullable */
  accounts?: BasicAccountInfo[] | null;
  activityStatus?: ActivityStatus;
  canInitiateTierUpgrade?: boolean;
  complianceTier?: UserComplianceTierType;
  /** @nullable */
  coreId?: string | null;
  /** @nullable */
  createdAt?: string | null;
  /** @nullable */
  documentExpirationDate?: number | null;
  /** @nullable */
  email?: string | null;
  /** @nullable */
  fullName?: string | null;
  /** @nullable */
  fullNameEnglish?: string | null;
  /** @nullable */
  id?: string | null;
  isTierExpired?: boolean;
  lastRequest?: UserReviewLastRequest;
  /** @nullable */
  lastSignInDate?: string | null;
  /** @nullable */
  nickname?: string | null;
  /** @nullable */
  roles?: string[] | null;
  tier?: UserTierType;
  /** @nullable */
  tierExpiresAt?: string | null;
  /** @nullable */
  verificationError?: string | null;
  /** @nullable */
  verificationFailedAt?: string | null;
  verificationIsInProgress?: boolean;
  verificationLevel?: number;
  verificationStartedAt?: string;
}

/**
 * Request for processing eligibility
 */
export interface ProcessEligibilityRequest {
  /**
   * CorePassId of the user
   * @nullable
   * @pattern ^[a-zA-Z0-9\-]*$
   */
  corePassId?: string | null;
  /**
   * Email of the user
   * @nullable
   */
  email?: string | null;
}

export interface PaymentSystemInfo {
  /** @nullable */
  assets?: string[] | null;
  /** @nullable */
  name?: string | null;
}

export type PaymentStatus = (typeof PaymentStatus)[keyof typeof PaymentStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PaymentStatus = {
  Initiated: 'Initiated',
  AwaitingConfirmation: 'AwaitingConfirmation',
  RecurringScheduled: 'RecurringScheduled',
  Completed: 'Completed',
  Failed: 'Failed',
  Cancelled: 'Cancelled',
  Expired: 'Expired',
} as const;

export interface PaymentQuoteResponse {
  accountCurrentBalanceAmount?: number;
  balanceIsSufficient?: boolean;
  /** @nullable */
  blockchainNetwork?: string | null;
  internalWithdrawalFeePercent?: number;
  isBelowMinimumPayerPaymentAmount?: boolean;
  issuedAtUtc?: number;
  maximumInternalWithdrawalFeeFixedAmount?: number;
  minimumPayerPaymentAmount?: number;
  payerPaymentAmount?: number;
  /** @nullable */
  payerPaymentAmountInPaymentFiat?: number | null;
  payerPaymentAmountInUserSettingFiat?: number;
  payerPaymentAmountRaw?: number;
  /** @nullable */
  paymentAsset?: string | null;
  /** @nullable */
  paymentCryptoToFiatRate?: number | null;
  /** @nullable */
  paymentCryptoToFiatRateRaw?: number | null;
  paymentFee?: number;
  /** @nullable */
  paymentFeeAsset?: string | null;
  /** @nullable */
  paymentFiatAsset?: string | null;
  /** @nullable */
  paymentFiatToCryptoRate?: number | null;
  /** @nullable */
  paymentFiatToCryptoRateRaw?: number | null;
  paymentUserSettingCryptoToFiatRate?: number;
  /** @nullable */
  paymentUserSettingFiatAsset?: string | null;
  paymentUserSettingFiatToCryptoRate?: number;
  quotedAmount?: number;
  /** @nullable */
  quotedFiatCurrency?: string | null;
  receiverPaymentAmount?: number;
  /** @nullable */
  receiverPaymentAmountInPaymentFiat?: number | null;
  receiverPaymentAmountInUserSettingFiat?: number;
  receiverPaymentAmountRaw?: number;
  /** @nullable */
  signature?: string | null;
}

export type PaymentMethod = (typeof PaymentMethod)[keyof typeof PaymentMethod];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PaymentMethod = {
  CreditDebitCard: 'CreditDebitCard',
  BankTransfer: 'BankTransfer',
  PayPal: 'PayPal',
  ApplePay: 'ApplePay',
  GooglePay: 'GooglePay',
  RevolutPay: 'RevolutPay',
  SepaBankTransfer: 'SepaBankTransfer',
  AchBankTransfer: 'AchBankTransfer',
  GbpBankTransfer: 'GbpBankTransfer',
  GbpOpenBankingTransfer: 'GbpOpenBankingTransfer',
  PixInstantPayment: 'PixInstantPayment',
  Interac: 'Interac',
  Venmo: 'Venmo',
  MoonPayBalance: 'MoonPayBalance',
} as const;

export interface PaymentMethodData {
  code?: PaymentMethod;
  /** @nullable */
  name?: string | null;
}

export interface PaymentListItemResponse {
  /** @nullable */
  assetId?: string | null;
  /** @nullable */
  clientPaymentId?: string | null;
  createdAt?: string;
  /** @nullable */
  donate?: boolean | null;
  id?: string;
  isRecurring?: boolean;
  /** @nullable */
  item?: string | null;
  /** @nullable */
  itemPhotoUrl?: string | null;
  /** @nullable */
  merchantPhotoUrl?: string | null;
  /** @nullable */
  organization?: string | null;
  /** @nullable */
  organizationIsVerified?: boolean | null;
  /** @nullable */
  payerPaymentAmount?: number | null;
  /** @nullable */
  paymentFee?: number | null;
  /** @nullable */
  receiverPaymentAmount?: number | null;
  recurringEnabled?: boolean;
  /** @nullable */
  recurringLastRunAt?: string | null;
  /** @nullable */
  recurringNextRunAt?: string | null;
  /** @nullable */
  recurringPattern?: string | null;
  recurringRunCount?: number;
  status?: PaymentStatus;
}

export interface PaymentListResponse {
  /** @nullable */
  items?: PaymentListItemResponse[] | null;
  totalCount?: number;
}

export type PaymentExecutionStatus = (typeof PaymentExecutionStatus)[keyof typeof PaymentExecutionStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PaymentExecutionStatus = {
  Success: 'Success',
  Failed: 'Failed',
  Skipped: 'Skipped',
} as const;

export interface PaymentExecutionListItemResponse {
  createdAt?: string;
  id?: string;
  payerPaymentAmount?: number;
  paymentFee?: number;
  receiverPaymentAmount?: number;
  runNo?: number;
  status?: PaymentExecutionStatus;
}

export interface PaymentExecutionListResponse {
  /** @nullable */
  items?: PaymentExecutionListItemResponse[] | null;
  totalCount?: number;
}

export interface PayPaymentRequest {
  /**
   * Optional amount when the payment request has no amount yet.
   * @nullable
   */
  amount?: number | null;
  /**
   * Required when the payment request has multiple digitized currency choices and is not yet confirmed by the user.
   * @nullable
   */
  blockchainNetwork?: string | null;
  /**
   * Required when the payment request has multiple digitized currency choices and is not yet confirmed by the user.
   * @nullable
   */
  cryptoCurrency?: string | null;
  paymentQuote: PaymentQuoteResponse;
  paymentRequestId: string;
}

export interface OriginatorBeneficiaryModel {
  /**
   * The amount associated with the transaction.
   * @minimum 0
   */
  amount: number;
  /**
   * The asset ID.
   * @minLength 0
   * @maxLength 12
   * @pattern ^[a-zA-Z]{3,12}$
   */
  assetId: string;
  beneficiary?: TravelBeneficiary;
  originator?: TravelOriginator;
  /**
   * The VASP ID of the originator.
   * @minLength 0
   * @maxLength 255
   * @pattern ^[a-zA-Z0-9-.\s]*$
   */
  originatorVASP: string;
  /**
   * The transaction ID.
   * @minLength 0
   * @maxLength 128
   * @pattern ^[a-zA-Z0-9-.\s]*$
   */
  transactionId: string;
}

export interface OrderTradesViewModelForUser {
  order?: OrderViewModel;
  /** @nullable */
  trades?: TradeViewModel[] | null;
}

/**
 * @nullable
 */
export type OrderInfoResponseFilteredResponseFilters = unknown | null;

export interface OrderInfoResponse {
  amount?: number;
  cancelReason?: CancelReason;
  commission?: number;
  createdAt?: string;
  executionPrice?: number;
  /** @nullable */
  feeAsset?: string | null;
  /** @nullable */
  instrument?: string | null;
  isLimit?: boolean;
  isPending?: boolean;
  /** @nullable */
  orderId?: string | null;
  orderType?: OrderType;
  price?: number;
  /** @nullable */
  rejectDetails?: string | null;
  remaining?: number;
  /** @nullable */
  remainingTokenIds?: string[] | null;
  requestedPrice?: number;
  side?: OrderSide;
  status?: OrderStatus;
  stopPrice?: number;
  /** @nullable */
  tokenIds?: string[] | null;
  total?: number;
  /** @nullable */
  type?: string | null;
  unitsFilled?: number;
  updatedAt?: string;
}

export interface OrderResponse {
  order?: OrderInfoResponse;
}

export interface OrderInfoResponseFilteredResponse {
  /** @nullable */
  data?: OrderInfoResponse[] | null;
  /** @nullable */
  filters?: OrderInfoResponseFilteredResponseFilters;
  paging?: Paging;
}

export interface OrderInfoRequest {
  activationPrice?: number;
  amount?: number;
  /** @nullable */
  instrument?: string | null;
  isLimit?: boolean;
  isStop?: boolean;
  /** Price of the order.
For Market orders, this property should be set to the VolumeWeightedPrice received from the GetQuote API.
- In Market sell orders, the Price is not utilized. */
  price?: number;
  selfMatchStrategy?: SelfMatchPreventionStrategy;
  /** @nullable */
  selfMatchToken?: string | null;
  /** @nullable */
  tokenIds?: string[] | null;
  /** @nullable */
  type?: string | null;
}

export interface OrderRequest {
  order?: OrderInfoRequest;
}

export interface NetworkItemInfo {
  /** @nullable */
  assets?: string[] | null;
  /** @nullable */
  name?: string | null;
}

export interface NetworkFeeResponse {
  readonly actualFee?: number;
  /** @nullable */
  assetId?: string | null;
  readonly composedFee?: number;
  readonly feeRate?: number;
  /** @nullable */
  readonly feeRateUnit?: string | null;
  readonly maximumAcceptableFeeRate?: number;
  /** @nullable */
  paymentSystem?: string | null;
  readonly thresholdReached?: boolean;
}

export interface MarketInfo {
  allowMarketOrder?: boolean;
  amountScale?: number;
  /** @nullable */
  baseAsset?: string | null;
  baseFee?: number;
  hidden?: boolean;
  /** @nullable */
  id?: string | null;
  isFixedRatio?: boolean;
  makerFee?: number;
  makerFeeLimit?: number;
  marketType?: ApiMarketType;
  maxPrice?: number;
  maxPriceDeviationPercent?: number;
  maxSellPriceVariationPercent?: number;
  minAmount?: number;
  minBuyPriceVariationPercent?: number;
  minPrice?: number;
  preventMarketMakersMatch?: boolean;
  priceScale?: number;
  /** @nullable */
  quoteAsset?: string | null;
  quoteFee?: number;
  status?: ApiMarketStatus;
  takerFee?: number;
  takerFeeLimit?: number;
  visibility?: MarketVisibility;
}

/**
 * Response model for market exchange rate with price deviation validation information
 */
export interface MarketExchangeRateResponse {
  /** @nullable */
  base_asset?: string | null;
  /** @nullable */
  base_currency?: string | null;
  /** @nullable */
  last_updated?: string | null;
  market_id?: number;
  /** @nullable */
  market_instrument?: string | null;
  /** @nullable */
  max_allowed_deviation_percent?: number | null;
  /** @nullable */
  max_valid_price?: number | null;
  /** @nullable */
  min_valid_price?: number | null;
  /** @nullable */
  official_rate?: number | null;
  /** @nullable */
  quote_asset?: string | null;
}

export interface LastUserReviewDocument {
  fileId?: string;
  /** @nullable */
  fileName?: string | null;
  /** @nullable */
  fileSize?: string | null;
  /** @nullable */
  kycVersion?: number | null;
}

export interface LastUserReviewResponse {
  /** @nullable */
  acknowledgedAt?: number | null;
  /** @nullable */
  comment?: string | null;
  /** @nullable */
  pending?: string | null;
  /** @nullable */
  readyToReviewAt?: string | null;
  /** @nullable */
  requestedForApprovalComplianceTier?: string | null;
  requestId?: string;
  requestType?: UserReviewRequestType;
  statusType?: UserReviewStatusType;
  /** @nullable */
  uploads?: LastUserReviewDocument[] | null;
}

export interface KycQrCodeResponse {
  alreadySent?: boolean;
  expiration?: number;
  /** @nullable */
  link?: string | null;
  /** @nullable */
  qrcode?: string | null;
}

/**
 * @nullable
 */
export type KycErrorResponseErrorDetails = { [key: string]: boolean } | null;

export interface KycErrorResponse {
  errorCode?: number;
  /** @nullable */
  errorDetails?: KycErrorResponseErrorDetails;
  /** @nullable */
  errorMessage?: string | null;
}

export interface JoinCampaignResponse {
  alreadyJoined?: boolean;
  campaignId?: string;
  /** @nullable */
  cardPreference?: string | null;
  entryWeight?: number;
  isQualified?: boolean;
  joinedAt?: string;
  participantId?: string;
}

export interface JoinCampaignRequest {
  /** @nullable */
  acceptedLegalTerms?: boolean | null;
  /** @nullable */
  cardPreference?: string | null;
  /** @nullable */
  marketingChannel?: string | null;
}

export interface IsWithdrawalAllowedResponse {
  withdrawalAllowanceStatus?: WithdrawalAllowanceStatusType;
}

export interface Int32Response {
  data?: number;
}

/**
 * @nullable
 */
export type InfoResponsePairs = { [key: string]: MarketInfo } | null;

export interface InfoResponse {
  /** @nullable */
  pairs?: InfoResponsePairs;
  serverTime?: number;
}

export interface GetUserSettingResponse {
  /** @nullable */
  currentCurrency?: string | null;
  /** @nullable */
  currentMarketType?: string | null;
  /** @nullable */
  readonly favoriteMarkets?: readonly string[] | null;
  /** @nullable */
  notificationLanguage?: string | null;
  /** @nullable */
  notificationPreferences?: string | null;
  /** @nullable */
  presets?: string | null;
}

export interface GetUserSettingResponseResponse {
  data?: GetUserSettingResponse;
}

export interface GetSignedAssetsContractsResponse {
  /** @nullable */
  assets?: SignedAssetContractsResponseItem[] | null;
}

export interface GetRampingAssetsResponse {
  /** @nullable */
  sourceAssets?: RampingAssetData[] | null;
  /** @nullable */
  targetAssets?: RampingAssetData[] | null;
}

export interface GetQuoteResponse {
  expectedLastMatchPrice?: number;
  fee?: number;
  /** @nullable */
  feeAsset?: string | null;
  fillableAmount?: number;
  /** @nullable */
  totalEstimateOnQuoteAsset?: string | null;
  volumeWeightedPrice?: number;
}

export interface GetLatestByAssetIdResponse {
  /** @nullable */
  assetId?: string | null;
  /** @nullable */
  content?: string | null;
  createdAt?: number;
  /** @nullable */
  format?: string | null;
  /** @nullable */
  id?: string | null;
  /** @nullable */
  structuredContent?: string | null;
  version?: number;
}

export interface GetCountriesResponse {
  /** @nullable */
  countries?: CountryData[] | null;
  userResidencyCountry?: CountryData;
}

export interface GetAssetsContractsResponse {
  /** @nullable */
  assets?: AssetContractsResponseItem[] | null;
}

export interface FormAResponse {
  /** @nullable */
  address?: string | null;
  /** @nullable */
  addressEnglish?: string | null;
  /** @nullable */
  category?: string | null;
  /** @nullable */
  contractingPartner?: string | null;
  /** @nullable */
  corePassId?: string | null;
  /** @nullable */
  dateOfBirth?: string | null;
  expirationTime?: number;
  /** @nullable */
  fullName?: string | null;
  /** @nullable */
  fullNameEnglish?: string | null;
  /** @nullable */
  link?: string | null;
  /** @nullable */
  nationality?: string | null;
}

export type FoCctpTransferStatus = (typeof FoCctpTransferStatus)[keyof typeof FoCctpTransferStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FoCctpTransferStatus = {
  Processing: 'Processing',
  Completed: 'Completed',
  Failed: 'Failed',
} as const;

export interface FoCctpTransferApiResponse {
  amount?: number;
  /** @nullable */
  assetId?: string | null;
  createdAt?: string;
  /** @nullable */
  destinationPaymentSystem?: string | null;
  /** @nullable */
  errorMessage?: string | null;
  id?: string;
  /** @nullable */
  sourcePaymentSystem?: string | null;
  status?: FoCctpTransferStatus;
  updatedAt?: string;
  walletStatus?: CctpTransferStatus;
  walletTransferId?: string;
}

export interface FeeResponse {
  fee?: number;
  /** @nullable */
  feeAsset?: string | null;
}

/**
 * @nullable
 */
export type ErrorData = { [key: string]: unknown } | null;

export interface Error {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  data?: ErrorData;
  /** @nullable */
  key?: string | null;
  /** @nullable */
  message?: string | null;
}

export interface EligibleEmailRequest {
  amount?: number;
  /** @nullable */
  email?: string | null;
}

export type DocumentTypeRpc = (typeof DocumentTypeRpc)[keyof typeof DocumentTypeRpc];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DocumentTypeRpc = {
  Passport: 'Passport',
  IdCard: 'IdCard',
  DriverLicense: 'DriverLicense',
  ResidencePermit: 'ResidencePermit',
  Address: 'Address',
  FormA: 'FormA',
  FaceImage: 'FaceImage',
  ProofOfFunds: 'ProofOfFunds',
  AdditionalImage: 'AdditionalImage',
  WalletVerification: 'WalletVerification',
  AssetContract: 'AssetContract',
  ComplianceManualTransitionEvidence: 'ComplianceManualTransitionEvidence',
} as const;

/**
 * Information about processed funds deposit request.
 */
export interface DepositFundsResponse {
  /** @nullable */
  address?: string | null;
  /** @nullable */
  asset?: string | null;
  /** @nullable */
  paymentSystem?: string | null;
  /** @nullable */
  qrUrl?: string | null;
}

export interface DepositFundsRequest {
  /** @nullable */
  amount?: number | null;
  /** @nullable */
  assetId?: string | null;
  /** @nullable */
  fiatPaymentMethod?: string | null;
  /** @nullable */
  paymentSystem?: string | null;
  /** @nullable */
  readonly paymentSystems?: readonly PaymentSystemInfo[] | null;
}

/**
 * Delete request
 */
export interface DeleteEligibleEmailRequest {
  /**
   * Email address of the eligibility to delete
   * @nullable
   */
  email?: string | null;
}

export interface DeleteAddressBookRequest {
  /**
   * Core ID of the owner of the wallet address
   * @minLength 0
   * @maxLength 64
   * @pattern ^[a-zA-Z0-9-.\s]*$
   */
  coreId: string;
  /**
   * The wallet address that need to be deleted
   * @minLength 0
   * @maxLength 128
   * @pattern ^[a-zA-Z0-9-.\s]*$
   */
  walletAddress: string;
}

export interface CreateUserReviewRequest {
  type?: UserReviewRequestType;
}

export interface CreateUserApiKeyResponse {
  /** @nullable */
  apiKey?: string | null;
  /** @nullable */
  apiSecret?: string | null;
  /** @nullable */
  displayName?: string | null;
  /** @nullable */
  expiresAt?: string | null;
}

export interface CreateUserApiKeyRequest {
  /**
   * @minLength 0
   * @maxLength 255
   * @pattern ^[a-zA-Z0-9]*$
   */
  displayName: string;
  /** @nullable */
  expiresAt?: string | null;
}

export interface CreateRampingOrderRequest {
  amount: number;
  /** @minLength 1 */
  countryCode: string;
  paymentMethod: PaymentMethod;
  provider: RampingProvider;
  side: RampOrderSide;
  sourceAsset: AssetFilter;
  targetAsset: AssetFilter;
}

export interface CreatePaymentRequestResponse {
  /** @nullable */
  address?: string | null;
  /** @nullable */
  amount?: number | null;
  /** @nullable */
  availableCryptoCurrencies?: AvailablePaymentCryptoCurrencyResponse[] | null;
  /** @nullable */
  blockchainNetwork?: string | null;
  /** @nullable */
  clientPaymentId?: string | null;
  createdAt?: string;
  /** @nullable */
  cryptoCurrency?: string | null;
  /** @nullable */
  deadline?: string | null;
  /** @nullable */
  digitize?: boolean | null;
  /** @nullable */
  donate?: boolean | null;
  /** @nullable */
  fiat?: string | null;
  /** @nullable */
  item?: string | null;
  /** @nullable */
  itemPhotoUrl?: string | null;
  /** @nullable */
  merchantPhotoUrl?: string | null;
  minimumPayerPaymentAmount?: number;
  /** @nullable */
  organization?: string | null;
  /** @nullable */
  organizationIsVerified?: boolean | null;
  paymentRequestId?: string;
  /** @nullable */
  recurringPattern?: string | null;
  /**
   * Human-readable recurring schedule for display (e.g. "Repeats automatically every month.").
   * @nullable
   */
  recurringPaymentDescription?: string | null;
  /** @nullable */
  referralCode?: string | null;
  /** @nullable */
  resolvedCurrencyConfirmedByUser?: boolean | null;
  /** @nullable */
  swap?: string | null;
}

export interface CreateOrderResponse {
  exchangeSignatureRequired?: boolean;
  /** @nullable */
  redirectUrl?: string | null;
}

export interface CreateAddressBookRequest {
  /**
   * @minLength 0
   * @maxLength 32
   * @nullable
   * @pattern ^([\p{L}\p{N}\s-/])*$
   */
  label?: string | null;
  /**
   * @minLength 0
   * @maxLength 32
   * @pattern ^([\p{L}\p{N}\s-/])*$
   */
  paymentSystem: string;
  /**
   * @minLength 0
   * @maxLength 64
   * @pattern ^[a-zA-Z0-9]{26,64}$
   */
  walletAddress: string;
}

export interface CountryData {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  currency?: string | null;
  /** @nullable */
  name?: string | null;
}

export type CorePassDocumentType = (typeof CorePassDocumentType)[keyof typeof CorePassDocumentType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CorePassDocumentType = {
  Passport: 'Passport',
  IdCard: 'IdCard',
  DriverLicense: 'DriverLicense',
  ResidencePermit: 'ResidencePermit',
  Address: 'Address',
  FormA: 'FormA',
  FaceImage: 'FaceImage',
  ProofOfFunds: 'ProofOfFunds',
  AdditionalImage: 'AdditionalImage',
  WalletVerification: 'WalletVerification',
  AssetContract: 'AssetContract',
} as const;

export interface ContactFiatRecord {
  /** @nullable */
  accountName?: string | null;
  /** @nullable */
  accountSurname?: string | null;
  /** @nullable */
  bankAddressLine?: string | null;
  /** @nullable */
  bankAddressLineOption?: string | null;
  /** @nullable */
  bankCountry?: string | null;
  /** @nullable */
  bankName?: string | null;
  /** @nullable */
  country?: string | null;
  dateCreated?: string;
  /** @nullable */
  email?: string | null;
  /** @nullable */
  iban?: string | null;
  id?: string;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  personalAddress?: string | null;
  /** @nullable */
  personalAddressOptional?: string | null;
  /** @nullable */
  phoneNumber?: string | null;
  /** @nullable */
  swift?: string | null;
}

export interface ContactFiatData {
  /**
   * @nullable
   * @pattern ^[a-zA-Z0-9]*$
   */
  accountName?: string | null;
  /**
   * @nullable
   * @pattern ^[a-zA-Z0-9]*$
   */
  accountSurname?: string | null;
  /**
   * @nullable
   * @pattern ^[a-zA-Z0-9]*$
   */
  bankAddressLine?: string | null;
  /**
   * @nullable
   * @pattern ^[a-zA-Z0-9]*$
   */
  bankAddressLineOption?: string | null;
  /**
   * @nullable
   * @pattern ^[a-zA-Z0-9]*$
   */
  bankCountry?: string | null;
  /**
   * @nullable
   * @pattern ^[a-zA-Z0-9]*$
   */
  bankName?: string | null;
  /**
   * @nullable
   * @pattern ^[a-zA-Z0-9]*$
   */
  country?: string | null;
  dateCreated?: string;
  /** @nullable */
  email?: string | null;
  /**
   * @nullable
   * @pattern ^[a-zA-Z0-9]*$
   */
  iban?: string | null;
  id?: string;
  /**
   * @nullable
   * @pattern ^[a-zA-Z0-9]*$
   */
  name?: string | null;
  /**
   * @nullable
   * @pattern ^[a-zA-Z0-9]*$
   */
  personalAddress?: string | null;
  /**
   * @nullable
   * @pattern ^[a-zA-Z0-9]*$
   */
  personalAddressOptional?: string | null;
  /**
   * @nullable
   * @pattern ^[a-zA-Z0-9]*$
   */
  phoneNumber?: string | null;
  /**
   * @nullable
   * @pattern ^[a-zA-Z0-9]*$
   */
  swift?: string | null;
}

export type ComplianceStepType = (typeof ComplianceStepType)[keyof typeof ComplianceStepType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ComplianceStepType = {
  NoData: 'NoData',
  EntityTypeDeclaration: 'EntityTypeDeclaration',
  KycRequest: 'KycRequest',
  FormA: 'FormA',
  PrimaryUse: 'PrimaryUse',
  PrimarySource: 'PrimarySource',
  EmploymentStatus: 'EmploymentStatus',
  TotalValue: 'TotalValue',
  Industry: 'Industry',
  SourceOfFunds: 'SourceOfFunds',
  Trading: 'Trading',
  PendingForReview: 'PendingForReview',
  Forbidden: 'Forbidden',
} as const;

export interface CommodityAsset {
  blockchain_metadata?: BlockchainMetaData;
  commodity_category?: ApiCommodityCategory;
  commodity_type?: ApiCommodityType;
  /** @nullable */
  readonly days_until_expiration?: number | null;
  /** @nullable */
  days_until_near_expiration?: number | null;
  /** @nullable */
  expiration_date?: string | null;
  readonly is_expired?: boolean;
  readonly is_near_expiration?: boolean;
  /** @nullable */
  last_trading_day?: string | null;
}

/**
 * Claiming rewards request sent by the user indicating which reard they want to claim
 */
export interface ClaimRewardRequest {
  /** Reward Id */
  rewardId: string;
}

export type CctpTransferStatus = (typeof CctpTransferStatus)[keyof typeof CctpTransferStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CctpTransferStatus = {
  Pending: 'Pending',
  Burning: 'Burning',
  BurnConfirmed: 'BurnConfirmed',
  AttestationPending: 'AttestationPending',
  AttestationReady: 'AttestationReady',
  Minting: 'Minting',
  MintConfirmed: 'MintConfirmed',
  Completed: 'Completed',
  Failed: 'Failed',
} as const;

export interface CctpTransferRequest {
  amount: number;
  /** @minLength 1 */
  assetId: string;
  /** @minLength 1 */
  destinationPaymentSystem: string;
  /** @minLength 1 */
  sourcePaymentSystem: string;
}

export interface CctpRouteApiResponse {
  /** @nullable */
  destinationPaymentSystem?: string | null;
  /** @nullable */
  maxTransferAmount?: number | null;
  minTransferAmount?: number;
  platformFee?: number;
  /** @nullable */
  sourcePaymentSystem?: string | null;
}

export interface CampaignWinnersResponse {
  campaignId?: string;
  /** @nullable */
  winners?: CampaignPrizeWinnerSummaryResponse[] | null;
}

export interface CampaignSummaryResponse {
  /** @nullable */
  description?: string | null;
  entryEndsAt?: string;
  entryStartsAt?: string;
  id?: string;
  participantCount?: number;
  qualifiedParticipantCount?: number;
  /** @nullable */
  slug?: string | null;
  status?: number;
  /** @nullable */
  title?: string | null;
}

export interface CampaignPrizeWinnerSummaryResponse {
  prizeAmount?: number;
  /** @nullable */
  prizeCurrency?: string | null;
  prizeId?: string;
  /** @nullable */
  prizeName?: string | null;
  tierOrder?: number;
  /** @nullable */
  winnerCoreIds?: string[] | null;
  winnerCount?: number;
}

export interface CampaignPrizeResponse {
  amount?: number;
  /** @nullable */
  currency?: string | null;
  id?: string;
  quantity?: number;
  /** @nullable */
  tierName?: string | null;
  tierOrder?: number;
}

export interface CampaignParticipationResponse {
  /** @nullable */
  cardPreference?: string | null;
  /** @nullable */
  entryWeight?: number | null;
  hasJoined?: boolean;
  /** @nullable */
  isQualified?: boolean | null;
  isWinner?: boolean;
  /** @nullable */
  joinedAt?: string | null;
  /** @nullable */
  prizeId?: string | null;
  /** @nullable */
  qualifiedAt?: string | null;
}

export interface CampaignParticipantActivityEventResponse {
  /** @nullable */
  actorType?: string | null;
  campaignId?: string;
  /** @nullable */
  eventType?: string | null;
  id?: string;
  occurredAt?: string;
  participantId?: string;
  /** @nullable */
  payloadJson?: string | null;
}

export interface CampaignMyResultResponse {
  campaignId?: string;
  campaignStatus?: number;
  /** @nullable */
  cardPreference?: string | null;
  entryWeight?: number;
  hasJoined?: boolean;
  isQualified?: boolean;
  isWinner?: boolean;
  joinedAt?: string;
  /** @nullable */
  prizeId?: string | null;
  wonPrize?: CampaignPrizeResponse;
}

export interface CampaignMyParticipationResponse {
  campaignId?: string;
  /** @nullable */
  campaignSlug?: string | null;
  /** @nullable */
  campaignStatus?: number | null;
  /** @nullable */
  campaignTitle?: string | null;
  /** @nullable */
  disqualificationComment?: string | null;
  /** @nullable */
  fulfillmentStatus?: string | null;
  isQualified?: boolean;
  isWinner?: boolean;
  joinedAt?: string;
  participantId?: string;
  /** @nullable */
  prizeId?: string | null;
  /** @nullable */
  qualifiedAt?: string | null;
  /** @nullable */
  winnerStatus?: string | null;
}

export interface CampaignMyActivityResponse {
  campaignId?: string;
  /** @nullable */
  events?: CampaignParticipantActivityEventResponse[] | null;
  participantId?: string;
}

export interface CampaignLegalDocumentsResponse {
  /** @nullable */
  contentFormat?: string | null;
  /** @nullable */
  privacyPolicy?: string | null;
  privacyRequireAcknowledgement?: boolean;
  requireAcknowledgement?: boolean;
  /** @nullable */
  termsAndConditions?: string | null;
  termsRequireAcknowledgement?: boolean;
}

export interface CampaignEmbeddedVideoResponse {
  /** @nullable */
  embedUrl?: string | null;
  /** @nullable */
  provider?: string | null;
  /** @nullable */
  title?: string | null;
}

export interface CampaignDetailResponse {
  /** @nullable */
  description?: string | null;
  /** @nullable */
  drawScheduledAt?: string | null;
  drawType?: number;
  /** @nullable */
  embeddedVideos?: CampaignEmbeddedVideoResponse[] | null;
  entryEndsAt?: string;
  entryStartsAt?: string;
  id?: string;
  legalDocuments?: CampaignLegalDocumentsResponse;
  participantCount?: number;
  participation?: CampaignParticipationResponse;
  /** @nullable */
  prizes?: CampaignPrizeResponse[] | null;
  qualifiedParticipantCount?: number;
  /** @nullable */
  rulesConfig?: string | null;
  showWinnerCoreIdPartiallyUnmasked?: boolean;
  /** @nullable */
  slug?: string | null;
  status?: number;
  /** @nullable */
  title?: string | null;
  /** @nullable */
  winnerCoreIdPartialMaskFormat?: string | null;
}

export interface CampaignConfigResponse {
  competitionsEnabled?: boolean;
  hasVisibleCompetitions?: boolean;
}

export interface BuildInfoResponse {
  /** @nullable */
  buildBranch?: string | null;
  /** @nullable */
  buildCommitHash?: string | null;
  /** @nullable */
  buildDate?: string | null;
}

export type BlockchainNetwork = (typeof BlockchainNetwork)[keyof typeof BlockchainNetwork];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BlockchainNetwork = {
  Bitcoin: 'Bitcoin',
  Litecoin: 'Litecoin',
  Ethereum: 'Ethereum',
  CoreBlockchain: 'CoreBlockchain',
  BinanceSmartChain: 'BinanceSmartChain',
  Polygon: 'Polygon',
  Solana: 'Solana',
} as const;

export interface BlockchainNetworkData {
  code?: BlockchainNetwork;
  /** @nullable */
  name?: string | null;
}

export interface AvailablePaymentCryptoCurrencyResponse {
  /** @nullable */
  blockchainNetwork?: string | null;
  /** @nullable */
  cryptoCurrency?: string | null;
}

export interface AssetResponse {
  /** @nullable */
  asset_name?: string | null;
  /** @nullable */
  blockchain_configs?: BlockchainConfig[] | null;
  commodity_asset?: CommodityAsset;
  contract_signature_required?: boolean;
  created_at?: string;
  /** @nullable */
  icon_url?: string | null;
  /** @nullable */
  id?: string | null;
  /** @nullable */
  scale?: number | null;
  type?: ApiAssetType;
  /** @nullable */
  website_url?: string | null;
  /** @nullable */
  withdrawal_fee_asset_id?: string | null;
}

export interface AssetResponseListResponse {
  /** @nullable */
  data?: AssetResponse[] | null;
}

export interface AssetFilter {
  blockchainNetwork?: BlockchainNetwork;
  /** @minLength 1 */
  symbol: string;
}

export interface AssetContractsResponseItem {
  /** @nullable */
  assetId?: string | null;
  /** @nullable */
  assetName?: string | null;
  contractVersion?: number;
  isSigned?: boolean;
  /** @nullable */
  signedAt?: string | null;
  /** @nullable */
  signedDocumentId?: string | null;
}

export interface AssetContractSignatureRequest {
  /** @minLength 1 */
  assetId: string;
}

/**
 * Market type reported in APIs. Corresponds to Ping.DataContracts.BackOffice.MarketType
 */
export type ApiMarketType = (typeof ApiMarketType)[keyof typeof ApiMarketType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApiMarketType = {
  InvalidMarketType: 'InvalidMarketType',
  Cryptocurrency: 'Cryptocurrency',
  Commodity: 'Commodity',
  Stock: 'Stock',
  Forex: 'Forex',
} as const;

/**
 * Market status reported in APIs. Corresponds to MyExchange.Common.Data.MarketStatus
 */
export type ApiMarketStatus = (typeof ApiMarketStatus)[keyof typeof ApiMarketStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApiMarketStatus = {
  Open: 'Open',
  Halted: 'Halted',
  Paused: 'Paused',
} as const;

/**
 * Commodity type reported in APIs. Corresponds to Ping.DataContracts.BackOffice.CommodityType
 */
export type ApiCommodityType = (typeof ApiCommodityType)[keyof typeof ApiCommodityType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApiCommodityType = {
  NonFractionalNFT: 'NonFractionalNFT',
  FractionalNFT: 'FractionalNFT',
  FT: 'FT',
} as const;

export type ApiCommodityCategory = (typeof ApiCommodityCategory)[keyof typeof ApiCommodityCategory];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApiCommodityCategory = {
  Energy: 'Energy',
  PreciousMetals: 'PreciousMetals',
  BaseMetals: 'BaseMetals',
  Agriculture: 'Agriculture',
  Livestock: 'Livestock',
  SoftCommodities: 'SoftCommodities',
  Technology: 'Technology',
  RealEstate: 'RealEstate',
  Collectibles: 'Collectibles',
  PatentsAndInnovation: 'PatentsAndInnovation',
  Music: 'Music',
  Entertainment: 'Entertainment',
  ArtAndCreativeWorks: 'ArtAndCreativeWorks',
} as const;

/**
 * Asset type reported in APIs. Corresponds to Ping.DataContracts.BackOffice.AssetType
 */
export type ApiAssetType = (typeof ApiAssetType)[keyof typeof ApiAssetType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApiAssetType = {
  Crypto: 'Crypto',
  Fiat: 'Fiat',
  Commodity: 'Commodity',
  Stock: 'Stock',
  Forex: 'Forex',
} as const;

export type AnnouncementType = (typeof AnnouncementType)[keyof typeof AnnouncementType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AnnouncementType = {
  Banner: 'Banner',
  Modal: 'Modal',
  Board: 'Board',
} as const;

/**
 * Represents an announcement.
 */
export interface AnnouncementResponse {
  /** The time when the announcement was created. */
  createdAt?: string;
  /**
   * The description of the announcement.
   * @nullable
   */
  description?: string | null;
  /** The time when the announcement expires. */
  expiresAt?: string;
  /**
   * The link of the announcement.
   * @nullable
   */
  link?: string | null;
  /** The time when the announcement is released. */
  releasesAt?: string;
  /**
   * The title of the announcement.
   * @nullable
   */
  title?: string | null;
  type?: AnnouncementType;
}

export interface AddressBookListItemDto {
  dateCreated?: string;
  id?: string;
  isPrimary?: boolean;
  isVerified?: boolean;
  /** @nullable */
  label?: string | null;
  /** @nullable */
  network?: string | null;
  /** @nullable */
  type?: string | null;
  /** @nullable */
  walletAddress?: string | null;
}

export interface AddressBookListResponse {
  /** @nullable */
  active?: AddressBookListItemDto[] | null;
  /** @nullable */
  invalid?: AddressBookListItemDto[] | null;
}

export interface AddDocumentResponse {
  documentFileId?: string;
  /** @nullable */
  fileName?: string | null;
  /** @nullable */
  readonly fileSize?: string | null;
  /** @nullable */
  hash?: string | null;
  size?: number;
}

export interface AcknowledgeRequest {
  requestId: string;
}

export interface AccountAssetResponse {
  /** @nullable */
  asset?: string | null;
  balance?: number;
}

export interface WithdrawalEconomicsResponse {
  /** @nullable */
  assetId?: string | null;
  /** @nullable */
  assetSymbol?: string | null;
  /** @nullable */
  assetType?: string | null;
  /** @nullable */
  chain?: string | null;
  gasCost?: number;
  isProfitable?: boolean;
  netWithdrawalProfit?: number;
  withdrawalFeeRevenue?: number;
  withdrawalMargin?: number;
}

export type WinnerCancellationReason = (typeof WinnerCancellationReason)[keyof typeof WinnerCancellationReason];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const WinnerCancellationReason = {
  AdminDecision: 'AdminDecision',
  BusinessStatusBlocked: 'BusinessStatusBlocked',
  BusinessStatusRestricted: 'BusinessStatusRestricted',
} as const;

export interface WalletTransactionRecoverRequest {
  paymentSystem: PaymentSystem;
  /** @pattern ^[a-zA-Z0-9]*$ */
  txId: string;
}

export interface UserTransferData {
  amount?: number;
  /** @nullable */
  asset?: string | null;
  /** @nullable */
  blockchainLink?: string | null;
  createdAt?: string;
  /** @nullable */
  errorCode?: string | null;
  /** @nullable */
  errorDetails?: string | null;
  status?: TransferStatus;
  transferReason?: TransferReasonType;
  /** @nullable */
  txId?: string | null;
  type?: TransferType;
  /** @nullable */
  userId?: string | null;
}

export type UserTierType = (typeof UserTierType)[keyof typeof UserTierType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserTierType = {
  Basic: 'Basic',
  Premium: 'Premium',
  PremiumForced: 'PremiumForced',
} as const;

export type UserState = (typeof UserState)[keyof typeof UserState];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserState = {
  NoRisk: 'NoRisk',
  HighRisk: 'HighRisk',
} as const;

export type UserReviewStatusType = (typeof UserReviewStatusType)[keyof typeof UserReviewStatusType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserReviewStatusType = {
  Open: 'Open',
  PendingForReview: 'PendingForReview',
  Approved: 'Approved',
  Denied: 'Denied',
  Cancelled: 'Cancelled',
  RequestedMoreData: 'RequestedMoreData',
} as const;

export interface UserReviewResolveRequest {
  /**
   * @minLength 0
   * @maxLength 1500
   * @nullable
   */
  comment?: string | null;
  resolve: ResolveComplienceRequestStatusType;
  userId: string;
}

export type UserReviewRequestType = (typeof UserReviewRequestType)[keyof typeof UserReviewRequestType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserReviewRequestType = {
  HighRiskToTier2: 'HighRiskToTier2',
  Tier1ToTier2: 'Tier1ToTier2',
  Tier1ToTier3: 'Tier1ToTier3',
  Tier2ToTier3: 'Tier2ToTier3',
  SuspiciousToTier1: 'SuspiciousToTier1',
  Downgrade: 'Downgrade',
  DocumentRequisition: 'DocumentRequisition',
} as const;

export interface UserResponse {
  /** @nullable */
  accounts?: BasicAccountInfo[] | null;
  /** @nullable */
  corePassId?: string | null;
  /** @nullable */
  createdAt?: string | null;
  /** @nullable */
  email?: string | null;
  /** @nullable */
  id?: string | null;
  isActive?: boolean;
  isEmailConfirmed?: boolean;
  isPhoneConfirmed?: boolean;
  isPioneer?: boolean;
  isTierExpired?: boolean;
  /** @nullable */
  lastSignInDate?: string | null;
  /** @nullable */
  nickname?: string | null;
  /** @nullable */
  registrationDate?: string | null;
  /** @nullable */
  roles?: string[] | null;
  status?: ActivityStatus;
  tier?: UserTierType;
  /** @nullable */
  tierExpiresAt?: string | null;
  verificationLevel?: number;
}

export interface UserResponseResponse {
  data?: UserResponse;
}

export interface UserPortfolioRequest {
  userId?: string;
}

export interface UserOrdersResponse {
  /** @nullable */
  cursor?: string | null;
  /** @nullable */
  data?: OrderItemData[] | null;
}

/**
 * @nullable
 */
export type UserItemResponseFilteredResponseFilters = unknown | null;

export interface UserItemResponse {
  availableBalance?: number;
  /** @nullable */
  corePassId?: string | null;
  /** @nullable */
  createdAt?: string | null;
  /** @nullable */
  email?: string | null;
  /** @nullable */
  id?: string | null;
  /** @nullable */
  kycError?: string | null;
  kycStatus?: KycStatus;
  /** @nullable */
  lastDepositAmount?: number | null;
  /** @nullable */
  lastDepositDate?: string | null;
  status?: ActivityStatus;
  totalBalance?: number;
  totalOnHoldBalance?: number;
  /** @nullable */
  tradeVolume?: number | null;
  /** @nullable */
  userName?: string | null;
}

export interface UserItemResponseFilteredResponse {
  /** @nullable */
  data?: UserItemResponse[] | null;
  /** @nullable */
  filters?: UserItemResponseFilteredResponseFilters;
  paging?: Paging;
}

export interface UserInfoResponse {
  /** @nullable */
  employmentStatus?: number | null;
  /** @nullable */
  entityType?: string | null;
  /** @nullable */
  formSignature?: string | null;
  /** @nullable */
  formSignatureDate?: string | null;
  /** @nullable */
  industry?: string | null;
  /** @nullable */
  primarySource?: number | null;
  /** @nullable */
  primaryUse?: number | null;
  /** @nullable */
  termsAccepted?: string | null;
  /** @nullable */
  totalValue?: number | null;
}

/**
 * Filters for users GET request
 */
export interface UserFilters {
  /** @nullable */
  fromLastDepositAmount?: number | null;
  /** @nullable */
  fromLastDepositDate?: string | null;
  /** @nullable */
  fromTradeVolume?: number | null;
  /**
   * A comma-separated list of expressions used to sort the items.
- For ascending sort use 'asc' suffix or nothing(default) like 'CreatedAt asc' or 'CreatedAt'.
- For descending sort use 'desc' suffix like 'CreatedAt desc'.
- Note: value is case insensitive
- Default: if nothing provided default ordering is by CreatedAt desc.
- Supported fields:
    - CorePassId
    - Email
    - Status
    - CreatedAt
   * @nullable
   */
  orderBy?: string | null;
  page?: number;
  perPage?: number;
  /**
   * User Name, user email search filter
   * @nullable
   */
  search?: string | null;
  status?: ActivityStatus;
  /** @nullable */
  toLastDepositAmount?: number | null;
  /** @nullable */
  toLastDepositDate?: string | null;
  /** @nullable */
  toTradeVolume?: number | null;
}

export interface UserDocument {
  /** @nullable */
  documentType?: string | null;
  /** @nullable */
  fileName?: string | null;
  /** @nullable */
  fileSize?: string | null;
  /** @nullable */
  id?: string | null;
  kycVersion?: number;
}

export type UserComplianceTierType = (typeof UserComplianceTierType)[keyof typeof UserComplianceTierType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserComplianceTierType = {
  Tier0: 'Tier0',
  Tier1: 'Tier1',
  Tier2: 'Tier2',
  Tier3: 'Tier3',
} as const;

export interface UserDetailsResponse {
  accountCreated?: string;
  addressBook?: AddressBookResponse;
  /** @nullable */
  addressNote?: string | null;
  amlCheck?: boolean;
  /** @nullable */
  amlData?: string | null;
  complianceRequestType?: UserReviewRequestType;
  complianceTier?: UserComplianceTierType;
  /** @nullable */
  coreId?: string | null;
  /** @nullable */
  documentNote?: string | null;
  /** @nullable */
  email?: string | null;
  /** @nullable */
  flagDetails?: FlagDetail[] | null;
  /** @nullable */
  fullName?: string | null;
  /** @nullable */
  fullNameEnglish?: string | null;
  /** @nullable */
  nationality?: string | null;
  /** @nullable */
  requestedForApprovalComplianceTier?: string | null;
  /**
   * RequestPendingTime is null when the user does not have any active requests
   * @nullable
   */
  requestPendingTime?: number | null;
  /** @nullable */
  residence?: string | null;
  status?: ActivityStatus;
  /**
   * Sum of the amount for the user's withdrawal transactions from the beginning of the current month.
   * @nullable
   */
  totalCurrentMonthWithdrawalAmount?: number | null;
  /**
   * Sum of the amount for the user's withdrawal transactions from the beginning of the current year
   * @nullable
   */
  totalCurrentYearWithdrawalAmount?: number | null;
  /**
   * The total monthly withdrawal limit for the user.
   * @nullable
   */
  totalMonthlyLimit?: number | null;
  /**
   * The total yearly withdrawal limit for the user.
   * @nullable
   */
  totalYearlyLimit?: number | null;
  userId?: string;
  userInfo?: UserInfoResponse;
  /** @nullable */
  userRequests?: ComplianceRequest[] | null;
  userStatus?: UserState;
}

export type UserComplianceTier = (typeof UserComplianceTier)[keyof typeof UserComplianceTier];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserComplianceTier = {
  Tier0: 'Tier0',
  Tier1: 'Tier1',
  Tier2: 'Tier2',
  Tier3: 'Tier3',
} as const;

export type UserComplianceRequestStatus =
  (typeof UserComplianceRequestStatus)[keyof typeof UserComplianceRequestStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserComplianceRequestStatus = {
  Pending: 'Pending',
  Completed: 'Completed',
} as const;

export interface UserBalanceCheckItem {
  /** @nullable */
  accounts?: AssetAccount[] | null;
  /** @nullable */
  corePassId?: string | null;
  /** @nullable */
  email?: string | null;
  /** @nullable */
  userId?: string | null;
}

export interface UserBalanceCheckResponse {
  total?: number;
  /** @nullable */
  users?: UserBalanceCheckItem[] | null;
}

export interface UpsertCctpRouteRequest {
  destinationDomainId: number;
  destinationPaymentSystem: string;
  enabled?: boolean;
  /** @nullable */
  maxTransferAmount?: number | null;
  messageTransmitterAddress: string;
  minTransferAmount: number;
  platformFee: number;
  sourceDomainId: number;
  sourcePaymentSystem: string;
  tokenMessengerAddress: string;
}

export interface UpdateUsersRequest {
  activityStatus: ActivityStatus;
  usersIds: string[];
}

export interface UpdateUserRequest {
  status?: ActivityStatus;
  /** @nullable */
  tradeLimit?: number | null;
  userId?: string;
}

export interface UpdateTreasuryRebalancePolicyRequest {
  approvalThreshold?: number;
  cooldownMinutes?: number;
  globalDailyCap?: number;
  maxSingleTransfer?: number;
  minTransferAmount?: number;
  suggestionIntervalMinutes?: number;
  withdrawalLiquidityHintsEnabled?: boolean;
}

/**
 * @nullable
 */
export type UpdateTreasuryNotificationPreferencesRequestRecipientEmails = { [key: string]: string } | null;

export interface UpdateTreasuryNotificationPreferencesRequest {
  emailEnabled?: boolean;
  /** @nullable */
  enabledAlerts?: string[] | null;
  /** @nullable */
  enabledReports?: string[] | null;
  /** @nullable */
  recipientEmails?: UpdateTreasuryNotificationPreferencesRequestRecipientEmails;
  /** @nullable */
  selectedRecipientCorePassIds?: string[] | null;
  webSocketEnabled?: boolean;
}

export interface UpdateTreasuryChainPolicyRequest {
  autoExecuteLimit?: number;
  dailyAutoExecuteCap?: number;
  demandWeight?: number;
  enabled?: boolean;
  maxHotBalance?: number;
  minHotBalance?: number;
  netFlowWindowHours?: number;
  paused?: boolean;
  targetHotBalance?: number;
}

/**
 * @nullable
 */
export type UpdateRevenueNotificationPreferencesRequestRecipientEmails = { [key: string]: string } | null;

export interface UpdateRevenueNotificationPreferencesRequest {
  emailEnabled?: boolean;
  /** @nullable */
  enabledAlerts?: string[] | null;
  /** @nullable */
  enabledReports?: string[] | null;
  /** @nullable */
  recipientEmails?: UpdateRevenueNotificationPreferencesRequestRecipientEmails;
  /** @nullable */
  selectedRecipientCorePassIds?: string[] | null;
  webSocketEnabled?: boolean;
}

export interface UpdateMarketRequest {
  /** @nullable */
  allowMarketOrder?: boolean | null;
  /** @nullable */
  amountScale?: number | null;
  /** @nullable */
  baseFee?: number | null;
  /** @nullable */
  hidden?: boolean | null;
  /** @nullable */
  isFixedRatio?: boolean | null;
  /** @nullable */
  isStable?: boolean | null;
  /** @nullable */
  makerFee?: number | null;
  /** @nullable */
  makerFeeLimit?: number | null;
  /** @nullable */
  maxPriceDeviationPercent?: number | null;
  /** @nullable */
  maxSellPriceVariationPercent?: number | null;
  /** @nullable */
  minAmount?: number | null;
  /** @nullable */
  minBuyPriceVariationPercent?: number | null;
  /** @nullable */
  preventMarketMakersMatch?: boolean | null;
  /** @nullable */
  priceScale?: number | null;
  /** @nullable */
  quoteFee?: number | null;
  status?: MarketStatus;
  /** @nullable */
  takerFee?: number | null;
  /** @nullable */
  takerFeeLimit?: number | null;
  visibility?: MarketVisibility;
}

export interface UpdateMarketingChannelRequest {
  code: string;
  label: string;
}

export interface UpdateCampaignEmbeddedVideosRequest {
  /** @nullable */
  embeddedVideos?: string | null;
}

export interface UpdateAppConfigRequest {
  /**
   * @minLength 1
   * @maxLength 256
   */
  key: string;
  value: string;
}

export interface UnblockUserApiRequest {
  userId?: string;
}

export interface TreasuryWithdrawalTrendChainValueResponse {
  /** @nullable */
  paymentSystem?: string | null;
  /** @nullable */
  shortName?: string | null;
  value?: number;
}

export interface TreasuryWithdrawalTrendPointResponse {
  /** @nullable */
  chains?: TreasuryWithdrawalTrendChainValueResponse[] | null;
  /** @nullable */
  label?: string | null;
  timestamp?: number;
}

export interface TreasuryWithdrawalTrendBucketChainResponse {
  count?: number;
  /** @nullable */
  paymentSystem?: string | null;
  volumeUsdc?: number;
}

export interface TreasuryWithdrawalTrendBucketResponse {
  bucketStart?: string;
  /** @nullable */
  chains?: TreasuryWithdrawalTrendBucketChainResponse[] | null;
  /** @nullable */
  label?: string | null;
}

export interface TreasuryWithdrawalPredictionPointResponse {
  actual?: number;
  /** @nullable */
  label?: string | null;
  predicted?: number;
}

export interface TreasuryWithdrawalLiquidityHintResponse {
  /** @nullable */
  alternativePaymentSystem?: string | null;
  /** @nullable */
  alternativePaymentSystemMessage?: string | null;
  enabled?: boolean;
  /** @nullable */
  estimatedLiquidityMinutes?: number | null;
  inFlightCctpInboundUsdc?: number;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  paymentSystem?: string | null;
  pendingWithdrawalsUsdc?: number;
  /** @nullable */
  status?: string | null;
  withdrawalCoverageGap?: number;
}

export interface TreasuryWithdrawalHistorySummaryResponse {
  averageDailyVolumeUsdc?: number;
  averageWithdrawalUsdc?: number;
  completedWithdrawalCount?: number;
  maxSingleWithdrawalUsdc?: number;
  p95DailyVolumeUsdc?: number;
  p95HourlyVolumeUsdc?: number;
  /** @nullable */
  paymentSystem?: string | null;
  totalVolumeUsdc?: number;
  volumeSharePercent?: number;
  withdrawalsPerDay?: number;
}

export interface TreasuryWithdrawalChainMetricsResponse {
  averageDailyVolumeUsdc?: number;
  completedWithdrawalCount?: number;
  p95DailyVolumeUsdc?: number;
  p95HourlyVolumeUsdc?: number;
  volumeSharePercent?: number;
  withdrawalsPerDay?: number;
}

export interface TreasuryUtilizationChainResponse {
  hot?: number;
  maxHot?: number;
  /** @nullable */
  paymentSystem?: string | null;
  percent?: number;
  /** @nullable */
  shortName?: string | null;
}

export interface TreasuryUtilizationMetricsResponse {
  /** @nullable */
  chains?: TreasuryUtilizationChainResponse[] | null;
  overallPercent?: number;
}

/**
 * @nullable
 */
export type TreasurySuggestionResponseFilteredResponseFilters = unknown | null;

export interface TreasurySuggestionResponse {
  amount?: number;
  createdAt?: string;
  /** @nullable */
  decisionType?: string | null;
  /** @nullable */
  demandSnapshot?: string | null;
  /** @nullable */
  destinationPaymentSystem?: string | null;
  /** @nullable */
  expiresAt?: string | null;
  id?: string;
  /** @nullable */
  policySnapshot?: string | null;
  /** @nullable */
  reasoning?: string | null;
  /** @nullable */
  sourcePaymentSystem?: string | null;
  /** @nullable */
  status?: string | null;
}

export interface TreasurySuggestionResponseFilteredResponse {
  /** @nullable */
  data?: TreasurySuggestionResponse[] | null;
  /** @nullable */
  filters?: TreasurySuggestionResponseFilteredResponseFilters;
  paging?: Paging;
}

export interface TreasurySnapshotResponse {
  /** @nullable */
  assetId?: string | null;
  capturedAt?: string;
  /** @nullable */
  chains?: TreasuryChainSnapshotResponse[] | null;
  /** @nullable */
  totalColdUsdc?: number | null;
  /** @nullable */
  totalHotUsdc?: number | null;
  totalInFlightCctpUsdc?: number;
  totalPendingColdReplenishmentUsdc?: number;
  /** @nullable */
  totalPendingWithdrawalsUsdc?: number | null;
}

export interface TreasurySetupRiskResponse {
  /** @nullable */
  description?: string | null;
  /** @nullable */
  paymentSystem?: string | null;
  /** @nullable */
  severity?: string | null;
  /** @nullable */
  title?: string | null;
}

export interface TreasurySetupAssumptionsResponse {
  autoExecuteTargetShare?: number;
  maxHotTargetMultiplier?: number;
  minHotHourlyBurnMultiplier?: number;
  minimumSampleWithdrawals?: number;
  minOperationalFloorUsdc?: number;
  netFlowWindowHours?: number;
  /** @nullable */
  notes?: string[] | null;
  targetDailyVolumeShare?: number;
}

export interface TreasurySetupRecommendationsResponse {
  analysisDays?: number;
  analysisEnd?: string;
  analysisStart?: string;
  assumptions?: TreasurySetupAssumptionsResponse;
  /** @nullable */
  calculationSummary?: string | null;
  /** @nullable */
  chainRecommendations?: TreasuryChainSetupRecommendationResponse[] | null;
  generatedAt?: string;
  hasSufficientHistoricalData?: boolean;
  /** @nullable */
  historicalSummary?: TreasuryWithdrawalHistorySummaryResponse[] | null;
  /** @nullable */
  peakPeriods?: TreasuryPeakDemandPeriodResponse[] | null;
  pendingQueue?: TreasuryPendingQueueAnalysisResponse;
  /** @nullable */
  risks?: TreasurySetupRiskResponse[] | null;
  /** @nullable */
  volumeTrend?: TreasuryWithdrawalTrendBucketResponse[] | null;
}

export interface TreasuryRunwayMetricResponse {
  effectiveHot?: number;
  hourlyBurn?: number;
  /** @nullable */
  paymentSystem?: string | null;
  runwayHours?: number;
  /** @nullable */
  shortName?: string | null;
}

export interface TreasuryRecommendedChainPolicyResponse {
  autoExecuteLimit?: number;
  dailyAutoExecuteCap?: number;
  demandWeight?: number;
  enabled?: boolean;
  maxHotBalance?: number;
  minHotBalance?: number;
  netFlowWindowHours?: number;
  paused?: boolean;
  targetHotBalance?: number;
}

export interface TreasuryRebalancePolicyResponse {
  approvalThreshold?: number;
  cooldownMinutes?: number;
  createdAt?: string;
  globalDailyCap?: number;
  id?: string;
  maxSingleTransfer?: number;
  minTransferAmount?: number;
  suggestionIntervalMinutes?: number;
  updatedAt?: string;
  withdrawalLiquidityHintsEnabled?: boolean;
}

/**
 * @nullable
 */
export type TreasuryRebalanceExecutionResponseFilteredResponseFilters = unknown | null;

export interface TreasuryRebalanceExecutionResponse {
  createdAt?: string;
  /** @nullable */
  errorMessage?: string | null;
  id?: string;
  /** @nullable */
  idempotencyKey?: string | null;
  retryCount?: number;
  /** @nullable */
  status?: string | null;
  suggestionId?: string;
  updatedAt?: string;
  /** @nullable */
  walletCctpTransferId?: string | null;
}

export interface TreasuryRebalanceExecutionResponseFilteredResponse {
  /** @nullable */
  data?: TreasuryRebalanceExecutionResponse[] | null;
  /** @nullable */
  filters?: TreasuryRebalanceExecutionResponseFilteredResponseFilters;
  paging?: Paging;
}

export interface TreasuryPolicyOptimizationRunResult {
  approvalRequiredCount?: number;
  autoAppliedCount?: number;
  createdCount?: number;
  /** @nullable */
  createdIds?: string[] | null;
  skippedCount?: number;
}

/**
 * @nullable
 */
export type TreasuryPolicyOptimizationResponseFilteredResponseFilters = unknown | null;

export interface TreasuryPolicyOptimizationResponseFilteredResponse {
  /** @nullable */
  data?: TreasuryPolicyOptimizationResponse[] | null;
  /** @nullable */
  filters?: TreasuryPolicyOptimizationResponseFilteredResponseFilters;
  paging?: Paging;
}

export interface TreasuryPolicyFieldChangeResponse {
  absoluteDelta?: number;
  /** @nullable */
  currentValue?: number | null;
  /** @nullable */
  field?: string | null;
  /** @nullable */
  recommendedValue?: number | null;
  relativeDeltaPercent?: number;
}

export interface TreasuryPolicyOptimizationResponse {
  analysisDays?: number;
  createdAt?: string;
  currentPolicy?: TreasuryChainPolicyResponse;
  /** @nullable */
  decisionType?: string | null;
  /** @nullable */
  expiresAt?: string | null;
  /** @nullable */
  fieldChanges?: TreasuryPolicyFieldChangeResponse[] | null;
  id?: string;
  /** @nullable */
  paymentSystem?: string | null;
  /** @nullable */
  rationale?: string[] | null;
  recommendedPolicy?: TreasuryRecommendedChainPolicyResponse;
  /** @nullable */
  resolvedAt?: string | null;
  /** @nullable */
  status?: string | null;
}

export interface TreasuryPendingQueueChainResponse {
  /** @nullable */
  oldestPendingAt?: string | null;
  /** @nullable */
  paymentSystem?: string | null;
  pendingAmountUsdc?: number;
  pendingCount?: number;
}

export interface TreasuryPendingQueueAnalysisResponse {
  /** @nullable */
  chains?: TreasuryPendingQueueChainResponse[] | null;
  totalPendingCount?: number;
  totalPendingUsdc?: number;
}

export interface TreasuryPeakDemandPeriodResponse {
  /** @nullable */
  paymentSystem?: string | null;
  peakToAverageRatio?: number;
  periodEnd?: string;
  periodStart?: string;
  volumeUsdc?: number;
  withdrawalCount?: number;
}

/**
 * @nullable
 */
export type TreasuryNotificationPreferencesResponseRecipientEmails = { [key: string]: string } | null;

export interface TreasuryNotificationPreferencesResponse {
  emailEnabled?: boolean;
  /** @nullable */
  enabledAlerts?: string[] | null;
  /** @nullable */
  enabledReports?: string[] | null;
  /** @nullable */
  recipientEmails?: TreasuryNotificationPreferencesResponseRecipientEmails;
  /** @nullable */
  selectedRecipientCorePassIds?: string[] | null;
  /** @nullable */
  updatedByCorePassId?: string | null;
  webSocketEnabled?: boolean;
}

export interface TreasuryNotificationPayloadResponse {
  /** @nullable */
  alertType?: string | null;
  /** @nullable */
  createdAt?: string | null;
  /** @nullable */
  id?: string | null;
  /** @nullable */
  kind?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  reportCadence?: string | null;
  /** @nullable */
  severity?: string | null;
  summary?: TreasurySnapshotResponse;
  /** @nullable */
  title?: string | null;
}

export interface TreasuryNotificationDeliveryEntryResponse {
  /** @nullable */
  alertType?: string | null;
  /** @nullable */
  channel?: string | null;
  content?: TreasuryNotificationPayloadResponse;
  /** @nullable */
  createdAt?: string | null;
  /** @nullable */
  id?: string | null;
  /** @nullable */
  kind?: string | null;
  /** @nullable */
  recipientCorePassId?: string | null;
  /** @nullable */
  reportCadence?: string | null;
  /** @nullable */
  status?: string | null;
  /** @nullable */
  title?: string | null;
}

export interface TreasuryNotificationDeliveryLogResponse {
  /** @nullable */
  items?: TreasuryNotificationDeliveryEntryResponse[] | null;
}

export interface TreasuryNotificationCatalogItemResponse {
  /** @nullable */
  category?: string | null;
  /** @nullable */
  description?: string | null;
  /** @nullable */
  id?: string | null;
  /** @nullable */
  label?: string | null;
}

export interface TreasuryNotificationCatalogResponse {
  /** @nullable */
  alerts?: TreasuryNotificationCatalogItemResponse[] | null;
  /** @nullable */
  reports?: TreasuryNotificationCatalogItemResponse[] | null;
}

export interface TreasuryNotificationAdminRecipientResponse {
  /** @nullable */
  corePassId?: string | null;
  /** @nullable */
  displayName?: string | null;
  /** @nullable */
  email?: string | null;
  /** @nullable */
  userId?: string | null;
}

export interface TreasuryNotificationAdminRecipientsResponse {
  /** @nullable */
  items?: TreasuryNotificationAdminRecipientResponse[] | null;
}

export interface TreasuryNetFlowPointResponse {
  netFlow?: number;
  /** @nullable */
  paymentSystem?: string | null;
  /** @nullable */
  shortName?: string | null;
}

export interface TreasuryLiquiditySlaSnapshot {
  chainsWithWithdrawalGap?: number;
  estimatedUncoveredGapAfterPlan?: number;
  proactivePrepositioningLegCount?: number;
  totalPlannedCctpAmount?: number;
  totalPlannedColdAmount?: number;
  totalWithdrawalCoverageGap?: number;
}

export interface TreasuryLiquidityPlanSimulationLegDraft {
  amount?: number;
  /** @nullable */
  cctpPurpose?: string | null;
  /** @nullable */
  destinationPaymentSystem?: string | null;
  /** @nullable */
  legType?: string | null;
  /** @nullable */
  notes?: string | null;
  requiresCctpFollowUp?: boolean;
  sequence?: number;
  /** @nullable */
  sourcePaymentSystem?: string | null;
}

export interface TreasuryLiquidityPlanSimulationDraft {
  adminResidualAmount?: number;
  /** @nullable */
  deficitPaymentSystem?: string | null;
  immediateCoverableHot?: number;
  /** @nullable */
  legs?: TreasuryLiquidityPlanSimulationLegDraft[] | null;
  plannedCctpAmount?: number;
  plannedColdAmount?: number;
  replenishmentNeed?: number;
  withdrawalCoverageGap?: number;
  wouldReplaceActivePlan?: boolean;
}

export interface TreasuryLiquidityPlanSimulationResult {
  /** @nullable */
  drafts?: TreasuryLiquidityPlanSimulationDraft[] | null;
  plansStabilized?: number;
  plansWouldCreate?: number;
  plansWouldSupersede?: number;
  reliefUrgent?: boolean;
  slaSnapshot?: TreasuryLiquiditySlaSnapshot;
}

export interface TreasuryLiquidityPlanRunResult {
  autoExecutedCctpCount?: number;
  cctpSuggestionsCreated?: number;
  coldBatchesPrepared?: number;
  /** @nullable */
  createdPlanIds?: string[] | null;
  legsDispatched?: number;
  plansCreated?: number;
  plansStabilized?: number;
  plansSuperseded?: number;
  reliefCycle?: boolean;
  reliefUrgent?: boolean;
  slaSnapshot?: TreasuryLiquiditySlaSnapshot;
}

/**
 * @nullable
 */
export type TreasuryLiquidityPlanResponseFilteredResponseFilters = unknown | null;

export interface TreasuryLiquidityPlanResponseFilteredResponse {
  /** @nullable */
  data?: TreasuryLiquidityPlanResponse[] | null;
  /** @nullable */
  filters?: TreasuryLiquidityPlanResponseFilteredResponseFilters;
  paging?: Paging;
}

export interface TreasuryLiquidityPlanLegResponse {
  amount?: number;
  /** @nullable */
  cctpPurpose?: string | null;
  createdAt?: string;
  /** @nullable */
  destinationPaymentSystem?: string | null;
  /** @nullable */
  dispatchedAt?: string | null;
  id?: string;
  /** @nullable */
  legType?: string | null;
  /** @nullable */
  linkedEntityId?: string | null;
  /** @nullable */
  linkedEntityType?: string | null;
  /** @nullable */
  notes?: string | null;
  planId?: string;
  requiresCctpFollowUp?: boolean;
  sequence?: number;
  /** @nullable */
  sourcePaymentSystem?: string | null;
  /** @nullable */
  status?: string | null;
}

export interface TreasuryLiquidityPlanResponse {
  adminResidualAmount?: number;
  createdAt?: string;
  /** @nullable */
  deficitPaymentSystem?: string | null;
  /** @nullable */
  expiresAt?: string | null;
  id?: string;
  immediateCoverableHot?: number;
  /** @nullable */
  legs?: TreasuryLiquidityPlanLegResponse[] | null;
  plannedCctpAmount?: number;
  plannedColdAmount?: number;
  replenishmentNeed?: number;
  /** @nullable */
  status?: string | null;
  totalPlannedAmount?: number;
  withdrawalCoverageGap?: number;
}

export interface TreasuryLiquidityByChainPointResponse {
  /** @nullable */
  paymentSystem?: string | null;
  /** @nullable */
  shortName?: string | null;
  value?: number;
}

export interface TreasuryIntelligenceRunResult {
  createdCount?: number;
  /** @nullable */
  createdSuggestionIds?: string[] | null;
  expiredCount?: number;
}

/**
 * @nullable
 */
export type TreasuryColdReplenishmentIntentResponseFilteredResponseFilters = unknown | null;

export interface TreasuryColdReplenishmentIntentResponse {
  amount?: number;
  /** @nullable */
  confirmationTxId?: string | null;
  /** @nullable */
  confirmedAt?: string | null;
  /** @nullable */
  confirmedBy?: string | null;
  createdAt?: string;
  createdBy?: string;
  id?: string;
  /** @nullable */
  intentNote?: string | null;
  /** @nullable */
  paymentSystem?: string | null;
  /** @nullable */
  status?: string | null;
}

export interface TreasuryColdReplenishmentIntentResponseFilteredResponse {
  /** @nullable */
  data?: TreasuryColdReplenishmentIntentResponse[] | null;
  /** @nullable */
  filters?: TreasuryColdReplenishmentIntentResponseFilteredResponseFilters;
  paging?: Paging;
}

export interface TreasuryColdAggregationRunResult {
  failedCount?: number;
  /** @nullable */
  preparedBatchIds?: string[] | null;
  preparedCount?: number;
  skippedCount?: number;
}

export interface TreasuryColdAggregationBroadcastResultResponse {
  /** @nullable */
  error?: string | null;
  id?: string;
  success?: boolean;
  /** @nullable */
  txHash?: string | null;
}

/**
 * @nullable
 */
export type TreasuryColdAggregationBatchResponseFilteredResponseFilters = unknown | null;

export interface TreasuryColdAggregationBatchResponse {
  /** @nullable */
  broadcastAt?: string | null;
  /** @nullable */
  broadcastResults?: TreasuryColdAggregationBroadcastResultResponse[] | null;
  /** @nullable */
  completedAt?: string | null;
  createdAt?: string;
  createdBy?: string;
  /** @nullable */
  destinationAddress?: string | null;
  /** @nullable */
  fuelInjectionRequestedAt?: string | null;
  /** @nullable */
  fuelInjectionRequestedBy?: string | null;
  /** @nullable */
  fuelInjectionRequestId?: number | null;
  /** @nullable */
  fuelInjectionStatus?: string | null;
  id?: string;
  /** @nullable */
  liquidityDestinationPaymentSystem?: string | null;
  /** @nullable */
  paymentSystem?: string | null;
  /** @nullable */
  plannedCctpAmount?: number | null;
  /** @nullable */
  preparationError?: string | null;
  /** @nullable */
  preparedAt?: string | null;
  /** @nullable */
  replenishmentIntentId?: string | null;
  requiredAmount?: number;
  requiresCctpFollowUp?: boolean;
  selectedAmount?: number;
  /** @nullable */
  signedUploadedAt?: string | null;
  /** @nullable */
  signedUploadedBy?: string | null;
  sourceWalletCount?: number;
  /** @nullable */
  status?: string | null;
  /** @nullable */
  walletBroadcastRequestId?: number | null;
}

export interface TreasuryColdAggregationBatchResponseFilteredResponse {
  /** @nullable */
  data?: TreasuryColdAggregationBatchResponse[] | null;
  /** @nullable */
  filters?: TreasuryColdAggregationBatchResponseFilteredResponseFilters;
  paging?: Paging;
}

export interface TreasuryChainSnapshotResponse {
  /** @nullable */
  coldUsdcBalance?: number | null;
  enabled?: boolean;
  /** @nullable */
  hotUsdcBalance?: number | null;
  /** @nullable */
  hotWalletAddress?: string | null;
  inFlightCctpInboundUsdc?: number;
  inFlightCctpUsdc?: number;
  maxHotBalance?: number;
  minHotBalance?: number;
  /** @nullable */
  oldestPendingWithdrawalAt?: string | null;
  paused?: boolean;
  /** @nullable */
  paymentSystem?: string | null;
  pendingColdReplenishmentUsdc?: number;
  /** @nullable */
  pendingWithdrawalCount?: number | null;
  /** @nullable */
  pendingWithdrawalsUsdc?: number | null;
  /** @nullable */
  snapshotError?: string | null;
  targetHotBalance?: number;
}

export interface TreasuryChainPolicyResponse {
  autoExecuteLimit?: number;
  createdAt?: string;
  dailyAutoExecuteCap?: number;
  demandWeight?: number;
  enabled?: boolean;
  id?: string;
  maxHotBalance?: number;
  minHotBalance?: number;
  netFlowWindowHours?: number;
  paused?: boolean;
  /** @nullable */
  paymentSystem?: string | null;
  targetHotBalance?: number;
  updatedAt?: string;
}

export interface TreasuryChainSetupRecommendationResponse {
  currentColdUsdc?: number;
  currentHotUsdc?: number;
  currentPolicy?: TreasuryChainPolicyResponse;
  metrics?: TreasuryWithdrawalChainMetricsResponse;
  /** @nullable */
  paymentSystem?: string | null;
  pendingWithdrawalsUsdc?: number;
  /** @nullable */
  rationale?: string[] | null;
  recommended?: TreasuryRecommendedChainPolicyResponse;
  recommendedEnabled?: boolean;
  /** @nullable */
  riskLevel?: string | null;
}

export interface TreasuryCctpActivityPointResponse {
  amount?: number;
  /** @nullable */
  createdAt?: string | null;
  /** @nullable */
  label?: string | null;
  /** @nullable */
  route?: string | null;
  /** @nullable */
  status?: string | null;
}

/**
 * @nullable
 */
export type TreasuryAuditLogResponseFilteredResponseFilters = unknown | null;

export interface TreasuryAuditLogResponse {
  /** @nullable */
  action?: string | null;
  actorId?: string;
  createdAt?: string;
  /** @nullable */
  entityId?: string | null;
  /** @nullable */
  entityType?: string | null;
  id?: string;
  /** @nullable */
  inputs?: string | null;
  /** @nullable */
  policyApplied?: string | null;
}

export interface TreasuryAuditLogResponseFilteredResponse {
  /** @nullable */
  data?: TreasuryAuditLogResponse[] | null;
  /** @nullable */
  filters?: TreasuryAuditLogResponseFilteredResponseFilters;
  paging?: Paging;
}

export interface TreasuryAnalyticsResponse {
  capturedAt?: string;
  /** @nullable */
  cctpActivity?: TreasuryCctpActivityPointResponse[] | null;
  /** @nullable */
  enabledChains?: string[] | null;
  /** @nullable */
  liquidityByChain?: TreasuryLiquidityByChainPointResponse[] | null;
  /** @nullable */
  netFlow?: TreasuryNetFlowPointResponse[] | null;
  /** @nullable */
  runway?: TreasuryRunwayMetricResponse[] | null;
  totalHotUsdc?: number;
  utilization?: TreasuryUtilizationMetricsResponse;
  /** @nullable */
  withdrawalPredictions?: TreasuryWithdrawalPredictionPointResponse[] | null;
  /** @nullable */
  withdrawalRange?: string | null;
  /** @nullable */
  withdrawalTrend?: TreasuryWithdrawalTrendPointResponse[] | null;
}

export interface TreasuryAdvisorStatusResponse {
  /** @nullable */
  displayMode?: string | null;
  isInitialized?: boolean;
  /** @nullable */
  lastOptimizationAt?: string | null;
  /** @nullable */
  lastPolicyUpdateAt?: string | null;
  pendingOptimizationCount?: number;
}

export type TransferType = (typeof TransferType)[keyof typeof TransferType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TransferType = {
  Deposit: 'Deposit',
  Withdrawal: 'Withdrawal',
} as const;

export type TransferStatus = (typeof TransferStatus)[keyof typeof TransferStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TransferStatus = {
  Working: 'Working',
  Pending: 'Pending',
  Completed: 'Completed',
  Failed: 'Failed',
  PendingReview: 'PendingReview',
} as const;

export interface TransfersResponse {
  /** @nullable */
  data?: AdminTransferData[] | null;
  paging?: PagingData;
  /** @nullable */
  sort?: string[] | null;
}

export type TransferReasonType = (typeof TransferReasonType)[keyof typeof TransferReasonType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TransferReasonType = {
  External: 'External',
  Internal: 'Internal',
  Reward: 'Reward',
  Manual: 'Manual',
} as const;

export interface TransferRecord {
  accountId?: number;
  amount?: number;
  /** @nullable */
  assetAmountScale?: number | null;
  /** @nullable */
  assetId?: string | null;
  /** @nullable */
  clientWithdrawRequestId?: string | null;
  /** @nullable */
  comment?: string | null;
  createdAt?: string;
  /** @nullable */
  data?: string | null;
  /** @nullable */
  errorMessage?: string | null;
  fee?: number;
  id?: string;
  isCommodityAsset?: boolean;
  /** @nullable */
  paymentSystem?: string | null;
  /** @nullable */
  paymentSystemId?: string | null;
  /** @nullable */
  portfolioLockId?: string | null;
  /** @nullable */
  price?: number | null;
  status?: TransferStatus;
  /** @nullable */
  targetAddress?: string | null;
  /** @nullable */
  tokenId?: string | null;
  transferReason?: TransferReasonType;
  /** @nullable */
  txId?: string | null;
  type?: TransferType;
  /** @nullable */
  unroundedAmount?: number | null;
  updatedAt?: string;
  version?: number;
  /** @nullable */
  withdrawalFeeAssetId?: string | null;
  /** @nullable */
  withdrawalFeePortfolioLockId?: string | null;
  /** @nullable */
  withdrawRequestId?: string | null;
}

export type TransactionType = (typeof TransactionType)[keyof typeof TransactionType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TransactionType = {
  Deposit: 'Deposit',
  Withdrawal: 'Withdrawal',
  FuelInjection: 'FuelInjection',
  Broadcast: 'Broadcast',
} as const;

export type TransactionStatus = (typeof TransactionStatus)[keyof typeof TransactionStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TransactionStatus = {
  AwaitingConfirmation: 'AwaitingConfirmation',
  ReplacedByFee: 'ReplacedByFee',
  Completed: 'Completed',
  Failed: 'Failed',
} as const;

export interface TransactionEventData {
  amount?: number;
  /** @nullable */
  assetId?: string | null;
  /** @nullable */
  broadcastRequestDetailTransactionId?: string | null;
  /** @nullable */
  broadcastRequestId?: number | null;
  confirmations?: number;
  /** @nullable */
  errorDetails?: string | null;
  /** @nullable */
  from?: string | null;
  minConfirmations?: number;
  ownerId?: number;
  /** @nullable */
  paymentSystem?: string | null;
  /** @nullable */
  paymentSystemId?: string | null;
  status?: TransactionStatus;
  /** @nullable */
  to?: string | null;
  /** @nullable */
  tokenId?: string | null;
  transferId?: string;
  /** @nullable */
  txId?: string | null;
  type?: TransactionType;
}

export interface TransactionEmergencyRecoverResult {
  /** @nullable */
  eventData?: TransactionEventData[] | null;
  recoverStatus?: RecoverStatus;
}

export interface TraderViewModel {
  accountId?: number;
  /** @nullable */
  activityStatus?: string | null;
  /** @nullable */
  corePassId?: string | null;
  /** @nullable */
  dateOfBirth?: string | null;
  /** @nullable */
  documentExpirationDate?: string | null;
  /** @nullable */
  email?: string | null;
  /** @nullable */
  expiringDocumentType?: string | null;
  /** @nullable */
  fullName?: string | null;
  /** @nullable */
  fullNameEnglish?: string | null;
  /** @nullable */
  governmentDocumentNumber?: string | null;
  /** @nullable */
  governmentDocumentType?: string | null;
  /** @nullable */
  id?: string | null;
  kycVersion?: number;
  /** @nullable */
  nationality?: string | null;
  /** @nullable */
  residency?: string | null;
  /** @nullable */
  tier?: string | null;
}

export type TradeRole = (typeof TradeRole)[keyof typeof TradeRole];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TradeRole = {
  Aggressor: 'Aggressor',
  Resting: 'Resting',
} as const;

export interface TradeData {
  /** @nullable */
  accountId?: string | null;
  accountVersion?: number;
  /** @nullable */
  commission?: string | null;
  /** @nullable */
  commissionCurrency?: string | null;
  /** @nullable */
  commissionType?: string | null;
  /** @nullable */
  email?: string | null;
  /** @nullable */
  market?: string | null;
  /** @nullable */
  orderId?: string | null;
  /** @nullable */
  remainingAmount?: string | null;
  side?: OrderSide;
  /** @nullable */
  tradeAmount?: string | null;
  /** @nullable */
  tradeId?: string | null;
  /** @nullable */
  tradePrice?: string | null;
  tradeQuoteAmount?: number;
  /** @nullable */
  tradeRole?: string | null;
  tradeTime?: string;
  /** @nullable */
  userName?: string | null;
}

export interface TradesResponse {
  /** @nullable */
  data?: TradeData[] | null;
  paging?: PagingData;
  /** @nullable */
  sort?: string[] | null;
}

export type TokenType = (typeof TokenType)[keyof typeof TokenType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TokenType = {
  Xrc20Full: 'Xrc20Full',
  Xrc721Full: 'Xrc721Full',
  Erc20Full: 'Erc20Full',
  NativeToken: 'NativeToken',
  SplToken: 'SplToken',
} as const;

export interface TagInfo {
  id?: number;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  values?: string[] | null;
}

export type TagCardinality = (typeof TagCardinality)[keyof typeof TagCardinality];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TagCardinality = {
  Single: 'Single',
  Multiple: 'Multiple',
} as const;

export interface SystemBalanceReportItem {
  /**
   * Calculated amount using transfers and orders
   * @nullable
   */
  amount?: string | null;
  /** @nullable */
  assetId?: string | null;
  /**
   * Calculated value -PortfolioAmount
   * @nullable
   */
  difference?: string | null;
  /** The calculated value is greater or equal to portfolio amount and locked amount */
  readonly isCorrect?: boolean;
  /** @nullable */
  lockedAmount?: string | null;
  /** @nullable */
  portfolioAmount?: string | null;
  /** @nullable */
  totalDeposit?: string | null;
  /** @nullable */
  totalOrder?: string | null;
  /** @nullable */
  totalWithdrawal?: string | null;
}

export interface SmartContractInfoResponse {
  /** @nullable */
  contract?: string | null;
  /** @nullable */
  decimals?: number | null;
  /** @nullable */
  icon?: string | null;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  symbol?: string | null;
  /** @nullable */
  type?: string | null;
  /** @nullable */
  web?: string | null;
}

export interface SetWinnerFulfillmentAdminRequest {
  comment: string;
  status: CampaignWinnerManualFulfillmentStatus;
}

export interface SealableValue {
  sealed?: boolean;
  /** @nullable */
  value?: string | null;
}

export type RoleType = (typeof RoleType)[keyof typeof RoleType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RoleType = {
  Admin: 'Admin',
  Support: 'Support',
  ComplianceReviewer: 'ComplianceReviewer',
  TradeDataViewer: 'TradeDataViewer',
} as const;

export interface RoleRequest {
  /** @nullable */
  roles?: RoleType[] | null;
  userId?: string;
}

export interface RewardRoiResponse {
  revenueGenerated?: number;
  rewardSpent?: number;
  roi?: number;
}

export type RewardReason = (typeof RewardReason)[keyof typeof RewardReason];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RewardReason = {
  ExistingUserCoreTokenDistribution: 'ExistingUserCoreTokenDistribution',
  VegaDistributionXCB: 'VegaDistributionXCB',
  SupportRefund: 'SupportRefund',
  VegaDistributionCTN: 'VegaDistributionCTN',
  MarketingCampaignEarlyAdaptorsPhase1: 'MarketingCampaignEarlyAdaptorsPhase1',
  InitialCoinOffering: 'InitialCoinOffering',
  Campaign: 'Campaign',
} as const;

export interface RewardRequestModel {
  /** @minimum 0 */
  amount: number;
  /**
   * @minLength 3
   * @maxLength 4
   * @pattern ^[a-zA-Z0-9]*$
   */
  assetId: string;
  /** @nullable */
  claimableAt?: string | null;
  /**
   * @minLength 1
   * @maxLength 2000
   */
  comment: string;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^[a-zA-Z0-9]*$
   */
  coreId: string;
  reason: RewardReason;
}

export type RewardInitiationSource = (typeof RewardInitiationSource)[keyof typeof RewardInitiationSource];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RewardInitiationSource = {
  Manual: 'Manual',
  EligibilityIcoOnKyc: 'EligibilityIcoOnKyc',
  Campaign: 'Campaign',
} as const;

/**
 * @nullable
 */
export type RewardAdminResponseFilteredResponseFilters = unknown | null;

export interface RewardAdminResponse {
  amount?: number;
  /** @nullable */
  assetId?: string | null;
  /** @nullable */
  claimableAt?: string | null;
  /** @nullable */
  claimDate?: string | null;
  /** @nullable */
  comment?: string | null;
  /** @nullable */
  coreId?: string | null;
  creationDate?: string;
  id?: string;
  /** @nullable */
  initiationSource?: string | null;
  isClaimed?: boolean;
  /** @nullable */
  reason?: string | null;
}

export interface RewardAdminResponseFilteredResponse {
  /** @nullable */
  data?: RewardAdminResponse[] | null;
  /** @nullable */
  filters?: RewardAdminResponseFilteredResponseFilters;
  paging?: Paging;
}

export interface RevenueTrendPointResponse {
  costs?: number;
  costToRevenueRatio?: number;
  /** @nullable */
  date?: string | null;
  netProfit?: number;
  profitMargin?: number;
  revenue?: number;
}

export interface RevenueTrendBySourcePointResponse {
  /** @nullable */
  date?: string | null;
  trading?: number;
  withdraw?: number;
}

export interface RevenueSummaryResponse {
  activeInvestments?: number;
  /** @nullable */
  assetId?: string | null;
  /** @nullable */
  capturedAt?: string | null;
  costToRevenueRatio?: number;
  netProfit?: number;
  netWithdrawalProfit?: number;
  normalizedUsdCosts?: number;
  normalizedUsdProfit?: number;
  normalizedUsdRevenue?: number;
  pendingFeeBalance?: number;
  profitMargin?: number;
  totalCosts?: number;
  totalGasCost?: number;
  totalRevenue?: number;
  totalWithdrawalFeeRevenue?: number;
}

/**
 * @nullable
 */
export type RevenueNotificationPreferencesResponseRecipientEmails = { [key: string]: string } | null;

export interface RevenueNotificationPreferencesResponse {
  emailEnabled?: boolean;
  /** @nullable */
  enabledAlerts?: string[] | null;
  /** @nullable */
  enabledReports?: string[] | null;
  /** @nullable */
  recipientEmails?: RevenueNotificationPreferencesResponseRecipientEmails;
  /** @nullable */
  selectedRecipientCorePassIds?: string[] | null;
  /** @nullable */
  updatedByCorePassId?: string | null;
  webSocketEnabled?: boolean;
}

export interface RevenueNotificationPayloadResponse {
  /** @nullable */
  alertType?: string | null;
  /** @nullable */
  createdAt?: string | null;
  /** @nullable */
  id?: string | null;
  /** @nullable */
  kind?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  reportCadence?: string | null;
  /** @nullable */
  severity?: string | null;
  summary?: RevenueSummaryResponse;
  /** @nullable */
  title?: string | null;
}

export interface RevenueNotificationDeliveryEntryResponse {
  /** @nullable */
  channel?: string | null;
  /** @nullable */
  createdAt?: string | null;
  /** @nullable */
  id?: string | null;
  /** @nullable */
  kind?: string | null;
  /** @nullable */
  recipientCorePassId?: string | null;
  /** @nullable */
  status?: string | null;
  /** @nullable */
  title?: string | null;
}

export interface RevenueNotificationDeliveryLogResponse {
  /** @nullable */
  items?: RevenueNotificationDeliveryEntryResponse[] | null;
}

export interface RevenueNotificationCatalogItemResponse {
  /** @nullable */
  category?: string | null;
  /** @nullable */
  description?: string | null;
  /** @nullable */
  id?: string | null;
  /** @nullable */
  label?: string | null;
}

export interface RevenueNotificationCatalogResponse {
  /** @nullable */
  alerts?: RevenueNotificationCatalogItemResponse[] | null;
  /** @nullable */
  reports?: RevenueNotificationCatalogItemResponse[] | null;
}

export interface RevenueNotificationAdminRecipientResponse {
  /** @nullable */
  corePassId?: string | null;
  /** @nullable */
  displayName?: string | null;
  /** @nullable */
  email?: string | null;
  /** @nullable */
  userId?: string | null;
}

export interface RevenueNotificationAdminRecipientsResponse {
  /** @nullable */
  items?: RevenueNotificationAdminRecipientResponse[] | null;
}

export interface RevenueInsightResponse {
  /** @nullable */
  category?: string | null;
  /** @nullable */
  id?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  tone?: string | null;
}

export interface RevenueBySourceResponse {
  amount?: number;
  normalizedUsdValue?: number;
  percentage?: number;
  /** @nullable */
  source?: string | null;
}

export interface RevenueByChainResponse {
  /** @nullable */
  chain?: string | null;
  gasCost?: number;
  netProfit?: number;
  netWithdrawalProfit?: number;
  /** @nullable */
  shortName?: string | null;
  total?: number;
  trading?: number;
  withdraw?: number;
}

export interface RevenueByAssetTypeResponse {
  /** @nullable */
  assetType?: string | null;
  costs?: number;
  netProfit?: number;
  profitMargin?: number;
  revenue?: number;
  revenueShare?: number;
}

export interface RevenueByAssetResponse {
  /** @nullable */
  assetId?: string | null;
  /** @nullable */
  assetSymbol?: string | null;
  /** @nullable */
  assetType?: string | null;
  costs?: number;
  netProfit?: number;
  normalizedUsdProfit?: number;
  profitMargin?: number;
  profitShare?: number;
  revenue?: number;
  revenueShare?: number;
}

export interface RevealCampaignPrizeResponse {
  campaignId?: string;
  campaignStatus?: CampaignStatus;
  prizeId?: string;
  /** @nullable */
  tierName?: string | null;
  /** @nullable */
  winners?: DrawWinnerResponse[] | null;
  winnersRevealed?: number;
}

export type ResolveComplienceRequestStatusType =
  (typeof ResolveComplienceRequestStatusType)[keyof typeof ResolveComplienceRequestStatusType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ResolveComplienceRequestStatusType = {
  Approved: 'Approved',
  Denied: 'Denied',
  RequestedMoreData: 'RequestedMoreData',
} as const;

export interface RejectMarketRegistrationRequest {
  rejectionReason: string;
}

export interface RejectAssetRegistration {
  rejectionReason: string;
}

export interface RegistrationTrendPointResponse {
  cumulativeRegistrationCount?: number;
  dailyRegistrationCount?: number;
  date?: string;
}

export type RecoverStatus = (typeof RecoverStatus)[keyof typeof RecoverStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RecoverStatus = {
  TransactionIsNotRelated: 'TransactionIsNotRelated',
  TransactionWasDetectedBefore: 'TransactionWasDetectedBefore',
  TransactionIsNowRecovered: 'TransactionIsNowRecovered',
} as const;

export interface ProfitResponse {
  /** @nullable */
  currencyId?: string | null;
  expense?: number;
  income?: number;
  profit?: number;
}

export interface ProblemDetails {
  /** @nullable */
  detail?: string | null;
  /** @nullable */
  instance?: string | null;
  /** @nullable */
  status?: number | null;
  /** @nullable */
  title?: string | null;
  /** @nullable */
  type?: string | null;
  [key: string]: unknown;
}

export interface PortfolioItemResponse {
  accountId?: number;
  amount?: number;
  /** @nullable */
  assetId?: string | null;
  availableAmount?: number;
  availableBalance?: number;
  /** @nullable */
  availableTokenIds?: string[] | null;
  balance?: number;
  onHoldAmount?: number;
  onHoldBalance?: number;
  /** @nullable */
  onHoldTokenIds?: string[] | null;
  percentageOfTotal?: number;
  /** @nullable */
  tokenIds?: string[] | null;
}

export interface PortfolioResponse {
  accountId?: number;
  availableBalance?: number;
  /** @nullable */
  currencyId?: string | null;
  /** @nullable */
  portfolioItems?: PortfolioItemResponse[] | null;
  totalBalance?: number;
  totalOnHoldBalance?: number;
  /** @nullable */
  userId?: string | null;
  withdrawalThresholdReached?: boolean;
}

export interface PaymentWebhookNotificationItemData {
  createdAt?: string;
  /** @nullable */
  error?: string | null;
  /** @nullable */
  id?: string | null;
  /** @nullable */
  paymentExecutionId?: string | null;
  /** @nullable */
  paymentId?: string | null;
  /** @nullable */
  requestBody?: string | null;
  /** @nullable */
  responseContent?: string | null;
  /** @nullable */
  responseStatusCode?: string | null;
  /** @nullable */
  status?: string | null;
}

export interface PaymentWebhookNotificationsResponse {
  /** @nullable */
  data?: PaymentWebhookNotificationItemData[] | null;
}

export type PaymentSystem = (typeof PaymentSystem)[keyof typeof PaymentSystem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PaymentSystem = {
  None: 'None',
  Bitcoin: 'Bitcoin',
  Litecoin: 'Litecoin',
  Ethereum: 'Ethereum',
  BitcoinCash: 'BitcoinCash',
  OpenPay: 'OpenPay',
  Omni: 'Omni',
  CoreBlockchain: 'CoreBlockchain',
  BinanceSmartChain: 'BinanceSmartChain',
  Polygon: 'Polygon',
  Solana: 'Solana',
} as const;

export interface PaymentRequestSnapshot {
  accountId?: number;
  /** @nullable */
  amount?: number | null;
  amountEnteredByUser?: boolean;
  /** @nullable */
  clientPaymentId?: string | null;
  createdAt?: string;
  /** @nullable */
  currency?: string | null;
  /** @nullable */
  deadline?: string | null;
  /** @nullable */
  digitize?: boolean | null;
  /** @nullable */
  donate?: boolean | null;
  /** @nullable */
  fiat?: string | null;
  /** @nullable */
  item?: string | null;
  /** @nullable */
  itemPhotoUrl?: string | null;
  /** @nullable */
  merchantPhotoUrl?: string | null;
  /** @nullable */
  organization?: string | null;
  /** @nullable */
  paymentRequestId?: string | null;
  /** @nullable */
  receiverCorePassId?: string | null;
  /** @nullable */
  recurringPattern?: string | null;
  /** @nullable */
  referralCode?: string | null;
  /** @nullable */
  resolvedCurrency?: string | null;
  /** @nullable */
  resolvedNetwork?: string | null;
  /** @nullable */
  swap?: string | null;
}

export interface PaymentItemData {
  accountId?: number;
  /** @nullable */
  corePassId?: string | null;
  createdAt?: string;
  /** @nullable */
  email?: string | null;
  isRecurring?: boolean;
  /** @nullable */
  payerPaymentAmount?: number | null;
  /** @nullable */
  paymentId?: string | null;
  paymentRequest?: PaymentRequestSnapshot;
  /** @nullable */
  paymentRequestId?: string | null;
  /** @nullable */
  quoteSnapshot?: string | null;
  recurringEnabled?: boolean;
  /** @nullable */
  recurringLastRunAt?: string | null;
  /** @nullable */
  recurringNextRunAt?: string | null;
  /** @nullable */
  recurringPattern?: string | null;
  recurringRunCount?: number;
  /** @nullable */
  status?: string | null;
  updatedAt?: string;
  /** @nullable */
  userName?: string | null;
  /** @nullable */
  withdrawRequestId?: string | null;
}

export interface PaymentsResponse {
  /** @nullable */
  cursor?: string | null;
  /** @nullable */
  data?: PaymentItemData[] | null;
}

export interface PaymentExecutionItemData {
  createdAt?: string;
  /** @nullable */
  error?: string | null;
  /** @nullable */
  finishedAt?: string | null;
  /** @nullable */
  payerPaymentAmount?: number | null;
  /** @nullable */
  paymentExecutionId?: string | null;
  /** @nullable */
  paymentId?: string | null;
  /** @nullable */
  quoteSnapshot?: string | null;
  runNo?: number;
  /** @nullable */
  scheduledAt?: string | null;
  /** @nullable */
  startedAt?: string | null;
  /** @nullable */
  status?: string | null;
  /** @nullable */
  transferId?: string | null;
  /** @nullable */
  withdrawRequestId?: string | null;
}

export interface PaymentExecutionsResponse {
  /** @nullable */
  cursor?: string | null;
  /** @nullable */
  data?: PaymentExecutionItemData[] | null;
}

export interface PaymentDigitizedCurrencyMappingItemData {
  createdAt?: string;
  /** @nullable */
  digitizedCryptoAssetId?: string | null;
  /** @nullable */
  fiatCurrency?: string | null;
  id?: string;
}

export interface PaymentDigitizedCurrencyMappingsResponse {
  /** @nullable */
  data?: PaymentDigitizedCurrencyMappingItemData[] | null;
}

export interface PagingData {
  /** @nullable */
  next?: string | null;
  /** @nullable */
  prev?: string | null;
}

export interface Paging {
  page?: number;
  per_page?: number;
  total?: number;
  total_elements?: number;
}

export interface OrderViewModel {
  amount?: number;
  /** @nullable */
  cancelReason?: string | null;
  commission?: number;
  createdAt?: string;
  executionPrice?: number;
  /** @nullable */
  feeAsset?: string | null;
  /** @nullable */
  instrument?: string | null;
  isLimit?: boolean;
  isPending?: boolean;
  marketId?: number;
  orderId?: string;
  /** @nullable */
  orderType?: string | null;
  price?: number;
  /** @nullable */
  rejectDetails?: string | null;
  remaining?: number;
  /** @nullable */
  remainingTokenIds?: string[] | null;
  /** @nullable */
  side?: string | null;
  /** @nullable */
  status?: string | null;
  stopPrice?: number;
  /** @nullable */
  tokenIds?: string[] | null;
  total?: number;
  /** @nullable */
  type?: string | null;
  unitsFilled?: number;
  updatedAt?: string;
}

export type OrderType = (typeof OrderType)[keyof typeof OrderType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrderType = {
  Limit: 'Limit',
  Market: 'Market',
  StopLimit: 'StopLimit',
  StopMarket: 'StopMarket',
  UnPaid: 'UnPaid',
} as const;

export interface OrderTradeListItem {
  matchedOrderTrade?: AdminTradeViewModel;
  matchedOrderTrader?: TraderViewModel;
}

export interface OrderTradesViewModel {
  order?: OrderViewModel;
  trader?: TraderViewModel;
  /** @nullable */
  trades?: OrderTradeListItem[] | null;
}

export type OrderStatus = (typeof OrderStatus)[keyof typeof OrderStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrderStatus = {
  Working: 'Working',
  Rejected: 'Rejected',
  Cancelled: 'Cancelled',
  Completed: 'Completed',
  Expired: 'Expired',
  WaitingForPayment: 'WaitingForPayment',
  Pending: 'Pending',
  Sending: 'Sending',
} as const;

/**
 * Orders request data - filters, sort parameters and cursor. If set to null, a property is excluded
from filtering.
 */
export interface OrdersRequest {
  /**
   * Filter by account.
   * @nullable
   */
  accountId?: string | null;
  /**
   * @minLength 0
   * @maxLength 50
   * @nullable
   * @pattern ^[a-zA-Z0-9]*$
   */
  corePassId?: string | null;
  /**
   * Filter orders with creation time greater or equal to the given value.
   * @nullable
   */
  from?: string | null;
  /**
   * Filter by requested amount minimum value.
   * @nullable
   */
  fromRequestedAmount?: number | null;
  /**
   * Filter by requested price minimum value.
   * @nullable
   */
  fromRequestedPrice?: number | null;
  /**
   * Filter by instrument.
   * @maxLength 16
   * @nullable
   * @pattern ^[a-zA-Z0-9_]*$
   */
  market?: string | null;
  /**
   * A comma-separated list of expressions used to sort the items.
- For ascending sort use 'asc' suffix or nothing(default) like 'CreatedAt asc' or 'CreatedAt'.
- For descending sort use 'desc' suffix like 'CreatedAt desc'.
- Note: value is case insensitive
- Default: if nothing provided default ordering is by CreatedAt desc.
- Supported fields:
    - CreatedAt
    - RequestedLimitPrice
   * @nullable
   */
  orderBy?: string | null;
  /**
   * Filter by piece of an order id.
   * @nullable
   */
  orderId?: string | null;
  paging?: PagingData;
  status?: OrderStatus;
  /**
   * Filter orders with creation time less than the given value.
   * @nullable
   */
  to?: string | null;
  /**
   * Filter by requested amount maximum value.
   * @nullable
   */
  toRequestedAmount?: number | null;
  /**
   * Filter by requested price maximum value.
   * @nullable
   */
  toRequestedPrice?: number | null;
  /**
   * Filter by order type.
   * @nullable
   */
  type?: OrderType[] | null;
  /**
   * Filter by piece of a username or an email.
   * @maxLength 256
   * @nullable
   * @pattern ^[a-zA-Z0-9-]*$
   */
  user?: string | null;
}

export interface OrderItemData {
  /** @nullable */
  accountId?: string | null;
  accountVersion?: number;
  /** @nullable */
  averageFillPrice?: string | null;
  cancelReason?: CancelReason;
  /** @nullable */
  commissionCurrency?: string | null;
  createdAt?: string;
  /** @nullable */
  effectiveLimitPrice?: string | null;
  /** @nullable */
  expirationTime?: string | null;
  /** @nullable */
  filledAmount?: string | null;
  /** @nullable */
  market?: string | null;
  /** @nullable */
  orderId?: string | null;
  orderStatus?: OrderStatus;
  orderType?: OrderType;
  /** @nullable */
  rejectDetails?: string | null;
  /** @nullable */
  rejectReason?: string | null;
  /** @nullable */
  remainingAmount?: string | null;
  /** @nullable */
  requestedAmount?: string | null;
  /** @nullable */
  requestedLimitPrice?: string | null;
  /** @nullable */
  requestedPrice?: string | null;
  /** @nullable */
  requestedStopPrice?: string | null;
  side?: OrderSide;
  /** @nullable */
  timeInForce?: string | null;
  /** @nullable */
  totalCommission?: string | null;
  /** @nullable */
  triggerPrice?: string | null;
  updatedAt?: string;
  /** @nullable */
  userId?: string | null;
}

export interface OrderData {
  /** @nullable */
  accountId?: string | null;
  accountVersion?: number;
  /** @nullable */
  averageFillPrice?: string | null;
  cancelReason?: CancelReason;
  /** @nullable */
  commissionCurrency?: string | null;
  /** @nullable */
  corePassId?: string | null;
  createdAt?: string;
  /** @nullable */
  effectiveLimitPrice?: string | null;
  /** @nullable */
  email?: string | null;
  /** @nullable */
  expirationTime?: string | null;
  /** @nullable */
  filledAmount?: string | null;
  /** @nullable */
  market?: string | null;
  /** @nullable */
  orderId?: string | null;
  orderStatus?: OrderStatus;
  orderType?: OrderType;
  /** @nullable */
  rejectDetails?: string | null;
  /** @nullable */
  rejectReason?: string | null;
  /** @nullable */
  remainingAmount?: string | null;
  /** @nullable */
  requestedAmount?: string | null;
  /** @nullable */
  requestedLimitPrice?: string | null;
  /** @nullable */
  requestedPrice?: string | null;
  /** @nullable */
  requestedStopPrice?: string | null;
  side?: OrderSide;
  /** @nullable */
  timeInForce?: string | null;
  /** @nullable */
  totalCommission?: string | null;
  /** @nullable */
  triggerPrice?: string | null;
  updatedAt?: string;
  /** @nullable */
  userId?: string | null;
  /** @nullable */
  userName?: string | null;
}

export interface OrdersResponse {
  /** @nullable */
  data?: OrderData[] | null;
  paging?: PagingData;
  /** @nullable */
  sort?: string[] | null;
}

export interface OrderDetails {
  /** @nullable */
  executions?: BriefExecution[] | null;
  order?: OrderData;
}

export interface MeasurementValue {
  /** @nullable */
  unit?: string | null;
  /** @nullable */
  value?: string | null;
}

export type MarketVisibility = (typeof MarketVisibility)[keyof typeof MarketVisibility];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MarketVisibility = {
  Invisible: 'Invisible',
  Visible: 'Visible',
  Internal: 'Internal',
} as const;

export interface MarketTypeProfitabilityResponse {
  costs?: number;
  /** @nullable */
  marketType?: string | null;
  netProfit?: number;
  profitMargin?: number;
  revenue?: number;
}

export type MarketType = (typeof MarketType)[keyof typeof MarketType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MarketType = {
  Cryptocurrency: 'Cryptocurrency',
  Commodity: 'Commodity',
  Stock: 'Stock',
  Forex: 'Forex',
} as const;

export type MarketStatus = (typeof MarketStatus)[keyof typeof MarketStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MarketStatus = {
  Open: 'Open',
  Halted: 'Halted',
  Paused: 'Paused',
} as const;

export interface MarketStableRequest {
  isStable?: boolean;
  marketId?: number;
}

export interface MarketResponse {
  allowMarketOrder?: boolean;
  amountScale?: number;
  /** @nullable */
  baseAsset?: string | null;
  baseFee?: number;
  hidden?: boolean;
  /** @nullable */
  id?: string | null;
  isFixedRatio?: boolean;
  isStable?: boolean;
  makerFee?: number;
  makerFeeLimit?: number;
  marketType?: MarketType;
  maxPrice?: number;
  /** @nullable */
  maxPriceDeviationPercent?: number | null;
  maxSellPriceVariationPercent?: number;
  minAmount?: number;
  minBuyPriceVariationPercent?: number;
  minPrice?: number;
  preventMarketMakersMatch?: boolean;
  priceScale?: number;
  /** @nullable */
  quoteAsset?: string | null;
  quoteFee?: number;
  status?: MarketStatus;
  takerFee?: number;
  takerFeeLimit?: number;
  visibility?: MarketVisibility;
}

export type MarketRegistrationStatus = (typeof MarketRegistrationStatus)[keyof typeof MarketRegistrationStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MarketRegistrationStatus = {
  Pending: 'Pending',
  Approved: 'Approved',
  Rejected: 'Rejected',
} as const;

/**
 * @nullable
 */
export type MarketRegistrationResponseFilteredResponseFilters = unknown | null;

export interface MarketRegistrationResponse {
  allowMarketOrder?: boolean;
  amountScale?: number;
  /** @nullable */
  baseAsset?: string | null;
  baseFee?: number;
  createdAt?: string;
  id?: string;
  /** @nullable */
  instrument?: string | null;
  isFixedRatio?: boolean;
  isStable?: boolean;
  makerFee?: number;
  makerFeeLimit?: number;
  marketType?: MarketType;
  maxPrice?: number;
  /** @nullable */
  maxPriceDeviationPercent?: number | null;
  maxSellPriceVariationPercent?: number;
  minAmount?: number;
  minBuyPriceVariationPercent?: number;
  minPrice?: number;
  preventMarketMakersMatch?: boolean;
  priceScale?: number;
  /** @nullable */
  quoteAsset?: string | null;
  quoteFee?: number;
  registrationStatus?: MarketRegistrationStatus;
  /** @nullable */
  rejectionReason?: string | null;
  /** @nullable */
  requestByCorePassId?: string | null;
  /** @nullable */
  reviewedAt?: string | null;
  /** @nullable */
  reviewedById?: string | null;
  takerFee?: number;
  takerFeeLimit?: number;
  /** @nullable */
  updatedAt?: string | null;
}

export interface MarketRegistrationResponseFilteredResponse {
  /** @nullable */
  data?: MarketRegistrationResponse[] | null;
  /** @nullable */
  filters?: MarketRegistrationResponseFilteredResponseFilters;
  paging?: Paging;
}

export interface MarketRegistrationDto {
  allowMarketOrder: boolean;
  amountScale: number;
  baseAsset: string;
  baseFee: number;
  instrument: string;
  isFixedRatio: boolean;
  isStable: boolean;
  makerFee: number;
  makerFeeLimit: number;
  marketType: MarketType;
  maxPrice: number;
  /** @nullable */
  maxPriceDeviationPercent?: number | null;
  maxSellPriceVariationPercent: number;
  minAmount: number;
  minBuyPriceVariationPercent: number;
  minPrice: number;
  preventMarketMakersMatch: boolean;
  priceScale: number;
  quoteAsset: string;
  quoteFee: number;
  takerFee: number;
  takerFeeLimit: number;
}

export interface MarketingChannelResponse {
  /** @nullable */
  code?: string | null;
  createdAt?: string;
  id?: string;
  /** @nullable */
  label?: string | null;
}

export interface ManualTransferRequest {
  amount: number;
  asset: string;
  /** @nullable */
  code?: string | null;
  /** @nullable */
  comment?: string | null;
  /** @nullable */
  errorDetails?: string | null;
  status: TransferStatus;
  /** @nullable */
  tokenId?: string | null;
  type: TransferType;
  userId: string;
}

export interface LabResults {
  ash?: MeasurementValue;
  color?: MeasurementValue;
  moisture?: MeasurementValue;
  ph?: MeasurementValue;
  polarization?: MeasurementValue;
  protein?: MeasurementValue;
  so2?: MeasurementValue;
}

export type KycStatus = (typeof KycStatus)[keyof typeof KycStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const KycStatus = {
  Kyc: 'Kyc',
  InProgress: 'InProgress',
  Failed: 'Failed',
} as const;

export interface KnownMetadata {
  documents?: SealableValue;
  lab?: SealableValue;
  tokenExpiration?: SealableValue;
  tradingStop?: SealableValue;
}

export interface IssueDigitalRewardsResponse {
  failedCount?: number;
  issuedCount?: number;
  skippedCount?: number;
  /** @nullable */
  winners?: CampaignWinnerAdminResponse[] | null;
}

export interface InvestmentRecordResponse {
  amount?: number;
  /** @nullable */
  assetId?: string | null;
  /** @nullable */
  chain?: string | null;
  /** @nullable */
  date?: string | null;
  generatedRevenue?: number;
  /** @nullable */
  id?: string | null;
  /** @nullable */
  paybackMonths?: number | null;
  roi?: number;
  /** @nullable */
  status?: string | null;
  /** @nullable */
  type?: string | null;
}

export interface InvestmentRecordResponseRevenuePagedResponse {
  /** @nullable */
  items?: InvestmentRecordResponse[] | null;
  page?: number;
  perPage?: number;
  totalElements?: number;
  totalPages?: number;
}

export interface InvalidateAddressbookRequest {
  addressBookId: string;
  /**
   * @minLength 0
   * @maxLength 2048
   */
  comment: string;
}

export interface InternalExchangeAccessRevokeRequest {
  userId: string;
}

export interface InternalExchangeAccessGrantRequest {
  userId: string;
}

export interface InternalExchangeAccessAccountInfoViewModel {
  accountId?: number;
  /** @nullable */
  activityStatus?: string | null;
  /** @nullable */
  complianceTier?: string | null;
  /** @nullable */
  corePassId?: string | null;
  /** @nullable */
  email?: string | null;
  /** @nullable */
  fullName?: string | null;
  /** @nullable */
  fullNameEnglish?: string | null;
  id?: number;
  /** @nullable */
  kycVersion?: number | null;
  /** @nullable */
  nationality?: string | null;
  /** @nullable */
  residency?: string | null;
  tagId?: number;
  /** @nullable */
  updatedAt?: string | null;
  /** @nullable */
  userId?: string | null;
  /** @nullable */
  userName?: string | null;
  value?: boolean;
}

export interface InternalExchangeAccessUsersPageViewModel {
  hasMore?: boolean;
  /** @nullable */
  nextCursor?: number | null;
  /** @nullable */
  users?: InternalExchangeAccessAccountInfoViewModel[] | null;
}

export interface InjectFuelRequest {
  /** @nullable */
  transfers?: IColdStorageTransactionColdStorageTransfer[] | null;
}

export interface InjectFuelItemResponse {
  createdAt?: string;
  /** @nullable */
  file?: string | null;
  id?: number;
  paymentSystem?: PaymentSystem;
  status?: FuelInjectionStatus;
}

export interface InjectFuelDetailItemResponse {
  /** @nullable */
  blockchainTxId?: string | null;
  createdAt?: string;
  /** @nullable */
  errorMessage?: string | null;
  id?: number;
  status?: FuelInjectionDetailStatus;
  transactionId?: string;
}

export interface IColdStorageTransaction {
  /** @nullable */
  readonly asset?: string | null;
  readonly id?: string;
}

export interface IColdStorageTransactionColdStorageTransfer {
  transaction?: IColdStorageTransaction;
}

export interface IColdStorageSignedTransaction {
  /** @nullable */
  readonly asset?: string | null;
  readonly id?: string;
  /** @nullable */
  readonly rawHex?: string | null;
}

export interface IBalance {
  /** @nullable */
  readonly amount?: string | null;
  /** @nullable */
  readonly asset?: string | null;
  readonly decimals?: number;
  readonly depositCount?: number;
  readonly nonce?: number;
}

export interface HotWalletResponse {
  /** @nullable */
  address?: string | null;
  /** @nullable */
  amount?: number | null;
  /** @nullable */
  assetId?: string | null;
  /** @nullable */
  coldWalletAddress?: string | null;
  /** @nullable */
  displayAmount?: number | null;
  /** @nullable */
  error?: string | null;
  /** @nullable */
  paymentSystem?: string | null;
  /** @nullable */
  rate?: number | null;
}

export interface GetUserRequest {
  userId?: string;
}

export interface GetUserOrderTradesDocumentRequest {
  matchedOrderId?: string;
  orderId?: string;
  userId?: string;
}

export interface GetUserDetailsRequest {
  requestId: string;
  userId: string;
}

export interface GetTransfersByUserResponse {
  /** @nullable */
  cursor?: string | null;
  /** @nullable */
  data?: UserTransferData[] | null;
}

export interface GetTransfersByUserRequest {
  /**
   * @maxLength 1024
   * @nullable
   */
  cursor?: string | null;
  /**
   * @minimum 1
   * @maximum 100
   * @nullable
   */
  perPage?: number | null;
  type: TransferType;
  userId: string;
}

export interface GetPaymentWebhookNotificationsRequest {
  /** @nullable */
  paymentExecutionId?: string | null;
  paymentId: string;
}

export interface GetPaymentsRequest {
  /**
   * @maxLength 128
   * @nullable
   */
  clientPaymentId?: string | null;
  /**
   * @maxLength 1024
   * @nullable
   */
  cursor?: string | null;
  /** @nullable */
  donate?: boolean | null;
  /** @nullable */
  endDate?: string | null;
  /** @nullable */
  isRecurring?: boolean | null;
  /**
   * @maxLength 128
   * @nullable
   */
  organization?: string | null;
  /**
   * @minimum 1
   * @maximum 100
   * @nullable
   */
  perPage?: number | null;
  /**
   * @maxLength 128
   * @nullable
   */
  receiverCorePassId?: string | null;
  /**
   * @maxLength 64
   * @nullable
   */
  resolvedCurrency?: string | null;
  /**
   * Find by UserName or Email or CorePassId
   * @maxLength 256
   * @nullable
   */
  search?: string | null;
  /** @nullable */
  startDate?: string | null;
  /**
   * @maxLength 32
   * @nullable
   */
  status?: string | null;
}

export interface GetPaymentsByUserRequest {
  /**
   * @maxLength 1024
   * @nullable
   */
  cursor?: string | null;
  /**
   * @minimum 1
   * @maximum 100
   * @nullable
   */
  perPage?: number | null;
  userId: string;
}

export interface GetPaymentExecutionsByPaymentIdRequest {
  /**
   * @maxLength 1024
   * @nullable
   */
  cursor?: string | null;
  paymentId: string;
  /**
   * @minimum 1
   * @maximum 100
   * @nullable
   */
  perPage?: number | null;
}

export interface GetPaymentDigitizedCurrencyMappingsRequest {
  /**
   * @maxLength 32
   * @nullable
   */
  fiatCurrency?: string | null;
}

export interface GetOrdersByUserRequest {
  /**
   * @maxLength 1024
   * @nullable
   */
  cursor?: string | null;
  /**
   * @minimum 1
   * @maximum 100
   * @nullable
   */
  perPage?: number | null;
  userId: string;
}

/**
 * @nullable
 */
export type GetInjectFuelsResponseFilters = unknown | null;

export interface GetInjectFuelsResponse {
  /** @nullable */
  data?: InjectFuelItemResponse[] | null;
  /** @nullable */
  filters?: GetInjectFuelsResponseFilters;
  paging?: Paging;
}

/**
 * @nullable
 */
export type GetInjectFuelDetailResponseFilters = unknown | null;

export interface GetInjectFuelDetailResponse {
  /** @nullable */
  data?: InjectFuelDetailItemResponse[] | null;
  /** @nullable */
  filters?: GetInjectFuelDetailResponseFilters;
  paging?: Paging;
}

export interface GetDocumentsByUserRequest {
  /** @nullable */
  kycVersion?: number | null;
  userId?: string;
}

/**
 * @nullable
 */
export type GetBroadcastRequestsResponseFilters = unknown | null;

export interface GetBroadcastRequestsResponse {
  /** @nullable */
  data?: BroadcastRequestItemResponse[] | null;
  /** @nullable */
  filters?: GetBroadcastRequestsResponseFilters;
  paging?: Paging;
}

/**
 * @nullable
 */
export type GetBroadcastRequestDetailResponseFilters = unknown | null;

export interface GetBroadcastRequestDetailResponse {
  /** @nullable */
  data?: BroadcastRequestDetailItemResponse[] | null;
  /** @nullable */
  filters?: GetBroadcastRequestDetailResponseFilters;
  paging?: Paging;
}

export interface GetAccountTagsByUserRequest {
  userId: string;
}

export interface GeographicCountryResponse {
  /** @nullable */
  countryCode?: string | null;
  /** @nullable */
  countryName?: string | null;
  userCount?: number;
}

export type FuelInjectionStatus = (typeof FuelInjectionStatus)[keyof typeof FuelInjectionStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FuelInjectionStatus = {
  Pending: 'Pending',
  Processing: 'Processing',
  Broadcasted: 'Broadcasted',
  PartiallyCompleted: 'PartiallyCompleted',
  Completed: 'Completed',
  Failed: 'Failed',
} as const;

export type FuelInjectionDetailStatus = (typeof FuelInjectionDetailStatus)[keyof typeof FuelInjectionDetailStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FuelInjectionDetailStatus = {
  Processing: 'Processing',
  Sent: 'Sent',
  AwaitingConfirmation: 'AwaitingConfirmation',
  Completed: 'Completed',
  Error: 'Error',
  Canceled: 'Canceled',
} as const;

export interface FtCommodityCoreblockchainBalance {
  maxAvailableAmount?: number;
  /** @nullable */
  symbol?: string | null;
  userRequestedAmount?: number;
}

export interface FtCommodityBalanceResponse {
  maxAvailableAmount?: number;
  /** @nullable */
  symbol?: string | null;
  userRequestedAmount?: number;
}

export interface FtCommodityBalanceAggregateRequest {
  /** @nullable */
  balances?: FtCommodityCoreblockchainBalance[] | null;
  destination?: ColdStorageDestination;
}

export type FlagType = (typeof FlagType)[keyof typeof FlagType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FlagType = {
  BannedResidence: 'BannedResidence',
  HighRiskResidence: 'HighRiskResidence',
  PoliticallyExposedPerson: 'PoliticallyExposedPerson',
  AntiMoneyLaunderingPositive: 'AntiMoneyLaunderingPositive',
  NameDiscrepancy: 'NameDiscrepancy',
  HighRiskNationality: 'HighRiskNationality',
  MissingAddressState: 'MissingAddressState',
  UnderAge: 'UnderAge',
  MissingExpiryDate: 'MissingExpiryDate',
  NationalityFieldMissing: 'NationalityFieldMissing',
} as const;

export interface FlagDetail {
  /** @nullable */
  comment?: string | null;
  /** @nullable */
  disabledAt?: string | null;
  flagType?: FlagType;
  isDisabled?: boolean;
}

export interface FeeWithdrawalRecordResponse {
  amount?: number;
  /** @nullable */
  assetId?: string | null;
  /** @nullable */
  createdAt?: string | null;
  /** @nullable */
  destination?: string | null;
  /** @nullable */
  id?: string | null;
  /** @nullable */
  notes?: string | null;
  /** @nullable */
  source?: string | null;
  /** @nullable */
  status?: string | null;
}

export interface FeeWithdrawalRecordResponseRevenuePagedResponse {
  /** @nullable */
  items?: FeeWithdrawalRecordResponse[] | null;
  page?: number;
  perPage?: number;
  totalElements?: number;
  totalPages?: number;
}

export interface FeeBalancePerAssetResponse {
  /** @nullable */
  assetId?: string | null;
  /** @nullable */
  assetSymbol?: string | null;
  safeWithdrawal?: number;
  totalAvailable?: number;
  tradingFees?: number;
  withdrawFees?: number;
}

export interface FeeBalancesResponse {
  /** @nullable */
  perAsset?: FeeBalancePerAssetResponse[] | null;
  recommendedReserve?: number;
  reserveRatio?: number;
  safeWithdrawalAmount?: number;
  suggestedWithdrawal?: number;
  totalAvailable?: number;
  tradingFees?: number;
  withdrawFees?: number;
}

export interface ExecuteCampaignRedrawResponse {
  campaignId?: string;
  redrawsExecuted?: number;
  /** @nullable */
  winners?: CampaignRedrawWinnerResponse[] | null;
}

export interface ExecuteCampaignRedrawRequest {
  /** @nullable */
  prizeId?: string | null;
}

export type ExecType = (typeof ExecType)[keyof typeof ExecType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExecType = {
  OrderStatusUpdate: 'OrderStatusUpdate',
  Trade: 'Trade',
} as const;

export interface DrawWinnerResponse {
  accountId?: number;
  /** @nullable */
  email?: string | null;
  entryWeight?: number;
  participantId?: string;
  prizeId?: string;
  /** @nullable */
  prizeName?: string | null;
  userId?: string;
  /** @nullable */
  userName?: string | null;
}

export interface DrawCampaignFullResponse {
  campaignId?: string;
  campaignStatus?: CampaignStatus;
  /** @nullable */
  winners?: DrawWinnerResponse[] | null;
  winnersSelected?: number;
}

export interface DeletePaymentDigitizedCurrencyMappingRequest {
  id: string;
}

export interface DeleteAccountTagRequest {
  id: number;
}

export interface CreateTreasuryColdReplenishmentIntentRequest {
  amount?: number;
  /** @nullable */
  intentNote?: string | null;
  /** @nullable */
  paymentSystem?: string | null;
}

export interface CreatePaymentDigitizedCurrencyMappingResponse {
  id?: string;
}

export interface CreatePaymentDigitizedCurrencyMappingRequest {
  /** @maxLength 32 */
  digitizedCryptoAssetId: string;
  /** @maxLength 32 */
  fiatCurrency: string;
}

export interface CreateMarketRequest {
  allow_market_order: boolean;
  amount_scale: number;
  base_asset: string;
  base_fee: number;
  hidden: boolean;
  instrument: string;
  is_fixed_ratio: boolean;
  is_stable: boolean;
  maker_fee: number;
  maker_fee_limit: number;
  market_type: MarketType;
  max_price: number;
  /** @nullable */
  max_price_deviation_percent?: number | null;
  max_sell_price_variation_percent: number;
  min_amount: number;
  min_buy_price_variation_percent: number;
  min_price: number;
  prevent_market_makers_match: boolean;
  price_scale: number;
  quote_asset: string;
  quote_fee: number;
  taker_fee: number;
  taker_fee_limit: number;
  visibility?: MarketVisibility;
}

export interface CreateMarketRegistrationRequest {
  corePassId: string;
  marketRegistrationDto: MarketRegistrationDto;
}

export interface CreateMarketingChannelRequest {
  code: string;
  label: string;
}

export interface CreateInvestmentRequest {
  amount?: number;
  /** @nullable */
  assetId?: string | null;
  /** @nullable */
  chain?: string | null;
  /** @nullable */
  date?: string | null;
  /** @nullable */
  type?: string | null;
}

export interface CreateFeeWithdrawalRequest {
  amount?: number;
  /** @nullable */
  assetId?: string | null;
  /** @nullable */
  destination?: string | null;
  /** @nullable */
  notes?: string | null;
  /** @nullable */
  source?: string | null;
}

export interface CreateCampaignPrizeRequest {
  amount: number;
  currency: string;
  prizeType?: CampaignPrizeType;
  /**
   * @minimum 1
   * @maximum 2147483647
   */
  quantity?: number;
  tierName: string;
  /**
   * @minimum 1
   * @maximum 2147483647
   */
  tierOrder?: number;
}

export interface CreateCampaignRequest {
  autoLifecycleEnabled?: boolean;
  /** @nullable */
  description?: string | null;
  /** @nullable */
  drawReminders?: CampaignDrawReminderRequest[] | null;
  /** @nullable */
  drawScheduledAt?: string | null;
  drawType?: CampaignDrawType;
  entryEndsAt: string;
  entryStartsAt: string;
  /** @minItems 1 */
  prizes: CreateCampaignPrizeRequest[];
  /** @nullable */
  qualificationReminders?: CampaignQualificationReminderRequest[] | null;
  /** @nullable */
  redrawEndsAt?: string | null;
  redrawRewardFulfillmentType?: CampaignRewardFulfillmentType;
  redrawType?: CampaignRedrawType;
  redrawWinnerAnnounceOrder?: CampaignWinnerAnnounceOrder;
  /** @nullable */
  referralCode?: string | null;
  /** @nullable */
  rewardClaimableAt?: string | null;
  rewardFulfillmentType?: CampaignRewardFulfillmentType;
  /** @nullable */
  rewardScheduledAt?: string | null;
  /** @nullable */
  rulesConfig?: string | null;
  showWinnerCoreIdPartiallyUnmasked?: boolean;
  slug: string;
  title: string;
  winnerAnnounceOrder?: CampaignWinnerAnnounceOrder;
  /** @nullable */
  winnerCoreIdPartialMaskFormat?: string | null;
}

export interface CreateBroadcastRequest {
  /** @nullable */
  signedTransactions?: IColdStorageSignedTransaction[] | null;
}

export interface CreateAssetRequest {
  asset_type: AssetType;
  blockchain_configs: AssetBlockchainConfigRequest[];
  /** @nullable */
  coingecko_id?: string | null;
  commodity_asset?: CommodityAssetRequest;
  /** @nullable */
  icon_url?: string | null;
  id: string;
  internal_withdrawal_fee_percent?: number;
  maximum_internal_withdrawal_fee_fixed_amount?: number;
  name: string;
  scale: number;
  /** @nullable */
  website_url?: string | null;
}

export interface CreateAssetRegistrationRequest {
  corePassId: string;
  createAssetRequest: CreateAssetRequest;
}

export interface CreateAssetContractRequest {
  /**
   * @minLength 0
   * @maxLength 8
   */
  asset_id: string;
  content: string;
  format: AssetContractFormat;
}

export interface CreateAppConfigRequest {
  /**
   * @minLength 1
   * @maxLength 256
   */
  key: string;
  value: string;
}

export interface CreateApiKeyResponse {
  /** @nullable */
  apiKey?: string | null;
  /** @nullable */
  apiSecret?: string | null;
  /** @nullable */
  displayName?: string | null;
  /** @nullable */
  expiresAt?: number | null;
}

export interface CreateAccountTagRequest {
  tagId: number;
  userId: string;
  /** @pattern ^[a-zA-Z0-9]*$ */
  value: string;
}

export interface CostTrendPointResponse {
  /** @nullable */
  date?: string | null;
  gas?: number;
  liquidityIncentive?: number;
  manualAdjustment?: number;
  marketMaking?: number;
  operational?: number;
  referral?: number;
  rewards?: number;
  total?: number;
}

export interface CostEfficiencyResponse {
  costToRevenueRatio?: number;
  referralGeneratedRevenue?: number;
  referralRoi?: number;
  referralSpent?: number;
  rewardEfficiency?: number;
  rewardGeneratedRevenue?: number;
  rewardSpent?: number;
}

export interface CostBreakdownItemResponse {
  amount?: number;
  /** @nullable */
  category?: string | null;
  normalizedUsdValue?: number;
  percentage?: number;
}

export interface ConfirmTreasuryColdReplenishmentIntentRequest {
  /** @nullable */
  confirmationTxId?: string | null;
}

export interface ComplianceUserWithdrawalLimitsResponse {
  /** @nullable */
  currentMonthWithdrawalAmount?: number | null;
  /** @nullable */
  currentYearWithdrawalAmount?: number | null;
  /** @nullable */
  monthlyLimit?: number | null;
  /** @nullable */
  yearlyLimit?: number | null;
}

export interface ComplianceUsersResponse {
  /** @nullable */
  cursor?: string | null;
  /** @nullable */
  data?: ComplianceResponseItem[] | null;
  pendingRequestsCount?: number;
}

export interface ComplianceUsersRequest {
  /** @nullable */
  cursor?: string | null;
  /** @nullable */
  perPage?: number | null;
  /** @nullable */
  search?: string | null;
  status?: UserComplianceRequestStatus;
  userTier?: UserComplianceTier;
}

export interface ComplianceUserSettingResponse {
  /** @nullable */
  key?: string | null;
  /** @nullable */
  namespace?: string | null;
  userId?: number;
  /** @nullable */
  value?: string | null;
}

export interface ComplianceUserRiskPolicyOutcomeResponse {
  /** @nullable */
  actionDueAt?: string | null;
  /** @nullable */
  evidenceIds?: string[] | null;
  isBlocking?: boolean;
  /** @nullable */
  minimumRiskLevel?: string | null;
  /** @nullable */
  outcomeType?: string | null;
  /** @nullable */
  policyCode?: string | null;
  /** @nullable */
  policyVersion?: string | null;
  /** @nullable */
  priority?: string | null;
  /** @nullable */
  reasonCode?: string | null;
  /** @nullable */
  summary?: string | null;
  /** @nullable */
  triggeringFactorCodes?: string[] | null;
}

export interface ComplianceUserRiskOverrideResponse {
  /** @nullable */
  approvedAt?: string | null;
  /** @nullable */
  approvedBy?: string | null;
  /** @nullable */
  effectiveRiskLevel?: string | null;
  /** @nullable */
  expiresAt?: string | null;
  overriddenAt?: string;
  /** @nullable */
  overriddenBy?: string | null;
  /** @nullable */
  overrideId?: string | null;
  /** @nullable */
  reason?: string | null;
  /** @nullable */
  reasonCode?: string | null;
  /** @nullable */
  relatedReviewId?: string | null;
}

export interface ComplianceUserRiskFactorResponse {
  /** @nullable */
  assessmentStatus?: string | null;
  /** @nullable */
  category?: string | null;
  /** @nullable */
  contributionBasisPoints?: number | null;
  /** @nullable */
  evidenceIds?: string[] | null;
  /** @nullable */
  factorCode?: string | null;
  /** @nullable */
  factorScore?: number | null;
  /** @nullable */
  ruleId?: string | null;
  /** @nullable */
  ruleVersion?: string | null;
  /** @nullable */
  summary?: string | null;
  weightBasisPoints?: number;
}

export interface ComplianceUserRiskEvidenceResponse {
  collectedAt?: string;
  /** @nullable */
  confidenceScore?: number | null;
  /** @nullable */
  dataVersion?: string | null;
  /** @nullable */
  evidenceId?: string | null;
  /** @nullable */
  evidenceType?: string | null;
  /** @nullable */
  observedAt?: string | null;
  /** @nullable */
  signalId?: string | null;
  /** @nullable */
  sourceReference?: string | null;
  /** @nullable */
  sourceSystem?: string | null;
  /** @nullable */
  summary?: string | null;
  /** @nullable */
  validUntil?: string | null;
}

export interface ComplianceUserRiskDataSourceResponse {
  /** @nullable */
  availabilityStatus?: string | null;
  /** @nullable */
  dataFrom?: string | null;
  /** @nullable */
  dataThrough?: string | null;
  /** @nullable */
  failureCode?: string | null;
  /** @nullable */
  missingDataCodes?: string[] | null;
  /** @nullable */
  retrievedAt?: string | null;
  /** @nullable */
  sourceSystem?: string | null;
}

export interface ComplianceUserRiskResponse {
  /** @nullable */
  assessmentId?: string | null;
  /** @nullable */
  assessmentStatus?: string | null;
  /** @nullable */
  assessmentTrigger?: string | null;
  /** @nullable */
  calculatedRiskLevel?: string | null;
  dataCompletenessScore?: number;
  /** @nullable */
  dataSources?: ComplianceUserRiskDataSourceResponse[] | null;
  /** @nullable */
  dataThrough?: string | null;
  /** @nullable */
  effectiveRiskLevel?: string | null;
  evaluatedAt?: string;
  /** @nullable */
  evidences?: ComplianceUserRiskEvidenceResponse[] | null;
  /** @nullable */
  factors?: ComplianceUserRiskFactorResponse[] | null;
  manualOverride?: ComplianceUserRiskOverrideResponse;
  /** @nullable */
  methodologyHash?: string | null;
  /** @nullable */
  methodologyVersion?: string | null;
  /** @nullable */
  nextReviewAt?: string | null;
  /** @nullable */
  policyOutcomes?: ComplianceUserRiskPolicyOutcomeResponse[] | null;
  /** @nullable */
  previousAssessmentId?: string | null;
  /** @nullable */
  regulatoryProfileVersion?: string | null;
  /** @nullable */
  riskScore?: number | null;
  /** @nullable */
  summary?: string | null;
  /** @nullable */
  triggerId?: string | null;
  /** @nullable */
  userId?: string | null;
}

export interface ComplianceUserReviewResponse {
  /** @nullable */
  acknowledgedAt?: string | null;
  /** @nullable */
  comment?: string | null;
  createdAt?: string;
  createdBySystem?: boolean;
  /** @nullable */
  id?: string | null;
  /** @nullable */
  modifierId?: string | null;
  /** @nullable */
  readyToReviewAt?: string | null;
  /** @nullable */
  resolvedAt?: string | null;
  /** @nullable */
  status?: string | null;
  /** @nullable */
  type?: string | null;
  /** @nullable */
  userId?: string | null;
}

export interface ComplianceUserKycSnapshotResponse {
  /** @nullable */
  addressCountry?: string | null;
  /** @nullable */
  addressExpirationDate?: string | null;
  /** @nullable */
  addressName?: string | null;
  /** @nullable */
  comment?: string | null;
  createdAt?: string;
  /** @nullable */
  documentCountry?: string | null;
  /** @nullable */
  documentExpirationDate?: string | null;
  /** @nullable */
  documentName?: string | null;
  /** @nullable */
  documentType?: string | null;
  /** @nullable */
  expirationDate?: string | null;
  /** @nullable */
  id?: string | null;
  kycVersion?: number;
  /** @nullable */
  userId?: string | null;
}

export interface ComplianceUserInfoResponse {
  /** @nullable */
  employmentStatus?: string | null;
  /** @nullable */
  entityType?: string | null;
  /** @nullable */
  formSignature?: string | null;
  /** @nullable */
  formSignatureDate?: string | null;
  /** @nullable */
  industry?: string | null;
  /** @nullable */
  otherIndustry?: string | null;
  /** @nullable */
  primarySource?: string | null;
  /** @nullable */
  primaryUse?: string | null;
  /** @nullable */
  termsAccepted?: string | null;
  /** @nullable */
  totalValue?: string | null;
  /** @nullable */
  userId?: string | null;
}

export interface ComplianceUserFlagResponse {
  assignedAt?: string;
  /** @nullable */
  comment?: string | null;
  /** @nullable */
  disabledAt?: string | null;
  /** @nullable */
  flagType?: string | null;
  /** @nullable */
  id?: string | null;
  isDisabled?: boolean;
  kycVersion?: number;
  /** @nullable */
  userId?: string | null;
}

export interface ComplianceUserResponse {
  /** @nullable */
  businessStatus?: string | null;
  complianceRisk?: ComplianceUserRiskResponse;
  /** @nullable */
  flags?: ComplianceUserFlagResponse[] | null;
  info?: ComplianceUserInfoResponse;
  kycFieldsSnapshot?: ComplianceUserKycSnapshotResponse;
  /** @nullable */
  reviews?: ComplianceUserReviewResponse[] | null;
  user?: ComplianceUserAccountResponse;
}

export interface ComplianceUserDetailsRequest {
  requestId: string;
  userId: string;
}

export interface ComplianceUserAccountResponse {
  accountId?: number;
  /** @nullable */
  activityStatus?: string | null;
  /** @nullable */
  affiliateId?: string | null;
  amlCheck?: boolean;
  /** @nullable */
  amlData?: string | null;
  /** @nullable */
  complianceTier?: string | null;
  /** @nullable */
  corePassId?: string | null;
  /** @nullable */
  documentExpirationDate?: string | null;
  /** @nullable */
  email?: string | null;
  /** @nullable */
  fullName?: string | null;
  /** @nullable */
  fullNameEnglish?: string | null;
  /** @nullable */
  id?: string | null;
  isKycVerified?: boolean;
  /** @nullable */
  kycError?: string | null;
  /** @nullable */
  kycFailedAt?: string | null;
  kycIsInProgress?: boolean;
  /** @nullable */
  kycStartedAt?: string | null;
  /** @nullable */
  kycVerifiedAt?: string | null;
  kycVersion?: number;
  /** @nullable */
  lastLoginDate?: string | null;
  /** @nullable */
  lastValidityCheck?: string | null;
  /** @nullable */
  nationality?: string | null;
  /** @nullable */
  normalizedEmail?: string | null;
  /** @nullable */
  referralAgentUserId?: number | null;
  /** @nullable */
  referralCode?: string | null;
  /** @nullable */
  referralId?: string | null;
  registrationDate?: string;
  /** @nullable */
  residency?: string | null;
  /** @nullable */
  settings?: ComplianceUserSettingResponse[] | null;
  userIntId?: number;
}

export interface ComplianceTierDowngradeRequest {
  /** @pattern ^[a-zA-Z0-9-.\s]*$ */
  reason: string;
  userId: string;
}

export interface ComplianceTierCountResponse {
  tier?: UserComplianceTierType;
  userCount?: number;
}

export interface ComplianceResponseItem {
  complianceRequestType?: UserReviewRequestType;
  complianceTier?: UserComplianceTierType;
  /** @nullable */
  corePassId?: string | null;
  /** @nullable */
  emailAddress?: string | null;
  /** @nullable */
  fullName?: string | null;
  isBusiness?: boolean;
  /** @nullable */
  requestPendingTime?: number | null;
  /** @nullable */
  userActiveRequestId?: string | null;
  userId?: string;
  userStatus?: ActivityStatus;
}

export interface ComplianceRequest {
  /** @nullable */
  comment?: string | null;
  complianceRequestType?: UserReviewRequestType;
  createdAt?: string;
  id?: string;
  /** @nullable */
  modifierId?: string | null;
  /** @nullable */
  readyToReviewAt?: string | null;
  /** @nullable */
  resolvedAt?: string | null;
  status?: UserReviewStatusType;
}

export interface ComplianceKybStages {
  dataRequest?: string;
  documents?: string;
  formK?: string;
  questionnaire?: string;
}

export interface ComplianceKybDecisionFlag {
  flag?: string;
  originKind?: string;
  /** @nullable */
  originRef?: string | null;
}

export interface ComplianceKybDecision {
  decidedAt?: string;
  /** @nullable */
  flags?: ComplianceKybDecisionFlag[] | null;
  outcome?: string;
  /** @nullable */
  questionnaireVersionId?: string | null;
  ruleVersion?: string;
}

export interface ComplianceKybSignedDocumentVersion {
  /** @nullable */
  content?: unknown;
  createdAt?: string;
  id?: string;
  /** @nullable */
  pdfStorageDocumentId?: string | null;
  status?: string;
  templateVersion?: string;
  updatedAt?: string;
}

export interface ComplianceKybApplication {
  createdAt?: string;
  /** @nullable */
  decision?: ComplianceKybDecision | null;
  /** @nullable */
  formKVersions?: ComplianceKybSignedDocumentVersion[] | null;
  id?: string;
  kind?: string;
  /** @nullable */
  questionnaireVersions?: ComplianceKybSignedDocumentVersion[] | null;
  /** @nullable */
  stages?: ComplianceKybStages | null;
  status?: string;
  /** @nullable */
  terminalReason?: string | null;
}

export interface ComplianceKybEvidenceField {
  fieldName?: string | null;
  label?: string;
  mandatory?: boolean;
  ordinal?: number;
  provenance?: string | null;
  refusalOutcome?: string | null;
  subject?: string | null;
  subjectType?: string | null;
  value?: string | null;
}

export interface ComplianceKybEvidence {
  /** @nullable */
  fields?: ComplianceKybEvidenceField[] | null;
  id?: string;
  kybApplicationId?: string;
  storedAt?: string;
}

export interface ComplianceBusinessProfile {
  businessStatus?: string;
  /** The company and declared facts. */
  content?: unknown;
  id?: string;
  kybStatus?: string;
  /** @nullable */
  oric?: string | null;
  tier?: string;
}

export interface ComplianceKybMember {
  corePassId?: string;
  /** @nullable */
  hasVotingRights?: boolean | null;
  /** @nullable */
  isCreator?: boolean | null;
  /** @nullable */
  isUbo?: boolean | null;
  kycMet?: boolean;
}

export interface ComplianceBusinessDetails {
  /** Newest first. */
  /** @nullable */
  applications?: ComplianceKybApplication[] | null;
  businessId?: string;
  businessWalletAddress?: string;
  /** @nullable */
  evidence?: ComplianceKybEvidence | null;
  /** @nullable */
  members?: ComplianceKybMember[] | null;
  /** @nullable */
  membersRetrievedAt?: string | null;
  /** @nullable */
  profile?: ComplianceBusinessProfile | null;
}

export interface ComplianceUserDetailsResponse {
  accountCreated?: string;
  addressBook?: AddressBookResponse;
  /** @nullable */
  addressNote?: string | null;
  amlCheck?: boolean;
  /** @nullable */
  amlData?: string | null;
  /** @nullable */
  availableStatusTransitions?: string[] | null;
  /** @nullable */
  business?: ComplianceBusinessDetails | null;
  /** @nullable */
  businessDocuments?: UserDocument[] | null;
  canApproveOrReject?: boolean;
  complianceRequestType?: UserReviewRequestType;
  complianceTier?: UserComplianceTierType;
  /** @nullable */
  coreId?: string | null;
  /** @nullable */
  documentNote?: string | null;
  /** @nullable */
  email?: string | null;
  /** @nullable */
  flagDetails?: FlagDetail[] | null;
  /** @nullable */
  fullName?: string | null;
  /** @nullable */
  fullNameEnglish?: string | null;
  /** @nullable */
  nationality?: string | null;
  /** @nullable */
  requestedForApprovalComplianceTier?: string | null;
  /** @nullable */
  requestPendingTime?: number | null;
  /** @nullable */
  residence?: string | null;
  /** Documents uploaded for a business compliance review. Empty for a person. */
  /** @nullable */
  reviewDocuments?: UserDocument[] | null;
  status?: ActivityStatus;
  /** @nullable */
  totalCurrentMonthWithdrawalAmount?: number | null;
  /** @nullable */
  totalCurrentYearWithdrawalAmount?: number | null;
  /** @nullable */
  totalMonthlyLimit?: number | null;
  /** @nullable */
  totalYearlyLimit?: number | null;
  /** @nullable */
  userDocuments?: UserDocument[] | null;
  userId?: string;
  userInfo?: UserInfoResponse;
  /** @nullable */
  userRequests?: ComplianceRequest[] | null;
  userStatus?: UserState;
}

export interface ComplianceRegistrationTrendResponse {
  /** @nullable */
  points?: RegistrationTrendPointResponse[] | null;
}

export type ComplianceGeographicDimension =
  (typeof ComplianceGeographicDimension)[keyof typeof ComplianceGeographicDimension];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ComplianceGeographicDimension = {
  Residency: 'Residency',
  Nationality: 'Nationality',
} as const;

export interface ComplianceGeographicDistributionResponse {
  /** @nullable */
  countries?: GeographicCountryResponse[] | null;
  dimension?: ComplianceGeographicDimension;
  unknownUserCount?: number;
}

export interface ComplianceDashboardUserResponse {
  complianceTier?: UserComplianceTierType;
  /** @nullable */
  corePassId?: string | null;
  /** @nullable */
  email?: string | null;
  /** @nullable */
  fullName?: string | null;
  /** @nullable */
  nationalityCode?: string | null;
  registrationDate?: string;
  /** @nullable */
  residencyCode?: string | null;
  userId?: string;
  userStatus?: ActivityStatus;
}

export interface ComplianceGeographicUsersResponse {
  /** @nullable */
  data?: ComplianceDashboardUserResponse[] | null;
  page?: number;
  perPage?: number;
  total?: number;
}

export interface ComplianceDashboardOverviewResponse {
  activeUsers?: number;
  frozenUsers?: number;
  inactiveUsers?: number;
  kycNotVerifiedUsers?: number;
  kycVerifiedUsers?: number;
  limitedUsers?: number;
  mutedUsers?: number;
  terminatedUsers?: number;
  /** @nullable */
  tierDistribution?: ComplianceTierCountResponse[] | null;
  totalUsers?: number;
  waitingForDataUsers?: number;
  waitingForReviewUsers?: number;
}

export interface ComplianceChangeUserStatusRequest {
  activityStatus?: ActivityStatus;
  mute?: boolean;
  /** @nullable */
  userId?: string | null;
  /** @nullable */
  usersIds?: string[] | null;
}

export type CommodityType = (typeof CommodityType)[keyof typeof CommodityType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CommodityType = {
  NonFractionalNFT: 'NonFractionalNFT',
  FractionalNFT: 'FractionalNFT',
  FT: 'FT',
} as const;

export interface CommodityMetadata {
  originCountry?: SealableValue;
  portDischarge?: SealableValue;
  shipmentAmount?: SealableValue;
  shipmentUnit?: SealableValue;
  shipmentWeight?: SealableValue;
  weightNet?: SealableValue;
}

export interface CommodityDocument {
  /** @nullable */
  fingerprint?: string | null;
  /** @nullable */
  location?: string | null;
  /** @nullable */
  name?: string | null;
}

export type CommodityCategory = (typeof CommodityCategory)[keyof typeof CommodityCategory];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CommodityCategory = {
  Energy: 'Energy',
  PreciousMetals: 'PreciousMetals',
  BaseMetals: 'BaseMetals',
  Agriculture: 'Agriculture',
  Livestock: 'Livestock',
  SoftCommodities: 'SoftCommodities',
  Technology: 'Technology',
  RealEstate: 'RealEstate',
  Collectibles: 'Collectibles',
  PatentsAndInnovation: 'PatentsAndInnovation',
  Music: 'Music',
  Entertainment: 'Entertainment',
  ArtAndCreativeWorks: 'ArtAndCreativeWorks',
} as const;

export interface CommodityAssetRequest {
  commodity_category: CommodityCategory;
  commodity_type: CommodityType;
  /** @nullable */
  days_until_near_expiration?: number | null;
  withdrawal_fee_asset_id: string;
}

export interface ColdWalletTransferRequest {
  amount: number;
  assetId: string;
  paymentSystem: string;
}

export interface ColdStorageDestination {
  /** @nullable */
  address?: string | null;
  readonly decimals?: number;
  /** @nullable */
  label?: string | null;
}

export interface CctpRouteResponse {
  createdAt?: string;
  destinationDomainId?: number;
  /** @nullable */
  destinationPaymentSystem?: string | null;
  enabled?: boolean;
  id?: string;
  /** @nullable */
  maxTransferAmount?: number | null;
  /** @nullable */
  messageTransmitterAddress?: string | null;
  minTransferAmount?: number;
  platformFee?: number;
  sourceDomainId?: number;
  /** @nullable */
  sourcePaymentSystem?: string | null;
  /** @nullable */
  tokenMessengerAddress?: string | null;
  updatedAt?: string;
}

export interface CashFlowPointResponse {
  costs?: number;
  /** @nullable */
  date?: string | null;
  fees?: number;
  gas?: number;
  inflow?: number;
  /** @nullable */
  liquidityRisk?: string | null;
  netFlow?: number;
  normalizedUsdInflow?: number;
  normalizedUsdNetFlow?: number;
  normalizedUsdOutflow?: number;
  outflow?: number;
  rewards?: number;
  withdrawals?: number;
}

export interface CancelWinnerAdminRequest {
  comment: string;
}

export type CancelReason = (typeof CancelReason)[keyof typeof CancelReason];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CancelReason = {
  NotCancelled: 'NotCancelled',
  CancelledByTrader: 'CancelledByTrader',
  CancelledBySystem: 'CancelledBySystem',
  SelfMatchPrevention: 'SelfMatchPrevention',
  CancelledByAdmin: 'CancelledByAdmin',
  NoMoreMatchesAvailable: 'NoMoreMatchesAvailable',
} as const;

export type CancellationActor = (typeof CancellationActor)[keyof typeof CancellationActor];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CancellationActor = {
  System: 'System',
  AdminUser: 'AdminUser',
} as const;

export interface CampaignWinnerRewardDetailResponse {
  amount?: number;
  /** @nullable */
  assetId?: string | null;
  /** @nullable */
  claimableAt?: string | null;
  creationDate?: string;
  isClaimed?: boolean;
  /** @nullable */
  reason?: string | null;
  rewardId?: string;
}

export type CampaignWinnerManualFulfillmentStatus =
  (typeof CampaignWinnerManualFulfillmentStatus)[keyof typeof CampaignWinnerManualFulfillmentStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CampaignWinnerManualFulfillmentStatus = {
  Given: 'Given',
  NotGiven: 'NotGiven',
} as const;

export type CampaignWinnerAnnounceOrder =
  (typeof CampaignWinnerAnnounceOrder)[keyof typeof CampaignWinnerAnnounceOrder];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CampaignWinnerAnnounceOrder = {
  HighestToLowest: 'HighestToLowest',
  LowestToHighest: 'LowestToHighest',
} as const;

export interface CampaignWinnerAdminResponse {
  /** @nullable */
  corePassId?: string | null;
  digitalRewardAttemptCount?: number;
  /** @nullable */
  digitalRewardLastError?: string | null;
  /** @nullable */
  drawSource?: string | null;
  /** @nullable */
  email?: string | null;
  /** @nullable */
  fulfilledAt?: string | null;
  /** @nullable */
  fulfillmentComment?: string | null;
  /** @nullable */
  fulfillmentStatus?: string | null;
  isRewardClaimed?: boolean;
  participantId?: string;
  prizeAmount?: number;
  /** @nullable */
  prizeCurrency?: string | null;
  prizeId?: string;
  prizeType?: CampaignPrizeType;
  /** @nullable */
  redrawNumber?: number | null;
  /** @nullable */
  replacedCancelledParticipantId?: string | null;
  /** @nullable */
  rewardId?: string | null;
  /** @nullable */
  tierName?: string | null;
  tierOrder?: number;
  /** @nullable */
  userName?: string | null;
  /** @nullable */
  winnerStatus?: string | null;
}

export type CampaignStatus = (typeof CampaignStatus)[keyof typeof CampaignStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CampaignStatus = {
  Draft: 'Draft',
  Scheduled: 'Scheduled',
  Active: 'Active',
  EntryClosed: 'EntryClosed',
  DrawInProgress: 'DrawInProgress',
  Completed: 'Completed',
  Cancelled: 'Cancelled',
} as const;

export type CampaignRewardFulfillmentType =
  (typeof CampaignRewardFulfillmentType)[keyof typeof CampaignRewardFulfillmentType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CampaignRewardFulfillmentType = {
  Auto: 'Auto',
  Manual: 'Manual',
} as const;

export interface CampaignRedrawWinnerResponse {
  accountId?: number;
  entryWeight?: number;
  participantId?: string;
  prizeId?: string;
  redrawNumber?: number;
  replacedCancelledParticipantId?: string;
  /** @nullable */
  tierName?: string | null;
  userId?: string;
}

export interface CampaignRedrawVacatedPrizeResponse {
  accountId?: number;
  cancelledParticipantId?: string;
  /** @nullable */
  corePassId?: string | null;
  prizeId?: string;
  /** @nullable */
  tierName?: string | null;
  tierOrder?: number;
}

export type CampaignRedrawType = (typeof CampaignRedrawType)[keyof typeof CampaignRedrawType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CampaignRedrawType = {
  Auto: 'Auto',
  Manual: 'Manual',
} as const;

export type CampaignRedrawStatus = (typeof CampaignRedrawStatus)[keyof typeof CampaignRedrawStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CampaignRedrawStatus = {
  NotStarted: 'NotStarted',
  Active: 'Active',
  Completed: 'Completed',
} as const;

export interface CampaignQualificationReminderResponse {
  id?: string;
  scheduledAt: string;
  /** @nullable */
  sentAt?: string | null;
}

export interface CampaignQualificationReminderRequest {
  scheduledAt: string;
}

export type CampaignPrizeType = (typeof CampaignPrizeType)[keyof typeof CampaignPrizeType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CampaignPrizeType = {
  DigitalAsset: 'DigitalAsset',
  Voucher: 'Voucher',
  Other: 'Other',
} as const;

export interface CampaignPrizeAdminResponse {
  amount?: number;
  /** @nullable */
  currency?: string | null;
  id?: string;
  prizeType?: CampaignPrizeType;
  quantity?: number;
  /** @nullable */
  tierName?: string | null;
  tierOrder?: number;
}

/**
 * @nullable
 */
export type CampaignParticipantsListResponseFilters = unknown | null;

export interface CampaignParticipantDetailAdminResponse {
  accountId?: number;
  /** @nullable */
  cardPreference?: string | null;
  /** @nullable */
  corePassId?: string | null;
  /** @nullable */
  disqualificationComment?: string | null;
  /** @nullable */
  drawSource?: string | null;
  /** @nullable */
  email?: string | null;
  entryWeight?: number;
  /** @nullable */
  fulfilledAt?: string | null;
  /** @nullable */
  fulfillmentComment?: string | null;
  /** @nullable */
  fulfillmentStatus?: string | null;
  id?: string;
  /** @nullable */
  isQualified?: boolean | null;
  isWinner?: boolean;
  joinedAt?: string;
  /** @nullable */
  marketingChannelCode?: string | null;
  /** @nullable */
  marketingChannelLabel?: string | null;
  /** @nullable */
  prizeId?: string | null;
  /** @nullable */
  qualifiedAt?: string | null;
  /** @nullable */
  redrawNumber?: number | null;
  /** @nullable */
  rewardId?: string | null;
  userId?: string;
  /** @nullable */
  userName?: string | null;
  /** @nullable */
  winnerStatus?: string | null;
}

export interface CampaignParticipantAdminResponse {
  accountId?: number;
  /** @nullable */
  cardPreference?: string | null;
  /** @nullable */
  corePassId?: string | null;
  /** @nullable */
  disqualificationComment?: string | null;
  /** @nullable */
  email?: string | null;
  entryWeight?: number;
  id?: string;
  /** @nullable */
  isQualified?: boolean | null;
  isWinner?: boolean;
  joinedAt?: string;
  /** @nullable */
  marketingChannelCode?: string | null;
  /** @nullable */
  marketingChannelLabel?: string | null;
  /** @nullable */
  prizeId?: string | null;
  /** @nullable */
  qualifiedAt?: string | null;
  userId?: string;
  /** @nullable */
  userName?: string | null;
  /** @nullable */
  winnerCancellationComment?: string | null;
  /** @nullable */
  winnerCancellationReason?: string | null;
  /** @nullable */
  winnerStatus?: string | null;
}

export interface CampaignParticipantsListResponse {
  average_entry_weight?: number;
  /** @nullable */
  data?: CampaignParticipantAdminResponse[] | null;
  eligible_participant_count?: number;
  /** @nullable */
  filters?: CampaignParticipantsListResponseFilters;
  paging?: Paging;
  qualified_participant_count?: number;
}

export interface CampaignParticipantActivityEventAdminResponse {
  /** @nullable */
  actorId?: string | null;
  /** @nullable */
  actorType?: string | null;
  /** @nullable */
  eventType?: string | null;
  id?: string;
  occurredAt?: string;
  /** @nullable */
  payloadJson?: string | null;
  /** @nullable */
  visibility?: string | null;
}

export interface CampaignParticipantActivityAdminResponse {
  campaignId?: string;
  /** @nullable */
  campaignSlug?: string | null;
  /** @nullable */
  campaignTitle?: string | null;
  /** @nullable */
  events?: CampaignParticipantActivityEventAdminResponse[] | null;
  participant?: CampaignParticipantDetailAdminResponse;
}

export interface CampaignMarketingChannelStatResponse {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  label?: string | null;
  participantCount?: number;
}

export type CampaignDrawType = (typeof CampaignDrawType)[keyof typeof CampaignDrawType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CampaignDrawType = {
  Auto: 'Auto',
  Manual: 'Manual',
} as const;

export interface CampaignDrawReminderResponse {
  /** @nullable */
  customMessage?: string | null;
  id?: string;
  scheduledAt: string;
  /** @nullable */
  sentAt?: string | null;
}

export interface CampaignDrawReminderRequest {
  /** @nullable */
  customMessage?: string | null;
  scheduledAt: string;
}

export interface CampaignCancelledWinnerAdminResponse {
  /** @nullable */
  cancellationComment?: string | null;
  cancellationReason?: WinnerCancellationReason;
  cancelledAt?: string;
  cancelledByActor?: CancellationActor;
  /** @nullable */
  cancelledByUserId?: string | null;
  /** @nullable */
  corePassId?: string | null;
  /** @nullable */
  email?: string | null;
  /** @nullable */
  fulfillmentStatus?: string | null;
  participantId?: string;
  prizeAmount?: number;
  /** @nullable */
  prizeCurrency?: string | null;
  prizeId?: string;
  prizeType?: CampaignPrizeType;
  /** @nullable */
  rewardId?: string | null;
  /** @nullable */
  tierName?: string | null;
  tierOrder?: number;
  /** @nullable */
  userName?: string | null;
}

export interface CampaignAnalyticsSummaryResponse {
  activeChannels?: number;
  attributedParticipants?: number;
  attributionRatePercent?: number;
  campaignsIncluded?: number;
  directParticipants?: number;
  mainDrawWinnerCount?: number;
  redrawWinnerCount?: number;
  /** @nullable */
  topChannelCode?: string | null;
  /** @nullable */
  topChannelLabel?: string | null;
  topChannelParticipants?: number;
  topChannelSharePercent?: number;
  totalParticipants?: number;
}

/**
 * @nullable
 */
export type CampaignAnalyticsSignupPointResponseByChannel = { [key: string]: number } | null;

export interface CampaignAnalyticsSignupPointResponse {
  /** @nullable */
  byChannel?: CampaignAnalyticsSignupPointResponseByChannel;
  periodStart?: string;
  totalCount?: number;
}

export interface CampaignAnalyticsChannelBreakdownResponse {
  avgEntryWeight?: number;
  /** @nullable */
  code?: string | null;
  /** @nullable */
  label?: string | null;
  participantCount?: number;
  sharePercent?: number;
  winnerCount?: number;
}

export interface CampaignAnalyticsCampaignBreakdownResponse {
  campaignId?: string;
  mainDrawWinnerCount?: number;
  participantCount?: number;
  redrawWinnerCount?: number;
  /** @nullable */
  slug?: string | null;
  /** @nullable */
  title?: string | null;
  /** @nullable */
  topChannelCode?: string | null;
  topChannelCount?: number;
  /** @nullable */
  topChannelLabel?: string | null;
}

export interface CampaignAnalyticsDashboardResponse {
  /** @nullable */
  campaignBreakdown?: CampaignAnalyticsCampaignBreakdownResponse[] | null;
  /** @nullable */
  channelBreakdown?: CampaignAnalyticsChannelBreakdownResponse[] | null;
  /** @nullable */
  signupsOverTime?: CampaignAnalyticsSignupPointResponse[] | null;
  summary?: CampaignAnalyticsSummaryResponse;
}

export interface CampaignAdminResponse {
  autoLifecycleEnabled?: boolean;
  createdAt?: string;
  /** @nullable */
  createdBy?: string | null;
  /** @nullable */
  description?: string | null;
  /** @nullable */
  drawReminders?: CampaignDrawReminderResponse[] | null;
  /** @nullable */
  drawScheduledAt?: string | null;
  drawType?: CampaignDrawType;
  /** @nullable */
  embeddedVideos?: string | null;
  entryEndsAt?: string;
  entryStartsAt?: string;
  id?: string;
  /** @nullable */
  prizes?: CampaignPrizeAdminResponse[] | null;
  /** @nullable */
  qualificationReminders?: CampaignQualificationReminderResponse[] | null;
  /** @nullable */
  redrawEndsAt?: string | null;
  redrawRewardFulfillmentType?: CampaignRewardFulfillmentType;
  /** @nullable */
  redrawStartsAt?: string | null;
  redrawStatus?: CampaignRedrawStatus;
  redrawType?: CampaignRedrawType;
  redrawWinnerAnnounceOrder?: CampaignWinnerAnnounceOrder;
  /** @nullable */
  referralCode?: string | null;
  /** @nullable */
  rewardClaimableAt?: string | null;
  rewardFulfillmentType?: CampaignRewardFulfillmentType;
  /** @nullable */
  rewardScheduledAt?: string | null;
  /** @nullable */
  rulesConfig?: string | null;
  showWinnerCoreIdPartiallyUnmasked?: boolean;
  /** @nullable */
  slug?: string | null;
  status?: CampaignStatus;
  /** @nullable */
  title?: string | null;
  winnerAnnounceOrder?: CampaignWinnerAnnounceOrder;
  /** @nullable */
  winnerCoreIdPartialMaskFormat?: string | null;
}

export type BroadcastRequestStatus = (typeof BroadcastRequestStatus)[keyof typeof BroadcastRequestStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BroadcastRequestStatus = {
  Pending: 'Pending',
  Processing: 'Processing',
  Broadcasted: 'Broadcasted',
  PartiallyCompleted: 'PartiallyCompleted',
  Completed: 'Completed',
  Failed: 'Failed',
} as const;

export interface BroadcastRequestItemResponse {
  createdAt?: string;
  id?: number;
  paymentSystem?: PaymentSystem;
  /** @nullable */
  signedTransactions?: string | null;
  status?: BroadcastRequestStatus;
}

export type BroadcastRequestDetailStatus =
  (typeof BroadcastRequestDetailStatus)[keyof typeof BroadcastRequestDetailStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BroadcastRequestDetailStatus = {
  Processing: 'Processing',
  Sent: 'Sent',
  AwaitingConfirmation: 'AwaitingConfirmation',
  Completed: 'Completed',
  Error: 'Error',
  Canceled: 'Canceled',
} as const;

export interface BroadcastRequestDetailItemResponse {
  /** @nullable */
  blockchainTxId?: string | null;
  broadcastRequestId?: number;
  createdAt?: string;
  /** @nullable */
  errorMessage?: string | null;
  id?: number;
  status?: BroadcastRequestDetailStatus;
  transactionId?: string;
}

export interface BriefExecution {
  accountVersion?: number;
  cancelReason?: CancelReason;
  /** @nullable */
  commission?: string | null;
  /** @nullable */
  commissionCurrency?: string | null;
  /** @nullable */
  commissionType?: string | null;
  createdAt?: string;
  execType?: ExecType;
  /** @nullable */
  filledAmount?: string | null;
  /** @nullable */
  filledBaseAmount?: string | null;
  /** @nullable */
  filledQuoteAmount?: string | null;
  orderStatus?: OrderStatus;
  /** @nullable */
  rejectDetails?: string | null;
  /** @nullable */
  rejectReason?: string | null;
  /** @nullable */
  remainingAmount?: string | null;
  /** @nullable */
  tradeAmount?: string | null;
  /** @nullable */
  tradeId?: string | null;
  /** @nullable */
  tradePrice?: string | null;
  tradeRole?: TradeRole;
  /** @nullable */
  triggerPrice?: string | null;
}

export interface BotGatewayUserInfoViewModel {
  accountId?: number;
  /** @nullable */
  activityStatus?: string | null;
  /** @nullable */
  complianceTier?: string | null;
  /** @nullable */
  corePassId?: string | null;
  /** @nullable */
  email?: string | null;
  /** @nullable */
  fullName?: string | null;
  /** @nullable */
  fullNameEnglish?: string | null;
  /** @nullable */
  kycVersion?: number | null;
  /** @nullable */
  nationality?: string | null;
  /** @nullable */
  residency?: string | null;
  /** @nullable */
  userId?: string | null;
  /** @nullable */
  userName?: string | null;
}

export interface BotGatewayTagRecordViewModel {
  id?: number;
  tagId?: number;
  /** @nullable */
  updatedAt?: string | null;
  value?: boolean;
}

export interface BotGatewayRevokePermissionRequest {
  tagId: number;
  userId: string;
}

export interface BotGatewayRevokeAccessRequest {
  userId: string;
}

export interface BotGatewayGrantPermissionRequest {
  tagId: number;
  userId: string;
  value: string;
}

export interface BotGatewayGrantAccessRequest {
  userId: string;
}

export interface BotGatewayAccountInfoViewModel {
  accountId?: number;
  /** @nullable */
  activityStatus?: string | null;
  /** @nullable */
  complianceTier?: string | null;
  /** @nullable */
  corePassId?: string | null;
  /** @nullable */
  email?: string | null;
  /** @nullable */
  fullName?: string | null;
  /** @nullable */
  fullNameEnglish?: string | null;
  id?: number;
  /** @nullable */
  kycVersion?: number | null;
  /** @nullable */
  nationality?: string | null;
  /** @nullable */
  residency?: string | null;
  tagId?: number;
  /** @nullable */
  updatedAt?: string | null;
  /** @nullable */
  userId?: string | null;
  /** @nullable */
  userName?: string | null;
  value?: boolean;
}

export interface BotGatewayUsersPageViewModel {
  hasMore?: boolean;
  /** @nullable */
  nextCursor?: number | null;
  /** @nullable */
  users?: BotGatewayAccountInfoViewModel[] | null;
}

export interface BotGatewayAccountHistoryViewModel {
  /** @nullable */
  history?: BotGatewayAuditRecordViewModel[] | null;
  /** @nullable */
  tags?: BotGatewayTagRecordViewModel[] | null;
  userInfo?: BotGatewayUserInfoViewModel;
}

export type BotGatewayAccessActionViewModel =
  (typeof BotGatewayAccessActionViewModel)[keyof typeof BotGatewayAccessActionViewModel];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BotGatewayAccessActionViewModel = {
  Grant: 'Grant',
  Revoke: 'Revoke',
} as const;

export interface BotGatewayAuditRecordViewModel {
  accountId?: number;
  action?: BotGatewayAccessActionViewModel;
  id?: string;
  performedAt?: string;
  performedBy?: string;
  tagId?: number;
  value?: boolean;
}

export interface BlockUserApiRequest {
  userId?: string;
}

export interface BlockchainMetaData {
  /** @nullable */
  circulatingSupply?: string | null;
  /** @nullable */
  contract?: string | null;
  /** @nullable */
  decimals?: number | null;
  /** @nullable */
  Documents?: CommodityDocument[] | null;
  /** @nullable */
  icon?: string | null;
  knownMetadata?: KnownMetadata;
  LabResults?: LabResults;
  metadata?: CommodityMetadata;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  symbol?: string | null;
  /** @nullable */
  totalSupply?: string | null;
  /** @nullable */
  type?: string | null;
  /** @nullable */
  web?: string | null;
}

export interface BasicAccountInfo {
  /** @nullable */
  code?: string | null;
  id?: string;
  /** @nullable */
  tags?: TagInfo[] | null;
  /** @nullable */
  tradeLimit?: number | null;
  type?: AccountType;
}

export interface BalanceAggregateRequest {
  /** @nullable */
  balances?: IBalance[] | null;
  destination?: ColdStorageDestination;
}

export type AssetType = (typeof AssetType)[keyof typeof AssetType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AssetType = {
  Crypto: 'Crypto',
  Fiat: 'Fiat',
  Commodity: 'Commodity',
  Stock: 'Stock',
  Forex: 'Forex',
} as const;

export interface AssetRequest {
  /** @nullable */
  blockchain_configs?: AssetBlockchainConfigRequest[] | null;
  /** @nullable */
  coingecko_id?: string | null;
  commodity_asset?: CommodityAssetRequest;
  /** @nullable */
  icon_url?: string | null;
  /** @nullable */
  internal_withdrawal_fee_percent?: number | null;
  /** @nullable */
  maximum_internal_withdrawal_fee_fixed_amount?: number | null;
  /** @nullable */
  scale?: number | null;
  /** @nullable */
  website_url?: string | null;
}

export type AssetRegistrationStatus = (typeof AssetRegistrationStatus)[keyof typeof AssetRegistrationStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AssetRegistrationStatus = {
  Pending: 'Pending',
  Approved: 'Approved',
  Rejected: 'Rejected',
} as const;

/**
 * @nullable
 */
export type AssetRegistrationResponseFilteredResponseFilters = unknown | null;

export interface AssetRegistrationResponse {
  /** @nullable */
  asset_name?: string | null;
  /** @nullable */
  blockchain_configs?: AssetBlockchainConfigResponse[] | null;
  /** @nullable */
  coingecko_id?: string | null;
  commodity_asset?: AdminCommodityAsset;
  created_at?: string;
  /** @nullable */
  icon_url?: string | null;
  /** @nullable */
  id?: string | null;
  internal_withdrawal_fee_percent?: number;
  maximum_internal_withdrawal_fee_fixed_amount?: number;
  /** @nullable */
  rejection_reason?: string | null;
  /** @nullable */
  request_by_core_pass_id?: string | null;
  request_id?: string;
  /** @nullable */
  reviewed_at?: string | null;
  /** @nullable */
  reviewed_by_id?: string | null;
  /** @nullable */
  scale?: number | null;
  status?: AssetRegistrationStatus;
  type?: AssetType;
  /** @nullable */
  updated_at?: string | null;
  /** @nullable */
  website_url?: string | null;
}

export interface AssetRegistrationResponseFilteredResponse {
  /** @nullable */
  data?: AssetRegistrationResponse[] | null;
  /** @nullable */
  filters?: AssetRegistrationResponseFilteredResponseFilters;
  paging?: Paging;
}

export interface AssetContractSignatureListItemResponse {
  asset_contract_id?: string;
  /** @nullable */
  asset_id?: string | null;
  id?: string;
  signed_at?: string;
  signed_document_id?: string;
  user_id?: string;
  version?: number;
}

export interface AssetContractSignatureResponse {
  /** @nullable */
  items?: AssetContractSignatureListItemResponse[] | null;
  total_count?: number;
}

export type AssetContractFormat = (typeof AssetContractFormat)[keyof typeof AssetContractFormat];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AssetContractFormat = {
  Text: 'Text',
  Json: 'Json',
  Markdown: 'Markdown',
} as const;

export interface AssetContractResponse {
  /** @nullable */
  asset_id?: string | null;
  /** @nullable */
  content?: string | null;
  created_at?: string;
  created_by?: string;
  format?: AssetContractFormat;
  id?: string;
  /** @nullable */
  structured_content?: string | null;
  /** @nullable */
  updated_at?: string | null;
  /** @nullable */
  updated_by?: string | null;
  version?: number;
}

export interface AssetBlockchainConfigResponse {
  /** @nullable */
  blockchainNetwork?: string | null;
  canDeposit?: boolean;
  canWithdraw?: boolean;
  /** @nullable */
  confirmationCount?: number | null;
  decimals?: number;
  id?: number;
  /** @nullable */
  minimumWithdrawAmount?: number | null;
  /** @nullable */
  tokenAddress?: string | null;
  /** @nullable */
  tokenType?: string | null;
  transferCost?: number;
  visibility?: AssetVisibility;
  /** @nullable */
  withdrawalFee?: number | null;
}

export interface AssetBlockchainConfigRequest {
  blockchain_network: PaymentSystem;
  can_deposit: boolean;
  can_withdraw: boolean;
  /** @nullable */
  confirmation_count?: number | null;
  decimals: number;
  min_withdraw: number;
  /** @nullable */
  token_address?: string | null;
  token_type?: TokenType;
  transfer_cost: number;
  visibility?: AssetVisibility;
  withdrawal_fee: number;
}

export interface AssetAccount {
  accountId?: number;
  /** @nullable */
  assetId?: string | null;
  balance?: number;
  /** ExpectedBalance - Balance */
  readonly difference?: number;
  expectedBalance?: number;
  readonly isCorrect?: boolean;
  totalDeposit?: number;
  totalOrder?: number;
  totalWithdrawal?: number;
}

export interface ApprovePendingReviewDepositRequest {
  /**
   * @minLength 0
   * @maxLength 500
   * @nullable
   */
  comment?: string | null;
  depositTransferId: string;
}

export interface ApproveMarketRegistrationRequest {
  isStable?: boolean;
  status: MarketStatus;
  visibility: MarketVisibility;
}

export interface ApplyTreasurySetupResponse {
  appliedCount?: number;
  /** @nullable */
  appliedPolicies?: TreasuryChainPolicyResponse[] | null;
  skippedCount?: number;
}

export interface ApplyTreasuryChainSetupRequest {
  apply?: boolean;
  /** @nullable */
  paymentSystem?: string | null;
  policy?: UpdateTreasuryChainPolicyRequest;
}

export interface ApplyTreasurySetupRequest {
  /** @nullable */
  chains?: ApplyTreasuryChainSetupRequest[] | null;
}

export interface AppConfigResponse {
  createdAt?: string;
  createdBy?: string;
  id?: string;
  /** @nullable */
  key?: string | null;
  /** @nullable */
  updatedAt?: string | null;
  /** @nullable */
  updatedBy?: string | null;
  /** @nullable */
  value?: string | null;
}

export interface ApiErrorData {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  key?: string | null;
  /** @nullable */
  message?: string | null;
  [key: string]: unknown;
}

export interface ApiErrorResponse {
  errorCode?: number;
  /** @nullable */
  errors?: ApiErrorData[] | null;
  /** @nullable */
  message?: string | null;
}

export interface AggregationBroadcastRequest {
  /** @nullable */
  signedTransactions?: IColdStorageSignedTransaction[] | null;
}

export type AdminUserTierRequestType = (typeof AdminUserTierRequestType)[keyof typeof AdminUserTierRequestType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminUserTierRequestType = {
  Basic: 'Basic',
  PremiumForced: 'PremiumForced',
} as const;

export interface AdminUserTierRequest {
  tier?: AdminUserTierRequestType;
  userId?: string;
}

export interface AdminTransferData {
  /** @nullable */
  accountId?: string | null;
  amount?: number;
  /** @nullable */
  asset?: string | null;
  /** @nullable */
  blockchainLink?: string | null;
  confirmations?: number;
  confirmationsRequired?: number;
  /** @nullable */
  corePassId?: string | null;
  createdAt?: string;
  /** @nullable */
  email?: string | null;
  /** @nullable */
  errorCode?: string | null;
  /** @nullable */
  errorDetails?: string | null;
  fee?: number;
  id?: string;
  /** @nullable */
  paymentSystem?: string | null;
  status?: TransferStatus;
  /** @nullable */
  targetAddress?: string | null;
  /** @nullable */
  targetCorePassId?: string | null;
  /** @nullable */
  tokenId?: string | null;
  /** @nullable */
  transferId?: string | null;
  transferReason?: TransferReasonType;
  /** @nullable */
  txId?: string | null;
  type?: TransferType;
  updatedAt?: string;
  /** @nullable */
  userId?: string | null;
  /** @nullable */
  userName?: string | null;
}

export interface AdminTradeViewModel {
  matchedOrderAccountId?: number;
  matchedOrderId?: string;
  /** @nullable */
  matchedOrderSide?: string | null;
  /** @nullable */
  matchedOrderType?: string | null;
  tradeAmount?: number;
  tradeDateUtc?: string;
  tradeFee?: number;
  /** @nullable */
  tradeFeeAsset?: string | null;
  tradeId?: number;
  tradePrice?: number;
  /** @nullable */
  tradeTokenIds?: string[] | null;
}

export interface AdminManualTransferResponse {
  data?: AdminTransferData;
  /** @nullable */
  provider?: string | null;
  twoFactorRequired?: boolean;
}

export interface AdminCreateUserApiKeyRequest {
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^[a-zA-Z0-9]*$
   */
  corePassId: string;
  /**
   * @minLength 0
   * @maxLength 255
   * @pattern ^[a-zA-Z0-9]*$
   */
  displayName: string;
  /** @nullable */
  expiresAt?: string | null;
}

export interface AdminCommodityAsset {
  blockchain_metadata?: BlockchainMetaData;
  commodity_category?: CommodityCategory;
  commodity_type?: CommodityType;
  /** @nullable */
  readonly days_until_expiration?: number | null;
  /** @nullable */
  days_until_near_expiration?: number | null;
  /** @nullable */
  expiration_date?: string | null;
  readonly is_expired?: boolean;
  readonly is_near_expiration?: boolean;
  /** @nullable */
  last_trading_day?: string | null;
  /** @nullable */
  withdrawal_fee_asset_id?: string | null;
}

export interface AdminAssetResponse {
  /** @nullable */
  asset_name?: string | null;
  /** @nullable */
  blockchain_configs?: AssetBlockchainConfigResponse[] | null;
  /** @nullable */
  coingecko_id?: string | null;
  commodity_asset?: AdminCommodityAsset;
  created_at?: string;
  /** @nullable */
  icon_url?: string | null;
  /** @nullable */
  id?: string | null;
  internal_withdrawal_fee_percent?: number;
  maximum_internal_withdrawal_fee_fixed_amount?: number;
  /** @nullable */
  scale?: number | null;
  type?: AssetType;
  /** @nullable */
  website_url?: string | null;
}

export type AddressBookType = (typeof AddressBookType)[keyof typeof AddressBookType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AddressBookType = {
  Internal: 'Internal',
  CorePass: 'CorePass',
  External: 'External',
} as const;

export interface AddressBookItemDto {
  dateCreated?: string;
  id?: string;
  isPrimary?: boolean;
  isVerified?: boolean;
  /** @nullable */
  label?: string | null;
  /** @nullable */
  network?: string | null;
  type?: AddressBookType;
  /** @nullable */
  walletAddress?: string | null;
}

export interface AddressBookResponse {
  /** @nullable */
  addresses?: AddressBookItemDto[] | null;
  /** @nullable */
  auditAddresses?: AddressBookAuditItemDto[] | null;
}

export type AddressBookAuditActionTypeRpc =
  (typeof AddressBookAuditActionTypeRpc)[keyof typeof AddressBookAuditActionTypeRpc];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AddressBookAuditActionTypeRpc = {
  InvalidAddressBookAuditActionType: 'InvalidAddressBookAuditActionType',
  InvalidatedByCompliance: 'InvalidatedByCompliance',
  ReplacedByOwner: 'ReplacedByOwner',
  CreateUnverifiedExternal: 'CreateUnverifiedExternal',
  InvalidatedAutomaticallyViaCorePassCheck: 'InvalidatedAutomaticallyViaCorePassCheck',
} as const;

export interface AddressBookAuditItemDto {
  actionType?: AddressBookAuditActionTypeRpc;
  changedById?: string;
  /** @nullable */
  comment?: string | null;
  dateChanged?: string;
  dateCreated?: string;
  id?: string;
  isPrimary?: boolean;
  isVerified?: boolean;
  /** @nullable */
  label?: string | null;
  /** @nullable */
  network?: string | null;
  type?: AddressBookType;
  /** @nullable */
  walletAddress?: string | null;
}

export type ActivityStatus = (typeof ActivityStatus)[keyof typeof ActivityStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ActivityStatus = {
  Active: 'Active',
  Frozen: 'Frozen',
  Terminated: 'Terminated',
  Banned: 'Banned',
  WaitingForData: 'WaitingForData',
  WaitingForReview: 'WaitingForReview',
  Limited: 'Limited',
} as const;

export type AccountType = (typeof AccountType)[keyof typeof AccountType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AccountType = {
  CASH: 'CASH',
  MARGIN: 'MARGIN',
} as const;

export interface AccountTagInfo {
  cardinality?: TagCardinality;
  editable?: boolean;
  id?: number;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  type?: string | null;
  /** @nullable */
  values?: string[] | null;
}

/**
 * @nullable
 */
export type TrendResponseTrends = { [key: string]: number } | null;

export interface TrendResponse {
  readonly change?: number;
  /** @nullable */
  trends?: TrendResponseTrends;
}

export interface TradeHistoryResponse {
  /**
   * Array of trade history
   * @nullable
   */
  items?: TradeHistoryResponseItem[] | null;
  /**
   * Cursor for fetching next set of records
   * @nullable
   */
  nextCursor?: string | null;
}

/**
 * Represents quote.
 */
export interface QuoteInfo {
  /** Close price */
  close?: number;
  CoinGeckoPrice?: number;
  /** End date and time of quote */
  end?: string;
  /** Highest price of quote in the timeframe. */
  high?: number;
  /** @nullable */
  instrument?: string | null;
  /** Lowest price of quote in the timeframe. */
  low?: number;
  /** Open price */
  open?: number;
  /** Start date and time of quote. */
  start?: string;
  /** milliseconds since Unix epoch of Start Time */
  readonly time?: number;
  /** Volume of trading */
  volume?: number;
}

export type OrderSide = (typeof OrderSide)[keyof typeof OrderSide];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrderSide = {
  Buy: 'Buy',
  Sell: 'Sell',
} as const;

export interface TradeHistoryResponseItem {
  /** The volume of the base currency traded. */
  baseVolume?: number;
  /** The price at which the trade occurred. */
  price?: number;
  side?: OrderSide;
  /** The volume of the target currency traded. */
  targetVolume?: number;
  /** The timestamp of when the trade occurred. */
  timestamp?: string;
  /** Unique identifier for the trade. */
  tradeId?: number;
}

export interface OrderBookLevelInfo {
  amount?: number;
  price?: number;
}

export interface OrderBookItem {
  /** The order amount. */
  amount?: number;
  /** The order price. */
  price?: number;
}

export interface OrderBookResponse {
  /**
   * List of ask orders
   * @nullable
   */
  asks?: OrderBookItem[] | null;
  /**
   * List of bid orders
   * @nullable
   */
  bids?: OrderBookItem[] | null;
  /** The timestamp of when the order book data was retrieved. */
  timestamp?: string;
  /** The version of the order book data. */
  version?: number;
}

export interface OrderBookInfo {
  /** @nullable */
  asks?: OrderBookLevelInfo[] | null;
  askTotalAmount?: number;
  /** @nullable */
  bids?: OrderBookLevelInfo[] | null;
  bidTotalAmount?: number;
  /** @nullable */
  instrument?: string | null;
  snapshot?: boolean;
  version?: number;
}

export interface MarketSummaryData {
  /**
   * Symbol/currency code of base currency, eg. btc
   * @nullable
   */
  baseAsset?: string | null;
  /** 24-hr volume of market pair denoted in BASE currency */
  baseVolume?: number;
  /** 24-hr % price change of market pair */
  changePercent?: number;
  /** Highest bid price of base currency based on given quote currency */
  highestBid?: number;
  /** Highest price of base currency based on given quote currency in the last 24-hrs */
  highestPrice?: number;
  /** Last transacted price of base currency based on given quote currency */
  lastPrice?: number;
  /** Lowest Ask price of base currency based on given quote currency */
  lowestAsk?: number;
  /** Lowest price of base currency based on given quote currency in the last 24-hrs */
  lowestPrice?: number;
  /**
   * Symbol/currency code of quote currency, eg. usdc
   * @nullable
   */
  quoteAsset?: string | null;
  /** 24-hr volume of market pair denoted in QUOTE currency */
  quoteVolume?: number;
  /**
   * Identifier of a ticker with delimiter to separate base/quote, eg. btc_usdc (Price of btc is quoted in usdc)
   * @nullable
   */
  symbol?: string | null;
}

export interface Market24HourData {
  /** Highest price of base currency based on given quote currency in the last 24-hrs */
  high?: number;
  /** Last transacted price of base currency based on given quote currency */
  lastPrice?: number;
  /** Lowest price of base currency based on given quote currency in the last 24-hrs */
  low?: number;
  /**
   * Identifier of a ticker with delimiter to separate base/quote, eg. btc_usdc (Price of btc is quoted in usdc)
   * @nullable
   */
  symbol?: string | null;
  /** 24 hour trading volume denoted in QUOTE currency */
  readonly targetVolume?: number;
  /** 24-hour trading volume denoted in BASE currency */
  volume?: number;
}

/**
 * Represents the last fair price.
 */
export interface LastFairPriceResponse {
  /** The last fair price */
  fairPrice?: number;
}

export interface ChartHistoryResponse {
  /** @nullable */
  data?: QuoteInfo[] | null;
  /** @nullable */
  endDateTime?: string | null;
  /** @nullable */
  errorMessage?: string | null;
  /** @nullable */
  instrument?: string | null;
  /** @nullable */
  startDateTime?: string | null;
  success?: boolean;
}

export type AssetVisibility = (typeof AssetVisibility)[keyof typeof AssetVisibility];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AssetVisibility = {
  Invisible: 'Invisible',
  Visible: 'Visible',
  Internal: 'Internal',
} as const;

export interface BlockchainConfig {
  /** @nullable */
  blockchain_network?: string | null;
  can_deposit?: boolean;
  can_withdraw?: boolean;
  /** @nullable */
  confirmation_count?: number | null;
  /** @nullable */
  min_withdraw?: number | null;
  visibility?: AssetVisibility;
  /** @nullable */
  withdrawal_fee?: number | null;
}

/**
 * Represents the response for an asset.
 */
export interface AssetsResponse {
  /** @nullable */
  blockchainConfigs?: BlockchainConfig[] | null;
  /**
   * List of contract addresses associated with this asset.
   * @nullable
   */
  contractAddress?: string[] | null;
  /**
   * List of URLs for the contract addresses associated with this asset.
   * @nullable
   */
  contractAddressUrl?: string[] | null;
  /**
   * The name of the asset.
   * @nullable
   */
  name?: string | null;
  /**
   * The unified identifier for the crypto asset, which is unique across the platform.
   * @nullable
   */
  unifiedCryptoAssetId?: string | null;
}

/**
 * @nullable
 */
export type Asset24HourDataTrends = { [key: string]: number } | null;

export interface Asset24HourData {
  /** @nullable */
  assetName?: string | null;
  changeRate?: number;
  price?: number;
  /** @nullable */
  symbol?: string | null;
  /** @nullable */
  trends?: Asset24HourDataTrends;
  volume?: number;
}

type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];

/**
 * @summary Gets all addresses related to current logged-in user
 */
export const getAllAddressBook = (options?: SecondParameter<typeof customInstance>, signal?: AbortSignal) => {
  return customInstance<AddressBookListResponse>(
    { url: `/frontoffice/api/address-book`, method: 'GET', signal },
    options
  );
};

export const getGetAllAddressBookQueryKey = () => {
  return [`/frontoffice/api/address-book`] as const;
};

export const getGetAllAddressBookQueryOptions = <
  TData = Awaited<ReturnType<typeof getAllAddressBook>>,
  TError = ErrorType<void>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getAllAddressBook>>, TError, TData>;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAllAddressBookQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllAddressBook>>> = ({ signal }) =>
    getAllAddressBook(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAllAddressBook>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAllAddressBookQueryResult = NonNullable<Awaited<ReturnType<typeof getAllAddressBook>>>;
export type GetAllAddressBookQueryError = ErrorType<void>;

/**
 * @summary Gets all addresses related to current logged-in user
 */

export function useGetAllAddressBook<
  TData = Awaited<ReturnType<typeof getAllAddressBook>>,
  TError = ErrorType<void>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getAllAddressBook>>, TError, TData>;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetAllAddressBookQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const createAddressBook = (
  createAddressBookRequest: CreateAddressBookRequest,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<void>(
    {
      url: `/frontoffice/api/address-book`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: createAddressBookRequest,
    },
    options
  );
};

export const getCreateAddressBookMutationOptions = <
  TError = ErrorType<ApiErrorResponse | void | IsWithdrawalAllowedResponse>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAddressBook>>,
    TError,
    { data: CreateAddressBookRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createAddressBook>>,
  TError,
  { data: CreateAddressBookRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createAddressBook>>,
    { data: CreateAddressBookRequest }
  > = props => {
    const { data } = props ?? {};

    return createAddressBook(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateAddressBookMutationResult = NonNullable<Awaited<ReturnType<typeof createAddressBook>>>;
export type CreateAddressBookMutationBody = CreateAddressBookRequest;
export type CreateAddressBookMutationError = ErrorType<ApiErrorResponse | void | IsWithdrawalAllowedResponse>;

export const useCreateAddressBook = <
  TError = ErrorType<ApiErrorResponse | void | IsWithdrawalAllowedResponse>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAddressBook>>,
    TError,
    { data: CreateAddressBookRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createAddressBook>>,
  TError,
  { data: CreateAddressBookRequest },
  TContext
> => {
  const mutationOptions = getCreateAddressBookMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getByIdAddressBook = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<AddressBookListItemDto>(
    { url: `/frontoffice/api/address-book/${id}`, method: 'GET', signal },
    options
  );
};

export const getGetByIdAddressBookQueryKey = (id: string) => {
  return [`/frontoffice/api/address-book/${id}`] as const;
};

export const getGetByIdAddressBookQueryOptions = <
  TData = Awaited<ReturnType<typeof getByIdAddressBook>>,
  TError = ErrorType<void>
>(
  id: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getByIdAddressBook>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetByIdAddressBookQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getByIdAddressBook>>> = ({ signal }) =>
    getByIdAddressBook(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getByIdAddressBook>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetByIdAddressBookQueryResult = NonNullable<Awaited<ReturnType<typeof getByIdAddressBook>>>;
export type GetByIdAddressBookQueryError = ErrorType<void>;

export function useGetByIdAddressBook<TData = Awaited<ReturnType<typeof getByIdAddressBook>>, TError = ErrorType<void>>(
  id: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getByIdAddressBook>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetByIdAddressBookQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const updateAddressBook = (
  id: string,
  updateAddressBookRequest: UpdateAddressBookRequest,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<AddressBookListItemDto>(
    {
      url: `/frontoffice/api/address-book/${id}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: updateAddressBookRequest,
    },
    options
  );
};

export const getUpdateAddressBookMutationOptions = <
  TError = ErrorType<ApiErrorResponse | void>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAddressBook>>,
    TError,
    { id: string; data: UpdateAddressBookRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateAddressBook>>,
  TError,
  { id: string; data: UpdateAddressBookRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateAddressBook>>,
    { id: string; data: UpdateAddressBookRequest }
  > = props => {
    const { id, data } = props ?? {};

    return updateAddressBook(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateAddressBookMutationResult = NonNullable<Awaited<ReturnType<typeof updateAddressBook>>>;
export type UpdateAddressBookMutationBody = UpdateAddressBookRequest;
export type UpdateAddressBookMutationError = ErrorType<ApiErrorResponse | void>;

export const useUpdateAddressBook = <TError = ErrorType<ApiErrorResponse | void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAddressBook>>,
    TError,
    { id: string; data: UpdateAddressBookRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateAddressBook>>,
  TError,
  { id: string; data: UpdateAddressBookRequest },
  TContext
> => {
  const mutationOptions = getUpdateAddressBookMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Deletes an AddressBook record in DEVELOPEMENT ENVIRONMENT ONLY by admin
 */
export const deleteAddressBook = (
  deleteAddressBookRequest: DeleteAddressBookRequest,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<void>(
    {
      url: `/frontoffice/api/address-book/dev`,
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: deleteAddressBookRequest,
    },
    options
  );
};

export const getDeleteAddressBookMutationOptions = <
  TError = ErrorType<ApiErrorResponse | void>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAddressBook>>,
    TError,
    { data: DeleteAddressBookRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteAddressBook>>,
  TError,
  { data: DeleteAddressBookRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteAddressBook>>,
    { data: DeleteAddressBookRequest }
  > = props => {
    const { data } = props ?? {};

    return deleteAddressBook(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteAddressBookMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAddressBook>>>;
export type DeleteAddressBookMutationBody = DeleteAddressBookRequest;
export type DeleteAddressBookMutationError = ErrorType<ApiErrorResponse | void>;

/**
 * @summary Deletes an AddressBook record in DEVELOPEMENT ENVIRONMENT ONLY by admin
 */
export const useDeleteAddressBook = <TError = ErrorType<ApiErrorResponse | void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAddressBook>>,
    TError,
    { data: DeleteAddressBookRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteAddressBook>>,
  TError,
  { data: DeleteAddressBookRequest },
  TContext
> => {
  const mutationOptions = getDeleteAddressBookMutationOptions(options);

  return useMutation(mutationOptions);
};

export const createDevelopmentAddressBook = (
  coreId: string,
  paymentSystem: string,
  createAddressBookRequest: CreateAddressBookRequest,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<void>(
    {
      url: `/frontoffice/api/address-book/dev/create/${coreId}/${paymentSystem}`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: createAddressBookRequest,
    },
    options
  );
};

export const getCreateDevelopmentAddressBookMutationOptions = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createDevelopmentAddressBook>>,
    TError,
    { coreId: string; paymentSystem: string; data: CreateAddressBookRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createDevelopmentAddressBook>>,
  TError,
  { coreId: string; paymentSystem: string; data: CreateAddressBookRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createDevelopmentAddressBook>>,
    { coreId: string; paymentSystem: string; data: CreateAddressBookRequest }
  > = props => {
    const { coreId, paymentSystem, data } = props ?? {};

    return createDevelopmentAddressBook(coreId, paymentSystem, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateDevelopmentAddressBookMutationResult = NonNullable<
  Awaited<ReturnType<typeof createDevelopmentAddressBook>>
>;
export type CreateDevelopmentAddressBookMutationBody = CreateAddressBookRequest;
export type CreateDevelopmentAddressBookMutationError = ErrorType<void>;

export const useCreateDevelopmentAddressBook = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createDevelopmentAddressBook>>,
    TError,
    { coreId: string; paymentSystem: string; data: CreateAddressBookRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createDevelopmentAddressBook>>,
  TError,
  { coreId: string; paymentSystem: string; data: CreateAddressBookRequest },
  TContext
> => {
  const mutationOptions = getCreateDevelopmentAddressBookMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Returns announcements which their display time is now.
 */
export const getAllAnnouncements = (options?: SecondParameter<typeof customInstance>, signal?: AbortSignal) => {
  return customInstance<AnnouncementResponse[]>(
    { url: `/frontoffice/api/v1/announcement`, method: 'GET', signal },
    options
  );
};

export const getGetAllAnnouncementsQueryKey = () => {
  return [`/frontoffice/api/v1/announcement`] as const;
};

export const getGetAllAnnouncementsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAllAnnouncements>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getAllAnnouncements>>, TError, TData>;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAllAnnouncementsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllAnnouncements>>> = ({ signal }) =>
    getAllAnnouncements(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAllAnnouncements>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAllAnnouncementsQueryResult = NonNullable<Awaited<ReturnType<typeof getAllAnnouncements>>>;
export type GetAllAnnouncementsQueryError = ErrorType<unknown>;

/**
 * @summary Returns announcements which their display time is now.
 */

export function useGetAllAnnouncements<
  TData = Awaited<ReturnType<typeof getAllAnnouncements>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getAllAnnouncements>>, TError, TData>;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetAllAnnouncementsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Gets all Assets
 */
export const getAllAsset = (options?: SecondParameter<typeof customInstance>, signal?: AbortSignal) => {
  return customInstance<AssetResponseListResponse>(
    { url: `/frontoffice/api/assets-info`, method: 'GET', signal },
    options
  );
};

export const getGetAllAssetQueryKey = () => {
  return [`/frontoffice/api/assets-info`] as const;
};

export const getGetAllAssetQueryOptions = <
  TData = Awaited<ReturnType<typeof getAllAsset>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getAllAsset>>, TError, TData>;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAllAssetQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllAsset>>> = ({ signal }) =>
    getAllAsset(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAllAsset>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAllAssetQueryResult = NonNullable<Awaited<ReturnType<typeof getAllAsset>>>;
export type GetAllAssetQueryError = ErrorType<unknown>;

/**
 * @summary Gets all Assets
 */

export function useGetAllAsset<TData = Awaited<ReturnType<typeof getAllAsset>>, TError = ErrorType<unknown>>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getAllAsset>>, TError, TData>;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetAllAssetQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getAssetsContractsAssetContract = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<GetAssetsContractsResponse>(
    { url: `/frontoffice/api/asset-contract`, method: 'GET', signal },
    options
  );
};

export const getGetAssetsContractsAssetContractQueryKey = () => {
  return [`/frontoffice/api/asset-contract`] as const;
};

export const getGetAssetsContractsAssetContractQueryOptions = <
  TData = Awaited<ReturnType<typeof getAssetsContractsAssetContract>>,
  TError = ErrorType<void>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getAssetsContractsAssetContract>>, TError, TData>;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAssetsContractsAssetContractQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAssetsContractsAssetContract>>> = ({ signal }) =>
    getAssetsContractsAssetContract(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAssetsContractsAssetContract>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAssetsContractsAssetContractQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAssetsContractsAssetContract>>
>;
export type GetAssetsContractsAssetContractQueryError = ErrorType<void>;

export function useGetAssetsContractsAssetContract<
  TData = Awaited<ReturnType<typeof getAssetsContractsAssetContract>>,
  TError = ErrorType<void>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getAssetsContractsAssetContract>>, TError, TData>;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetAssetsContractsAssetContractQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getSignedAssetsContractsAssetContract = (
  params?: GetSignedAssetsContractsAssetContractParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<GetSignedAssetsContractsResponse>(
    { url: `/frontoffice/api/asset-contract/signed`, method: 'GET', params, signal },
    options
  );
};

export const getGetSignedAssetsContractsAssetContractQueryKey = (
  params?: GetSignedAssetsContractsAssetContractParams
) => {
  return [`/frontoffice/api/asset-contract/signed`, ...(params ? [params] : [])] as const;
};

export const getGetSignedAssetsContractsAssetContractQueryOptions = <
  TData = Awaited<ReturnType<typeof getSignedAssetsContractsAssetContract>>,
  TError = ErrorType<void>
>(
  params?: GetSignedAssetsContractsAssetContractParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getSignedAssetsContractsAssetContract>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSignedAssetsContractsAssetContractQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSignedAssetsContractsAssetContract>>> = ({ signal }) =>
    getSignedAssetsContractsAssetContract(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSignedAssetsContractsAssetContract>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetSignedAssetsContractsAssetContractQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSignedAssetsContractsAssetContract>>
>;
export type GetSignedAssetsContractsAssetContractQueryError = ErrorType<void>;

export function useGetSignedAssetsContractsAssetContract<
  TData = Awaited<ReturnType<typeof getSignedAssetsContractsAssetContract>>,
  TError = ErrorType<void>
>(
  params?: GetSignedAssetsContractsAssetContractParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getSignedAssetsContractsAssetContract>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetSignedAssetsContractsAssetContractQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getAssetContracts = (
  assetId: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<GetLatestByAssetIdResponse>(
    { url: `/frontoffice/api/asset-contract/${assetId}`, method: 'GET', signal },
    options
  );
};

export const getGetAssetContractsQueryKey = (assetId: string) => {
  return [`/frontoffice/api/asset-contract/${assetId}`] as const;
};

export const getGetAssetContractsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAssetContracts>>,
  TError = ErrorType<void>
>(
  assetId: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getAssetContracts>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAssetContractsQueryKey(assetId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAssetContracts>>> = ({ signal }) =>
    getAssetContracts(assetId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!assetId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAssetContracts>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAssetContractsQueryResult = NonNullable<Awaited<ReturnType<typeof getAssetContracts>>>;
export type GetAssetContractsQueryError = ErrorType<void>;

export function useGetAssetContracts<TData = Awaited<ReturnType<typeof getAssetContracts>>, TError = ErrorType<void>>(
  assetId: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getAssetContracts>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetAssetContractsQueryOptions(assetId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const requestContractSignatureAssetContract = (
  assetContractSignatureRequest: AssetContractSignatureRequest,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<string>(
    {
      url: `/frontoffice/api/asset-contract/request`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: assetContractSignatureRequest,
    },
    options
  );
};

export const getRequestContractSignatureAssetContractMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof requestContractSignatureAssetContract>>,
    TError,
    { data: AssetContractSignatureRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof requestContractSignatureAssetContract>>,
  TError,
  { data: AssetContractSignatureRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof requestContractSignatureAssetContract>>,
    { data: AssetContractSignatureRequest }
  > = props => {
    const { data } = props ?? {};

    return requestContractSignatureAssetContract(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RequestContractSignatureAssetContractMutationResult = NonNullable<
  Awaited<ReturnType<typeof requestContractSignatureAssetContract>>
>;
export type RequestContractSignatureAssetContractMutationBody = AssetContractSignatureRequest;
export type RequestContractSignatureAssetContractMutationError = ErrorType<void>;

export const useRequestContractSignatureAssetContract = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof requestContractSignatureAssetContract>>,
    TError,
    { data: AssetContractSignatureRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof requestContractSignatureAssetContract>>,
  TError,
  { data: AssetContractSignatureRequest },
  TContext
> => {
  const mutationOptions = getRequestContractSignatureAssetContractMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteByIdAssetContract = (id: string, options?: SecondParameter<typeof customInstance>) => {
  return customInstance<void>({ url: `/frontoffice/api/asset-contract/by-id/${id}`, method: 'DELETE' }, options);
};

export const getDeleteByIdAssetContractMutationOptions = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof deleteByIdAssetContract>>, TError, { id: string }, TContext>;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<Awaited<ReturnType<typeof deleteByIdAssetContract>>, TError, { id: string }, TContext> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteByIdAssetContract>>, { id: string }> = props => {
    const { id } = props ?? {};

    return deleteByIdAssetContract(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteByIdAssetContractMutationResult = NonNullable<Awaited<ReturnType<typeof deleteByIdAssetContract>>>;

export type DeleteByIdAssetContractMutationError = ErrorType<void>;

export const useDeleteByIdAssetContract = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof deleteByIdAssetContract>>, TError, { id: string }, TContext>;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<Awaited<ReturnType<typeof deleteByIdAssetContract>>, TError, { id: string }, TContext> => {
  const mutationOptions = getDeleteByIdAssetContractMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteByUserIdAssetContract = (assetId: string, options?: SecondParameter<typeof customInstance>) => {
  return customInstance<void>({ url: `/frontoffice/api/asset-contract/by-user/${assetId}`, method: 'DELETE' }, options);
};

export const getDeleteByUserIdAssetContractMutationOptions = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteByUserIdAssetContract>>,
    TError,
    { assetId: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteByUserIdAssetContract>>,
  TError,
  { assetId: string },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteByUserIdAssetContract>>,
    { assetId: string }
  > = props => {
    const { assetId } = props ?? {};

    return deleteByUserIdAssetContract(assetId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteByUserIdAssetContractMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteByUserIdAssetContract>>
>;

export type DeleteByUserIdAssetContractMutationError = ErrorType<void>;

export const useDeleteByUserIdAssetContract = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteByUserIdAssetContract>>,
    TError,
    { assetId: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteByUserIdAssetContract>>,
  TError,
  { assetId: string },
  TContext
> => {
  const mutationOptions = getDeleteByUserIdAssetContractMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getBySlugCampaign = (
  slug: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<CampaignDetailResponse>(
    { url: `/frontoffice/api/v1/campaigns/slug/${slug}`, method: 'GET', signal },
    options
  );
};

export const getGetBySlugCampaignQueryKey = (slug: string) => {
  return [`/frontoffice/api/v1/campaigns/slug/${slug}`] as const;
};

export const getGetBySlugCampaignQueryOptions = <
  TData = Awaited<ReturnType<typeof getBySlugCampaign>>,
  TError = ErrorType<unknown>
>(
  slug: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getBySlugCampaign>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetBySlugCampaignQueryKey(slug);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getBySlugCampaign>>> = ({ signal }) =>
    getBySlugCampaign(slug, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!slug, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getBySlugCampaign>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetBySlugCampaignQueryResult = NonNullable<Awaited<ReturnType<typeof getBySlugCampaign>>>;
export type GetBySlugCampaignQueryError = ErrorType<unknown>;

export function useGetBySlugCampaign<
  TData = Awaited<ReturnType<typeof getBySlugCampaign>>,
  TError = ErrorType<unknown>
>(
  slug: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getBySlugCampaign>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetBySlugCampaignQueryOptions(slug, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getWinnersBySlugCampaign = (
  slug: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<CampaignWinnersResponse>(
    { url: `/frontoffice/api/v1/campaigns/slug/${slug}/winners`, method: 'GET', signal },
    options
  );
};

export const getGetWinnersBySlugCampaignQueryKey = (slug: string) => {
  return [`/frontoffice/api/v1/campaigns/slug/${slug}/winners`] as const;
};

export const getGetWinnersBySlugCampaignQueryOptions = <
  TData = Awaited<ReturnType<typeof getWinnersBySlugCampaign>>,
  TError = ErrorType<unknown>
>(
  slug: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getWinnersBySlugCampaign>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetWinnersBySlugCampaignQueryKey(slug);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getWinnersBySlugCampaign>>> = ({ signal }) =>
    getWinnersBySlugCampaign(slug, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!slug, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getWinnersBySlugCampaign>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetWinnersBySlugCampaignQueryResult = NonNullable<Awaited<ReturnType<typeof getWinnersBySlugCampaign>>>;
export type GetWinnersBySlugCampaignQueryError = ErrorType<unknown>;

export function useGetWinnersBySlugCampaign<
  TData = Awaited<ReturnType<typeof getWinnersBySlugCampaign>>,
  TError = ErrorType<unknown>
>(
  slug: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getWinnersBySlugCampaign>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetWinnersBySlugCampaignQueryOptions(slug, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Public campaign details. When authenticated, includes the caller's participation status and entry weight.
 */
export const getByIdCampaign = (id: string, options?: SecondParameter<typeof customInstance>, signal?: AbortSignal) => {
  return customInstance<CampaignDetailResponse>(
    { url: `/frontoffice/api/v1/campaigns/${id}`, method: 'GET', signal },
    options
  );
};

export const getGetByIdCampaignQueryKey = (id: string) => {
  return [`/frontoffice/api/v1/campaigns/${id}`] as const;
};

export const getGetByIdCampaignQueryOptions = <
  TData = Awaited<ReturnType<typeof getByIdCampaign>>,
  TError = ErrorType<unknown>
>(
  id: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getByIdCampaign>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetByIdCampaignQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getByIdCampaign>>> = ({ signal }) =>
    getByIdCampaign(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getByIdCampaign>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetByIdCampaignQueryResult = NonNullable<Awaited<ReturnType<typeof getByIdCampaign>>>;
export type GetByIdCampaignQueryError = ErrorType<unknown>;

/**
 * @summary Public campaign details. When authenticated, includes the caller's participation status and entry weight.
 */

export function useGetByIdCampaign<TData = Awaited<ReturnType<typeof getByIdCampaign>>, TError = ErrorType<unknown>>(
  id: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getByIdCampaign>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetByIdCampaignQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Join a campaign. Requires an active user account. Idempotent when already joined.
 */
export const joinCampaign = (
  id: string,
  joinCampaignRequest: JoinCampaignRequest,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<JoinCampaignResponse>(
    {
      url: `/frontoffice/api/v1/campaigns/${id}/join`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: joinCampaignRequest,
    },
    options
  );
};

export const getJoinCampaignMutationOptions = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof joinCampaign>>,
    TError,
    { id: string; data: JoinCampaignRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof joinCampaign>>,
  TError,
  { id: string; data: JoinCampaignRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof joinCampaign>>,
    { id: string; data: JoinCampaignRequest }
  > = props => {
    const { id, data } = props ?? {};

    return joinCampaign(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type JoinCampaignMutationResult = NonNullable<Awaited<ReturnType<typeof joinCampaign>>>;
export type JoinCampaignMutationBody = JoinCampaignRequest;
export type JoinCampaignMutationError = ErrorType<void>;

/**
 * @summary Join a campaign. Requires an active user account. Idempotent when already joined.
 */
export const useJoinCampaign = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof joinCampaign>>,
    TError,
    { id: string; data: JoinCampaignRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof joinCampaign>>,
  TError,
  { id: string; data: JoinCampaignRequest },
  TContext
> => {
  const mutationOptions = getJoinCampaignMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Returns the authenticated user's result for a campaign after joining (including winner status).
 */
export const getMyResultCampaign = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<CampaignMyResultResponse>(
    { url: `/frontoffice/api/v1/campaigns/${id}/my-result`, method: 'GET', signal },
    options
  );
};

export const getGetMyResultCampaignQueryKey = (id: string) => {
  return [`/frontoffice/api/v1/campaigns/${id}/my-result`] as const;
};

export const getGetMyResultCampaignQueryOptions = <
  TData = Awaited<ReturnType<typeof getMyResultCampaign>>,
  TError = ErrorType<void>
>(
  id: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getMyResultCampaign>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMyResultCampaignQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyResultCampaign>>> = ({ signal }) =>
    getMyResultCampaign(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMyResultCampaign>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMyResultCampaignQueryResult = NonNullable<Awaited<ReturnType<typeof getMyResultCampaign>>>;
export type GetMyResultCampaignQueryError = ErrorType<void>;

/**
 * @summary Returns the authenticated user's result for a campaign after joining (including winner status).
 */

export function useGetMyResultCampaign<
  TData = Awaited<ReturnType<typeof getMyResultCampaign>>,
  TError = ErrorType<void>
>(
  id: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getMyResultCampaign>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetMyResultCampaignQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getMyActivityCampaign = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<CampaignMyActivityResponse>(
    { url: `/frontoffice/api/v1/campaigns/${id}/my-activity`, method: 'GET', signal },
    options
  );
};

export const getGetMyActivityCampaignQueryKey = (id: string) => {
  return [`/frontoffice/api/v1/campaigns/${id}/my-activity`] as const;
};

export const getGetMyActivityCampaignQueryOptions = <
  TData = Awaited<ReturnType<typeof getMyActivityCampaign>>,
  TError = ErrorType<void>
>(
  id: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getMyActivityCampaign>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMyActivityCampaignQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyActivityCampaign>>> = ({ signal }) =>
    getMyActivityCampaign(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMyActivityCampaign>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMyActivityCampaignQueryResult = NonNullable<Awaited<ReturnType<typeof getMyActivityCampaign>>>;
export type GetMyActivityCampaignQueryError = ErrorType<void>;

export function useGetMyActivityCampaign<
  TData = Awaited<ReturnType<typeof getMyActivityCampaign>>,
  TError = ErrorType<void>
>(
  id: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getMyActivityCampaign>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetMyActivityCampaignQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getMyParticipationsCampaign = (options?: SecondParameter<typeof customInstance>, signal?: AbortSignal) => {
  return customInstance<CampaignMyParticipationResponse[]>(
    { url: `/frontoffice/api/v1/campaigns/mine`, method: 'GET', signal },
    options
  );
};

export const getGetMyParticipationsCampaignQueryKey = () => {
  return [`/frontoffice/api/v1/campaigns/mine`] as const;
};

export const getGetMyParticipationsCampaignQueryOptions = <
  TData = Awaited<ReturnType<typeof getMyParticipationsCampaign>>,
  TError = ErrorType<void>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getMyParticipationsCampaign>>, TError, TData>;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMyParticipationsCampaignQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyParticipationsCampaign>>> = ({ signal }) =>
    getMyParticipationsCampaign(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMyParticipationsCampaign>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMyParticipationsCampaignQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMyParticipationsCampaign>>
>;
export type GetMyParticipationsCampaignQueryError = ErrorType<void>;

export function useGetMyParticipationsCampaign<
  TData = Awaited<ReturnType<typeof getMyParticipationsCampaign>>,
  TError = ErrorType<void>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getMyParticipationsCampaign>>, TError, TData>;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetMyParticipationsCampaignQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Public feature flags for the competitions UI.
 */
export const getConfigCampaign = (options?: SecondParameter<typeof customInstance>, signal?: AbortSignal) => {
  return customInstance<CampaignConfigResponse>(
    { url: `/frontoffice/api/v1/campaigns/config`, method: 'GET', signal },
    options
  );
};

export const getGetConfigCampaignQueryKey = () => {
  return [`/frontoffice/api/v1/campaigns/config`] as const;
};

export const getGetConfigCampaignQueryOptions = <
  TData = Awaited<ReturnType<typeof getConfigCampaign>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getConfigCampaign>>, TError, TData>;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetConfigCampaignQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getConfigCampaign>>> = ({ signal }) =>
    getConfigCampaign(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getConfigCampaign>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetConfigCampaignQueryResult = NonNullable<Awaited<ReturnType<typeof getConfigCampaign>>>;
export type GetConfigCampaignQueryError = ErrorType<unknown>;

/**
 * @summary Public feature flags for the competitions UI.
 */

export function useGetConfigCampaign<
  TData = Awaited<ReturnType<typeof getConfigCampaign>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getConfigCampaign>>, TError, TData>;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetConfigCampaignQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Lists all campaigns for the competitions hub, newest first.
 */
export const listCampaign = (options?: SecondParameter<typeof customInstance>, signal?: AbortSignal) => {
  return customInstance<CampaignSummaryResponse[]>(
    { url: `/frontoffice/api/v1/campaigns`, method: 'GET', signal },
    options
  );
};

export const getListCampaignQueryKey = () => {
  return [`/frontoffice/api/v1/campaigns`] as const;
};

export const getListCampaignQueryOptions = <
  TData = Awaited<ReturnType<typeof listCampaign>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof listCampaign>>, TError, TData>;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListCampaignQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listCampaign>>> = ({ signal }) =>
    listCampaign(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listCampaign>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListCampaignQueryResult = NonNullable<Awaited<ReturnType<typeof listCampaign>>>;
export type ListCampaignQueryError = ErrorType<unknown>;

/**
 * @summary Lists all campaigns for the competitions hub, newest first.
 */

export function useListCampaign<
  TData = Awaited<ReturnType<typeof listCampaign>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof listCampaign>>, TError, TData>;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListCampaignQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Returns the next step that needs to be shown to the user if they want to proceed with compliance tier upgrade.
 */
export const getNextStepCompliance = (
  params?: GetNextStepComplianceParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ComplianceStepType>(
    { url: `/frontoffice/api/compliance/get-next-step`, method: 'GET', params, signal },
    options
  );
};

export const getGetNextStepComplianceQueryKey = (params?: GetNextStepComplianceParams) => {
  return [`/frontoffice/api/compliance/get-next-step`, ...(params ? [params] : [])] as const;
};

export const getGetNextStepComplianceQueryOptions = <
  TData = Awaited<ReturnType<typeof getNextStepCompliance>>,
  TError = ErrorType<void>
>(
  params?: GetNextStepComplianceParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getNextStepCompliance>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetNextStepComplianceQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getNextStepCompliance>>> = ({ signal }) =>
    getNextStepCompliance(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getNextStepCompliance>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetNextStepComplianceQueryResult = NonNullable<Awaited<ReturnType<typeof getNextStepCompliance>>>;
export type GetNextStepComplianceQueryError = ErrorType<void>;

/**
 * @summary Returns the next step that needs to be shown to the user if they want to proceed with compliance tier upgrade.
 */

export function useGetNextStepCompliance<
  TData = Awaited<ReturnType<typeof getNextStepCompliance>>,
  TError = ErrorType<void>
>(
  params?: GetNextStepComplianceParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getNextStepCompliance>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetNextStepComplianceQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getPreviousStepCompliance = (
  params?: GetPreviousStepComplianceParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ComplianceStepType>(
    { url: `/frontoffice/api/compliance/get-previous-step`, method: 'GET', params, signal },
    options
  );
};

export const getGetPreviousStepComplianceQueryKey = (params?: GetPreviousStepComplianceParams) => {
  return [`/frontoffice/api/compliance/get-previous-step`, ...(params ? [params] : [])] as const;
};

export const getGetPreviousStepComplianceQueryOptions = <
  TData = Awaited<ReturnType<typeof getPreviousStepCompliance>>,
  TError = ErrorType<void>
>(
  params?: GetPreviousStepComplianceParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getPreviousStepCompliance>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPreviousStepComplianceQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPreviousStepCompliance>>> = ({ signal }) =>
    getPreviousStepCompliance(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPreviousStepCompliance>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPreviousStepComplianceQueryResult = NonNullable<Awaited<ReturnType<typeof getPreviousStepCompliance>>>;
export type GetPreviousStepComplianceQueryError = ErrorType<void>;

export function useGetPreviousStepCompliance<
  TData = Awaited<ReturnType<typeof getPreviousStepCompliance>>,
  TError = ErrorType<void>
>(
  params?: GetPreviousStepComplianceParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getPreviousStepCompliance>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetPreviousStepComplianceQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Creates new review request in Open state, using given RequestType.
 */
export const createCompliance = (
  createUserReviewRequest: CreateUserReviewRequest,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<void>(
    {
      url: `/frontoffice/api/compliance`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: createUserReviewRequest,
    },
    options
  );
};

export const getCreateComplianceMutationOptions = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCompliance>>,
    TError,
    { data: CreateUserReviewRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createCompliance>>,
  TError,
  { data: CreateUserReviewRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createCompliance>>,
    { data: CreateUserReviewRequest }
  > = props => {
    const { data } = props ?? {};

    return createCompliance(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateComplianceMutationResult = NonNullable<Awaited<ReturnType<typeof createCompliance>>>;
export type CreateComplianceMutationBody = CreateUserReviewRequest;
export type CreateComplianceMutationError = ErrorType<void>;

/**
 * @summary Creates new review request in Open state, using given RequestType.
 */
export const useCreateCompliance = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCompliance>>,
    TError,
    { data: CreateUserReviewRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createCompliance>>,
  TError,
  { data: CreateUserReviewRequest },
  TContext
> => {
  const mutationOptions = getCreateComplianceMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Cancels active review, Returns true, if any active review is found and cancelled, otherwise returns false.
 */
export const cancelActiveReviewCompliance = (options?: SecondParameter<typeof customInstance>) => {
  return customInstance<void>({ url: `/frontoffice/api/compliance/cancel`, method: 'POST' }, options);
};

export const getCancelActiveReviewComplianceMutationOptions = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof cancelActiveReviewCompliance>>, TError, void, TContext>;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<Awaited<ReturnType<typeof cancelActiveReviewCompliance>>, TError, void, TContext> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelActiveReviewCompliance>>, void> = () => {
    return cancelActiveReviewCompliance(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CancelActiveReviewComplianceMutationResult = NonNullable<
  Awaited<ReturnType<typeof cancelActiveReviewCompliance>>
>;

export type CancelActiveReviewComplianceMutationError = ErrorType<void>;

/**
 * @summary Cancels active review, Returns true, if any active review is found and cancelled, otherwise returns false.
 */
export const useCancelActiveReviewCompliance = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof cancelActiveReviewCompliance>>, TError, void, TContext>;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<Awaited<ReturnType<typeof cancelActiveReviewCompliance>>, TError, void, TContext> => {
  const mutationOptions = getCancelActiveReviewComplianceMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Gets last request even when it's rejected
 */
export const getLastRequestCompliance = (options?: SecondParameter<typeof customInstance>, signal?: AbortSignal) => {
  return customInstance<LastUserReviewResponse | void>(
    { url: `/frontoffice/api/compliance/active`, method: 'GET', signal },
    options
  );
};

export const getGetLastRequestComplianceQueryKey = () => {
  return [`/frontoffice/api/compliance/active`] as const;
};

export const getGetLastRequestComplianceQueryOptions = <
  TData = Awaited<ReturnType<typeof getLastRequestCompliance>>,
  TError = ErrorType<void>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getLastRequestCompliance>>, TError, TData>;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetLastRequestComplianceQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getLastRequestCompliance>>> = ({ signal }) =>
    getLastRequestCompliance(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getLastRequestCompliance>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetLastRequestComplianceQueryResult = NonNullable<Awaited<ReturnType<typeof getLastRequestCompliance>>>;
export type GetLastRequestComplianceQueryError = ErrorType<void>;

/**
 * @summary Gets last request even when it's rejected
 */

export function useGetLastRequestCompliance<
  TData = Awaited<ReturnType<typeof getLastRequestCompliance>>,
  TError = ErrorType<void>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getLastRequestCompliance>>, TError, TData>;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetLastRequestComplianceQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Submits the open compliance review request that updates request status to PendingForReview
 */
export const submitReviewRequestCompliance = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<void>({ url: `/frontoffice/api/compliance/submit`, method: 'GET', signal }, options);
};

export const getSubmitReviewRequestComplianceQueryKey = () => {
  return [`/frontoffice/api/compliance/submit`] as const;
};

export const getSubmitReviewRequestComplianceQueryOptions = <
  TData = Awaited<ReturnType<typeof submitReviewRequestCompliance>>,
  TError = ErrorType<void>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof submitReviewRequestCompliance>>, TError, TData>;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSubmitReviewRequestComplianceQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof submitReviewRequestCompliance>>> = ({ signal }) =>
    submitReviewRequestCompliance(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof submitReviewRequestCompliance>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SubmitReviewRequestComplianceQueryResult = NonNullable<
  Awaited<ReturnType<typeof submitReviewRequestCompliance>>
>;
export type SubmitReviewRequestComplianceQueryError = ErrorType<void>;

/**
 * @summary Submits the open compliance review request that updates request status to PendingForReview
 */

export function useSubmitReviewRequestCompliance<
  TData = Awaited<ReturnType<typeof submitReviewRequestCompliance>>,
  TError = ErrorType<void>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof submitReviewRequestCompliance>>, TError, TData>;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getSubmitReviewRequestComplianceQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Acknowledges user review request which is rejected.
 */
export const acknowledgeRejectedReviewCompliance = (
  acknowledgeRequest: AcknowledgeRequest,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<void>(
    {
      url: `/frontoffice/api/compliance/acknowledge`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: acknowledgeRequest,
    },
    options
  );
};

export const getAcknowledgeRejectedReviewComplianceMutationOptions = <
  TError = ErrorType<void | ApiErrorResponse>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof acknowledgeRejectedReviewCompliance>>,
    TError,
    { data: AcknowledgeRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof acknowledgeRejectedReviewCompliance>>,
  TError,
  { data: AcknowledgeRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof acknowledgeRejectedReviewCompliance>>,
    { data: AcknowledgeRequest }
  > = props => {
    const { data } = props ?? {};

    return acknowledgeRejectedReviewCompliance(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AcknowledgeRejectedReviewComplianceMutationResult = NonNullable<
  Awaited<ReturnType<typeof acknowledgeRejectedReviewCompliance>>
>;
export type AcknowledgeRejectedReviewComplianceMutationBody = AcknowledgeRequest;
export type AcknowledgeRejectedReviewComplianceMutationError = ErrorType<void | ApiErrorResponse>;

/**
 * @summary Acknowledges user review request which is rejected.
 */
export const useAcknowledgeRejectedReviewCompliance = <
  TError = ErrorType<void | ApiErrorResponse>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof acknowledgeRejectedReviewCompliance>>,
    TError,
    { data: AcknowledgeRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof acknowledgeRejectedReviewCompliance>>,
  TError,
  { data: AcknowledgeRequest },
  TContext
> => {
  const mutationOptions = getAcknowledgeRejectedReviewComplianceMutationOptions(options);

  return useMutation(mutationOptions);
};

export const updateContactFiat = (
  contactFiatData: ContactFiatData,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<ContactFiatRecord>(
    {
      url: `/frontoffice/api/contactfiat`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: contactFiatData,
    },
    options
  );
};

export const getUpdateContactFiatMutationOptions = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateContactFiat>>,
    TError,
    { data: ContactFiatData },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<Awaited<ReturnType<typeof updateContactFiat>>, TError, { data: ContactFiatData }, TContext> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateContactFiat>>,
    { data: ContactFiatData }
  > = props => {
    const { data } = props ?? {};

    return updateContactFiat(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateContactFiatMutationResult = NonNullable<Awaited<ReturnType<typeof updateContactFiat>>>;
export type UpdateContactFiatMutationBody = ContactFiatData;
export type UpdateContactFiatMutationError = ErrorType<void>;

export const useUpdateContactFiat = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateContactFiat>>,
    TError,
    { data: ContactFiatData },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<Awaited<ReturnType<typeof updateContactFiat>>, TError, { data: ContactFiatData }, TContext> => {
  const mutationOptions = getUpdateContactFiatMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteContactFiat = (id: string, options?: SecondParameter<typeof customInstance>) => {
  return customInstance<ContactFiatRecord>({ url: `/frontoffice/api/contactfiat/${id}`, method: 'DELETE' }, options);
};

export const getDeleteContactFiatMutationOptions = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof deleteContactFiat>>, TError, { id: string }, TContext>;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<Awaited<ReturnType<typeof deleteContactFiat>>, TError, { id: string }, TContext> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteContactFiat>>, { id: string }> = props => {
    const { id } = props ?? {};

    return deleteContactFiat(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteContactFiatMutationResult = NonNullable<Awaited<ReturnType<typeof deleteContactFiat>>>;

export type DeleteContactFiatMutationError = ErrorType<void>;

export const useDeleteContactFiat = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof deleteContactFiat>>, TError, { id: string }, TContext>;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<Awaited<ReturnType<typeof deleteContactFiat>>, TError, { id: string }, TContext> => {
  const mutationOptions = getDeleteContactFiatMutationOptions(options);

  return useMutation(mutationOptions);
};

export const requestQrCodeCorePassConnector = (options?: SecondParameter<typeof customInstance>) => {
  return customInstance<KycQrCodeResponse>(
    { url: `/frontoffice/api/corepass-connector/kyc/request`, method: 'POST' },
    options
  );
};

export const getRequestQrCodeCorePassConnectorMutationOptions = <
  TError = ErrorType<KycErrorResponse | void>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof requestQrCodeCorePassConnector>>, TError, void, TContext>;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<Awaited<ReturnType<typeof requestQrCodeCorePassConnector>>, TError, void, TContext> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof requestQrCodeCorePassConnector>>, void> = () => {
    return requestQrCodeCorePassConnector(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RequestQrCodeCorePassConnectorMutationResult = NonNullable<
  Awaited<ReturnType<typeof requestQrCodeCorePassConnector>>
>;

export type RequestQrCodeCorePassConnectorMutationError = ErrorType<KycErrorResponse | void>;

export const useRequestQrCodeCorePassConnector = <
  TError = ErrorType<KycErrorResponse | void>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof requestQrCodeCorePassConnector>>, TError, void, TContext>;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<Awaited<ReturnType<typeof requestQrCodeCorePassConnector>>, TError, void, TContext> => {
  const mutationOptions = getRequestQrCodeCorePassConnectorMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Data-delivery and terminal-failure webhook (INTEGRATOR_GUIDE 6.1 and 6.2). Registered with the
connector as `callback`.
 */
export const callbackCorePassConnector = (options?: SecondParameter<typeof customInstance>) => {
  return customInstance<void>({ url: `/frontoffice/api/corepass-connector/kyc/callback`, method: 'POST' }, options);
};

export const getCallbackCorePassConnectorMutationOptions = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof callbackCorePassConnector>>, TError, void, TContext>;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<Awaited<ReturnType<typeof callbackCorePassConnector>>, TError, void, TContext> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof callbackCorePassConnector>>, void> = () => {
    return callbackCorePassConnector(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CallbackCorePassConnectorMutationResult = NonNullable<
  Awaited<ReturnType<typeof callbackCorePassConnector>>
>;

export type CallbackCorePassConnectorMutationError = ErrorType<unknown>;

/**
 * @summary Data-delivery and terminal-failure webhook (INTEGRATOR_GUIDE 6.1 and 6.2). Registered with the
connector as `callback`.
 */
export const useCallbackCorePassConnector = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof callbackCorePassConnector>>, TError, void, TContext>;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<Awaited<ReturnType<typeof callbackCorePassConnector>>, TError, void, TContext> => {
  const mutationOptions = getCallbackCorePassConnectorMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Lifecycle status webhook (INTEGRATOR_GUIDE 6.3). Registered with the connector as
`statusCallback`; one POST per transition.
 */
export const statusCallbackCorePassConnector = (options?: SecondParameter<typeof customInstance>) => {
  return customInstance<void>(
    { url: `/frontoffice/api/corepass-connector/kyc/statusCallback`, method: 'POST' },
    options
  );
};

export const getStatusCallbackCorePassConnectorMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof statusCallbackCorePassConnector>>, TError, void, TContext>;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<Awaited<ReturnType<typeof statusCallbackCorePassConnector>>, TError, void, TContext> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof statusCallbackCorePassConnector>>, void> = () => {
    return statusCallbackCorePassConnector(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type StatusCallbackCorePassConnectorMutationResult = NonNullable<
  Awaited<ReturnType<typeof statusCallbackCorePassConnector>>
>;

export type StatusCallbackCorePassConnectorMutationError = ErrorType<unknown>;

/**
 * @summary Lifecycle status webhook (INTEGRATOR_GUIDE 6.3). Registered with the connector as
`statusCallback`; one POST per transition.
 */
export const useStatusCallbackCorePassConnector = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof statusCallbackCorePassConnector>>, TError, void, TContext>;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<Awaited<ReturnType<typeof statusCallbackCorePassConnector>>, TError, void, TContext> => {
  const mutationOptions = getStatusCallbackCorePassConnectorMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary For testing purposes and possibility of adding eligible emails by admin
 */
export const addEligibleEmail = (
  eligibleEmailRequest: EligibleEmailRequest,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<void>(
    {
      url: `/frontoffice/api/eligibleemails`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: eligibleEmailRequest,
    },
    options
  );
};

export const getAddEligibleEmailMutationOptions = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addEligibleEmail>>,
    TError,
    { data: EligibleEmailRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof addEligibleEmail>>,
  TError,
  { data: EligibleEmailRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof addEligibleEmail>>,
    { data: EligibleEmailRequest }
  > = props => {
    const { data } = props ?? {};

    return addEligibleEmail(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AddEligibleEmailMutationResult = NonNullable<Awaited<ReturnType<typeof addEligibleEmail>>>;
export type AddEligibleEmailMutationBody = EligibleEmailRequest;
export type AddEligibleEmailMutationError = ErrorType<void>;

/**
 * @summary For testing purposes and possibility of adding eligible emails by admin
 */
export const useAddEligibleEmail = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addEligibleEmail>>,
    TError,
    { data: EligibleEmailRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof addEligibleEmail>>,
  TError,
  { data: EligibleEmailRequest },
  TContext
> => {
  const mutationOptions = getAddEligibleEmailMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary For testing purposes lets the admin delete an eligibility record
 */
export const deleteEligibleEmail = (
  deleteEligibleEmailRequest: DeleteEligibleEmailRequest,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<void>(
    {
      url: `/frontoffice/api/eligibleemails`,
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: deleteEligibleEmailRequest,
    },
    options
  );
};

export const getDeleteEligibleEmailMutationOptions = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteEligibleEmail>>,
    TError,
    { data: DeleteEligibleEmailRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteEligibleEmail>>,
  TError,
  { data: DeleteEligibleEmailRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteEligibleEmail>>,
    { data: DeleteEligibleEmailRequest }
  > = props => {
    const { data } = props ?? {};

    return deleteEligibleEmail(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteEligibleEmailMutationResult = NonNullable<Awaited<ReturnType<typeof deleteEligibleEmail>>>;
export type DeleteEligibleEmailMutationBody = DeleteEligibleEmailRequest;
export type DeleteEligibleEmailMutationError = ErrorType<void>;

/**
 * @summary For testing purposes lets the admin delete an eligibility record
 */
export const useDeleteEligibleEmail = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteEligibleEmail>>,
    TError,
    { data: DeleteEligibleEmailRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteEligibleEmail>>,
  TError,
  { data: DeleteEligibleEmailRequest },
  TContext
> => {
  const mutationOptions = getDeleteEligibleEmailMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary For testing purposes and possibility of processing eligible emails by admin
 */
export const processEligibilityEligibleEmail = (
  processEligibilityRequest: ProcessEligibilityRequest,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<void>(
    {
      url: `/frontoffice/api/eligibleemails/process`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: processEligibilityRequest,
    },
    options
  );
};

export const getProcessEligibilityEligibleEmailMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof processEligibilityEligibleEmail>>,
    TError,
    { data: ProcessEligibilityRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof processEligibilityEligibleEmail>>,
  TError,
  { data: ProcessEligibilityRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof processEligibilityEligibleEmail>>,
    { data: ProcessEligibilityRequest }
  > = props => {
    const { data } = props ?? {};

    return processEligibilityEligibleEmail(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ProcessEligibilityEligibleEmailMutationResult = NonNullable<
  Awaited<ReturnType<typeof processEligibilityEligibleEmail>>
>;
export type ProcessEligibilityEligibleEmailMutationBody = ProcessEligibilityRequest;
export type ProcessEligibilityEligibleEmailMutationError = ErrorType<void>;

/**
 * @summary For testing purposes and possibility of processing eligible emails by admin
 */
export const useProcessEligibilityEligibleEmail = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof processEligibilityEligibleEmail>>,
    TError,
    { data: ProcessEligibilityRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof processEligibilityEligibleEmail>>,
  TError,
  { data: ProcessEligibilityRequest },
  TContext
> => {
  const mutationOptions = getProcessEligibilityEligibleEmailMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Gets the exchange rate for a specific market along with price deviation validation information
 */
export const getMarketExchangeRate = (
  params?: GetMarketExchangeRateParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<MarketExchangeRateResponse>(
    { url: `/frontoffice/api/exchange-rate/market`, method: 'GET', params, signal },
    options
  );
};

export const getGetMarketExchangeRateQueryKey = (params?: GetMarketExchangeRateParams) => {
  return [`/frontoffice/api/exchange-rate/market`, ...(params ? [params] : [])] as const;
};

export const getGetMarketExchangeRateQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketExchangeRate>>,
  TError = ErrorType<void>
>(
  params?: GetMarketExchangeRateParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getMarketExchangeRate>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketExchangeRateQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketExchangeRate>>> = ({ signal }) =>
    getMarketExchangeRate(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMarketExchangeRate>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMarketExchangeRateQueryResult = NonNullable<Awaited<ReturnType<typeof getMarketExchangeRate>>>;
export type GetMarketExchangeRateQueryError = ErrorType<void>;

/**
 * @summary Gets the exchange rate for a specific market along with price deviation validation information
 */

export function useGetMarketExchangeRate<
  TData = Awaited<ReturnType<typeof getMarketExchangeRate>>,
  TError = ErrorType<void>
>(
  params?: GetMarketExchangeRateParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getMarketExchangeRate>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetMarketExchangeRateQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Gets the exchange rate for a specific market by market ID along with price deviation validation information
 */
export const getMarketExchangeRateById = (
  marketId: number,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<MarketExchangeRateResponse>(
    { url: `/frontoffice/api/exchange-rate/market/${marketId}`, method: 'GET', signal },
    options
  );
};

export const getGetMarketExchangeRateByIdQueryKey = (marketId: number) => {
  return [`/frontoffice/api/exchange-rate/market/${marketId}`] as const;
};

export const getGetMarketExchangeRateByIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketExchangeRateById>>,
  TError = ErrorType<void>
>(
  marketId: number,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getMarketExchangeRateById>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketExchangeRateByIdQueryKey(marketId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketExchangeRateById>>> = ({ signal }) =>
    getMarketExchangeRateById(marketId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!marketId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMarketExchangeRateById>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMarketExchangeRateByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getMarketExchangeRateById>>>;
export type GetMarketExchangeRateByIdQueryError = ErrorType<void>;

/**
 * @summary Gets the exchange rate for a specific market by market ID along with price deviation validation information
 */

export function useGetMarketExchangeRateById<
  TData = Awaited<ReturnType<typeof getMarketExchangeRateById>>,
  TError = ErrorType<void>
>(
  marketId: number,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getMarketExchangeRateById>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetMarketExchangeRateByIdQueryOptions(marketId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Gets a file, validate request and uploads to google cloud storage. In the 
content-disposition section, filename is mandatory and must be supplied. 
This API could not test directly in swagger. 
Use some tools like Postman or Insomnia instead.
 */
export const uploadFileToCloudStorageFileTransfer = (
  params: UploadFileToCloudStorageFileTransferParams,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<AddDocumentResponse>(
    { url: `/frontoffice/api/v1/file-transfer/upload`, method: 'POST', params },
    options
  );
};

export const getUploadFileToCloudStorageFileTransferMutationOptions = <
  TError = ErrorType<ApiErrorResponse | void | ProblemDetails>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof uploadFileToCloudStorageFileTransfer>>,
    TError,
    { params: UploadFileToCloudStorageFileTransferParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof uploadFileToCloudStorageFileTransfer>>,
  TError,
  { params: UploadFileToCloudStorageFileTransferParams },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof uploadFileToCloudStorageFileTransfer>>,
    { params: UploadFileToCloudStorageFileTransferParams }
  > = props => {
    const { params } = props ?? {};

    return uploadFileToCloudStorageFileTransfer(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UploadFileToCloudStorageFileTransferMutationResult = NonNullable<
  Awaited<ReturnType<typeof uploadFileToCloudStorageFileTransfer>>
>;

export type UploadFileToCloudStorageFileTransferMutationError = ErrorType<ApiErrorResponse | void | ProblemDetails>;

/**
 * @summary Gets a file, validate request and uploads to google cloud storage. In the 
content-disposition section, filename is mandatory and must be supplied. 
This API could not test directly in swagger. 
Use some tools like Postman or Insomnia instead.
 */
export const useUploadFileToCloudStorageFileTransfer = <
  TError = ErrorType<ApiErrorResponse | void | ProblemDetails>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof uploadFileToCloudStorageFileTransfer>>,
    TError,
    { params: UploadFileToCloudStorageFileTransferParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof uploadFileToCloudStorageFileTransfer>>,
  TError,
  { params: UploadFileToCloudStorageFileTransferParams },
  TContext
> => {
  const mutationOptions = getUploadFileToCloudStorageFileTransferMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Download a document by given ID. Only Admin and ComplianceReviewer are allowed to access this endpoint.
 */
export const downloadFileFromCloudStorageFileTransfer = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<void>(
    { url: `/frontoffice/api/v1/file-transfer/download/${id}`, method: 'GET', signal },
    options
  );
};

export const getDownloadFileFromCloudStorageFileTransferQueryKey = (id: string) => {
  return [`/frontoffice/api/v1/file-transfer/download/${id}`] as const;
};

export const getDownloadFileFromCloudStorageFileTransferQueryOptions = <
  TData = Awaited<ReturnType<typeof downloadFileFromCloudStorageFileTransfer>>,
  TError = ErrorType<void>
>(
  id: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof downloadFileFromCloudStorageFileTransfer>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDownloadFileFromCloudStorageFileTransferQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadFileFromCloudStorageFileTransfer>>> = ({ signal }) =>
    downloadFileFromCloudStorageFileTransfer(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof downloadFileFromCloudStorageFileTransfer>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type DownloadFileFromCloudStorageFileTransferQueryResult = NonNullable<
  Awaited<ReturnType<typeof downloadFileFromCloudStorageFileTransfer>>
>;
export type DownloadFileFromCloudStorageFileTransferQueryError = ErrorType<void>;

/**
 * @summary Download a document by given ID. Only Admin and ComplianceReviewer are allowed to access this endpoint.
 */

export function useDownloadFileFromCloudStorageFileTransfer<
  TData = Awaited<ReturnType<typeof downloadFileFromCloudStorageFileTransfer>>,
  TError = ErrorType<void>
>(
  id: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof downloadFileFromCloudStorageFileTransfer>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getDownloadFileFromCloudStorageFileTransferQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getInfo = (options?: SecondParameter<typeof customInstance>, signal?: AbortSignal) => {
  return customInstance<InfoResponse>({ url: `/frontoffice/api/info`, method: 'GET', signal }, options);
};

export const getGetInfoQueryKey = () => {
  return [`/frontoffice/api/info`] as const;
};

export const getGetInfoQueryOptions = <
  TData = Awaited<ReturnType<typeof getInfo>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getInfo>>, TError, TData>;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetInfoQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getInfo>>> = ({ signal }) => getInfo(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getInfo>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetInfoQueryResult = NonNullable<Awaited<ReturnType<typeof getInfo>>>;
export type GetInfoQueryError = ErrorType<unknown>;

export function useGetInfo<TData = Awaited<ReturnType<typeof getInfo>>, TError = ErrorType<unknown>>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getInfo>>, TError, TData>;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetInfoQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Returns system build date, branch and commit hash.
 */
export const getBuildInfo = (options?: SecondParameter<typeof customInstance>, signal?: AbortSignal) => {
  return customInstance<BuildInfoResponse>({ url: `/frontoffice/api/build-info`, method: 'GET', signal }, options);
};

export const getGetBuildInfoQueryKey = () => {
  return [`/frontoffice/api/build-info`] as const;
};

export const getGetBuildInfoQueryOptions = <
  TData = Awaited<ReturnType<typeof getBuildInfo>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getBuildInfo>>, TError, TData>;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetBuildInfoQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getBuildInfo>>> = ({ signal }) =>
    getBuildInfo(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getBuildInfo>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetBuildInfoQueryResult = NonNullable<Awaited<ReturnType<typeof getBuildInfo>>>;
export type GetBuildInfoQueryError = ErrorType<unknown>;

/**
 * @summary Returns system build date, branch and commit hash.
 */

export function useGetBuildInfo<
  TData = Awaited<ReturnType<typeof getBuildInfo>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getBuildInfo>>, TError, TData>;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetBuildInfoQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary This method is called by corepass connector when data is ready or it's failed
 */
export const kycCallback = (options?: SecondParameter<typeof customInstance>) => {
  return customInstance<void>({ url: `/frontoffice/api/v2/kyc/callback`, method: 'POST' }, options);
};

export const getKycCallbackMutationOptions = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof kycCallback>>, TError, void, TContext>;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<Awaited<ReturnType<typeof kycCallback>>, TError, void, TContext> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof kycCallback>>, void> = () => {
    return kycCallback(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type KycCallbackMutationResult = NonNullable<Awaited<ReturnType<typeof kycCallback>>>;

export type KycCallbackMutationError = ErrorType<unknown>;

/**
 * @summary This method is called by corepass connector when data is ready or it's failed
 */
export const useKycCallback = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof kycCallback>>, TError, void, TContext>;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<Awaited<ReturnType<typeof kycCallback>>, TError, void, TContext> => {
  const mutationOptions = getKycCallbackMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary This method is called by corepass connector when request status gets updated
 */
export const kycStatusCallback = (options?: SecondParameter<typeof customInstance>) => {
  return customInstance<void>({ url: `/frontoffice/api/v2/kyc/statusCallback`, method: 'POST' }, options);
};

export const getKycStatusCallbackMutationOptions = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof kycStatusCallback>>, TError, void, TContext>;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<Awaited<ReturnType<typeof kycStatusCallback>>, TError, void, TContext> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof kycStatusCallback>>, void> = () => {
    return kycStatusCallback(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type KycStatusCallbackMutationResult = NonNullable<Awaited<ReturnType<typeof kycStatusCallback>>>;

export type KycStatusCallbackMutationError = ErrorType<unknown>;

/**
 * @summary This method is called by corepass connector when request status gets updated
 */
export const useKycStatusCallback = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof kycStatusCallback>>, TError, void, TContext>;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<Awaited<ReturnType<typeof kycStatusCallback>>, TError, void, TContext> => {
  const mutationOptions = getKycStatusCallbackMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary This method uses corepassId in the claim and creates a request for kyc data after
    Checking that the data is verified. The request is returned in qrcode and link
    Which can be returned to user to sign.
 */
export const kycRequest = (options?: SecondParameter<typeof customInstance>) => {
  return customInstance<QrCodeData>({ url: `/frontoffice/api/v2/kyc/request`, method: 'POST' }, options);
};

export const getKycRequestMutationOptions = <
  TError = ErrorType<ApiErrorResponse | void>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof kycRequest>>, TError, void, TContext>;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<Awaited<ReturnType<typeof kycRequest>>, TError, void, TContext> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof kycRequest>>, void> = () => {
    return kycRequest(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type KycRequestMutationResult = NonNullable<Awaited<ReturnType<typeof kycRequest>>>;

export type KycRequestMutationError = ErrorType<ApiErrorResponse | void>;

/**
 * @summary This method uses corepassId in the claim and creates a request for kyc data after
    Checking that the data is verified. The request is returned in qrcode and link
    Which can be returned to user to sign.
 */
export const useKycRequest = <TError = ErrorType<ApiErrorResponse | void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof kycRequest>>, TError, void, TContext>;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<Awaited<ReturnType<typeof kycRequest>>, TError, void, TContext> => {
  const mutationOptions = getKycRequestMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Invalidates vault data
 */
export const invalidateKyc = (params: InvalidateKycParams, options?: SecondParameter<typeof customInstance>) => {
  return customInstance<void>({ url: `/frontoffice/api/v2/kyc/invalidate`, method: 'POST', params }, options);
};

export const getInvalidateKycMutationOptions = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof invalidateKyc>>,
    TError,
    { params: InvalidateKycParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof invalidateKyc>>,
  TError,
  { params: InvalidateKycParams },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof invalidateKyc>>,
    { params: InvalidateKycParams }
  > = props => {
    const { params } = props ?? {};

    return invalidateKyc(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type InvalidateKycMutationResult = NonNullable<Awaited<ReturnType<typeof invalidateKyc>>>;

export type InvalidateKycMutationError = ErrorType<void>;

/**
 * @summary Invalidates vault data
 */
export const useInvalidateKyc = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof invalidateKyc>>,
    TError,
    { params: InvalidateKycParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<Awaited<ReturnType<typeof invalidateKyc>>, TError, { params: InvalidateKycParams }, TContext> => {
  const mutationOptions = getInvalidateKycMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Sets user status to WaitingForManualReview to simulate the compliance officer acquiring more data.
This API is for development/testing purposes only.
 */
export const changeUserStatusToWaitingForDataKyc = (
  params: ChangeUserStatusToWaitingForDataKycParams,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<void>(
    { url: `/frontoffice/api/v2/kyc/change-to-waiting-for-data`, method: 'POST', params },
    options
  );
};

export const getChangeUserStatusToWaitingForDataKycMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof changeUserStatusToWaitingForDataKyc>>,
    TError,
    { params: ChangeUserStatusToWaitingForDataKycParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof changeUserStatusToWaitingForDataKyc>>,
  TError,
  { params: ChangeUserStatusToWaitingForDataKycParams },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof changeUserStatusToWaitingForDataKyc>>,
    { params: ChangeUserStatusToWaitingForDataKycParams }
  > = props => {
    const { params } = props ?? {};

    return changeUserStatusToWaitingForDataKyc(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ChangeUserStatusToWaitingForDataKycMutationResult = NonNullable<
  Awaited<ReturnType<typeof changeUserStatusToWaitingForDataKyc>>
>;

export type ChangeUserStatusToWaitingForDataKycMutationError = ErrorType<void>;

/**
 * @summary Sets user status to WaitingForManualReview to simulate the compliance officer acquiring more data.
This API is for development/testing purposes only.
 */
export const useChangeUserStatusToWaitingForDataKyc = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof changeUserStatusToWaitingForDataKyc>>,
    TError,
    { params: ChangeUserStatusToWaitingForDataKycParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof changeUserStatusToWaitingForDataKyc>>,
  TError,
  { params: ChangeUserStatusToWaitingForDataKycParams },
  TContext
> => {
  const mutationOptions = getChangeUserStatusToWaitingForDataKycMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Checks if given email has done KYC or not.
 */
export const checkKycByEmail = (
  email: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<void>({ url: `/frontoffice/api/v2/kyc/valid-emails/${email}`, method: 'GET', signal }, options);
};

export const getCheckKycByEmailQueryKey = (email: string) => {
  return [`/frontoffice/api/v2/kyc/valid-emails/${email}`] as const;
};

export const getCheckKycByEmailQueryOptions = <
  TData = Awaited<ReturnType<typeof checkKycByEmail>>,
  TError = ErrorType<ProblemDetails>
>(
  email: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof checkKycByEmail>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCheckKycByEmailQueryKey(email);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof checkKycByEmail>>> = ({ signal }) =>
    checkKycByEmail(email, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!email, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof checkKycByEmail>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type CheckKycByEmailQueryResult = NonNullable<Awaited<ReturnType<typeof checkKycByEmail>>>;
export type CheckKycByEmailQueryError = ErrorType<ProblemDetails>;

/**
 * @summary Checks if given email has done KYC or not.
 */

export function useCheckKycByEmail<
  TData = Awaited<ReturnType<typeof checkKycByEmail>>,
  TError = ErrorType<ProblemDetails>
>(
  email: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof checkKycByEmail>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getCheckKycByEmailQueryOptions(email, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Starts payment withdrawal with CorePass signing and returns the encoded CorePass URL.
 */
export const payPayment = (payPaymentRequest: PayPaymentRequest, options?: SecondParameter<typeof customInstance>) => {
  return customInstance<string>(
    {
      url: `/frontoffice/api/payment/payments/pay`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: payPaymentRequest,
    },
    options
  );
};

export const getPayPaymentMutationOptions = <
  TError = ErrorType<ApiErrorResponse | void>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof payPayment>>, TError, { data: PayPaymentRequest }, TContext>;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<Awaited<ReturnType<typeof payPayment>>, TError, { data: PayPaymentRequest }, TContext> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof payPayment>>, { data: PayPaymentRequest }> = props => {
    const { data } = props ?? {};

    return payPayment(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PayPaymentMutationResult = NonNullable<Awaited<ReturnType<typeof payPayment>>>;
export type PayPaymentMutationBody = PayPaymentRequest;
export type PayPaymentMutationError = ErrorType<ApiErrorResponse | void>;

/**
 * @summary Starts payment withdrawal with CorePass signing and returns the encoded CorePass URL.
 */
export const usePayPayment = <TError = ErrorType<ApiErrorResponse | void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof payPayment>>, TError, { data: PayPaymentRequest }, TContext>;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<Awaited<ReturnType<typeof payPayment>>, TError, { data: PayPaymentRequest }, TContext> => {
  const mutationOptions = getPayPaymentMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Lists payments for the authenticated user. Optional `startDate` / `endDate` on `created_at`; optional `isRecurring` (`true` / `false`) on `is_recurring`.
 */
export const listPayments = (
  params?: ListPaymentsParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<PaymentListResponse>(
    { url: `/frontoffice/api/payment/payments`, method: 'GET', params, signal },
    options
  );
};

export const getListPaymentsQueryKey = (params?: ListPaymentsParams) => {
  return [`/frontoffice/api/payment/payments`, ...(params ? [params] : [])] as const;
};

export const getListPaymentsQueryOptions = <TData = Awaited<ReturnType<typeof listPayments>>, TError = ErrorType<void>>(
  params?: ListPaymentsParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof listPayments>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListPaymentsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listPayments>>> = ({ signal }) =>
    listPayments(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listPayments>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListPaymentsQueryResult = NonNullable<Awaited<ReturnType<typeof listPayments>>>;
export type ListPaymentsQueryError = ErrorType<void>;

/**
 * @summary Lists payments for the authenticated user. Optional `startDate` / `endDate` on `created_at`; optional `isRecurring` (`true` / `false`) on `is_recurring`.
 */

export function useListPayments<TData = Awaited<ReturnType<typeof listPayments>>, TError = ErrorType<void>>(
  params?: ListPaymentsParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof listPayments>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListPaymentsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const enableRecurringPayment = (paymentId: string, options?: SecondParameter<typeof customInstance>) => {
  return customInstance<void>(
    { url: `/frontoffice/api/payment/payments/${paymentId}/recurring/enable`, method: 'POST' },
    options
  );
};

export const getEnableRecurringPaymentMutationOptions = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof enableRecurringPayment>>,
    TError,
    { paymentId: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<Awaited<ReturnType<typeof enableRecurringPayment>>, TError, { paymentId: string }, TContext> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof enableRecurringPayment>>,
    { paymentId: string }
  > = props => {
    const { paymentId } = props ?? {};

    return enableRecurringPayment(paymentId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type EnableRecurringPaymentMutationResult = NonNullable<Awaited<ReturnType<typeof enableRecurringPayment>>>;

export type EnableRecurringPaymentMutationError = ErrorType<void>;

export const useEnableRecurringPayment = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof enableRecurringPayment>>,
    TError,
    { paymentId: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<Awaited<ReturnType<typeof enableRecurringPayment>>, TError, { paymentId: string }, TContext> => {
  const mutationOptions = getEnableRecurringPaymentMutationOptions(options);

  return useMutation(mutationOptions);
};

export const disableRecurringPayment = (paymentId: string, options?: SecondParameter<typeof customInstance>) => {
  return customInstance<void>(
    { url: `/frontoffice/api/payment/payments/${paymentId}/recurring/disable`, method: 'POST' },
    options
  );
};

export const getDisableRecurringPaymentMutationOptions = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof disableRecurringPayment>>,
    TError,
    { paymentId: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof disableRecurringPayment>>,
  TError,
  { paymentId: string },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof disableRecurringPayment>>,
    { paymentId: string }
  > = props => {
    const { paymentId } = props ?? {};

    return disableRecurringPayment(paymentId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DisableRecurringPaymentMutationResult = NonNullable<Awaited<ReturnType<typeof disableRecurringPayment>>>;

export type DisableRecurringPaymentMutationError = ErrorType<void>;

export const useDisableRecurringPayment = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof disableRecurringPayment>>,
    TError,
    { paymentId: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<Awaited<ReturnType<typeof disableRecurringPayment>>, TError, { paymentId: string }, TContext> => {
  const mutationOptions = getDisableRecurringPaymentMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Cancels a recurring payment (sets `recurring_enabled` to false).
 */
export const cancelRecurringPayment = (paymentId: string, options?: SecondParameter<typeof customInstance>) => {
  return customInstance<void>(
    { url: `/frontoffice/api/payment/payments/${paymentId}/recurring/cancel`, method: 'POST' },
    options
  );
};

export const getCancelRecurringPaymentMutationOptions = <
  TError = ErrorType<ApiErrorResponse | void>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cancelRecurringPayment>>,
    TError,
    { paymentId: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<Awaited<ReturnType<typeof cancelRecurringPayment>>, TError, { paymentId: string }, TContext> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof cancelRecurringPayment>>,
    { paymentId: string }
  > = props => {
    const { paymentId } = props ?? {};

    return cancelRecurringPayment(paymentId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CancelRecurringPaymentMutationResult = NonNullable<Awaited<ReturnType<typeof cancelRecurringPayment>>>;

export type CancelRecurringPaymentMutationError = ErrorType<ApiErrorResponse | void>;

/**
 * @summary Cancels a recurring payment (sets `recurring_enabled` to false).
 */
export const useCancelRecurringPayment = <TError = ErrorType<ApiErrorResponse | void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cancelRecurringPayment>>,
    TError,
    { paymentId: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<Awaited<ReturnType<typeof cancelRecurringPayment>>, TError, { paymentId: string }, TContext> => {
  const mutationOptions = getCancelRecurringPaymentMutationOptions(options);

  return useMutation(mutationOptions);
};

export const listExecutionsPayment = (
  paymentId: string,
  params?: ListExecutionsPaymentParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<PaymentExecutionListResponse>(
    { url: `/frontoffice/api/payment/payments/${paymentId}/executions`, method: 'GET', params, signal },
    options
  );
};

export const getListExecutionsPaymentQueryKey = (paymentId: string, params?: ListExecutionsPaymentParams) => {
  return [`/frontoffice/api/payment/payments/${paymentId}/executions`, ...(params ? [params] : [])] as const;
};

export const getListExecutionsPaymentQueryOptions = <
  TData = Awaited<ReturnType<typeof listExecutionsPayment>>,
  TError = ErrorType<void>
>(
  paymentId: string,
  params?: ListExecutionsPaymentParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof listExecutionsPayment>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListExecutionsPaymentQueryKey(paymentId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listExecutionsPayment>>> = ({ signal }) =>
    listExecutionsPayment(paymentId, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!paymentId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listExecutionsPayment>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListExecutionsPaymentQueryResult = NonNullable<Awaited<ReturnType<typeof listExecutionsPayment>>>;
export type ListExecutionsPaymentQueryError = ErrorType<void>;

export function useListExecutionsPayment<
  TData = Awaited<ReturnType<typeof listExecutionsPayment>>,
  TError = ErrorType<void>
>(
  paymentId: string,
  params?: ListExecutionsPaymentParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof listExecutionsPayment>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListExecutionsPaymentQueryOptions(paymentId, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Returns a payment quote for the given crypto currency and amount (optionally denominated in fiat).
 */
export const getQuotePaymentQuote = (
  params?: GetQuotePaymentQuoteParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<PaymentQuoteResponse>(
    { url: `/frontoffice/api/payment/payment-quote`, method: 'GET', params, signal },
    options
  );
};

export const getGetQuotePaymentQuoteQueryKey = (params?: GetQuotePaymentQuoteParams) => {
  return [`/frontoffice/api/payment/payment-quote`, ...(params ? [params] : [])] as const;
};

export const getGetQuotePaymentQuoteQueryOptions = <
  TData = Awaited<ReturnType<typeof getQuotePaymentQuote>>,
  TError = ErrorType<ApiErrorResponse | void>
>(
  params?: GetQuotePaymentQuoteParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getQuotePaymentQuote>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetQuotePaymentQuoteQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getQuotePaymentQuote>>> = ({ signal }) =>
    getQuotePaymentQuote(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getQuotePaymentQuote>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetQuotePaymentQuoteQueryResult = NonNullable<Awaited<ReturnType<typeof getQuotePaymentQuote>>>;
export type GetQuotePaymentQuoteQueryError = ErrorType<ApiErrorResponse | void>;

/**
 * @summary Returns a payment quote for the given crypto currency and amount (optionally denominated in fiat).
 */

export function useGetQuotePaymentQuote<
  TData = Awaited<ReturnType<typeof getQuotePaymentQuote>>,
  TError = ErrorType<ApiErrorResponse | void>
>(
  params?: GetQuotePaymentQuoteParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getQuotePaymentQuote>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetQuotePaymentQuoteQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Creates a payment request from query-string parameters.
 */
export const createPaymentRequest = (
  params?: CreatePaymentRequestParams,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<CreatePaymentRequestResponse>(
    { url: `/frontoffice/api/payment/payment-request`, method: 'POST', params },
    options
  );
};

export const getCreatePaymentRequestMutationOptions = <
  TError = ErrorType<ApiErrorResponse | void>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createPaymentRequest>>,
    TError,
    { params?: CreatePaymentRequestParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createPaymentRequest>>,
  TError,
  { params?: CreatePaymentRequestParams },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createPaymentRequest>>,
    { params?: CreatePaymentRequestParams }
  > = props => {
    const { params } = props ?? {};

    return createPaymentRequest(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreatePaymentRequestMutationResult = NonNullable<Awaited<ReturnType<typeof createPaymentRequest>>>;

export type CreatePaymentRequestMutationError = ErrorType<ApiErrorResponse | void>;

/**
 * @summary Creates a payment request from query-string parameters.
 */
export const useCreatePaymentRequest = <TError = ErrorType<ApiErrorResponse | void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createPaymentRequest>>,
    TError,
    { params?: CreatePaymentRequestParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createPaymentRequest>>,
  TError,
  { params?: CreatePaymentRequestParams },
  TContext
> => {
  const mutationOptions = getCreatePaymentRequestMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary The controller returns users' current asset values with the estimated price based on the current currency.
Sorted by the estimated value in descending order.
param: CurrencyId - the id of the currency which the amount has been converted to.
 */
export const getPortfolio = (options?: SecondParameter<typeof customInstance>, signal?: AbortSignal) => {
  return customInstance<PortfolioResponse>({ url: `/frontoffice/api/v2/portfolio`, method: 'GET', signal }, options);
};

export const getGetPortfolioQueryKey = () => {
  return [`/frontoffice/api/v2/portfolio`] as const;
};

export const getGetPortfolioQueryOptions = <
  TData = Awaited<ReturnType<typeof getPortfolio>>,
  TError = ErrorType<void>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getPortfolio>>, TError, TData>;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPortfolioQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPortfolio>>> = ({ signal }) =>
    getPortfolio(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPortfolio>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPortfolioQueryResult = NonNullable<Awaited<ReturnType<typeof getPortfolio>>>;
export type GetPortfolioQueryError = ErrorType<void>;

/**
 * @summary The controller returns users' current asset values with the estimated price based on the current currency.
Sorted by the estimated value in descending order.
param: CurrencyId - the id of the currency which the amount has been converted to.
 */

export function useGetPortfolio<TData = Awaited<ReturnType<typeof getPortfolio>>, TError = ErrorType<void>>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getPortfolio>>, TError, TData>;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetPortfolioQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary This is for testing purposes and should not be used by any part of UI. 
This endpoint replaces the corepassId with some random Id
This will not be available in the production
 */
export const resetCorepassIdProfile = (
  params?: ResetCorepassIdProfileParams,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<void>({ url: `/frontoffice/api/profile/reset`, method: 'POST', params }, options);
};

export const getResetCorepassIdProfileMutationOptions = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resetCorepassIdProfile>>,
    TError,
    { params?: ResetCorepassIdProfileParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof resetCorepassIdProfile>>,
  TError,
  { params?: ResetCorepassIdProfileParams },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof resetCorepassIdProfile>>,
    { params?: ResetCorepassIdProfileParams }
  > = props => {
    const { params } = props ?? {};

    return resetCorepassIdProfile(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ResetCorepassIdProfileMutationResult = NonNullable<Awaited<ReturnType<typeof resetCorepassIdProfile>>>;

export type ResetCorepassIdProfileMutationError = ErrorType<void>;

/**
 * @summary This is for testing purposes and should not be used by any part of UI. 
This endpoint replaces the corepassId with some random Id
This will not be available in the production
 */
export const useResetCorepassIdProfile = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resetCorepassIdProfile>>,
    TError,
    { params?: ResetCorepassIdProfileParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof resetCorepassIdProfile>>,
  TError,
  { params?: ResetCorepassIdProfileParams },
  TContext
> => {
  const mutationOptions = getResetCorepassIdProfileMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary This is for testing purposes only and should not be used by any part of the UI. 
This endpoint sends a message to specific user identified by the corepassId
 */
export const notificationProfile = (
  params?: NotificationProfileParams,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<void>({ url: `/frontoffice/api/profile/notification`, method: 'POST', params }, options);
};

export const getNotificationProfileMutationOptions = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof notificationProfile>>,
    TError,
    { params?: NotificationProfileParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof notificationProfile>>,
  TError,
  { params?: NotificationProfileParams },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof notificationProfile>>,
    { params?: NotificationProfileParams }
  > = props => {
    const { params } = props ?? {};

    return notificationProfile(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type NotificationProfileMutationResult = NonNullable<Awaited<ReturnType<typeof notificationProfile>>>;

export type NotificationProfileMutationError = ErrorType<void>;

/**
 * @summary This is for testing purposes only and should not be used by any part of the UI. 
This endpoint sends a message to specific user identified by the corepassId
 */
export const useNotificationProfile = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof notificationProfile>>,
    TError,
    { params?: NotificationProfileParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof notificationProfile>>,
  TError,
  { params?: NotificationProfileParams },
  TContext
> => {
  const mutationOptions = getNotificationProfileMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Gets the user profile based on the corepassId or creates a new user if doesn't exist and returns it
 */
export const getOrCreateProfile = (
  params?: GetOrCreateProfileParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ProfileResponse>({ url: `/frontoffice/api/profile`, method: 'GET', params, signal }, options);
};

export const getGetOrCreateProfileQueryKey = (params?: GetOrCreateProfileParams) => {
  return [`/frontoffice/api/profile`, ...(params ? [params] : [])] as const;
};

export const getGetOrCreateProfileQueryOptions = <
  TData = Awaited<ReturnType<typeof getOrCreateProfile>>,
  TError = ErrorType<void>
>(
  params?: GetOrCreateProfileParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getOrCreateProfile>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOrCreateProfileQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrCreateProfile>>> = ({ signal }) =>
    getOrCreateProfile(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getOrCreateProfile>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetOrCreateProfileQueryResult = NonNullable<Awaited<ReturnType<typeof getOrCreateProfile>>>;
export type GetOrCreateProfileQueryError = ErrorType<void>;

/**
 * @summary Gets the user profile based on the corepassId or creates a new user if doesn't exist and returns it
 */

export function useGetOrCreateProfile<TData = Awaited<ReturnType<typeof getOrCreateProfile>>, TError = ErrorType<void>>(
  params?: GetOrCreateProfileParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getOrCreateProfile>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetOrCreateProfileQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getOrCreateProfileV2 = (
  params?: GetOrCreateProfileV2Params,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ProfileResponse>(
    { url: `/frontoffice/api/profile/v2`, method: 'GET', params, signal },
    options
  );
};

export const getGetOrCreateProfileV2QueryKey = (params?: GetOrCreateProfileV2Params) => {
  return [`/frontoffice/api/profile/v2`, ...(params ? [params] : [])] as const;
};

export const getGetOrCreateProfileV2QueryOptions = <
  TData = Awaited<ReturnType<typeof getOrCreateProfileV2>>,
  TError = ErrorType<void>
>(
  params?: GetOrCreateProfileV2Params,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getOrCreateProfileV2>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOrCreateProfileV2QueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrCreateProfileV2>>> = ({ signal }) =>
    getOrCreateProfileV2(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getOrCreateProfileV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetOrCreateProfileV2QueryResult = NonNullable<Awaited<ReturnType<typeof getOrCreateProfileV2>>>;
export type GetOrCreateProfileV2QueryError = ErrorType<void>;

export function useGetOrCreateProfileV2<
  TData = Awaited<ReturnType<typeof getOrCreateProfileV2>>,
  TError = ErrorType<void>
>(
  params?: GetOrCreateProfileV2Params,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getOrCreateProfileV2>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetOrCreateProfileV2QueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const profileCreateApiKey = (
  createUserApiKeyRequest: CreateUserApiKeyRequest,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<CreateUserApiKeyResponse>(
    {
      url: `/frontoffice/api/profile/api-key/create`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: createUserApiKeyRequest,
    },
    options
  );
};

export const getProfileCreateApiKeyMutationOptions = <
  TError = ErrorType<ApiErrorResponse>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof profileCreateApiKey>>,
    TError,
    { data: CreateUserApiKeyRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof profileCreateApiKey>>,
  TError,
  { data: CreateUserApiKeyRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof profileCreateApiKey>>,
    { data: CreateUserApiKeyRequest }
  > = props => {
    const { data } = props ?? {};

    return profileCreateApiKey(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ProfileCreateApiKeyMutationResult = NonNullable<Awaited<ReturnType<typeof profileCreateApiKey>>>;
export type ProfileCreateApiKeyMutationBody = CreateUserApiKeyRequest;
export type ProfileCreateApiKeyMutationError = ErrorType<ApiErrorResponse>;

export const useProfileCreateApiKey = <TError = ErrorType<ApiErrorResponse>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof profileCreateApiKey>>,
    TError,
    { data: CreateUserApiKeyRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof profileCreateApiKey>>,
  TError,
  { data: CreateUserApiKeyRequest },
  TContext
> => {
  const mutationOptions = getProfileCreateApiKeyMutationOptions(options);

  return useMutation(mutationOptions);
};

export const profileRevokeApiKey = (
  revokeUserApiKeyRequest: RevokeUserApiKeyRequest,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<void>(
    {
      url: `/frontoffice/api/profile/api-key/revoke`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: revokeUserApiKeyRequest,
    },
    options
  );
};

export const getProfileRevokeApiKeyMutationOptions = <
  TError = ErrorType<ApiErrorResponse>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof profileRevokeApiKey>>,
    TError,
    { data: RevokeUserApiKeyRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof profileRevokeApiKey>>,
  TError,
  { data: RevokeUserApiKeyRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof profileRevokeApiKey>>,
    { data: RevokeUserApiKeyRequest }
  > = props => {
    const { data } = props ?? {};

    return profileRevokeApiKey(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ProfileRevokeApiKeyMutationResult = NonNullable<Awaited<ReturnType<typeof profileRevokeApiKey>>>;
export type ProfileRevokeApiKeyMutationBody = RevokeUserApiKeyRequest;
export type ProfileRevokeApiKeyMutationError = ErrorType<ApiErrorResponse>;

export const useProfileRevokeApiKey = <TError = ErrorType<ApiErrorResponse>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof profileRevokeApiKey>>,
    TError,
    { data: RevokeUserApiKeyRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof profileRevokeApiKey>>,
  TError,
  { data: RevokeUserApiKeyRequest },
  TContext
> => {
  const mutationOptions = getProfileRevokeApiKeyMutationOptions(options);

  return useMutation(mutationOptions);
};

export const profileListApiKeys = (options?: SecondParameter<typeof customInstance>, signal?: AbortSignal) => {
  return customInstance<UserApiKeyViewModel[]>(
    { url: `/frontoffice/api/profile/api-key/my`, method: 'GET', signal },
    options
  );
};

export const getProfileListApiKeysQueryKey = () => {
  return [`/frontoffice/api/profile/api-key/my`] as const;
};

export const getProfileListApiKeysQueryOptions = <
  TData = Awaited<ReturnType<typeof profileListApiKeys>>,
  TError = ErrorType<ApiErrorResponse>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof profileListApiKeys>>, TError, TData>;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getProfileListApiKeysQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof profileListApiKeys>>> = ({ signal }) =>
    profileListApiKeys(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof profileListApiKeys>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ProfileListApiKeysQueryResult = NonNullable<Awaited<ReturnType<typeof profileListApiKeys>>>;
export type ProfileListApiKeysQueryError = ErrorType<ApiErrorResponse>;

export function useProfileListApiKeys<
  TData = Awaited<ReturnType<typeof profileListApiKeys>>,
  TError = ErrorType<ApiErrorResponse>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof profileListApiKeys>>, TError, TData>;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getProfileListApiKeysQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Steps to call ramp APIs:
- Call `api/ramp/countries` to get countries from active providers
- Call `api/ramp/assets` to get assets from active providers
- Call `api/v1/ramp/payment-methods` to get available payment-methods (here if user selected source and target assets, we can pass them as parameters to `payment-methods` API)
- Call `api/ramp/quotes` to get quotes based on provided paramters(here we can call this API every N seconds and/or when user changed the inputs)
- Call `api/ramp/orders` to create a ramp order based on parameters, result will be a redirect url, that user should be redirected to.
 * @summary Get countries based on active providers
 */
export const getCountriesRamp = (
  params: GetCountriesRampParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<GetCountriesResponse>(
    { url: `/frontoffice/api/ramp/countries`, method: 'GET', params, signal },
    options
  );
};

export const getGetCountriesRampQueryKey = (params: GetCountriesRampParams) => {
  return [`/frontoffice/api/ramp/countries`, ...(params ? [params] : [])] as const;
};

export const getGetCountriesRampQueryOptions = <
  TData = Awaited<ReturnType<typeof getCountriesRamp>>,
  TError = ErrorType<void>
>(
  params: GetCountriesRampParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getCountriesRamp>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCountriesRampQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCountriesRamp>>> = ({ signal }) =>
    getCountriesRamp(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCountriesRamp>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCountriesRampQueryResult = NonNullable<Awaited<ReturnType<typeof getCountriesRamp>>>;
export type GetCountriesRampQueryError = ErrorType<void>;

/**
 * @summary Get countries based on active providers
 */

export function useGetCountriesRamp<TData = Awaited<ReturnType<typeof getCountriesRamp>>, TError = ErrorType<void>>(
  params: GetCountriesRampParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getCountriesRamp>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetCountriesRampQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getAssetsRamp = (
  params: GetAssetsRampParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<GetRampingAssetsResponse>(
    { url: `/frontoffice/api/ramp/assets`, method: 'GET', params, signal },
    options
  );
};

export const getGetAssetsRampQueryKey = (params: GetAssetsRampParams) => {
  return [`/frontoffice/api/ramp/assets`, ...(params ? [params] : [])] as const;
};

export const getGetAssetsRampQueryOptions = <
  TData = Awaited<ReturnType<typeof getAssetsRamp>>,
  TError = ErrorType<void>
>(
  params: GetAssetsRampParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getAssetsRamp>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAssetsRampQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAssetsRamp>>> = ({ signal }) =>
    getAssetsRamp(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAssetsRamp>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAssetsRampQueryResult = NonNullable<Awaited<ReturnType<typeof getAssetsRamp>>>;
export type GetAssetsRampQueryError = ErrorType<void>;

export function useGetAssetsRamp<TData = Awaited<ReturnType<typeof getAssetsRamp>>, TError = ErrorType<void>>(
  params: GetAssetsRampParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getAssetsRamp>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetAssetsRampQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getPaymentMethodsRamp = (
  params: GetPaymentMethodsRampParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<PaymentMethodData[]>(
    { url: `/frontoffice/api/ramp/payment-methods`, method: 'GET', params, signal },
    options
  );
};

export const getGetPaymentMethodsRampQueryKey = (params: GetPaymentMethodsRampParams) => {
  return [`/frontoffice/api/ramp/payment-methods`, ...(params ? [params] : [])] as const;
};

export const getGetPaymentMethodsRampQueryOptions = <
  TData = Awaited<ReturnType<typeof getPaymentMethodsRamp>>,
  TError = ErrorType<void>
>(
  params: GetPaymentMethodsRampParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getPaymentMethodsRamp>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPaymentMethodsRampQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPaymentMethodsRamp>>> = ({ signal }) =>
    getPaymentMethodsRamp(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPaymentMethodsRamp>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPaymentMethodsRampQueryResult = NonNullable<Awaited<ReturnType<typeof getPaymentMethodsRamp>>>;
export type GetPaymentMethodsRampQueryError = ErrorType<void>;

export function useGetPaymentMethodsRamp<
  TData = Awaited<ReturnType<typeof getPaymentMethodsRamp>>,
  TError = ErrorType<void>
>(
  params: GetPaymentMethodsRampParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getPaymentMethodsRamp>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetPaymentMethodsRampQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getQuotesRamp = (
  params: GetQuotesRampParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<QuoteData[]>({ url: `/frontoffice/api/ramp/quotes`, method: 'GET', params, signal }, options);
};

export const getGetQuotesRampQueryKey = (params: GetQuotesRampParams) => {
  return [`/frontoffice/api/ramp/quotes`, ...(params ? [params] : [])] as const;
};

export const getGetQuotesRampQueryOptions = <
  TData = Awaited<ReturnType<typeof getQuotesRamp>>,
  TError = ErrorType<void>
>(
  params: GetQuotesRampParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getQuotesRamp>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetQuotesRampQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getQuotesRamp>>> = ({ signal }) =>
    getQuotesRamp(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getQuotesRamp>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetQuotesRampQueryResult = NonNullable<Awaited<ReturnType<typeof getQuotesRamp>>>;
export type GetQuotesRampQueryError = ErrorType<void>;

export function useGetQuotesRamp<TData = Awaited<ReturnType<typeof getQuotesRamp>>, TError = ErrorType<void>>(
  params: GetQuotesRampParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getQuotesRamp>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetQuotesRampQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const createOrderRamp = (
  createRampingOrderRequest: CreateRampingOrderRequest,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<CreateOrderResponse>(
    {
      url: `/frontoffice/api/ramp/orders`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: createRampingOrderRequest,
    },
    options
  );
};

export const getCreateOrderRampMutationOptions = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createOrderRamp>>,
    TError,
    { data: CreateRampingOrderRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createOrderRamp>>,
  TError,
  { data: CreateRampingOrderRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createOrderRamp>>,
    { data: CreateRampingOrderRequest }
  > = props => {
    const { data } = props ?? {};

    return createOrderRamp(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateOrderRampMutationResult = NonNullable<Awaited<ReturnType<typeof createOrderRamp>>>;
export type CreateOrderRampMutationBody = CreateRampingOrderRequest;
export type CreateOrderRampMutationError = ErrorType<void>;

export const useCreateOrderRamp = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createOrderRamp>>,
    TError,
    { data: CreateRampingOrderRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createOrderRamp>>,
  TError,
  { data: CreateRampingOrderRequest },
  TContext
> => {
  const mutationOptions = getCreateOrderRampMutationOptions(options);

  return useMutation(mutationOptions);
};

export const callbackRamp = (options?: SecondParameter<typeof customInstance>, signal?: AbortSignal) => {
  return customInstance<RampingCallbackResponse>(
    { url: `/frontoffice/api/ramp/callback`, method: 'GET', signal },
    options
  );
};

export const getCallbackRampQueryKey = () => {
  return [`/frontoffice/api/ramp/callback`] as const;
};

export const getCallbackRampQueryOptions = <
  TData = Awaited<ReturnType<typeof callbackRamp>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof callbackRamp>>, TError, TData>;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCallbackRampQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof callbackRamp>>> = ({ signal }) =>
    callbackRamp(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof callbackRamp>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type CallbackRampQueryResult = NonNullable<Awaited<ReturnType<typeof callbackRamp>>>;
export type CallbackRampQueryError = ErrorType<unknown>;

export function useCallbackRamp<
  TData = Awaited<ReturnType<typeof callbackRamp>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof callbackRamp>>, TError, TData>;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getCallbackRampQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getReferral = (options?: SecondParameter<typeof customInstance>, signal?: AbortSignal) => {
  return customInstance<ReferralResponse>({ url: `/frontoffice/api/v2/referral`, method: 'GET', signal }, options);
};

export const getGetReferralQueryKey = () => {
  return [`/frontoffice/api/v2/referral`] as const;
};

export const getGetReferralQueryOptions = <
  TData = Awaited<ReturnType<typeof getReferral>>,
  TError = ErrorType<void>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getReferral>>, TError, TData>;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetReferralQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getReferral>>> = ({ signal }) =>
    getReferral(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getReferral>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetReferralQueryResult = NonNullable<Awaited<ReturnType<typeof getReferral>>>;
export type GetReferralQueryError = ErrorType<void>;

export function useGetReferral<TData = Awaited<ReturnType<typeof getReferral>>, TError = ErrorType<void>>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getReferral>>, TError, TData>;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetReferralQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getReferralStatus = (
  params?: GetReferralStatusParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ReferralStatusResponse>(
    { url: `/frontoffice/api/v2/referral/status`, method: 'GET', params, signal },
    options
  );
};

export const getGetReferralStatusQueryKey = (params?: GetReferralStatusParams) => {
  return [`/frontoffice/api/v2/referral/status`, ...(params ? [params] : [])] as const;
};

export const getGetReferralStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof getReferralStatus>>,
  TError = ErrorType<void>
>(
  params?: GetReferralStatusParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getReferralStatus>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetReferralStatusQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getReferralStatus>>> = ({ signal }) =>
    getReferralStatus(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getReferralStatus>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetReferralStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getReferralStatus>>>;
export type GetReferralStatusQueryError = ErrorType<void>;

export function useGetReferralStatus<TData = Awaited<ReturnType<typeof getReferralStatus>>, TError = ErrorType<void>>(
  params?: GetReferralStatusParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getReferralStatus>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetReferralStatusQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Used for claiming the rewards available to the user. The amount will be deposited to the user's portfolio.
 */
export const claimReward = (
  claimRewardRequest: ClaimRewardRequest,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<void>(
    {
      url: `/frontoffice/api/rewards/claim`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: claimRewardRequest,
    },
    options
  );
};

export const getClaimRewardMutationOptions = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof claimReward>>,
    TError,
    { data: ClaimRewardRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<Awaited<ReturnType<typeof claimReward>>, TError, { data: ClaimRewardRequest }, TContext> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof claimReward>>, { data: ClaimRewardRequest }> = props => {
    const { data } = props ?? {};

    return claimReward(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ClaimRewardMutationResult = NonNullable<Awaited<ReturnType<typeof claimReward>>>;
export type ClaimRewardMutationBody = ClaimRewardRequest;
export type ClaimRewardMutationError = ErrorType<void>;

/**
 * @summary Used for claiming the rewards available to the user. The amount will be deposited to the user's portfolio.
 */
export const useClaimReward = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof claimReward>>,
    TError,
    { data: ClaimRewardRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<Awaited<ReturnType<typeof claimReward>>, TError, { data: ClaimRewardRequest }, TContext> => {
  const mutationOptions = getClaimRewardMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Returns paginated rewards for the user (claimed and unclaimed).
 */
export const getRewards = (
  params?: GetRewardsParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<RewardListResponse>(
    { url: `/frontoffice/api/rewards`, method: 'GET', params, signal },
    options
  );
};

export const getGetRewardsQueryKey = (params?: GetRewardsParams) => {
  return [`/frontoffice/api/rewards`, ...(params ? [params] : [])] as const;
};

export const getGetRewardsQueryOptions = <TData = Awaited<ReturnType<typeof getRewards>>, TError = ErrorType<void>>(
  params?: GetRewardsParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getRewards>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetRewardsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getRewards>>> = ({ signal }) =>
    getRewards(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getRewards>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetRewardsQueryResult = NonNullable<Awaited<ReturnType<typeof getRewards>>>;
export type GetRewardsQueryError = ErrorType<void>;

/**
 * @summary Returns paginated rewards for the user (claimed and unclaimed).
 */

export function useGetRewards<TData = Awaited<ReturnType<typeof getRewards>>, TError = ErrorType<void>>(
  params?: GetRewardsParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getRewards>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetRewardsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const createTrade = (orderRequest: OrderRequest, options?: SecondParameter<typeof customInstance>) => {
  return customInstance<OrderResponse>(
    {
      url: `/frontoffice/api/order`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: orderRequest,
    },
    options
  );
};

export const getCreateTradeMutationOptions = <
  TError = ErrorType<ApiErrorResponse | void>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof createTrade>>, TError, { data: OrderRequest }, TContext>;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<Awaited<ReturnType<typeof createTrade>>, TError, { data: OrderRequest }, TContext> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof createTrade>>, { data: OrderRequest }> = props => {
    const { data } = props ?? {};

    return createTrade(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateTradeMutationResult = NonNullable<Awaited<ReturnType<typeof createTrade>>>;
export type CreateTradeMutationBody = OrderRequest;
export type CreateTradeMutationError = ErrorType<ApiErrorResponse | void>;

export const useCreateTrade = <TError = ErrorType<ApiErrorResponse | void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof createTrade>>, TError, { data: OrderRequest }, TContext>;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<Awaited<ReturnType<typeof createTrade>>, TError, { data: OrderRequest }, TContext> => {
  const mutationOptions = getCreateTradeMutationOptions(options);

  return useMutation(mutationOptions);
};

export const cancelTrade = (orderId: string, options?: SecondParameter<typeof customInstance>) => {
  return customInstance<OrderResponse>({ url: `/frontoffice/api/orders/${orderId}`, method: 'DELETE' }, options);
};

export const getCancelTradeMutationOptions = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof cancelTrade>>, TError, { orderId: string }, TContext>;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<Awaited<ReturnType<typeof cancelTrade>>, TError, { orderId: string }, TContext> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelTrade>>, { orderId: string }> = props => {
    const { orderId } = props ?? {};

    return cancelTrade(orderId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CancelTradeMutationResult = NonNullable<Awaited<ReturnType<typeof cancelTrade>>>;

export type CancelTradeMutationError = ErrorType<void>;

export const useCancelTrade = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof cancelTrade>>, TError, { orderId: string }, TContext>;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<Awaited<ReturnType<typeof cancelTrade>>, TError, { orderId: string }, TContext> => {
  const mutationOptions = getCancelTradeMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Gets an order related to current logged-in user.
 */
export const getOrderTrade = (
  orderId: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<OrderInfoResponse>(
    { url: `/frontoffice/api/orders/${orderId}`, method: 'GET', signal },
    options
  );
};

export const getGetOrderTradeQueryKey = (orderId: string) => {
  return [`/frontoffice/api/orders/${orderId}`] as const;
};

export const getGetOrderTradeQueryOptions = <
  TData = Awaited<ReturnType<typeof getOrderTrade>>,
  TError = ErrorType<void>
>(
  orderId: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getOrderTrade>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOrderTradeQueryKey(orderId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrderTrade>>> = ({ signal }) =>
    getOrderTrade(orderId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!orderId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getOrderTrade>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetOrderTradeQueryResult = NonNullable<Awaited<ReturnType<typeof getOrderTrade>>>;
export type GetOrderTradeQueryError = ErrorType<void>;

/**
 * @summary Gets an order related to current logged-in user.
 */

export function useGetOrderTrade<TData = Awaited<ReturnType<typeof getOrderTrade>>, TError = ErrorType<void>>(
  orderId: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getOrderTrade>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetOrderTradeQueryOptions(orderId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Gets a paginated list of open orders related to current logged-in user.
 */
export const myTrade = (options?: SecondParameter<typeof customInstance>, signal?: AbortSignal) => {
  return customInstance<OrderInfoResponse[]>({ url: `/frontoffice/api/orders/my`, method: 'GET', signal }, options);
};

export const getMyTradeQueryKey = () => {
  return [`/frontoffice/api/orders/my`] as const;
};

export const getMyTradeQueryOptions = <
  TData = Awaited<ReturnType<typeof myTrade>>,
  TError = ErrorType<void>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof myTrade>>, TError, TData>;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getMyTradeQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof myTrade>>> = ({ signal }) => myTrade(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof myTrade>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type MyTradeQueryResult = NonNullable<Awaited<ReturnType<typeof myTrade>>>;
export type MyTradeQueryError = ErrorType<void>;

/**
 * @summary Gets a paginated list of open orders related to current logged-in user.
 */

export function useMyTrade<TData = Awaited<ReturnType<typeof myTrade>>, TError = ErrorType<void>>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof myTrade>>, TError, TData>;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getMyTradeQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Tries to cancel all user's active orders.
            
On success reports the number of cancelled orders.
 */
export const cancelAllActiveOrdersTrade = (options?: SecondParameter<typeof customInstance>) => {
  return customInstance<Int32Response>({ url: `/frontoffice/api/orders`, method: 'DELETE' }, options);
};

export const getCancelAllActiveOrdersTradeMutationOptions = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof cancelAllActiveOrdersTrade>>, TError, void, TContext>;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<Awaited<ReturnType<typeof cancelAllActiveOrdersTrade>>, TError, void, TContext> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelAllActiveOrdersTrade>>, void> = () => {
    return cancelAllActiveOrdersTrade(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CancelAllActiveOrdersTradeMutationResult = NonNullable<
  Awaited<ReturnType<typeof cancelAllActiveOrdersTrade>>
>;

export type CancelAllActiveOrdersTradeMutationError = ErrorType<void>;

/**
 * @summary Tries to cancel all user's active orders.
            
On success reports the number of cancelled orders.
 */
export const useCancelAllActiveOrdersTrade = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof cancelAllActiveOrdersTrade>>, TError, void, TContext>;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<Awaited<ReturnType<typeof cancelAllActiveOrdersTrade>>, TError, void, TContext> => {
  const mutationOptions = getCancelAllActiveOrdersTradeMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Returns the user order history. 
The user is detected form the logged in user token
 */
export const orderHistoryTrade = (
  params?: OrderHistoryTradeParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<OrderInfoResponseFilteredResponse>(
    { url: `/frontoffice/api/order_history`, method: 'GET', params, signal },
    options
  );
};

export const getOrderHistoryTradeQueryKey = (params?: OrderHistoryTradeParams) => {
  return [`/frontoffice/api/order_history`, ...(params ? [params] : [])] as const;
};

export const getOrderHistoryTradeQueryOptions = <
  TData = Awaited<ReturnType<typeof orderHistoryTrade>>,
  TError = ErrorType<void>
>(
  params?: OrderHistoryTradeParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof orderHistoryTrade>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getOrderHistoryTradeQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof orderHistoryTrade>>> = ({ signal }) =>
    orderHistoryTrade(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof orderHistoryTrade>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type OrderHistoryTradeQueryResult = NonNullable<Awaited<ReturnType<typeof orderHistoryTrade>>>;
export type OrderHistoryTradeQueryError = ErrorType<void>;

/**
 * @summary Returns the user order history. 
The user is detected form the logged in user token
 */

export function useOrderHistoryTrade<TData = Awaited<ReturnType<typeof orderHistoryTrade>>, TError = ErrorType<void>>(
  params?: OrderHistoryTradeParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof orderHistoryTrade>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getOrderHistoryTradeQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Returns the user trade history
 */
export const getTradeHistory = (
  params?: GetTradeHistoryParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<TradeHistoryItemFilteredResponse>(
    { url: `/frontoffice/api/trade_history`, method: 'GET', params, signal },
    options
  );
};

export const getGetTradeHistoryQueryKey = (params?: GetTradeHistoryParams) => {
  return [`/frontoffice/api/trade_history`, ...(params ? [params] : [])] as const;
};

export const getGetTradeHistoryQueryOptions = <
  TData = Awaited<ReturnType<typeof getTradeHistory>>,
  TError = ErrorType<void>
>(
  params?: GetTradeHistoryParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getTradeHistory>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTradeHistoryQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTradeHistory>>> = ({ signal }) =>
    getTradeHistory(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTradeHistory>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetTradeHistoryQueryResult = NonNullable<Awaited<ReturnType<typeof getTradeHistory>>>;
export type GetTradeHistoryQueryError = ErrorType<void>;

/**
 * @summary Returns the user trade history
 */

export function useGetTradeHistory<TData = Awaited<ReturnType<typeof getTradeHistory>>, TError = ErrorType<void>>(
  params?: GetTradeHistoryParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getTradeHistory>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetTradeHistoryQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const fullAssetsTrade = (options?: SecondParameter<typeof customInstance>, signal?: AbortSignal) => {
  return customInstance<AccountAssetResponse[]>({ url: `/frontoffice/api/assets`, method: 'GET', signal }, options);
};

export const getFullAssetsTradeQueryKey = () => {
  return [`/frontoffice/api/assets`] as const;
};

export const getFullAssetsTradeQueryOptions = <
  TData = Awaited<ReturnType<typeof fullAssetsTrade>>,
  TError = ErrorType<void>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof fullAssetsTrade>>, TError, TData>;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getFullAssetsTradeQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof fullAssetsTrade>>> = ({ signal }) =>
    fullAssetsTrade(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof fullAssetsTrade>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type FullAssetsTradeQueryResult = NonNullable<Awaited<ReturnType<typeof fullAssetsTrade>>>;
export type FullAssetsTradeQueryError = ErrorType<void>;

export function useFullAssetsTrade<
  TData = Awaited<ReturnType<typeof fullAssetsTrade>>,
  TError = ErrorType<void>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof fullAssetsTrade>>, TError, TData>;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getFullAssetsTradeQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Tries to get the latest price for the specified instrument, if couldn't be found gets from coingecko.
 */
export const swapTrade = (
  params: SwapTradeParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<SwapResponse>({ url: `/frontoffice/api/swap`, method: 'GET', params, signal }, options);
};

export const getSwapTradeQueryKey = (params: SwapTradeParams) => {
  return [`/frontoffice/api/swap`, ...(params ? [params] : [])] as const;
};

export const getSwapTradeQueryOptions = <
  TData = Awaited<ReturnType<typeof swapTrade>>,
  TError = ErrorType<Error | ApiErrorResponse>
>(
  params: SwapTradeParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof swapTrade>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSwapTradeQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof swapTrade>>> = ({ signal }) =>
    swapTrade(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof swapTrade>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SwapTradeQueryResult = NonNullable<Awaited<ReturnType<typeof swapTrade>>>;
export type SwapTradeQueryError = ErrorType<Error | ApiErrorResponse>;

/**
 * @summary Tries to get the latest price for the specified instrument, if couldn't be found gets from coingecko.
 */

export function useSwapTrade<
  TData = Awaited<ReturnType<typeof swapTrade>>,
  TError = ErrorType<Error | ApiErrorResponse>
>(
  params: SwapTradeParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof swapTrade>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getSwapTradeQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Returns 50 recent trades that have completed.
 */
export const recentTrades = (
  params?: RecentTradesParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<RecentTradesResponse[]>(
    { url: `/frontoffice/api/recent`, method: 'GET', params, signal },
    options
  );
};

export const getRecentTradesQueryKey = (params?: RecentTradesParams) => {
  return [`/frontoffice/api/recent`, ...(params ? [params] : [])] as const;
};

export const getRecentTradesQueryOptions = <
  TData = Awaited<ReturnType<typeof recentTrades>>,
  TError = ErrorType<unknown>
>(
  params?: RecentTradesParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof recentTrades>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getRecentTradesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof recentTrades>>> = ({ signal }) =>
    recentTrades(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof recentTrades>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type RecentTradesQueryResult = NonNullable<Awaited<ReturnType<typeof recentTrades>>>;
export type RecentTradesQueryError = ErrorType<unknown>;

/**
 * @summary Returns 50 recent trades that have completed.
 */

export function useRecentTrades<TData = Awaited<ReturnType<typeof recentTrades>>, TError = ErrorType<unknown>>(
  params?: RecentTradesParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof recentTrades>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getRecentTradesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Returns a quote for the specified amount and market.
 */
export const quoteTrade = (
  params?: QuoteTradeParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<GetQuoteResponse>({ url: `/frontoffice/api/quote`, method: 'GET', params, signal }, options);
};

export const getQuoteTradeQueryKey = (params?: QuoteTradeParams) => {
  return [`/frontoffice/api/quote`, ...(params ? [params] : [])] as const;
};

export const getQuoteTradeQueryOptions = <TData = Awaited<ReturnType<typeof quoteTrade>>, TError = ErrorType<void>>(
  params?: QuoteTradeParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof quoteTrade>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getQuoteTradeQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof quoteTrade>>> = ({ signal }) =>
    quoteTrade(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof quoteTrade>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type QuoteTradeQueryResult = NonNullable<Awaited<ReturnType<typeof quoteTrade>>>;
export type QuoteTradeQueryError = ErrorType<void>;

/**
 * @summary Returns a quote for the specified amount and market.
 */

export function useQuoteTrade<TData = Awaited<ReturnType<typeof quoteTrade>>, TError = ErrorType<void>>(
  params?: QuoteTradeParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof quoteTrade>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getQuoteTradeQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Calculates and returns the fee and fee asset for an order request.
 */
export const feeTrade = (
  params?: FeeTradeParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<FeeResponse>({ url: `/frontoffice/api/order/fee`, method: 'GET', params, signal }, options);
};

export const getFeeTradeQueryKey = (params?: FeeTradeParams) => {
  return [`/frontoffice/api/order/fee`, ...(params ? [params] : [])] as const;
};

export const getFeeTradeQueryOptions = <TData = Awaited<ReturnType<typeof feeTrade>>, TError = ErrorType<void>>(
  params?: FeeTradeParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof feeTrade>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getFeeTradeQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof feeTrade>>> = ({ signal }) =>
    feeTrade(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof feeTrade>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type FeeTradeQueryResult = NonNullable<Awaited<ReturnType<typeof feeTrade>>>;
export type FeeTradeQueryError = ErrorType<void>;

/**
 * @summary Calculates and returns the fee and fee asset for an order request.
 */

export function useFeeTrade<TData = Awaited<ReturnType<typeof feeTrade>>, TError = ErrorType<void>>(
  params?: FeeTradeParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof feeTrade>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getFeeTradeQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Returns all trades related to a specific order
 */
export const getOrderTrades = (
  orderId: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<OrderTradesViewModelForUser>(
    { url: `/frontoffice/api/order/${orderId}/trades`, method: 'GET', signal },
    options
  );
};

export const getGetOrderTradesQueryKey = (orderId: string) => {
  return [`/frontoffice/api/order/${orderId}/trades`] as const;
};

export const getGetOrderTradesQueryOptions = <
  TData = Awaited<ReturnType<typeof getOrderTrades>>,
  TError = ErrorType<void>
>(
  orderId: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getOrderTrades>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOrderTradesQueryKey(orderId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrderTrades>>> = ({ signal }) =>
    getOrderTrades(orderId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!orderId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getOrderTrades>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetOrderTradesQueryResult = NonNullable<Awaited<ReturnType<typeof getOrderTrades>>>;
export type GetOrderTradesQueryError = ErrorType<void>;

/**
 * @summary Returns all trades related to a specific order
 */

export function useGetOrderTrades<TData = Awaited<ReturnType<typeof getOrderTrades>>, TError = ErrorType<void>>(
  orderId: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getOrderTrades>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetOrderTradesQueryOptions(orderId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Verifies whether the provided wallet address is associated with PingExchange or not.
- Before using this API, providers must submit their profile to PingExchange, including the Virtual Asset Service Provider's name (VASP) and a secret key. The VASP's name will be referred to as the vaspId. Based on `RFC #2104 section.3` and also `RFC #4848 page.5`, key needs to be chosen at random (or using a cryptographically strong pseudo-random generator seeded with a random seed). This key is required by `HMAC` cryptography mechanism.
- To comply with the `FATF Travel Rule` verify if a wallet address is linked to PingExchange, a call to the following API is necessary.
 * @summary Check Address Validity
 */
export const checkAddressValidityTravel = (
  travelCheckRequest: TravelCheckRequest,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<void>(
    {
      url: `/frontoffice/api/v1/travel/address`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: travelCheckRequest,
    },
    options
  );
};

export const getCheckAddressValidityTravelMutationOptions = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof checkAddressValidityTravel>>,
    TError,
    { data: TravelCheckRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof checkAddressValidityTravel>>,
  TError,
  { data: TravelCheckRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof checkAddressValidityTravel>>,
    { data: TravelCheckRequest }
  > = props => {
    const { data } = props ?? {};

    return checkAddressValidityTravel(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CheckAddressValidityTravelMutationResult = NonNullable<
  Awaited<ReturnType<typeof checkAddressValidityTravel>>
>;
export type CheckAddressValidityTravelMutationBody = TravelCheckRequest;
export type CheckAddressValidityTravelMutationError = ErrorType<void>;

/**
 * @summary Check Address Validity
 */
export const useCheckAddressValidityTravel = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof checkAddressValidityTravel>>,
    TError,
    { data: TravelCheckRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof checkAddressValidityTravel>>,
  TError,
  { data: TravelCheckRequest },
  TContext
> => {
  const mutationOptions = getCheckAddressValidityTravelMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Collecting travel information and saving it in PingExchange, if given signature is valid.
- the supplier needs to initially submit their information in the `PingExchange`.
- To transmit and save information in the `PingExchange`, it is essential to invoke this API.
 * @summary Store Travel Address
 */
export const storeAddressTravel = (travelRequest: TravelRequest, options?: SecondParameter<typeof customInstance>) => {
  return customInstance<void>(
    {
      url: `/frontoffice/api/v1/travel/data`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: travelRequest,
    },
    options
  );
};

export const getStoreAddressTravelMutationOptions = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof storeAddressTravel>>,
    TError,
    { data: TravelRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<Awaited<ReturnType<typeof storeAddressTravel>>, TError, { data: TravelRequest }, TContext> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof storeAddressTravel>>,
    { data: TravelRequest }
  > = props => {
    const { data } = props ?? {};

    return storeAddressTravel(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type StoreAddressTravelMutationResult = NonNullable<Awaited<ReturnType<typeof storeAddressTravel>>>;
export type StoreAddressTravelMutationBody = TravelRequest;
export type StoreAddressTravelMutationError = ErrorType<void>;

/**
 * @summary Store Travel Address
 */
export const useStoreAddressTravel = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof storeAddressTravel>>,
    TError,
    { data: TravelRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<Awaited<ReturnType<typeof storeAddressTravel>>, TError, { data: TravelRequest }, TContext> => {
  const mutationOptions = getStoreAddressTravelMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary The corepass app signs the request and calls this callback afterwards.
 */
export const callbackTwoFactorAuth = (
  twoFactorAuthCallbackRequest: TwoFactorAuthCallbackRequest,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<void>(
    {
      url: `/frontoffice/api/v2/2fa`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: twoFactorAuthCallbackRequest,
    },
    options
  );
};

export const getCallbackTwoFactorAuthMutationOptions = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof callbackTwoFactorAuth>>,
    TError,
    { data: TwoFactorAuthCallbackRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof callbackTwoFactorAuth>>,
  TError,
  { data: TwoFactorAuthCallbackRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof callbackTwoFactorAuth>>,
    { data: TwoFactorAuthCallbackRequest }
  > = props => {
    const { data } = props ?? {};

    return callbackTwoFactorAuth(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CallbackTwoFactorAuthMutationResult = NonNullable<Awaited<ReturnType<typeof callbackTwoFactorAuth>>>;
export type CallbackTwoFactorAuthMutationBody = TwoFactorAuthCallbackRequest;
export type CallbackTwoFactorAuthMutationError = ErrorType<unknown>;

/**
 * @summary The corepass app signs the request and calls this callback afterwards.
 */
export const useCallbackTwoFactorAuth = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof callbackTwoFactorAuth>>,
    TError,
    { data: TwoFactorAuthCallbackRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof callbackTwoFactorAuth>>,
  TError,
  { data: TwoFactorAuthCallbackRequest },
  TContext
> => {
  const mutationOptions = getCallbackTwoFactorAuthMutationOptions(options);

  return useMutation(mutationOptions);
};

export const assetContractAggrementCallbackTwoFactorAuth = (
  twoFactorAuthCallbackRequest: TwoFactorAuthCallbackRequest,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<void>(
    {
      url: `/frontoffice/api/v2/2fa/asset-contract-aggrement`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: twoFactorAuthCallbackRequest,
    },
    options
  );
};

export const getAssetContractAggrementCallbackTwoFactorAuthMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof assetContractAggrementCallbackTwoFactorAuth>>,
    TError,
    { data: TwoFactorAuthCallbackRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof assetContractAggrementCallbackTwoFactorAuth>>,
  TError,
  { data: TwoFactorAuthCallbackRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof assetContractAggrementCallbackTwoFactorAuth>>,
    { data: TwoFactorAuthCallbackRequest }
  > = props => {
    const { data } = props ?? {};

    return assetContractAggrementCallbackTwoFactorAuth(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AssetContractAggrementCallbackTwoFactorAuthMutationResult = NonNullable<
  Awaited<ReturnType<typeof assetContractAggrementCallbackTwoFactorAuth>>
>;
export type AssetContractAggrementCallbackTwoFactorAuthMutationBody = TwoFactorAuthCallbackRequest;
export type AssetContractAggrementCallbackTwoFactorAuthMutationError = ErrorType<unknown>;

export const useAssetContractAggrementCallbackTwoFactorAuth = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof assetContractAggrementCallbackTwoFactorAuth>>,
    TError,
    { data: TwoFactorAuthCallbackRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof assetContractAggrementCallbackTwoFactorAuth>>,
  TError,
  { data: TwoFactorAuthCallbackRequest },
  TContext
> => {
  const mutationOptions = getAssetContractAggrementCallbackTwoFactorAuthMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Receives UserId and returns list of user documents. This action works with admin credentials.
 */
export const getByUserIdUserDocuments = (
  userId: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<UserDocumentDto[]>(
    { url: `/frontoffice/api/v1/user-document/${userId}`, method: 'GET', signal },
    options
  );
};

export const getGetByUserIdUserDocumentsQueryKey = (userId: string) => {
  return [`/frontoffice/api/v1/user-document/${userId}`] as const;
};

export const getGetByUserIdUserDocumentsQueryOptions = <
  TData = Awaited<ReturnType<typeof getByUserIdUserDocuments>>,
  TError = ErrorType<void>
>(
  userId: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getByUserIdUserDocuments>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetByUserIdUserDocumentsQueryKey(userId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getByUserIdUserDocuments>>> = ({ signal }) =>
    getByUserIdUserDocuments(userId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!userId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getByUserIdUserDocuments>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetByUserIdUserDocumentsQueryResult = NonNullable<Awaited<ReturnType<typeof getByUserIdUserDocuments>>>;
export type GetByUserIdUserDocumentsQueryError = ErrorType<void>;

/**
 * @summary Receives UserId and returns list of user documents. This action works with admin credentials.
 */

export function useGetByUserIdUserDocuments<
  TData = Awaited<ReturnType<typeof getByUserIdUserDocuments>>,
  TError = ErrorType<void>
>(
  userId: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getByUserIdUserDocuments>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetByUserIdUserDocumentsQueryOptions(userId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Gets the user info for the specified user.
 */
export const getUserInfo = (options?: SecondParameter<typeof customInstance>, signal?: AbortSignal) => {
  return customInstance<UserInfo>({ url: `/frontoffice/api/userinfo`, method: 'GET', signal }, options);
};

export const getGetUserInfoQueryKey = () => {
  return [`/frontoffice/api/userinfo`] as const;
};

export const getGetUserInfoQueryOptions = <
  TData = Awaited<ReturnType<typeof getUserInfo>>,
  TError = ErrorType<void>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getUserInfo>>, TError, TData>;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetUserInfoQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserInfo>>> = ({ signal }) =>
    getUserInfo(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUserInfo>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetUserInfoQueryResult = NonNullable<Awaited<ReturnType<typeof getUserInfo>>>;
export type GetUserInfoQueryError = ErrorType<void>;

/**
 * @summary Gets the user info for the specified user.
 */

export function useGetUserInfo<TData = Awaited<ReturnType<typeof getUserInfo>>, TError = ErrorType<void>>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getUserInfo>>, TError, TData>;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetUserInfoQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Sets the user info for the specified user.
 */
export const setUserInfo = (userInfo: UserInfo, options?: SecondParameter<typeof customInstance>) => {
  return customInstance<void>(
    {
      url: `/frontoffice/api/userinfo`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: userInfo,
    },
    options
  );
};

export const getSetUserInfoMutationOptions = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof setUserInfo>>, TError, { data: UserInfo }, TContext>;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<Awaited<ReturnType<typeof setUserInfo>>, TError, { data: UserInfo }, TContext> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof setUserInfo>>, { data: UserInfo }> = props => {
    const { data } = props ?? {};

    return setUserInfo(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SetUserInfoMutationResult = NonNullable<Awaited<ReturnType<typeof setUserInfo>>>;
export type SetUserInfoMutationBody = UserInfo;
export type SetUserInfoMutationError = ErrorType<void>;

/**
 * @summary Sets the user info for the specified user.
 */
export const useSetUserInfo = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof setUserInfo>>, TError, { data: UserInfo }, TContext>;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<Awaited<ReturnType<typeof setUserInfo>>, TError, { data: UserInfo }, TContext> => {
  const mutationOptions = getSetUserInfoMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getFormAUserInfo = (options?: SecondParameter<typeof customInstance>, signal?: AbortSignal) => {
  return customInstance<FormAResponse>(
    { url: `/frontoffice/api/userinfo/request/forma`, method: 'GET', signal },
    options
  );
};

export const getGetFormAUserInfoQueryKey = () => {
  return [`/frontoffice/api/userinfo/request/forma`] as const;
};

export const getGetFormAUserInfoQueryOptions = <
  TData = Awaited<ReturnType<typeof getFormAUserInfo>>,
  TError = ErrorType<ApiErrorResponse | void>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getFormAUserInfo>>, TError, TData>;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetFormAUserInfoQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getFormAUserInfo>>> = ({ signal }) =>
    getFormAUserInfo(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getFormAUserInfo>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetFormAUserInfoQueryResult = NonNullable<Awaited<ReturnType<typeof getFormAUserInfo>>>;
export type GetFormAUserInfoQueryError = ErrorType<ApiErrorResponse | void>;

export function useGetFormAUserInfo<
  TData = Awaited<ReturnType<typeof getFormAUserInfo>>,
  TError = ErrorType<ApiErrorResponse | void>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getFormAUserInfo>>, TError, TData>;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetFormAUserInfoQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary This method is called by CorePass connector when data is requested data is signed.
 */
export const formACallbackUserInfo = (options?: SecondParameter<typeof customInstance>) => {
  return customInstance<void>({ url: `/frontoffice/api/userinfo/formacallback`, method: 'POST' }, options);
};

export const getFormACallbackUserInfoMutationOptions = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof formACallbackUserInfo>>, TError, void, TContext>;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<Awaited<ReturnType<typeof formACallbackUserInfo>>, TError, void, TContext> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof formACallbackUserInfo>>, void> = () => {
    return formACallbackUserInfo(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type FormACallbackUserInfoMutationResult = NonNullable<Awaited<ReturnType<typeof formACallbackUserInfo>>>;

export type FormACallbackUserInfoMutationError = ErrorType<unknown>;

/**
 * @summary This method is called by CorePass connector when data is requested data is signed.
 */
export const useFormACallbackUserInfo = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof formACallbackUserInfo>>, TError, void, TContext>;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<Awaited<ReturnType<typeof formACallbackUserInfo>>, TError, void, TContext> => {
  const mutationOptions = getFormACallbackUserInfoMutationOptions(options);

  return useMutation(mutationOptions);
};

export const createWalletVerificationPdfUserInfo = (
  verifyWalletWithSignedFormRequest: VerifyWalletWithSignedFormRequest,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<void>(
    {
      url: `/frontoffice/api/userinfo/create-pdf`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: verifyWalletWithSignedFormRequest,
    },
    options
  );
};

export const getCreateWalletVerificationPdfUserInfoMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createWalletVerificationPdfUserInfo>>,
    TError,
    { data: VerifyWalletWithSignedFormRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createWalletVerificationPdfUserInfo>>,
  TError,
  { data: VerifyWalletWithSignedFormRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createWalletVerificationPdfUserInfo>>,
    { data: VerifyWalletWithSignedFormRequest }
  > = props => {
    const { data } = props ?? {};

    return createWalletVerificationPdfUserInfo(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateWalletVerificationPdfUserInfoMutationResult = NonNullable<
  Awaited<ReturnType<typeof createWalletVerificationPdfUserInfo>>
>;
export type CreateWalletVerificationPdfUserInfoMutationBody = VerifyWalletWithSignedFormRequest;
export type CreateWalletVerificationPdfUserInfoMutationError = ErrorType<void>;

export const useCreateWalletVerificationPdfUserInfo = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createWalletVerificationPdfUserInfo>>,
    TError,
    { data: VerifyWalletWithSignedFormRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createWalletVerificationPdfUserInfo>>,
  TError,
  { data: VerifyWalletWithSignedFormRequest },
  TContext
> => {
  const mutationOptions = getCreateWalletVerificationPdfUserInfoMutationOptions(options);

  return useMutation(mutationOptions);
};

export const userSettingsGet = (options?: SecondParameter<typeof customInstance>, signal?: AbortSignal) => {
  return customInstance<GetUserSettingResponseResponse>(
    { url: `/frontoffice/api/settings`, method: 'GET', signal },
    options
  );
};

export const getUserSettingsGetQueryKey = () => {
  return [`/frontoffice/api/settings`] as const;
};

export const getUserSettingsGetQueryOptions = <
  TData = Awaited<ReturnType<typeof userSettingsGet>>,
  TError = ErrorType<void>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof userSettingsGet>>, TError, TData>;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUserSettingsGetQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof userSettingsGet>>> = ({ signal }) =>
    userSettingsGet(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof userSettingsGet>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type UserSettingsGetQueryResult = NonNullable<Awaited<ReturnType<typeof userSettingsGet>>>;
export type UserSettingsGetQueryError = ErrorType<void>;

export function useUserSettingsGet<
  TData = Awaited<ReturnType<typeof userSettingsGet>>,
  TError = ErrorType<void>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof userSettingsGet>>, TError, TData>;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getUserSettingsGetQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const userSettingsUpdate = (
  profileSettingsUpdateRequest: ProfileSettingsUpdateRequest,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<void>(
    {
      url: `/frontoffice/api/setting`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: profileSettingsUpdateRequest,
    },
    options
  );
};

export const getUserSettingsUpdateMutationOptions = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof userSettingsUpdate>>,
    TError,
    { data: ProfileSettingsUpdateRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof userSettingsUpdate>>,
  TError,
  { data: ProfileSettingsUpdateRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof userSettingsUpdate>>,
    { data: ProfileSettingsUpdateRequest }
  > = props => {
    const { data } = props ?? {};

    return userSettingsUpdate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UserSettingsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof userSettingsUpdate>>>;
export type UserSettingsUpdateMutationBody = ProfileSettingsUpdateRequest;
export type UserSettingsUpdateMutationError = ErrorType<void>;

export const useUserSettingsUpdate = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof userSettingsUpdate>>,
    TError,
    { data: ProfileSettingsUpdateRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof userSettingsUpdate>>,
  TError,
  { data: ProfileSettingsUpdateRequest },
  TContext
> => {
  const mutationOptions = getUserSettingsUpdateMutationOptions(options);

  return useMutation(mutationOptions);
};

export const userSettingsDelete = (
  profileSettingsUpdateRequest: ProfileSettingsUpdateRequest,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<void>(
    {
      url: `/frontoffice/api/setting`,
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: profileSettingsUpdateRequest,
    },
    options
  );
};

export const getUserSettingsDeleteMutationOptions = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof userSettingsDelete>>,
    TError,
    { data: ProfileSettingsUpdateRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof userSettingsDelete>>,
  TError,
  { data: ProfileSettingsUpdateRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof userSettingsDelete>>,
    { data: ProfileSettingsUpdateRequest }
  > = props => {
    const { data } = props ?? {};

    return userSettingsDelete(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UserSettingsDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof userSettingsDelete>>>;
export type UserSettingsDeleteMutationBody = ProfileSettingsUpdateRequest;
export type UserSettingsDeleteMutationError = ErrorType<void>;

export const useUserSettingsDelete = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof userSettingsDelete>>,
    TError,
    { data: ProfileSettingsUpdateRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof userSettingsDelete>>,
  TError,
  { data: ProfileSettingsUpdateRequest },
  TContext
> => {
  const mutationOptions = getUserSettingsDeleteMutationOptions(options);

  return useMutation(mutationOptions);
};

export const toggleSubscriptionUserTier = (options?: SecondParameter<typeof customInstance>) => {
  return customInstance<void>({ url: `/frontoffice/api/v2/usertiers`, method: 'POST' }, options);
};

export const getToggleSubscriptionUserTierMutationOptions = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof toggleSubscriptionUserTier>>, TError, void, TContext>;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<Awaited<ReturnType<typeof toggleSubscriptionUserTier>>, TError, void, TContext> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof toggleSubscriptionUserTier>>, void> = () => {
    return toggleSubscriptionUserTier(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ToggleSubscriptionUserTierMutationResult = NonNullable<
  Awaited<ReturnType<typeof toggleSubscriptionUserTier>>
>;

export type ToggleSubscriptionUserTierMutationError = ErrorType<void>;

export const useToggleSubscriptionUserTier = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof toggleSubscriptionUserTier>>, TError, void, TContext>;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<Awaited<ReturnType<typeof toggleSubscriptionUserTier>>, TError, void, TContext> => {
  const mutationOptions = getToggleSubscriptionUserTierMutationOptions(options);

  return useMutation(mutationOptions);
};

export const depositWallet = (
  depositFundsRequest: NonReadonly<DepositFundsRequest>,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<DepositFundsResponse>(
    {
      url: `/frontoffice/api/wallet/deposit`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: depositFundsRequest,
    },
    options
  );
};

export const getDepositWalletMutationOptions = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof depositWallet>>,
    TError,
    { data: NonReadonly<DepositFundsRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof depositWallet>>,
  TError,
  { data: NonReadonly<DepositFundsRequest> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof depositWallet>>,
    { data: NonReadonly<DepositFundsRequest> }
  > = props => {
    const { data } = props ?? {};

    return depositWallet(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DepositWalletMutationResult = NonNullable<Awaited<ReturnType<typeof depositWallet>>>;
export type DepositWalletMutationBody = NonReadonly<DepositFundsRequest>;
export type DepositWalletMutationError = ErrorType<void>;

export const useDepositWallet = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof depositWallet>>,
    TError,
    { data: NonReadonly<DepositFundsRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof depositWallet>>,
  TError,
  { data: NonReadonly<DepositFundsRequest> },
  TContext
> => {
  const mutationOptions = getDepositWalletMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getWithdrawalReceiveAmountWallet = (
  params: GetWithdrawalReceiveAmountWalletParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<void>(
    { url: `/frontoffice/api/wallet/withdrawal/receive-amount`, method: 'GET', params, signal },
    options
  );
};

export const getGetWithdrawalReceiveAmountWalletQueryKey = (params: GetWithdrawalReceiveAmountWalletParams) => {
  return [`/frontoffice/api/wallet/withdrawal/receive-amount`, ...(params ? [params] : [])] as const;
};

export const getGetWithdrawalReceiveAmountWalletQueryOptions = <
  TData = Awaited<ReturnType<typeof getWithdrawalReceiveAmountWallet>>,
  TError = ErrorType<void>
>(
  params: GetWithdrawalReceiveAmountWalletParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getWithdrawalReceiveAmountWallet>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetWithdrawalReceiveAmountWalletQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getWithdrawalReceiveAmountWallet>>> = ({ signal }) =>
    getWithdrawalReceiveAmountWallet(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getWithdrawalReceiveAmountWallet>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetWithdrawalReceiveAmountWalletQueryResult = NonNullable<
  Awaited<ReturnType<typeof getWithdrawalReceiveAmountWallet>>
>;
export type GetWithdrawalReceiveAmountWalletQueryError = ErrorType<void>;

export function useGetWithdrawalReceiveAmountWallet<
  TData = Awaited<ReturnType<typeof getWithdrawalReceiveAmountWallet>>,
  TError = ErrorType<void>
>(
  params: GetWithdrawalReceiveAmountWalletParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getWithdrawalReceiveAmountWallet>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetWithdrawalReceiveAmountWalletQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const withdrawalWallet = (
  withdrawalRequest: WithdrawalRequest,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<string>(
    {
      url: `/frontoffice/api/wallet/withdrawal`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: withdrawalRequest,
    },
    options
  );
};

export const getWithdrawalWalletMutationOptions = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof withdrawalWallet>>,
    TError,
    { data: WithdrawalRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<Awaited<ReturnType<typeof withdrawalWallet>>, TError, { data: WithdrawalRequest }, TContext> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof withdrawalWallet>>,
    { data: WithdrawalRequest }
  > = props => {
    const { data } = props ?? {};

    return withdrawalWallet(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type WithdrawalWalletMutationResult = NonNullable<Awaited<ReturnType<typeof withdrawalWallet>>>;
export type WithdrawalWalletMutationBody = WithdrawalRequest;
export type WithdrawalWalletMutationError = ErrorType<void>;

export const useWithdrawalWallet = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof withdrawalWallet>>,
    TError,
    { data: WithdrawalRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<Awaited<ReturnType<typeof withdrawalWallet>>, TError, { data: WithdrawalRequest }, TContext> => {
  const mutationOptions = getWithdrawalWalletMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * This action requires the user to have one of the following policies: Qodex.Auth.Policy.TraderUser or Qodex.Auth.Policy.LimitedTrader.
 * @summary Determines if a withdrawal is allowed for the specified payment system and address.
 */
export const isWithdrawalAllowedWallet = (
  params: IsWithdrawalAllowedWalletParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<IsWithdrawalAllowedResponse>(
    { url: `/frontoffice/api/wallet/withdrawal/check-allowance`, method: 'GET', params, signal },
    options
  );
};

export const getIsWithdrawalAllowedWalletQueryKey = (params: IsWithdrawalAllowedWalletParams) => {
  return [`/frontoffice/api/wallet/withdrawal/check-allowance`, ...(params ? [params] : [])] as const;
};

export const getIsWithdrawalAllowedWalletQueryOptions = <
  TData = Awaited<ReturnType<typeof isWithdrawalAllowedWallet>>,
  TError = ErrorType<void>
>(
  params: IsWithdrawalAllowedWalletParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof isWithdrawalAllowedWallet>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getIsWithdrawalAllowedWalletQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof isWithdrawalAllowedWallet>>> = ({ signal }) =>
    isWithdrawalAllowedWallet(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof isWithdrawalAllowedWallet>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type IsWithdrawalAllowedWalletQueryResult = NonNullable<Awaited<ReturnType<typeof isWithdrawalAllowedWallet>>>;
export type IsWithdrawalAllowedWalletQueryError = ErrorType<void>;

/**
 * @summary Determines if a withdrawal is allowed for the specified payment system and address.
 */

export function useIsWithdrawalAllowedWallet<
  TData = Awaited<ReturnType<typeof isWithdrawalAllowedWallet>>,
  TError = ErrorType<void>
>(
  params: IsWithdrawalAllowedWalletParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof isWithdrawalAllowedWallet>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getIsWithdrawalAllowedWalletQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getWithdrawalLiquidityHintWallet = (
  params: GetWithdrawalLiquidityHintWalletParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<WithdrawalLiquidityHintResponse>(
    { url: `/frontoffice/api/wallet/withdrawal/liquidity-hint`, method: 'GET', params, signal },
    options
  );
};

export const getGetWithdrawalLiquidityHintWalletQueryKey = (params: GetWithdrawalLiquidityHintWalletParams) => {
  return [`/frontoffice/api/wallet/withdrawal/liquidity-hint`, ...(params ? [params] : [])] as const;
};

export const getGetWithdrawalLiquidityHintWalletQueryOptions = <
  TData = Awaited<ReturnType<typeof getWithdrawalLiquidityHintWallet>>,
  TError = ErrorType<void>
>(
  params: GetWithdrawalLiquidityHintWalletParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getWithdrawalLiquidityHintWallet>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetWithdrawalLiquidityHintWalletQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getWithdrawalLiquidityHintWallet>>> = ({ signal }) =>
    getWithdrawalLiquidityHintWallet(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getWithdrawalLiquidityHintWallet>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetWithdrawalLiquidityHintWalletQueryResult = NonNullable<
  Awaited<ReturnType<typeof getWithdrawalLiquidityHintWallet>>
>;
export type GetWithdrawalLiquidityHintWalletQueryError = ErrorType<void>;

export function useGetWithdrawalLiquidityHintWallet<
  TData = Awaited<ReturnType<typeof getWithdrawalLiquidityHintWallet>>,
  TError = ErrorType<void>
>(
  params: GetWithdrawalLiquidityHintWalletParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getWithdrawalLiquidityHintWallet>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetWithdrawalLiquidityHintWalletQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const verifyAddressWallet = (
  verifyAddressRequest: VerifyAddressRequest,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<VerifyAddressResponse>(
    {
      url: `/frontoffice/api/wallet/verify-address`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: verifyAddressRequest,
    },
    options
  );
};

export const getVerifyAddressWalletMutationOptions = <
  TError = ErrorType<ApiErrorResponse | void>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof verifyAddressWallet>>,
    TError,
    { data: VerifyAddressRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof verifyAddressWallet>>,
  TError,
  { data: VerifyAddressRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof verifyAddressWallet>>,
    { data: VerifyAddressRequest }
  > = props => {
    const { data } = props ?? {};

    return verifyAddressWallet(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type VerifyAddressWalletMutationResult = NonNullable<Awaited<ReturnType<typeof verifyAddressWallet>>>;
export type VerifyAddressWalletMutationBody = VerifyAddressRequest;
export type VerifyAddressWalletMutationError = ErrorType<ApiErrorResponse | void>;

export const useVerifyAddressWallet = <TError = ErrorType<ApiErrorResponse | void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof verifyAddressWallet>>,
    TError,
    { data: VerifyAddressRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof verifyAddressWallet>>,
  TError,
  { data: VerifyAddressRequest },
  TContext
> => {
  const mutationOptions = getVerifyAddressWalletMutationOptions(options);

  return useMutation(mutationOptions);
};

export const verifyAddressCallbackWallet = (options?: SecondParameter<typeof customInstance>) => {
  return customInstance<void>({ url: `/frontoffice/api/wallet/verify-address-callback`, method: 'POST' }, options);
};

export const getVerifyAddressCallbackWalletMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof verifyAddressCallbackWallet>>, TError, void, TContext>;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<Awaited<ReturnType<typeof verifyAddressCallbackWallet>>, TError, void, TContext> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof verifyAddressCallbackWallet>>, void> = () => {
    return verifyAddressCallbackWallet(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type VerifyAddressCallbackWalletMutationResult = NonNullable<
  Awaited<ReturnType<typeof verifyAddressCallbackWallet>>
>;

export type VerifyAddressCallbackWalletMutationError = ErrorType<unknown>;

export const useVerifyAddressCallbackWallet = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof verifyAddressCallbackWallet>>, TError, void, TContext>;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<Awaited<ReturnType<typeof verifyAddressCallbackWallet>>, TError, void, TContext> => {
  const mutationOptions = getVerifyAddressCallbackWalletMutationOptions(options);

  return useMutation(mutationOptions);
};

export const verifyAddressStatusCallbackWallet = (options?: SecondParameter<typeof customInstance>) => {
  return customInstance<void>(
    { url: `/frontoffice/api/wallet/verify-address-status-callback`, method: 'POST' },
    options
  );
};

export const getVerifyAddressStatusCallbackWalletMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof verifyAddressStatusCallbackWallet>>, TError, void, TContext>;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<Awaited<ReturnType<typeof verifyAddressStatusCallbackWallet>>, TError, void, TContext> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof verifyAddressStatusCallbackWallet>>, void> = () => {
    return verifyAddressStatusCallbackWallet(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type VerifyAddressStatusCallbackWalletMutationResult = NonNullable<
  Awaited<ReturnType<typeof verifyAddressStatusCallbackWallet>>
>;

export type VerifyAddressStatusCallbackWalletMutationError = ErrorType<unknown>;

export const useVerifyAddressStatusCallbackWallet = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof verifyAddressStatusCallbackWallet>>, TError, void, TContext>;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<Awaited<ReturnType<typeof verifyAddressStatusCallbackWallet>>, TError, void, TContext> => {
  const mutationOptions = getVerifyAddressStatusCallbackWalletMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getTransferHistoryWallet = (
  params?: GetTransferHistoryWalletParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<TransferHistoryResponseFilteredResponse>(
    { url: `/frontoffice/api/wallet/transfer_history`, method: 'GET', params, signal },
    options
  );
};

export const getGetTransferHistoryWalletQueryKey = (params?: GetTransferHistoryWalletParams) => {
  return [`/frontoffice/api/wallet/transfer_history`, ...(params ? [params] : [])] as const;
};

export const getGetTransferHistoryWalletQueryOptions = <
  TData = Awaited<ReturnType<typeof getTransferHistoryWallet>>,
  TError = ErrorType<void>
>(
  params?: GetTransferHistoryWalletParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getTransferHistoryWallet>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTransferHistoryWalletQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTransferHistoryWallet>>> = ({ signal }) =>
    getTransferHistoryWallet(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTransferHistoryWallet>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetTransferHistoryWalletQueryResult = NonNullable<Awaited<ReturnType<typeof getTransferHistoryWallet>>>;
export type GetTransferHistoryWalletQueryError = ErrorType<void>;

export function useGetTransferHistoryWallet<
  TData = Awaited<ReturnType<typeof getTransferHistoryWallet>>,
  TError = ErrorType<void>
>(
  params?: GetTransferHistoryWalletParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getTransferHistoryWallet>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetTransferHistoryWalletQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getNetworkFeeWallet = (
  params: GetNetworkFeeWalletParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<NetworkFeeResponse>(
    { url: `/frontoffice/api/wallet/network-fee`, method: 'GET', params, signal },
    options
  );
};

export const getGetNetworkFeeWalletQueryKey = (params: GetNetworkFeeWalletParams) => {
  return [`/frontoffice/api/wallet/network-fee`, ...(params ? [params] : [])] as const;
};

export const getGetNetworkFeeWalletQueryOptions = <
  TData = Awaited<ReturnType<typeof getNetworkFeeWallet>>,
  TError = ErrorType<unknown>
>(
  params: GetNetworkFeeWalletParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getNetworkFeeWallet>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetNetworkFeeWalletQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getNetworkFeeWallet>>> = ({ signal }) =>
    getNetworkFeeWallet(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getNetworkFeeWallet>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetNetworkFeeWalletQueryResult = NonNullable<Awaited<ReturnType<typeof getNetworkFeeWallet>>>;
export type GetNetworkFeeWalletQueryError = ErrorType<unknown>;

export function useGetNetworkFeeWallet<
  TData = Awaited<ReturnType<typeof getNetworkFeeWallet>>,
  TError = ErrorType<unknown>
>(
  params: GetNetworkFeeWalletParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getNetworkFeeWallet>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetNetworkFeeWalletQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getNetworksWallet = (
  params?: GetNetworksWalletParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<NetworkItemInfo[]>(
    { url: `/frontoffice/api/wallet/networks`, method: 'GET', params, signal },
    options
  );
};

export const getGetNetworksWalletQueryKey = (params?: GetNetworksWalletParams) => {
  return [`/frontoffice/api/wallet/networks`, ...(params ? [params] : [])] as const;
};

export const getGetNetworksWalletQueryOptions = <
  TData = Awaited<ReturnType<typeof getNetworksWallet>>,
  TError = ErrorType<void>
>(
  params?: GetNetworksWalletParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getNetworksWallet>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetNetworksWalletQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getNetworksWallet>>> = ({ signal }) =>
    getNetworksWallet(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getNetworksWallet>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetNetworksWalletQueryResult = NonNullable<Awaited<ReturnType<typeof getNetworksWallet>>>;
export type GetNetworksWalletQueryError = ErrorType<void>;

export function useGetNetworksWallet<TData = Awaited<ReturnType<typeof getNetworksWallet>>, TError = ErrorType<void>>(
  params?: GetNetworksWalletParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getNetworksWallet>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetNetworksWalletQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const createWalletVerificationRequest = (
  verifyWalletWithSignedFormRequest: VerifyWalletWithSignedFormRequest,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<VerifyAddressWithSignedFormResult>(
    {
      url: `/frontoffice/api/wallet/verify-address-with-signed-form`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: verifyWalletWithSignedFormRequest,
    },
    options
  );
};

export const getCreateWalletVerificationRequestMutationOptions = <
  TError = ErrorType<ApiErrorResponse | void>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createWalletVerificationRequest>>,
    TError,
    { data: VerifyWalletWithSignedFormRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createWalletVerificationRequest>>,
  TError,
  { data: VerifyWalletWithSignedFormRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createWalletVerificationRequest>>,
    { data: VerifyWalletWithSignedFormRequest }
  > = props => {
    const { data } = props ?? {};

    return createWalletVerificationRequest(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateWalletVerificationRequestMutationResult = NonNullable<
  Awaited<ReturnType<typeof createWalletVerificationRequest>>
>;
export type CreateWalletVerificationRequestMutationBody = VerifyWalletWithSignedFormRequest;
export type CreateWalletVerificationRequestMutationError = ErrorType<ApiErrorResponse | void>;

export const useCreateWalletVerificationRequest = <
  TError = ErrorType<ApiErrorResponse | void>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createWalletVerificationRequest>>,
    TError,
    { data: VerifyWalletWithSignedFormRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createWalletVerificationRequest>>,
  TError,
  { data: VerifyWalletWithSignedFormRequest },
  TContext
> => {
  const mutationOptions = getCreateWalletVerificationRequestMutationOptions(options);

  return useMutation(mutationOptions);
};

export const createWalletVerificationCallback = (options?: SecondParameter<typeof customInstance>) => {
  return customInstance<void>(
    { url: `/frontoffice/api/wallet/verify-address-with-signed-form-callback`, method: 'POST' },
    options
  );
};

export const getCreateWalletVerificationCallbackMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof createWalletVerificationCallback>>, TError, void, TContext>;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<Awaited<ReturnType<typeof createWalletVerificationCallback>>, TError, void, TContext> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof createWalletVerificationCallback>>, void> = () => {
    return createWalletVerificationCallback(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateWalletVerificationCallbackMutationResult = NonNullable<
  Awaited<ReturnType<typeof createWalletVerificationCallback>>
>;

export type CreateWalletVerificationCallbackMutationError = ErrorType<unknown>;

export const useCreateWalletVerificationCallback = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof createWalletVerificationCallback>>, TError, void, TContext>;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<Awaited<ReturnType<typeof createWalletVerificationCallback>>, TError, void, TContext> => {
  const mutationOptions = getCreateWalletVerificationCallbackMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getCctpRoutesWallet = (options?: SecondParameter<typeof customInstance>, signal?: AbortSignal) => {
  return customInstance<CctpRouteApiResponse[]>(
    { url: `/frontoffice/api/wallet/cctp/routes`, method: 'GET', signal },
    options
  );
};

export const getGetCctpRoutesWalletQueryKey = () => {
  return [`/frontoffice/api/wallet/cctp/routes`] as const;
};

export const getGetCctpRoutesWalletQueryOptions = <
  TData = Awaited<ReturnType<typeof getCctpRoutesWallet>>,
  TError = ErrorType<void>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getCctpRoutesWallet>>, TError, TData>;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCctpRoutesWalletQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCctpRoutesWallet>>> = ({ signal }) =>
    getCctpRoutesWallet(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCctpRoutesWallet>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCctpRoutesWalletQueryResult = NonNullable<Awaited<ReturnType<typeof getCctpRoutesWallet>>>;
export type GetCctpRoutesWalletQueryError = ErrorType<void>;

export function useGetCctpRoutesWallet<
  TData = Awaited<ReturnType<typeof getCctpRoutesWallet>>,
  TError = ErrorType<void>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getCctpRoutesWallet>>, TError, TData>;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetCctpRoutesWalletQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const createCctpTransferWallet = (
  cctpTransferRequest: CctpTransferRequest,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<FoCctpTransferApiResponse>(
    {
      url: `/frontoffice/api/wallet/cctp/transfer`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: cctpTransferRequest,
    },
    options
  );
};

export const getCreateCctpTransferWalletMutationOptions = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCctpTransferWallet>>,
    TError,
    { data: CctpTransferRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createCctpTransferWallet>>,
  TError,
  { data: CctpTransferRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createCctpTransferWallet>>,
    { data: CctpTransferRequest }
  > = props => {
    const { data } = props ?? {};

    return createCctpTransferWallet(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateCctpTransferWalletMutationResult = NonNullable<Awaited<ReturnType<typeof createCctpTransferWallet>>>;
export type CreateCctpTransferWalletMutationBody = CctpTransferRequest;
export type CreateCctpTransferWalletMutationError = ErrorType<void>;

export const useCreateCctpTransferWallet = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCctpTransferWallet>>,
    TError,
    { data: CctpTransferRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createCctpTransferWallet>>,
  TError,
  { data: CctpTransferRequest },
  TContext
> => {
  const mutationOptions = getCreateCctpTransferWalletMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getCctpTransferWallet = (
  transferId: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<FoCctpTransferApiResponse>(
    { url: `/frontoffice/api/wallet/cctp/transfer/${transferId}`, method: 'GET', signal },
    options
  );
};

export const getGetCctpTransferWalletQueryKey = (transferId: string) => {
  return [`/frontoffice/api/wallet/cctp/transfer/${transferId}`] as const;
};

export const getGetCctpTransferWalletQueryOptions = <
  TData = Awaited<ReturnType<typeof getCctpTransferWallet>>,
  TError = ErrorType<void>
>(
  transferId: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getCctpTransferWallet>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCctpTransferWalletQueryKey(transferId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCctpTransferWallet>>> = ({ signal }) =>
    getCctpTransferWallet(transferId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!transferId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCctpTransferWallet>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCctpTransferWalletQueryResult = NonNullable<Awaited<ReturnType<typeof getCctpTransferWallet>>>;
export type GetCctpTransferWalletQueryError = ErrorType<void>;

export function useGetCctpTransferWallet<
  TData = Awaited<ReturnType<typeof getCctpTransferWallet>>,
  TError = ErrorType<void>
>(
  transferId: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getCctpTransferWallet>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetCctpTransferWalletQueryOptions(transferId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Opens a transfer request for one wallet address and returns the QR code to scan (§5.2).
 */
export const verifyAddressWalletVerificationConnector = (
  walletConnectorVerifyAddressRequest: WalletConnectorVerifyAddressRequest,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<WalletConnectorVerifyAddressResponse>(
    {
      url: `/frontoffice/api/v2/wallet/verify-address`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: walletConnectorVerifyAddressRequest,
    },
    options
  );
};

export const getVerifyAddressWalletVerificationConnectorMutationOptions = <
  TError = ErrorType<ApiErrorResponse | void>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof verifyAddressWalletVerificationConnector>>,
    TError,
    { data: WalletConnectorVerifyAddressRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof verifyAddressWalletVerificationConnector>>,
  TError,
  { data: WalletConnectorVerifyAddressRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof verifyAddressWalletVerificationConnector>>,
    { data: WalletConnectorVerifyAddressRequest }
  > = props => {
    const { data } = props ?? {};

    return verifyAddressWalletVerificationConnector(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type VerifyAddressWalletVerificationConnectorMutationResult = NonNullable<
  Awaited<ReturnType<typeof verifyAddressWalletVerificationConnector>>
>;
export type VerifyAddressWalletVerificationConnectorMutationBody = WalletConnectorVerifyAddressRequest;
export type VerifyAddressWalletVerificationConnectorMutationError = ErrorType<ApiErrorResponse | void>;

/**
 * @summary Opens a transfer request for one wallet address and returns the QR code to scan (§5.2).
 */
export const useVerifyAddressWalletVerificationConnector = <
  TError = ErrorType<ApiErrorResponse | void>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof verifyAddressWalletVerificationConnector>>,
    TError,
    { data: WalletConnectorVerifyAddressRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof verifyAddressWalletVerificationConnector>>,
  TError,
  { data: WalletConnectorVerifyAddressRequest },
  TContext
> => {
  const mutationOptions = getVerifyAddressWalletVerificationConnectorMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Data-delivery and terminal-failure webhook (§6.1, §6.2). Registered with the connector as
`callback`.
 */
export const callbackWalletVerificationConnector = (options?: SecondParameter<typeof customInstance>) => {
  return customInstance<void>({ url: `/frontoffice/api/v2/wallet/callback`, method: 'POST' }, options);
};

export const getCallbackWalletVerificationConnectorMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof callbackWalletVerificationConnector>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<Awaited<ReturnType<typeof callbackWalletVerificationConnector>>, TError, void, TContext> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof callbackWalletVerificationConnector>>, void> = () => {
    return callbackWalletVerificationConnector(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CallbackWalletVerificationConnectorMutationResult = NonNullable<
  Awaited<ReturnType<typeof callbackWalletVerificationConnector>>
>;

export type CallbackWalletVerificationConnectorMutationError = ErrorType<unknown>;

/**
 * @summary Data-delivery and terminal-failure webhook (§6.1, §6.2). Registered with the connector as
`callback`.
 */
export const useCallbackWalletVerificationConnector = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof callbackWalletVerificationConnector>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<Awaited<ReturnType<typeof callbackWalletVerificationConnector>>, TError, void, TContext> => {
  const mutationOptions = getCallbackWalletVerificationConnectorMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Lifecycle status webhook (§6.3). Registered with the connector as `statusCallback`; one
POST per transition.
 */
export const statusCallbackWalletVerificationConnector = (options?: SecondParameter<typeof customInstance>) => {
  return customInstance<void>({ url: `/frontoffice/api/v2/wallet/statusCallback`, method: 'POST' }, options);
};

export const getStatusCallbackWalletVerificationConnectorMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof statusCallbackWalletVerificationConnector>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof statusCallbackWalletVerificationConnector>>,
  TError,
  void,
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof statusCallbackWalletVerificationConnector>>,
    void
  > = () => {
    return statusCallbackWalletVerificationConnector(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type StatusCallbackWalletVerificationConnectorMutationResult = NonNullable<
  Awaited<ReturnType<typeof statusCallbackWalletVerificationConnector>>
>;

export type StatusCallbackWalletVerificationConnectorMutationError = ErrorType<unknown>;

/**
 * @summary Lifecycle status webhook (§6.3). Registered with the connector as `statusCallback`; one
POST per transition.
 */
export const useStatusCallbackWalletVerificationConnector = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof statusCallbackWalletVerificationConnector>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof statusCallbackWalletVerificationConnector>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getStatusCallbackWalletVerificationConnectorMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getJwksWellKnown = (options?: SecondParameter<typeof customInstance>, signal?: AbortSignal) => {
  return customInstance<void>({ url: `/frontoffice/.well-known/jwks.json`, method: 'GET', signal }, options);
};

export const getGetJwksWellKnownQueryKey = () => {
  return [`/frontoffice/.well-known/jwks.json`] as const;
};

export const getGetJwksWellKnownQueryOptions = <
  TData = Awaited<ReturnType<typeof getJwksWellKnown>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getJwksWellKnown>>, TError, TData>;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetJwksWellKnownQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getJwksWellKnown>>> = ({ signal }) =>
    getJwksWellKnown(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getJwksWellKnown>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetJwksWellKnownQueryResult = NonNullable<Awaited<ReturnType<typeof getJwksWellKnown>>>;
export type GetJwksWellKnownQueryError = ErrorType<unknown>;

export function useGetJwksWellKnown<
  TData = Awaited<ReturnType<typeof getJwksWellKnown>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getJwksWellKnown>>, TError, TData>;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetJwksWellKnownQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Returns withdrawal limits for current user
 */
export const getWithdrawalLimit = (options?: SecondParameter<typeof customInstance>, signal?: AbortSignal) => {
  return customInstance<WithdrawalLimitResponse>(
    { url: `/frontoffice/api/wallet/withdrawal/limits`, method: 'GET', signal },
    options
  );
};

export const getGetWithdrawalLimitQueryKey = () => {
  return [`/frontoffice/api/wallet/withdrawal/limits`] as const;
};

export const getGetWithdrawalLimitQueryOptions = <
  TData = Awaited<ReturnType<typeof getWithdrawalLimit>>,
  TError = ErrorType<void>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getWithdrawalLimit>>, TError, TData>;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetWithdrawalLimitQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getWithdrawalLimit>>> = ({ signal }) =>
    getWithdrawalLimit(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getWithdrawalLimit>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetWithdrawalLimitQueryResult = NonNullable<Awaited<ReturnType<typeof getWithdrawalLimit>>>;
export type GetWithdrawalLimitQueryError = ErrorType<void>;

/**
 * @summary Returns withdrawal limits for current user
 */

export function useGetWithdrawalLimit<
  TData = Awaited<ReturnType<typeof getWithdrawalLimit>>,
  TError = ErrorType<void>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getWithdrawalLimit>>, TError, TData>;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetWithdrawalLimitQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Roles: Admin
 * @summary Get a list of tags that can be assigned to user accounts
 */
export const getTagsInfoAccountTagsInfo = (options?: SecondParameter<typeof customInstance>, signal?: AbortSignal) => {
  return customInstance<AccountTagInfo[]>(
    { url: `/back-api/api/v1/account-tags/info`, method: 'GET', signal },
    options
  );
};

export const getGetTagsInfoAccountTagsInfoQueryKey = () => {
  return [`/back-api/api/v1/account-tags/info`] as const;
};

export const getGetTagsInfoAccountTagsInfoQueryOptions = <
  TData = Awaited<ReturnType<typeof getTagsInfoAccountTagsInfo>>,
  TError = ErrorType<void>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getTagsInfoAccountTagsInfo>>, TError, TData>;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTagsInfoAccountTagsInfoQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTagsInfoAccountTagsInfo>>> = ({ signal }) =>
    getTagsInfoAccountTagsInfo(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTagsInfoAccountTagsInfo>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetTagsInfoAccountTagsInfoQueryResult = NonNullable<Awaited<ReturnType<typeof getTagsInfoAccountTagsInfo>>>;
export type GetTagsInfoAccountTagsInfoQueryError = ErrorType<void>;

/**
 * @summary Get a list of tags that can be assigned to user accounts
 */

export function useGetTagsInfoAccountTagsInfo<
  TData = Awaited<ReturnType<typeof getTagsInfoAccountTagsInfo>>,
  TError = ErrorType<void>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getTagsInfoAccountTagsInfo>>, TError, TData>;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetTagsInfoAccountTagsInfoQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Roles: Admin, ComplianceReviewer
 * @summary Invalidate a user address book item
 */
export const invalidateAddressBook = (
  invalidateAddressbookRequest: InvalidateAddressbookRequest,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<void>(
    {
      url: `/back-api/backoffice/address-book/invalidate`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: invalidateAddressbookRequest,
    },
    options
  );
};

export const getInvalidateAddressBookMutationOptions = <
  TError = ErrorType<ApiErrorResponse | void>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof invalidateAddressBook>>,
    TError,
    { data: InvalidateAddressbookRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof invalidateAddressBook>>,
  TError,
  { data: InvalidateAddressbookRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof invalidateAddressBook>>,
    { data: InvalidateAddressbookRequest }
  > = props => {
    const { data } = props ?? {};

    return invalidateAddressBook(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type InvalidateAddressBookMutationResult = NonNullable<Awaited<ReturnType<typeof invalidateAddressBook>>>;
export type InvalidateAddressBookMutationBody = InvalidateAddressbookRequest;
export type InvalidateAddressBookMutationError = ErrorType<ApiErrorResponse | void>;

/**
 * @summary Invalidate a user address book item
 */
export const useInvalidateAddressBook = <TError = ErrorType<ApiErrorResponse | void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof invalidateAddressBook>>,
    TError,
    { data: InvalidateAddressbookRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof invalidateAddressBook>>,
  TError,
  { data: InvalidateAddressbookRequest },
  TContext
> => {
  const mutationOptions = getInvalidateAddressBookMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Get Total asset deposit and wallet value by username or email
 */
export const getUserDepositInfoAdminAccounting = (
  params?: GetUserDepositInfoAdminAccountingParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<unknown>(
    { url: `/back-api/backoffice/admin-accounting/deposits`, method: 'GET', params, signal },
    options
  );
};

export const getGetUserDepositInfoAdminAccountingQueryKey = (params?: GetUserDepositInfoAdminAccountingParams) => {
  return [`/back-api/backoffice/admin-accounting/deposits`, ...(params ? [params] : [])] as const;
};

export const getGetUserDepositInfoAdminAccountingQueryOptions = <
  TData = Awaited<ReturnType<typeof getUserDepositInfoAdminAccounting>>,
  TError = ErrorType<void | ApiErrorResponse>
>(
  params?: GetUserDepositInfoAdminAccountingParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getUserDepositInfoAdminAccounting>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetUserDepositInfoAdminAccountingQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserDepositInfoAdminAccounting>>> = ({ signal }) =>
    getUserDepositInfoAdminAccounting(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUserDepositInfoAdminAccounting>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetUserDepositInfoAdminAccountingQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUserDepositInfoAdminAccounting>>
>;
export type GetUserDepositInfoAdminAccountingQueryError = ErrorType<void | ApiErrorResponse>;

/**
 * @summary Get Total asset deposit and wallet value by username or email
 */

export function useGetUserDepositInfoAdminAccounting<
  TData = Awaited<ReturnType<typeof getUserDepositInfoAdminAccounting>>,
  TError = ErrorType<void | ApiErrorResponse>
>(
  params?: GetUserDepositInfoAdminAccountingParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getUserDepositInfoAdminAccounting>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetUserDepositInfoAdminAccountingQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary This endpoint is used to retrieve the balance and expected balance of user's asset account.
 */
export const getUserBalanceCheckAdminAccounting = (
  params?: GetUserBalanceCheckAdminAccountingParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<UserBalanceCheckResponse>(
    { url: `/back-api/backoffice/admin-accounting/balancecheck`, method: 'GET', params, signal },
    options
  );
};

export const getGetUserBalanceCheckAdminAccountingQueryKey = (params?: GetUserBalanceCheckAdminAccountingParams) => {
  return [`/back-api/backoffice/admin-accounting/balancecheck`, ...(params ? [params] : [])] as const;
};

export const getGetUserBalanceCheckAdminAccountingQueryOptions = <
  TData = Awaited<ReturnType<typeof getUserBalanceCheckAdminAccounting>>,
  TError = ErrorType<void>
>(
  params?: GetUserBalanceCheckAdminAccountingParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getUserBalanceCheckAdminAccounting>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetUserBalanceCheckAdminAccountingQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserBalanceCheckAdminAccounting>>> = ({ signal }) =>
    getUserBalanceCheckAdminAccounting(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUserBalanceCheckAdminAccounting>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetUserBalanceCheckAdminAccountingQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUserBalanceCheckAdminAccounting>>
>;
export type GetUserBalanceCheckAdminAccountingQueryError = ErrorType<void>;

/**
 * @summary This endpoint is used to retrieve the balance and expected balance of user's asset account.
 */

export function useGetUserBalanceCheckAdminAccounting<
  TData = Awaited<ReturnType<typeof getUserBalanceCheckAdminAccounting>>,
  TError = ErrorType<void>
>(
  params?: GetUserBalanceCheckAdminAccountingParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getUserBalanceCheckAdminAccounting>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetUserBalanceCheckAdminAccountingQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Gets all executions and all successful transfers; calculates the total amount of each asset and compares it to the total amount of the asset in the portfolio
 */
export const getSystemBalanceAdminAccounting = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<SystemBalanceReportItem[]>(
    { url: `/back-api/backoffice/admin-accounting/system-balance-check`, method: 'GET', signal },
    options
  );
};

export const getGetSystemBalanceAdminAccountingQueryKey = () => {
  return [`/back-api/backoffice/admin-accounting/system-balance-check`] as const;
};

export const getGetSystemBalanceAdminAccountingQueryOptions = <
  TData = Awaited<ReturnType<typeof getSystemBalanceAdminAccounting>>,
  TError = ErrorType<void>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getSystemBalanceAdminAccounting>>, TError, TData>;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSystemBalanceAdminAccountingQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSystemBalanceAdminAccounting>>> = ({ signal }) =>
    getSystemBalanceAdminAccounting(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSystemBalanceAdminAccounting>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetSystemBalanceAdminAccountingQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSystemBalanceAdminAccounting>>
>;
export type GetSystemBalanceAdminAccountingQueryError = ErrorType<void>;

/**
 * @summary Gets all executions and all successful transfers; calculates the total amount of each asset and compares it to the total amount of the asset in the portfolio
 */

export function useGetSystemBalanceAdminAccounting<
  TData = Awaited<ReturnType<typeof getSystemBalanceAdminAccounting>>,
  TError = ErrorType<void>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getSystemBalanceAdminAccounting>>, TError, TData>;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetSystemBalanceAdminAccountingQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const updateUserTierAdminUserTier = (
  adminUserTierRequest: AdminUserTierRequest,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<void>(
    {
      url: `/back-api/api/v2/usertiers`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: adminUserTierRequest,
    },
    options
  );
};

export const getUpdateUserTierAdminUserTierMutationOptions = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateUserTierAdminUserTier>>,
    TError,
    { data: AdminUserTierRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateUserTierAdminUserTier>>,
  TError,
  { data: AdminUserTierRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateUserTierAdminUserTier>>,
    { data: AdminUserTierRequest }
  > = props => {
    const { data } = props ?? {};

    return updateUserTierAdminUserTier(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateUserTierAdminUserTierMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateUserTierAdminUserTier>>
>;
export type UpdateUserTierAdminUserTierMutationBody = AdminUserTierRequest;
export type UpdateUserTierAdminUserTierMutationError = ErrorType<void>;

export const useUpdateUserTierAdminUserTier = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateUserTierAdminUserTier>>,
    TError,
    { data: AdminUserTierRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateUserTierAdminUserTier>>,
  TError,
  { data: AdminUserTierRequest },
  TContext
> => {
  const mutationOptions = getUpdateUserTierAdminUserTierMutationOptions(options);

  return useMutation(mutationOptions);
};

export const apiKeysCreateApiKeys = (
  adminCreateUserApiKeyRequest: AdminCreateUserApiKeyRequest,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<CreateApiKeyResponse>(
    {
      url: `/back-api/backoffice/api-keys/create`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: adminCreateUserApiKeyRequest,
    },
    options
  );
};

export const getApiKeysCreateApiKeysMutationOptions = <
  TError = ErrorType<void | ApiErrorResponse>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiKeysCreateApiKeys>>,
    TError,
    { data: AdminCreateUserApiKeyRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiKeysCreateApiKeys>>,
  TError,
  { data: AdminCreateUserApiKeyRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiKeysCreateApiKeys>>,
    { data: AdminCreateUserApiKeyRequest }
  > = props => {
    const { data } = props ?? {};

    return apiKeysCreateApiKeys(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiKeysCreateApiKeysMutationResult = NonNullable<Awaited<ReturnType<typeof apiKeysCreateApiKeys>>>;
export type ApiKeysCreateApiKeysMutationBody = AdminCreateUserApiKeyRequest;
export type ApiKeysCreateApiKeysMutationError = ErrorType<void | ApiErrorResponse>;

export const useApiKeysCreateApiKeys = <TError = ErrorType<void | ApiErrorResponse>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiKeysCreateApiKeys>>,
    TError,
    { data: AdminCreateUserApiKeyRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiKeysCreateApiKeys>>,
  TError,
  { data: AdminCreateUserApiKeyRequest },
  TContext
> => {
  const mutationOptions = getApiKeysCreateApiKeysMutationOptions(options);

  return useMutation(mutationOptions);
};

export const apiKeysGetUserApiKeys = (options?: SecondParameter<typeof customInstance>, signal?: AbortSignal) => {
  return customInstance<void>({ url: `/back-api/backoffice/api-keys/list`, method: 'GET', signal }, options);
};

export const getApiKeysGetUserApiKeysQueryKey = () => {
  return [`/back-api/backoffice/api-keys/list`] as const;
};

export const getApiKeysGetUserApiKeysQueryOptions = <
  TData = Awaited<ReturnType<typeof apiKeysGetUserApiKeys>>,
  TError = ErrorType<void>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof apiKeysGetUserApiKeys>>, TError, TData>;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiKeysGetUserApiKeysQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiKeysGetUserApiKeys>>> = ({ signal }) =>
    apiKeysGetUserApiKeys(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiKeysGetUserApiKeys>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ApiKeysGetUserApiKeysQueryResult = NonNullable<Awaited<ReturnType<typeof apiKeysGetUserApiKeys>>>;
export type ApiKeysGetUserApiKeysQueryError = ErrorType<void>;

export function useApiKeysGetUserApiKeys<
  TData = Awaited<ReturnType<typeof apiKeysGetUserApiKeys>>,
  TError = ErrorType<void>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof apiKeysGetUserApiKeys>>, TError, TData>;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getApiKeysGetUserApiKeysQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getListAppConfig = (options?: SecondParameter<typeof customInstance>, signal?: AbortSignal) => {
  return customInstance<AppConfigResponse[]>({ url: `/back-api/api/v1/app-config`, method: 'GET', signal }, options);
};

export const getGetListAppConfigQueryKey = () => {
  return [`/back-api/api/v1/app-config`] as const;
};

export const getGetListAppConfigQueryOptions = <
  TData = Awaited<ReturnType<typeof getListAppConfig>>,
  TError = ErrorType<void>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getListAppConfig>>, TError, TData>;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetListAppConfigQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getListAppConfig>>> = ({ signal }) =>
    getListAppConfig(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getListAppConfig>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetListAppConfigQueryResult = NonNullable<Awaited<ReturnType<typeof getListAppConfig>>>;
export type GetListAppConfigQueryError = ErrorType<void>;

export function useGetListAppConfig<
  TData = Awaited<ReturnType<typeof getListAppConfig>>,
  TError = ErrorType<void>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getListAppConfig>>, TError, TData>;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetListAppConfigQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const createAppConfig = (
  createAppConfigRequest: CreateAppConfigRequest,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<AppConfigResponse>(
    {
      url: `/back-api/api/v1/app-config`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: createAppConfigRequest,
    },
    options
  );
};

export const getCreateAppConfigMutationOptions = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAppConfig>>,
    TError,
    { data: CreateAppConfigRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createAppConfig>>,
  TError,
  { data: CreateAppConfigRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createAppConfig>>,
    { data: CreateAppConfigRequest }
  > = props => {
    const { data } = props ?? {};

    return createAppConfig(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateAppConfigMutationResult = NonNullable<Awaited<ReturnType<typeof createAppConfig>>>;
export type CreateAppConfigMutationBody = CreateAppConfigRequest;
export type CreateAppConfigMutationError = ErrorType<void>;

export const useCreateAppConfig = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAppConfig>>,
    TError,
    { data: CreateAppConfigRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createAppConfig>>,
  TError,
  { data: CreateAppConfigRequest },
  TContext
> => {
  const mutationOptions = getCreateAppConfigMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getByIdAppConfig = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<AppConfigResponse>(
    { url: `/back-api/api/v1/app-config/${id}`, method: 'GET', signal },
    options
  );
};

export const getGetByIdAppConfigQueryKey = (id: string) => {
  return [`/back-api/api/v1/app-config/${id}`] as const;
};

export const getGetByIdAppConfigQueryOptions = <
  TData = Awaited<ReturnType<typeof getByIdAppConfig>>,
  TError = ErrorType<void>
>(
  id: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getByIdAppConfig>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetByIdAppConfigQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getByIdAppConfig>>> = ({ signal }) =>
    getByIdAppConfig(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getByIdAppConfig>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetByIdAppConfigQueryResult = NonNullable<Awaited<ReturnType<typeof getByIdAppConfig>>>;
export type GetByIdAppConfigQueryError = ErrorType<void>;

export function useGetByIdAppConfig<TData = Awaited<ReturnType<typeof getByIdAppConfig>>, TError = ErrorType<void>>(
  id: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getByIdAppConfig>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetByIdAppConfigQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const updateAppConfig = (
  id: string,
  updateAppConfigRequest: UpdateAppConfigRequest,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<AppConfigResponse>(
    {
      url: `/back-api/api/v1/app-config/${id}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: updateAppConfigRequest,
    },
    options
  );
};

export const getUpdateAppConfigMutationOptions = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAppConfig>>,
    TError,
    { id: string; data: UpdateAppConfigRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateAppConfig>>,
  TError,
  { id: string; data: UpdateAppConfigRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateAppConfig>>,
    { id: string; data: UpdateAppConfigRequest }
  > = props => {
    const { id, data } = props ?? {};

    return updateAppConfig(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateAppConfigMutationResult = NonNullable<Awaited<ReturnType<typeof updateAppConfig>>>;
export type UpdateAppConfigMutationBody = UpdateAppConfigRequest;
export type UpdateAppConfigMutationError = ErrorType<void>;

export const useUpdateAppConfig = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAppConfig>>,
    TError,
    { id: string; data: UpdateAppConfigRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateAppConfig>>,
  TError,
  { id: string; data: UpdateAppConfigRequest },
  TContext
> => {
  const mutationOptions = getUpdateAppConfigMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getByKeyAppConfig = (
  key: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<AppConfigResponse>(
    { url: `/back-api/api/v1/app-config/${key}`, method: 'GET', signal },
    options
  );
};

export const getGetByKeyAppConfigQueryKey = (key: string) => {
  return [`/back-api/api/v1/app-config/${key}`] as const;
};

export const getGetByKeyAppConfigQueryOptions = <
  TData = Awaited<ReturnType<typeof getByKeyAppConfig>>,
  TError = ErrorType<void>
>(
  key: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getByKeyAppConfig>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetByKeyAppConfigQueryKey(key);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getByKeyAppConfig>>> = ({ signal }) =>
    getByKeyAppConfig(key, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!key, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getByKeyAppConfig>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetByKeyAppConfigQueryResult = NonNullable<Awaited<ReturnType<typeof getByKeyAppConfig>>>;
export type GetByKeyAppConfigQueryError = ErrorType<void>;

export function useGetByKeyAppConfig<TData = Awaited<ReturnType<typeof getByKeyAppConfig>>, TError = ErrorType<void>>(
  key: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getByKeyAppConfig>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetByKeyAppConfigQueryOptions(key, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * <br>
  <b>Behavior</b>

<br>- If asset_type is Commodity, also saves commodity data.
<br>- Saves per-blockchain token configs from blockchain_configs.
<br>- Publishes an AssetUpdateMessage after successful creation.
<br></para>
<para>
  <b>Parameters (CreateAssetRequest)</b>

<br>- id (string, required): lowercase letters and numbers only; length 1–8.
<br>- name (string, required): length 1–50.
<br>- can_deposit (bool, required)
<br>- can_withdraw (bool, required)
<br>- withdrawal_fee (decimal, required): ≥ 0; if asset_type == Crypto then < min_withdraw.
<br>- scale (int, required): 1–18.
<br>- min_withdraw (decimal, required): > 0.
<br>- coingecko_id (string, optional): if provided, length 1–50.
<br>- confirmation_count (int, optional): if provided, ≥ 0.
<br>- asset_type (enum, required): valid AssetType value (e.g., Crypto, Fiat, Commodity).
<br>- commodity_asset (object): required if asset_type == Commodity; must be omitted otherwise. Fields include commodity_type, days_until_near_expiration, commodity_category, withdrawal_fee_asset_id (must reference an existing Crypto asset).
<br>- blockchain_configs (array, required): each item has blockchain_network, token_address, token_type, decimals, transfer_cost, can_deposit, can_withdraw, withdrawal_fee, min_withdraw, confirmation_count, and visibility (enum: Invisible/Visible/Internal; HTTP default Visible).
<br>- internal_withdrawal_fee_percent (decimal, optional): fraction for internal withdrawal fee (0 = no fee); must be >= 0 and < 1 (e.g. 0.01 = 1%).
<br>- maximum_internal_withdrawal_fee_fixed_amount (decimal, optional): maximum withdrawal fee cap in asset units (0 = unlimited); must be >= 0.
 * @summary Creates a new asset.
 */
export const createAsset = (
  createAssetRequest: CreateAssetRequest,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<AdminAssetResponse>(
    {
      url: `/back-api/backoffice/asset`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: createAssetRequest,
    },
    options
  );
};

export const getCreateAssetMutationOptions = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAsset>>,
    TError,
    { data: CreateAssetRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<Awaited<ReturnType<typeof createAsset>>, TError, { data: CreateAssetRequest }, TContext> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAsset>>, { data: CreateAssetRequest }> = props => {
    const { data } = props ?? {};

    return createAsset(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateAssetMutationResult = NonNullable<Awaited<ReturnType<typeof createAsset>>>;
export type CreateAssetMutationBody = CreateAssetRequest;
export type CreateAssetMutationError = ErrorType<void>;

/**
 * @summary Creates a new asset.
 */
export const useCreateAsset = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAsset>>,
    TError,
    { data: CreateAssetRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<Awaited<ReturnType<typeof createAsset>>, TError, { data: CreateAssetRequest }, TContext> => {
  const mutationOptions = getCreateAssetMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Let the admin set properties of an asset
 */
export const updateAsset = (
  assetId: string,
  assetRequest: AssetRequest,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<void>(
    {
      url: `/back-api/backoffice/asset/${assetId}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: assetRequest,
    },
    options
  );
};

export const getUpdateAssetMutationOptions = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAsset>>,
    TError,
    { assetId: string; data: AssetRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateAsset>>,
  TError,
  { assetId: string; data: AssetRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateAsset>>,
    { assetId: string; data: AssetRequest }
  > = props => {
    const { assetId, data } = props ?? {};

    return updateAsset(assetId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateAssetMutationResult = NonNullable<Awaited<ReturnType<typeof updateAsset>>>;
export type UpdateAssetMutationBody = AssetRequest;
export type UpdateAssetMutationError = ErrorType<void>;

/**
 * @summary Let the admin set properties of an asset
 */
export const useUpdateAsset = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAsset>>,
    TError,
    { assetId: string; data: AssetRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateAsset>>,
  TError,
  { assetId: string; data: AssetRequest },
  TContext
> => {
  const mutationOptions = getUpdateAssetMutationOptions(options);

  return useMutation(mutationOptions);
};

export const updateAssetType = (id: string, assetType: AssetType, options?: SecondParameter<typeof customInstance>) => {
  return customInstance<void>({ url: `/back-api/backoffice/asset/${id}/${assetType}`, method: 'PUT' }, options);
};

export const getUpdateAssetTypeMutationOptions = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAssetType>>,
    TError,
    { id: string; assetType: AssetType },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateAssetType>>,
  TError,
  { id: string; assetType: AssetType },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateAssetType>>,
    { id: string; assetType: AssetType }
  > = props => {
    const { id, assetType } = props ?? {};

    return updateAssetType(id, assetType, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateAssetTypeMutationResult = NonNullable<Awaited<ReturnType<typeof updateAssetType>>>;

export type UpdateAssetTypeMutationError = ErrorType<void>;

export const useUpdateAssetType = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAssetType>>,
    TError,
    { id: string; assetType: AssetType },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateAssetType>>,
  TError,
  { id: string; assetType: AssetType },
  TContext
> => {
  const mutationOptions = getUpdateAssetTypeMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteAsset = (id: string, options?: SecondParameter<typeof customInstance>) => {
  return customInstance<void>({ url: `/back-api/backoffice/asset/${id}`, method: 'DELETE' }, options);
};

export const getDeleteAssetMutationOptions = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof deleteAsset>>, TError, { id: string }, TContext>;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<Awaited<ReturnType<typeof deleteAsset>>, TError, { id: string }, TContext> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAsset>>, { id: string }> = props => {
    const { id } = props ?? {};

    return deleteAsset(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteAssetMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAsset>>>;

export type DeleteAssetMutationError = ErrorType<void>;

export const useDeleteAsset = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof deleteAsset>>, TError, { id: string }, TContext>;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<Awaited<ReturnType<typeof deleteAsset>>, TError, { id: string }, TContext> => {
  const mutationOptions = getDeleteAssetMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Gets list of all assets.
 */
export const getAdminAssets = (options?: SecondParameter<typeof customInstance>, signal?: AbortSignal) => {
  return customInstance<AdminAssetResponse[]>(
    { url: `/back-api/backoffice/asset-list`, method: 'GET', signal },
    options
  );
};

export const getGetAdminAssetsQueryKey = () => {
  return [`/back-api/backoffice/asset-list`] as const;
};

export const getGetAdminAssetsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAdminAssets>>,
  TError = ErrorType<void>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getAdminAssets>>, TError, TData>;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAdminAssetsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminAssets>>> = ({ signal }) =>
    getAdminAssets(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAdminAssets>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAdminAssetsQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminAssets>>>;
export type GetAdminAssetsQueryError = ErrorType<void>;

/**
 * @summary Gets list of all assets.
 */

export function useGetAdminAssets<
  TData = Awaited<ReturnType<typeof getAdminAssets>>,
  TError = ErrorType<void>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getAdminAssets>>, TError, TData>;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetAdminAssetsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Fetches Core Blockchain smart-contract metadata from Blockindex (proxied to avoid browser CORS).
 */
export const getSmartContractInfoAsset = (
  address: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<SmartContractInfoResponse>(
    { url: `/back-api/backoffice/asset/coreblockchain/smart-contract/${address}`, method: 'GET', signal },
    options
  );
};

export const getGetSmartContractInfoAssetQueryKey = (address: string) => {
  return [`/back-api/backoffice/asset/coreblockchain/smart-contract/${address}`] as const;
};

export const getGetSmartContractInfoAssetQueryOptions = <
  TData = Awaited<ReturnType<typeof getSmartContractInfoAsset>>,
  TError = ErrorType<void>
>(
  address: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getSmartContractInfoAsset>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSmartContractInfoAssetQueryKey(address);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSmartContractInfoAsset>>> = ({ signal }) =>
    getSmartContractInfoAsset(address, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!address, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSmartContractInfoAsset>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetSmartContractInfoAssetQueryResult = NonNullable<Awaited<ReturnType<typeof getSmartContractInfoAsset>>>;
export type GetSmartContractInfoAssetQueryError = ErrorType<void>;

/**
 * @summary Fetches Core Blockchain smart-contract metadata from Blockindex (proxied to avoid browser CORS).
 */

export function useGetSmartContractInfoAsset<
  TData = Awaited<ReturnType<typeof getSmartContractInfoAsset>>,
  TError = ErrorType<void>
>(
  address: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getSmartContractInfoAsset>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetSmartContractInfoAssetQueryOptions(address, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getListByAssetIdAssetContract = (
  assetId: string,
  params?: GetListByAssetIdAssetContractParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<AssetContractResponse[]>(
    { url: `/back-api/api/v1/asset-contract/${assetId}`, method: 'GET', params, signal },
    options
  );
};

export const getGetListByAssetIdAssetContractQueryKey = (
  assetId: string,
  params?: GetListByAssetIdAssetContractParams
) => {
  return [`/back-api/api/v1/asset-contract/${assetId}`, ...(params ? [params] : [])] as const;
};

export const getGetListByAssetIdAssetContractQueryOptions = <
  TData = Awaited<ReturnType<typeof getListByAssetIdAssetContract>>,
  TError = ErrorType<void>
>(
  assetId: string,
  params?: GetListByAssetIdAssetContractParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getListByAssetIdAssetContract>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetListByAssetIdAssetContractQueryKey(assetId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getListByAssetIdAssetContract>>> = ({ signal }) =>
    getListByAssetIdAssetContract(assetId, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!assetId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getListByAssetIdAssetContract>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetListByAssetIdAssetContractQueryResult = NonNullable<
  Awaited<ReturnType<typeof getListByAssetIdAssetContract>>
>;
export type GetListByAssetIdAssetContractQueryError = ErrorType<void>;

export function useGetListByAssetIdAssetContract<
  TData = Awaited<ReturnType<typeof getListByAssetIdAssetContract>>,
  TError = ErrorType<void>
>(
  assetId: string,
  params?: GetListByAssetIdAssetContractParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getListByAssetIdAssetContract>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetListByAssetIdAssetContractQueryOptions(assetId, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getLatestByAssetIdAssetContract = (
  assetId: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<AssetContractResponse>(
    { url: `/back-api/api/v1/asset-contract/latest/${assetId}`, method: 'GET', signal },
    options
  );
};

export const getGetLatestByAssetIdAssetContractQueryKey = (assetId: string) => {
  return [`/back-api/api/v1/asset-contract/latest/${assetId}`] as const;
};

export const getGetLatestByAssetIdAssetContractQueryOptions = <
  TData = Awaited<ReturnType<typeof getLatestByAssetIdAssetContract>>,
  TError = ErrorType<void>
>(
  assetId: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getLatestByAssetIdAssetContract>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetLatestByAssetIdAssetContractQueryKey(assetId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getLatestByAssetIdAssetContract>>> = ({ signal }) =>
    getLatestByAssetIdAssetContract(assetId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!assetId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getLatestByAssetIdAssetContract>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetLatestByAssetIdAssetContractQueryResult = NonNullable<
  Awaited<ReturnType<typeof getLatestByAssetIdAssetContract>>
>;
export type GetLatestByAssetIdAssetContractQueryError = ErrorType<void>;

export function useGetLatestByAssetIdAssetContract<
  TData = Awaited<ReturnType<typeof getLatestByAssetIdAssetContract>>,
  TError = ErrorType<void>
>(
  assetId: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getLatestByAssetIdAssetContract>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetLatestByAssetIdAssetContractQueryOptions(assetId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const createAssetContract = (
  createAssetContractRequest: CreateAssetContractRequest,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<AssetContractResponse>(
    {
      url: `/back-api/api/v1/asset-contract`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: createAssetContractRequest,
    },
    options
  );
};

export const getCreateAssetContractMutationOptions = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAssetContract>>,
    TError,
    { data: CreateAssetContractRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createAssetContract>>,
  TError,
  { data: CreateAssetContractRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createAssetContract>>,
    { data: CreateAssetContractRequest }
  > = props => {
    const { data } = props ?? {};

    return createAssetContract(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateAssetContractMutationResult = NonNullable<Awaited<ReturnType<typeof createAssetContract>>>;
export type CreateAssetContractMutationBody = CreateAssetContractRequest;
export type CreateAssetContractMutationError = ErrorType<void>;

export const useCreateAssetContract = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAssetContract>>,
    TError,
    { data: CreateAssetContractRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createAssetContract>>,
  TError,
  { data: CreateAssetContractRequest },
  TContext
> => {
  const mutationOptions = getCreateAssetContractMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getAllSignedAssetContract = (
  assetId: string,
  params?: GetAllSignedAssetContractParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<AssetContractSignatureResponse>(
    { url: `/back-api/api/v1/asset-contract/signed-list/${assetId}`, method: 'GET', params, signal },
    options
  );
};

export const getGetAllSignedAssetContractQueryKey = (assetId: string, params?: GetAllSignedAssetContractParams) => {
  return [`/back-api/api/v1/asset-contract/signed-list/${assetId}`, ...(params ? [params] : [])] as const;
};

export const getGetAllSignedAssetContractQueryOptions = <
  TData = Awaited<ReturnType<typeof getAllSignedAssetContract>>,
  TError = ErrorType<void>
>(
  assetId: string,
  params?: GetAllSignedAssetContractParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getAllSignedAssetContract>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAllSignedAssetContractQueryKey(assetId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllSignedAssetContract>>> = ({ signal }) =>
    getAllSignedAssetContract(assetId, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!assetId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAllSignedAssetContract>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAllSignedAssetContractQueryResult = NonNullable<Awaited<ReturnType<typeof getAllSignedAssetContract>>>;
export type GetAllSignedAssetContractQueryError = ErrorType<void>;

export function useGetAllSignedAssetContract<
  TData = Awaited<ReturnType<typeof getAllSignedAssetContract>>,
  TError = ErrorType<void>
>(
  assetId: string,
  params?: GetAllSignedAssetContractParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getAllSignedAssetContract>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetAllSignedAssetContractQueryOptions(assetId, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getAllSignedForUserAssetContract = (
  assetId: string,
  params?: GetAllSignedForUserAssetContractParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<AssetContractSignatureResponse>(
    { url: `/back-api/api/v1/asset-contract/signed-for-user/${assetId}`, method: 'GET', params, signal },
    options
  );
};

export const getGetAllSignedForUserAssetContractQueryKey = (
  assetId: string,
  params?: GetAllSignedForUserAssetContractParams
) => {
  return [`/back-api/api/v1/asset-contract/signed-for-user/${assetId}`, ...(params ? [params] : [])] as const;
};

export const getGetAllSignedForUserAssetContractQueryOptions = <
  TData = Awaited<ReturnType<typeof getAllSignedForUserAssetContract>>,
  TError = ErrorType<void>
>(
  assetId: string,
  params?: GetAllSignedForUserAssetContractParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getAllSignedForUserAssetContract>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAllSignedForUserAssetContractQueryKey(assetId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllSignedForUserAssetContract>>> = ({ signal }) =>
    getAllSignedForUserAssetContract(assetId, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!assetId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAllSignedForUserAssetContract>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAllSignedForUserAssetContractQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAllSignedForUserAssetContract>>
>;
export type GetAllSignedForUserAssetContractQueryError = ErrorType<void>;

export function useGetAllSignedForUserAssetContract<
  TData = Awaited<ReturnType<typeof getAllSignedForUserAssetContract>>,
  TError = ErrorType<void>
>(
  assetId: string,
  params?: GetAllSignedForUserAssetContractParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getAllSignedForUserAssetContract>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetAllSignedForUserAssetContractQueryOptions(assetId, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getListAssetRegistration = (
  params?: GetListAssetRegistrationParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<AssetRegistrationResponseFilteredResponse>(
    { url: `/back-api/api/v1/asset-registration`, method: 'GET', params, signal },
    options
  );
};

export const getGetListAssetRegistrationQueryKey = (params?: GetListAssetRegistrationParams) => {
  return [`/back-api/api/v1/asset-registration`, ...(params ? [params] : [])] as const;
};

export const getGetListAssetRegistrationQueryOptions = <
  TData = Awaited<ReturnType<typeof getListAssetRegistration>>,
  TError = ErrorType<void>
>(
  params?: GetListAssetRegistrationParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getListAssetRegistration>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetListAssetRegistrationQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getListAssetRegistration>>> = ({ signal }) =>
    getListAssetRegistration(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getListAssetRegistration>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetListAssetRegistrationQueryResult = NonNullable<Awaited<ReturnType<typeof getListAssetRegistration>>>;
export type GetListAssetRegistrationQueryError = ErrorType<void>;

export function useGetListAssetRegistration<
  TData = Awaited<ReturnType<typeof getListAssetRegistration>>,
  TError = ErrorType<void>
>(
  params?: GetListAssetRegistrationParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getListAssetRegistration>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetListAssetRegistrationQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const createAssetRegistration = (
  createAssetRegistrationRequest: CreateAssetRegistrationRequest,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<AssetRegistrationResponse>(
    {
      url: `/back-api/api/v1/asset-registration`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: createAssetRegistrationRequest,
    },
    options
  );
};

export const getCreateAssetRegistrationMutationOptions = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAssetRegistration>>,
    TError,
    { data: CreateAssetRegistrationRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createAssetRegistration>>,
  TError,
  { data: CreateAssetRegistrationRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createAssetRegistration>>,
    { data: CreateAssetRegistrationRequest }
  > = props => {
    const { data } = props ?? {};

    return createAssetRegistration(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateAssetRegistrationMutationResult = NonNullable<Awaited<ReturnType<typeof createAssetRegistration>>>;
export type CreateAssetRegistrationMutationBody = CreateAssetRegistrationRequest;
export type CreateAssetRegistrationMutationError = ErrorType<void>;

export const useCreateAssetRegistration = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAssetRegistration>>,
    TError,
    { data: CreateAssetRegistrationRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createAssetRegistration>>,
  TError,
  { data: CreateAssetRegistrationRequest },
  TContext
> => {
  const mutationOptions = getCreateAssetRegistrationMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getAssetRegistration = (
  id: string,
  params?: GetAssetRegistrationParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<AssetRegistrationResponse>(
    { url: `/back-api/api/v1/asset-registration/${id}`, method: 'GET', params, signal },
    options
  );
};

export const getGetAssetRegistrationQueryKey = (id: string, params?: GetAssetRegistrationParams) => {
  return [`/back-api/api/v1/asset-registration/${id}`, ...(params ? [params] : [])] as const;
};

export const getGetAssetRegistrationQueryOptions = <
  TData = Awaited<ReturnType<typeof getAssetRegistration>>,
  TError = ErrorType<void>
>(
  id: string,
  params?: GetAssetRegistrationParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getAssetRegistration>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAssetRegistrationQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAssetRegistration>>> = ({ signal }) =>
    getAssetRegistration(id, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAssetRegistration>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAssetRegistrationQueryResult = NonNullable<Awaited<ReturnType<typeof getAssetRegistration>>>;
export type GetAssetRegistrationQueryError = ErrorType<void>;

export function useGetAssetRegistration<
  TData = Awaited<ReturnType<typeof getAssetRegistration>>,
  TError = ErrorType<void>
>(
  id: string,
  params?: GetAssetRegistrationParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getAssetRegistration>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetAssetRegistrationQueryOptions(id, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const approveAssetRegistration = (id: string, options?: SecondParameter<typeof customInstance>) => {
  return customInstance<AdminAssetResponse>(
    { url: `/back-api/api/v1/asset-registration/approve/${id}`, method: 'PUT' },
    options
  );
};

export const getApproveAssetRegistrationMutationOptions = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof approveAssetRegistration>>, TError, { id: string }, TContext>;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<Awaited<ReturnType<typeof approveAssetRegistration>>, TError, { id: string }, TContext> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof approveAssetRegistration>>, { id: string }> = props => {
    const { id } = props ?? {};

    return approveAssetRegistration(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApproveAssetRegistrationMutationResult = NonNullable<Awaited<ReturnType<typeof approveAssetRegistration>>>;

export type ApproveAssetRegistrationMutationError = ErrorType<void>;

export const useApproveAssetRegistration = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof approveAssetRegistration>>, TError, { id: string }, TContext>;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<Awaited<ReturnType<typeof approveAssetRegistration>>, TError, { id: string }, TContext> => {
  const mutationOptions = getApproveAssetRegistrationMutationOptions(options);

  return useMutation(mutationOptions);
};

export const rejectAssetRegistration = (
  id: string,
  rejectAssetRegistration: RejectAssetRegistration,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<AssetRegistrationResponse>(
    {
      url: `/back-api/api/v1/asset-registration/reject/${id}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: rejectAssetRegistration,
    },
    options
  );
};

export const getRejectAssetRegistrationMutationOptions = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof rejectAssetRegistration>>,
    TError,
    { id: string; data: RejectAssetRegistration },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof rejectAssetRegistration>>,
  TError,
  { id: string; data: RejectAssetRegistration },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof rejectAssetRegistration>>,
    { id: string; data: RejectAssetRegistration }
  > = props => {
    const { id, data } = props ?? {};

    return rejectAssetRegistration(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RejectAssetRegistrationMutationResult = NonNullable<Awaited<ReturnType<typeof rejectAssetRegistration>>>;
export type RejectAssetRegistrationMutationBody = RejectAssetRegistration;
export type RejectAssetRegistrationMutationError = ErrorType<void>;

export const useRejectAssetRegistration = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof rejectAssetRegistration>>,
    TError,
    { id: string; data: RejectAssetRegistration },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof rejectAssetRegistration>>,
  TError,
  { id: string; data: RejectAssetRegistration },
  TContext
> => {
  const mutationOptions = getRejectAssetRegistrationMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Get balances for specific payment system.
 */
export const balancesBalanceAggregator = (
  paymentSystem: string,
  params?: BalancesBalanceAggregatorParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<void>(
    { url: `/back-api/api/v2/wallets/aggregation/balances/${paymentSystem}`, method: 'GET', params, signal },
    options
  );
};

export const getBalancesBalanceAggregatorQueryKey = (
  paymentSystem: string,
  params?: BalancesBalanceAggregatorParams
) => {
  return [`/back-api/api/v2/wallets/aggregation/balances/${paymentSystem}`, ...(params ? [params] : [])] as const;
};

export const getBalancesBalanceAggregatorQueryOptions = <
  TData = Awaited<ReturnType<typeof balancesBalanceAggregator>>,
  TError = ErrorType<void>
>(
  paymentSystem: string,
  params?: BalancesBalanceAggregatorParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof balancesBalanceAggregator>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getBalancesBalanceAggregatorQueryKey(paymentSystem, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof balancesBalanceAggregator>>> = ({ signal }) =>
    balancesBalanceAggregator(paymentSystem, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!paymentSystem, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof balancesBalanceAggregator>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type BalancesBalanceAggregatorQueryResult = NonNullable<Awaited<ReturnType<typeof balancesBalanceAggregator>>>;
export type BalancesBalanceAggregatorQueryError = ErrorType<void>;

/**
 * @summary Get balances for specific payment system.
 */

export function useBalancesBalanceAggregator<
  TData = Awaited<ReturnType<typeof balancesBalanceAggregator>>,
  TError = ErrorType<void>
>(
  paymentSystem: string,
  params?: BalancesBalanceAggregatorParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof balancesBalanceAggregator>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getBalancesBalanceAggregatorQueryOptions(paymentSystem, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get nft tokens for specific payment system.
 */
export const balancesNftTokensBalanceAggregator = (
  paymentSystem: string,
  params?: BalancesNftTokensBalanceAggregatorParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<void>(
    { url: `/back-api/api/v2/wallets/aggregation/balances-nft-tokens/${paymentSystem}`, method: 'GET', params, signal },
    options
  );
};

export const getBalancesNftTokensBalanceAggregatorQueryKey = (
  paymentSystem: string,
  params?: BalancesNftTokensBalanceAggregatorParams
) => {
  return [
    `/back-api/api/v2/wallets/aggregation/balances-nft-tokens/${paymentSystem}`,
    ...(params ? [params] : []),
  ] as const;
};

export const getBalancesNftTokensBalanceAggregatorQueryOptions = <
  TData = Awaited<ReturnType<typeof balancesNftTokensBalanceAggregator>>,
  TError = ErrorType<void>
>(
  paymentSystem: string,
  params?: BalancesNftTokensBalanceAggregatorParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof balancesNftTokensBalanceAggregator>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getBalancesNftTokensBalanceAggregatorQueryKey(paymentSystem, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof balancesNftTokensBalanceAggregator>>> = ({ signal }) =>
    balancesNftTokensBalanceAggregator(paymentSystem, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!paymentSystem, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof balancesNftTokensBalanceAggregator>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type BalancesNftTokensBalanceAggregatorQueryResult = NonNullable<
  Awaited<ReturnType<typeof balancesNftTokensBalanceAggregator>>
>;
export type BalancesNftTokensBalanceAggregatorQueryError = ErrorType<void>;

/**
 * @summary Get nft tokens for specific payment system.
 */

export function useBalancesNftTokensBalanceAggregator<
  TData = Awaited<ReturnType<typeof balancesNftTokensBalanceAggregator>>,
  TError = ErrorType<void>
>(
  paymentSystem: string,
  params?: BalancesNftTokensBalanceAggregatorParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof balancesNftTokensBalanceAggregator>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getBalancesNftTokensBalanceAggregatorQueryOptions(paymentSystem, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get ft commodity for the provided payment system.
 */
export const balancesFtCommodityBalanceAggregator = (
  paymentSystem: string,
  params?: BalancesFtCommodityBalanceAggregatorParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<FtCommodityBalanceResponse[]>(
    {
      url: `/back-api/api/v2/wallets/aggregation/balances-ft-commodity/${paymentSystem}`,
      method: 'GET',
      params,
      signal,
    },
    options
  );
};

export const getBalancesFtCommodityBalanceAggregatorQueryKey = (
  paymentSystem: string,
  params?: BalancesFtCommodityBalanceAggregatorParams
) => {
  return [
    `/back-api/api/v2/wallets/aggregation/balances-ft-commodity/${paymentSystem}`,
    ...(params ? [params] : []),
  ] as const;
};

export const getBalancesFtCommodityBalanceAggregatorQueryOptions = <
  TData = Awaited<ReturnType<typeof balancesFtCommodityBalanceAggregator>>,
  TError = ErrorType<void>
>(
  paymentSystem: string,
  params?: BalancesFtCommodityBalanceAggregatorParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof balancesFtCommodityBalanceAggregator>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getBalancesFtCommodityBalanceAggregatorQueryKey(paymentSystem, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof balancesFtCommodityBalanceAggregator>>> = ({ signal }) =>
    balancesFtCommodityBalanceAggregator(paymentSystem, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!paymentSystem, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof balancesFtCommodityBalanceAggregator>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type BalancesFtCommodityBalanceAggregatorQueryResult = NonNullable<
  Awaited<ReturnType<typeof balancesFtCommodityBalanceAggregator>>
>;
export type BalancesFtCommodityBalanceAggregatorQueryError = ErrorType<void>;

/**
 * @summary Get ft commodity for the provided payment system.
 */

export function useBalancesFtCommodityBalanceAggregator<
  TData = Awaited<ReturnType<typeof balancesFtCommodityBalanceAggregator>>,
  TError = ErrorType<void>
>(
  paymentSystem: string,
  params?: BalancesFtCommodityBalanceAggregatorParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof balancesFtCommodityBalanceAggregator>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getBalancesFtCommodityBalanceAggregatorQueryOptions(paymentSystem, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Aggregate balances to transfers.
 */
export const aggregateBalanceAggregator = (
  balanceAggregateRequest: BalanceAggregateRequest[],
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<void>(
    {
      url: `/back-api/api/v2/wallets/aggregation/aggregate`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: balanceAggregateRequest,
    },
    options
  );
};

export const getAggregateBalanceAggregatorMutationOptions = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof aggregateBalanceAggregator>>,
    TError,
    { data: BalanceAggregateRequest[] },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof aggregateBalanceAggregator>>,
  TError,
  { data: BalanceAggregateRequest[] },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof aggregateBalanceAggregator>>,
    { data: BalanceAggregateRequest[] }
  > = props => {
    const { data } = props ?? {};

    return aggregateBalanceAggregator(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AggregateBalanceAggregatorMutationResult = NonNullable<
  Awaited<ReturnType<typeof aggregateBalanceAggregator>>
>;
export type AggregateBalanceAggregatorMutationBody = BalanceAggregateRequest[];
export type AggregateBalanceAggregatorMutationError = ErrorType<void>;

/**
 * @summary Aggregate balances to transfers.
 */
export const useAggregateBalanceAggregator = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof aggregateBalanceAggregator>>,
    TError,
    { data: BalanceAggregateRequest[] },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof aggregateBalanceAggregator>>,
  TError,
  { data: BalanceAggregateRequest[] },
  TContext
> => {
  const mutationOptions = getAggregateBalanceAggregatorMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Aggregate nft tokens to transfers.
 */
export const nftAggregateBalanceAggregator = (
  balanceAggregateRequest: BalanceAggregateRequest[],
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<void>(
    {
      url: `/back-api/api/v2/wallets/aggregation/nft-aggregate`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: balanceAggregateRequest,
    },
    options
  );
};

export const getNftAggregateBalanceAggregatorMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof nftAggregateBalanceAggregator>>,
    TError,
    { data: BalanceAggregateRequest[] },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof nftAggregateBalanceAggregator>>,
  TError,
  { data: BalanceAggregateRequest[] },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof nftAggregateBalanceAggregator>>,
    { data: BalanceAggregateRequest[] }
  > = props => {
    const { data } = props ?? {};

    return nftAggregateBalanceAggregator(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type NftAggregateBalanceAggregatorMutationResult = NonNullable<
  Awaited<ReturnType<typeof nftAggregateBalanceAggregator>>
>;
export type NftAggregateBalanceAggregatorMutationBody = BalanceAggregateRequest[];
export type NftAggregateBalanceAggregatorMutationError = ErrorType<void>;

/**
 * @summary Aggregate nft tokens to transfers.
 */
export const useNftAggregateBalanceAggregator = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof nftAggregateBalanceAggregator>>,
    TError,
    { data: BalanceAggregateRequest[] },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof nftAggregateBalanceAggregator>>,
  TError,
  { data: BalanceAggregateRequest[] },
  TContext
> => {
  const mutationOptions = getNftAggregateBalanceAggregatorMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Aggregate ft commodity assets to transfers.
 */
export const aggregateFtCommodityBalanceAggregator = (
  ftCommodityBalanceAggregateRequest: FtCommodityBalanceAggregateRequest,
  params?: AggregateFtCommodityBalanceAggregatorParams,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<void>(
    {
      url: `/back-api/api/v2/wallets/aggregation/aggregate-ft-commodity`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: ftCommodityBalanceAggregateRequest,
      params,
    },
    options
  );
};

export const getAggregateFtCommodityBalanceAggregatorMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof aggregateFtCommodityBalanceAggregator>>,
    TError,
    { data: FtCommodityBalanceAggregateRequest; params?: AggregateFtCommodityBalanceAggregatorParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof aggregateFtCommodityBalanceAggregator>>,
  TError,
  { data: FtCommodityBalanceAggregateRequest; params?: AggregateFtCommodityBalanceAggregatorParams },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof aggregateFtCommodityBalanceAggregator>>,
    { data: FtCommodityBalanceAggregateRequest; params?: AggregateFtCommodityBalanceAggregatorParams }
  > = props => {
    const { data, params } = props ?? {};

    return aggregateFtCommodityBalanceAggregator(data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AggregateFtCommodityBalanceAggregatorMutationResult = NonNullable<
  Awaited<ReturnType<typeof aggregateFtCommodityBalanceAggregator>>
>;
export type AggregateFtCommodityBalanceAggregatorMutationBody = FtCommodityBalanceAggregateRequest;
export type AggregateFtCommodityBalanceAggregatorMutationError = ErrorType<void>;

/**
 * @summary Aggregate ft commodity assets to transfers.
 */
export const useAggregateFtCommodityBalanceAggregator = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof aggregateFtCommodityBalanceAggregator>>,
    TError,
    { data: FtCommodityBalanceAggregateRequest; params?: AggregateFtCommodityBalanceAggregatorParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof aggregateFtCommodityBalanceAggregator>>,
  TError,
  { data: FtCommodityBalanceAggregateRequest; params?: AggregateFtCommodityBalanceAggregatorParams },
  TContext
> => {
  const mutationOptions = getAggregateFtCommodityBalanceAggregatorMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * aggregate-sponser/{token} api was merged into this api
 * @summary Aggregate token balances to transfers
 */
export const aggregateTokenBalanceAggregator = (
  token: string,
  balanceAggregateRequest: BalanceAggregateRequest[],
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<void>(
    {
      url: `/back-api/api/v2/wallets/aggregation/aggregate-token/${token}`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: balanceAggregateRequest,
    },
    options
  );
};

export const getAggregateTokenBalanceAggregatorMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof aggregateTokenBalanceAggregator>>,
    TError,
    { token: string; data: BalanceAggregateRequest[] },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof aggregateTokenBalanceAggregator>>,
  TError,
  { token: string; data: BalanceAggregateRequest[] },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof aggregateTokenBalanceAggregator>>,
    { token: string; data: BalanceAggregateRequest[] }
  > = props => {
    const { token, data } = props ?? {};

    return aggregateTokenBalanceAggregator(token, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AggregateTokenBalanceAggregatorMutationResult = NonNullable<
  Awaited<ReturnType<typeof aggregateTokenBalanceAggregator>>
>;
export type AggregateTokenBalanceAggregatorMutationBody = BalanceAggregateRequest[];
export type AggregateTokenBalanceAggregatorMutationError = ErrorType<void>;

/**
 * @summary Aggregate token balances to transfers
 */
export const useAggregateTokenBalanceAggregator = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof aggregateTokenBalanceAggregator>>,
    TError,
    { token: string; data: BalanceAggregateRequest[] },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof aggregateTokenBalanceAggregator>>,
  TError,
  { token: string; data: BalanceAggregateRequest[] },
  TContext
> => {
  const mutationOptions = getAggregateTokenBalanceAggregatorMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Get sponser with his balances wich will pay for token transfers for specific payment system.
 */
export const sponserBalanceAggregator = (
  paymentSystem: string,
  params?: SponserBalanceAggregatorParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<void>(
    { url: `/back-api/api/v2/wallets/aggregation/sponser/${paymentSystem}`, method: 'GET', params, signal },
    options
  );
};

export const getSponserBalanceAggregatorQueryKey = (paymentSystem: string, params?: SponserBalanceAggregatorParams) => {
  return [`/back-api/api/v2/wallets/aggregation/sponser/${paymentSystem}`, ...(params ? [params] : [])] as const;
};

export const getSponserBalanceAggregatorQueryOptions = <
  TData = Awaited<ReturnType<typeof sponserBalanceAggregator>>,
  TError = ErrorType<void>
>(
  paymentSystem: string,
  params?: SponserBalanceAggregatorParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof sponserBalanceAggregator>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSponserBalanceAggregatorQueryKey(paymentSystem, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof sponserBalanceAggregator>>> = ({ signal }) =>
    sponserBalanceAggregator(paymentSystem, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!paymentSystem, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof sponserBalanceAggregator>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SponserBalanceAggregatorQueryResult = NonNullable<Awaited<ReturnType<typeof sponserBalanceAggregator>>>;
export type SponserBalanceAggregatorQueryError = ErrorType<void>;

/**
 * @summary Get sponser with his balances wich will pay for token transfers for specific payment system.
 */

export function useSponserBalanceAggregator<
  TData = Awaited<ReturnType<typeof sponserBalanceAggregator>>,
  TError = ErrorType<void>
>(
  paymentSystem: string,
  params?: SponserBalanceAggregatorParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof sponserBalanceAggregator>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getSponserBalanceAggregatorQueryOptions(paymentSystem, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Approve sponser for specific token and the balances wich will pay for token transfers.
 */
export const approveBalanceAggregator = (
  token: string,
  balanceAggregateRequest: BalanceAggregateRequest[],
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<void>(
    {
      url: `/back-api/api/v2/wallets/aggregation/approve/${token}`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: balanceAggregateRequest,
    },
    options
  );
};

export const getApproveBalanceAggregatorMutationOptions = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof approveBalanceAggregator>>,
    TError,
    { token: string; data: BalanceAggregateRequest[] },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof approveBalanceAggregator>>,
  TError,
  { token: string; data: BalanceAggregateRequest[] },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof approveBalanceAggregator>>,
    { token: string; data: BalanceAggregateRequest[] }
  > = props => {
    const { token, data } = props ?? {};

    return approveBalanceAggregator(token, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApproveBalanceAggregatorMutationResult = NonNullable<Awaited<ReturnType<typeof approveBalanceAggregator>>>;
export type ApproveBalanceAggregatorMutationBody = BalanceAggregateRequest[];
export type ApproveBalanceAggregatorMutationError = ErrorType<void>;

/**
 * @summary Approve sponser for specific token and the balances wich will pay for token transfers.
 */
export const useApproveBalanceAggregator = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof approveBalanceAggregator>>,
    TError,
    { token: string; data: BalanceAggregateRequest[] },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof approveBalanceAggregator>>,
  TError,
  { token: string; data: BalanceAggregateRequest[] },
  TContext
> => {
  const mutationOptions = getApproveBalanceAggregatorMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Broadcast the signed transfers to the blockchain network
 */
export const broadcastBalanceAggregator = (
  aggregationBroadcastRequest: AggregationBroadcastRequest,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<void>(
    {
      url: `/back-api/api/v2/wallets/aggregation/broadcast`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: aggregationBroadcastRequest,
    },
    options
  );
};

export const getBroadcastBalanceAggregatorMutationOptions = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof broadcastBalanceAggregator>>,
    TError,
    { data: AggregationBroadcastRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof broadcastBalanceAggregator>>,
  TError,
  { data: AggregationBroadcastRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof broadcastBalanceAggregator>>,
    { data: AggregationBroadcastRequest }
  > = props => {
    const { data } = props ?? {};

    return broadcastBalanceAggregator(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BroadcastBalanceAggregatorMutationResult = NonNullable<
  Awaited<ReturnType<typeof broadcastBalanceAggregator>>
>;
export type BroadcastBalanceAggregatorMutationBody = AggregationBroadcastRequest;
export type BroadcastBalanceAggregatorMutationError = ErrorType<void>;

/**
 * @summary Broadcast the signed transfers to the blockchain network
 */
export const useBroadcastBalanceAggregator = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof broadcastBalanceAggregator>>,
    TError,
    { data: AggregationBroadcastRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof broadcastBalanceAggregator>>,
  TError,
  { data: AggregationBroadcastRequest },
  TContext
> => {
  const mutationOptions = getBroadcastBalanceAggregatorMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Inject fuel to source addresses based on provided transactions
 */
export const injectFuelBalanceAggregator = (
  paymentSystem: string,
  injectFuelRequest: InjectFuelRequest,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<number>(
    {
      url: `/back-api/api/v2/wallets/aggregation/inject-fuel/${paymentSystem}`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: injectFuelRequest,
    },
    options
  );
};

export const getInjectFuelBalanceAggregatorMutationOptions = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof injectFuelBalanceAggregator>>,
    TError,
    { paymentSystem: string; data: InjectFuelRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof injectFuelBalanceAggregator>>,
  TError,
  { paymentSystem: string; data: InjectFuelRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof injectFuelBalanceAggregator>>,
    { paymentSystem: string; data: InjectFuelRequest }
  > = props => {
    const { paymentSystem, data } = props ?? {};

    return injectFuelBalanceAggregator(paymentSystem, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type InjectFuelBalanceAggregatorMutationResult = NonNullable<
  Awaited<ReturnType<typeof injectFuelBalanceAggregator>>
>;
export type InjectFuelBalanceAggregatorMutationBody = InjectFuelRequest;
export type InjectFuelBalanceAggregatorMutationError = ErrorType<void>;

/**
 * @summary Inject fuel to source addresses based on provided transactions
 */
export const useInjectFuelBalanceAggregator = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof injectFuelBalanceAggregator>>,
    TError,
    { paymentSystem: string; data: InjectFuelRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof injectFuelBalanceAggregator>>,
  TError,
  { paymentSystem: string; data: InjectFuelRequest },
  TContext
> => {
  const mutationOptions = getInjectFuelBalanceAggregatorMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Get inject fuel requests
 */
export const getInjectFuelsBalanceAggregator = (
  paymentSystem: string,
  params?: GetInjectFuelsBalanceAggregatorParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<GetInjectFuelsResponse>(
    { url: `/back-api/api/v2/wallets/aggregation/inject-fuel/${paymentSystem}`, method: 'GET', params, signal },
    options
  );
};

export const getGetInjectFuelsBalanceAggregatorQueryKey = (
  paymentSystem: string,
  params?: GetInjectFuelsBalanceAggregatorParams
) => {
  return [`/back-api/api/v2/wallets/aggregation/inject-fuel/${paymentSystem}`, ...(params ? [params] : [])] as const;
};

export const getGetInjectFuelsBalanceAggregatorQueryOptions = <
  TData = Awaited<ReturnType<typeof getInjectFuelsBalanceAggregator>>,
  TError = ErrorType<void>
>(
  paymentSystem: string,
  params?: GetInjectFuelsBalanceAggregatorParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getInjectFuelsBalanceAggregator>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetInjectFuelsBalanceAggregatorQueryKey(paymentSystem, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getInjectFuelsBalanceAggregator>>> = ({ signal }) =>
    getInjectFuelsBalanceAggregator(paymentSystem, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!paymentSystem, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getInjectFuelsBalanceAggregator>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetInjectFuelsBalanceAggregatorQueryResult = NonNullable<
  Awaited<ReturnType<typeof getInjectFuelsBalanceAggregator>>
>;
export type GetInjectFuelsBalanceAggregatorQueryError = ErrorType<void>;

/**
 * @summary Get inject fuel requests
 */

export function useGetInjectFuelsBalanceAggregator<
  TData = Awaited<ReturnType<typeof getInjectFuelsBalanceAggregator>>,
  TError = ErrorType<void>
>(
  paymentSystem: string,
  params?: GetInjectFuelsBalanceAggregatorParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getInjectFuelsBalanceAggregator>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetInjectFuelsBalanceAggregatorQueryOptions(paymentSystem, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get transactions for the provided inject fuel request
 */
export const getInjectFuelDetailBalanceAggregator = (
  id: number,
  params?: GetInjectFuelDetailBalanceAggregatorParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<GetInjectFuelDetailResponse>(
    { url: `/back-api/api/v2/wallets/aggregation/inject-fuel/detail/${id}`, method: 'GET', params, signal },
    options
  );
};

export const getGetInjectFuelDetailBalanceAggregatorQueryKey = (
  id: number,
  params?: GetInjectFuelDetailBalanceAggregatorParams
) => {
  return [`/back-api/api/v2/wallets/aggregation/inject-fuel/detail/${id}`, ...(params ? [params] : [])] as const;
};

export const getGetInjectFuelDetailBalanceAggregatorQueryOptions = <
  TData = Awaited<ReturnType<typeof getInjectFuelDetailBalanceAggregator>>,
  TError = ErrorType<void>
>(
  id: number,
  params?: GetInjectFuelDetailBalanceAggregatorParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getInjectFuelDetailBalanceAggregator>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetInjectFuelDetailBalanceAggregatorQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getInjectFuelDetailBalanceAggregator>>> = ({ signal }) =>
    getInjectFuelDetailBalanceAggregator(id, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getInjectFuelDetailBalanceAggregator>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetInjectFuelDetailBalanceAggregatorQueryResult = NonNullable<
  Awaited<ReturnType<typeof getInjectFuelDetailBalanceAggregator>>
>;
export type GetInjectFuelDetailBalanceAggregatorQueryError = ErrorType<void>;

/**
 * @summary Get transactions for the provided inject fuel request
 */

export function useGetInjectFuelDetailBalanceAggregator<
  TData = Awaited<ReturnType<typeof getInjectFuelDetailBalanceAggregator>>,
  TError = ErrorType<void>
>(
  id: number,
  params?: GetInjectFuelDetailBalanceAggregatorParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getInjectFuelDetailBalanceAggregator>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetInjectFuelDetailBalanceAggregatorQueryOptions(id, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Broadcast signed transactions on specified blockchain
 */
export const createBroadcastRequestBalanceAggregator = (
  paymentSystem: string,
  createBroadcastRequest: CreateBroadcastRequest,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<number>(
    {
      url: `/back-api/api/v2/wallets/aggregation/broadcast-request/${paymentSystem}`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: createBroadcastRequest,
    },
    options
  );
};

export const getCreateBroadcastRequestBalanceAggregatorMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createBroadcastRequestBalanceAggregator>>,
    TError,
    { paymentSystem: string; data: CreateBroadcastRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createBroadcastRequestBalanceAggregator>>,
  TError,
  { paymentSystem: string; data: CreateBroadcastRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createBroadcastRequestBalanceAggregator>>,
    { paymentSystem: string; data: CreateBroadcastRequest }
  > = props => {
    const { paymentSystem, data } = props ?? {};

    return createBroadcastRequestBalanceAggregator(paymentSystem, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateBroadcastRequestBalanceAggregatorMutationResult = NonNullable<
  Awaited<ReturnType<typeof createBroadcastRequestBalanceAggregator>>
>;
export type CreateBroadcastRequestBalanceAggregatorMutationBody = CreateBroadcastRequest;
export type CreateBroadcastRequestBalanceAggregatorMutationError = ErrorType<void>;

/**
 * @summary Broadcast signed transactions on specified blockchain
 */
export const useCreateBroadcastRequestBalanceAggregator = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createBroadcastRequestBalanceAggregator>>,
    TError,
    { paymentSystem: string; data: CreateBroadcastRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createBroadcastRequestBalanceAggregator>>,
  TError,
  { paymentSystem: string; data: CreateBroadcastRequest },
  TContext
> => {
  const mutationOptions = getCreateBroadcastRequestBalanceAggregatorMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Get broadcast requests
 */
export const getBroadcastRequestsBalanceAggregator = (
  paymentSystem: string,
  params?: GetBroadcastRequestsBalanceAggregatorParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<GetBroadcastRequestsResponse>(
    { url: `/back-api/api/v2/wallets/aggregation/broadcast-request/${paymentSystem}`, method: 'GET', params, signal },
    options
  );
};

export const getGetBroadcastRequestsBalanceAggregatorQueryKey = (
  paymentSystem: string,
  params?: GetBroadcastRequestsBalanceAggregatorParams
) => {
  return [
    `/back-api/api/v2/wallets/aggregation/broadcast-request/${paymentSystem}`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetBroadcastRequestsBalanceAggregatorQueryOptions = <
  TData = Awaited<ReturnType<typeof getBroadcastRequestsBalanceAggregator>>,
  TError = ErrorType<void>
>(
  paymentSystem: string,
  params?: GetBroadcastRequestsBalanceAggregatorParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getBroadcastRequestsBalanceAggregator>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetBroadcastRequestsBalanceAggregatorQueryKey(paymentSystem, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getBroadcastRequestsBalanceAggregator>>> = ({ signal }) =>
    getBroadcastRequestsBalanceAggregator(paymentSystem, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!paymentSystem, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getBroadcastRequestsBalanceAggregator>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetBroadcastRequestsBalanceAggregatorQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBroadcastRequestsBalanceAggregator>>
>;
export type GetBroadcastRequestsBalanceAggregatorQueryError = ErrorType<void>;

/**
 * @summary Get broadcast requests
 */

export function useGetBroadcastRequestsBalanceAggregator<
  TData = Awaited<ReturnType<typeof getBroadcastRequestsBalanceAggregator>>,
  TError = ErrorType<void>
>(
  paymentSystem: string,
  params?: GetBroadcastRequestsBalanceAggregatorParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getBroadcastRequestsBalanceAggregator>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetBroadcastRequestsBalanceAggregatorQueryOptions(paymentSystem, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get transactions for the provided broadcast request
 */
export const getBroadcastRequestDetailBalanceAggregator = (
  id: number,
  params?: GetBroadcastRequestDetailBalanceAggregatorParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<GetBroadcastRequestDetailResponse>(
    { url: `/back-api/api/v2/wallets/aggregation/broadcast-request/detail/${id}`, method: 'GET', params, signal },
    options
  );
};

export const getGetBroadcastRequestDetailBalanceAggregatorQueryKey = (
  id: number,
  params?: GetBroadcastRequestDetailBalanceAggregatorParams
) => {
  return [`/back-api/api/v2/wallets/aggregation/broadcast-request/detail/${id}`, ...(params ? [params] : [])] as const;
};

export const getGetBroadcastRequestDetailBalanceAggregatorQueryOptions = <
  TData = Awaited<ReturnType<typeof getBroadcastRequestDetailBalanceAggregator>>,
  TError = ErrorType<void>
>(
  id: number,
  params?: GetBroadcastRequestDetailBalanceAggregatorParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getBroadcastRequestDetailBalanceAggregator>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetBroadcastRequestDetailBalanceAggregatorQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getBroadcastRequestDetailBalanceAggregator>>> = ({ signal }) =>
    getBroadcastRequestDetailBalanceAggregator(id, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getBroadcastRequestDetailBalanceAggregator>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetBroadcastRequestDetailBalanceAggregatorQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBroadcastRequestDetailBalanceAggregator>>
>;
export type GetBroadcastRequestDetailBalanceAggregatorQueryError = ErrorType<void>;

/**
 * @summary Get transactions for the provided broadcast request
 */

export function useGetBroadcastRequestDetailBalanceAggregator<
  TData = Awaited<ReturnType<typeof getBroadcastRequestDetailBalanceAggregator>>,
  TError = ErrorType<void>
>(
  id: number,
  params?: GetBroadcastRequestDetailBalanceAggregatorParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getBroadcastRequestDetailBalanceAggregator>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetBroadcastRequestDetailBalanceAggregatorQueryOptions(id, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Roles: Admin
 * @summary Get the tag definitions for all bot gateway permission tags
 */
export const getTagsBotGatewayManagement = (options?: SecondParameter<typeof customInstance>, signal?: AbortSignal) => {
  return customInstance<AccountTagInfo[]>({ url: `/back-api/api/v3/bot-gateway/tags`, method: 'GET', signal }, options);
};

export const getGetTagsBotGatewayManagementQueryKey = () => {
  return [`/back-api/api/v3/bot-gateway/tags`] as const;
};

export const getGetTagsBotGatewayManagementQueryOptions = <
  TData = Awaited<ReturnType<typeof getTagsBotGatewayManagement>>,
  TError = ErrorType<void>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getTagsBotGatewayManagement>>, TError, TData>;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTagsBotGatewayManagementQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTagsBotGatewayManagement>>> = ({ signal }) =>
    getTagsBotGatewayManagement(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTagsBotGatewayManagement>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetTagsBotGatewayManagementQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTagsBotGatewayManagement>>
>;
export type GetTagsBotGatewayManagementQueryError = ErrorType<void>;

/**
 * @summary Get the tag definitions for all bot gateway permission tags
 */

export function useGetTagsBotGatewayManagement<
  TData = Awaited<ReturnType<typeof getTagsBotGatewayManagement>>,
  TError = ErrorType<void>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getTagsBotGatewayManagement>>, TError, TData>;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetTagsBotGatewayManagementQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Roles: Admin
 * @summary Grant bot gateway access to a user
 */
export const grantAccessBotGatewayManagement = (
  botGatewayGrantAccessRequest: BotGatewayGrantAccessRequest,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<void>(
    {
      url: `/back-api/api/v3/bot-gateway/access/grant`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: botGatewayGrantAccessRequest,
    },
    options
  );
};

export const getGrantAccessBotGatewayManagementMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof grantAccessBotGatewayManagement>>,
    TError,
    { data: BotGatewayGrantAccessRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof grantAccessBotGatewayManagement>>,
  TError,
  { data: BotGatewayGrantAccessRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof grantAccessBotGatewayManagement>>,
    { data: BotGatewayGrantAccessRequest }
  > = props => {
    const { data } = props ?? {};

    return grantAccessBotGatewayManagement(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GrantAccessBotGatewayManagementMutationResult = NonNullable<
  Awaited<ReturnType<typeof grantAccessBotGatewayManagement>>
>;
export type GrantAccessBotGatewayManagementMutationBody = BotGatewayGrantAccessRequest;
export type GrantAccessBotGatewayManagementMutationError = ErrorType<void>;

/**
 * @summary Grant bot gateway access to a user
 */
export const useGrantAccessBotGatewayManagement = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof grantAccessBotGatewayManagement>>,
    TError,
    { data: BotGatewayGrantAccessRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof grantAccessBotGatewayManagement>>,
  TError,
  { data: BotGatewayGrantAccessRequest },
  TContext
> => {
  const mutationOptions = getGrantAccessBotGatewayManagementMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Roles: Admin
 * @summary Revoke bot gateway access from a user
 */
export const revokeAccessBotGatewayManagement = (
  botGatewayRevokeAccessRequest: BotGatewayRevokeAccessRequest,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<void>(
    {
      url: `/back-api/api/v3/bot-gateway/access/revoke`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: botGatewayRevokeAccessRequest,
    },
    options
  );
};

export const getRevokeAccessBotGatewayManagementMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof revokeAccessBotGatewayManagement>>,
    TError,
    { data: BotGatewayRevokeAccessRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof revokeAccessBotGatewayManagement>>,
  TError,
  { data: BotGatewayRevokeAccessRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof revokeAccessBotGatewayManagement>>,
    { data: BotGatewayRevokeAccessRequest }
  > = props => {
    const { data } = props ?? {};

    return revokeAccessBotGatewayManagement(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RevokeAccessBotGatewayManagementMutationResult = NonNullable<
  Awaited<ReturnType<typeof revokeAccessBotGatewayManagement>>
>;
export type RevokeAccessBotGatewayManagementMutationBody = BotGatewayRevokeAccessRequest;
export type RevokeAccessBotGatewayManagementMutationError = ErrorType<void>;

/**
 * @summary Revoke bot gateway access from a user
 */
export const useRevokeAccessBotGatewayManagement = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof revokeAccessBotGatewayManagement>>,
    TError,
    { data: BotGatewayRevokeAccessRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof revokeAccessBotGatewayManagement>>,
  TError,
  { data: BotGatewayRevokeAccessRequest },
  TContext
> => {
  const mutationOptions = getRevokeAccessBotGatewayManagementMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Roles: Admin
 * @summary Grant a bot gateway permission tag to a user
 */
export const grantPermissionBotGatewayManagement = (
  botGatewayGrantPermissionRequest: BotGatewayGrantPermissionRequest,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<void>(
    {
      url: `/back-api/api/v3/bot-gateway/permission/grant`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: botGatewayGrantPermissionRequest,
    },
    options
  );
};

export const getGrantPermissionBotGatewayManagementMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof grantPermissionBotGatewayManagement>>,
    TError,
    { data: BotGatewayGrantPermissionRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof grantPermissionBotGatewayManagement>>,
  TError,
  { data: BotGatewayGrantPermissionRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof grantPermissionBotGatewayManagement>>,
    { data: BotGatewayGrantPermissionRequest }
  > = props => {
    const { data } = props ?? {};

    return grantPermissionBotGatewayManagement(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GrantPermissionBotGatewayManagementMutationResult = NonNullable<
  Awaited<ReturnType<typeof grantPermissionBotGatewayManagement>>
>;
export type GrantPermissionBotGatewayManagementMutationBody = BotGatewayGrantPermissionRequest;
export type GrantPermissionBotGatewayManagementMutationError = ErrorType<void>;

/**
 * @summary Grant a bot gateway permission tag to a user
 */
export const useGrantPermissionBotGatewayManagement = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof grantPermissionBotGatewayManagement>>,
    TError,
    { data: BotGatewayGrantPermissionRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof grantPermissionBotGatewayManagement>>,
  TError,
  { data: BotGatewayGrantPermissionRequest },
  TContext
> => {
  const mutationOptions = getGrantPermissionBotGatewayManagementMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Roles: Admin
 * @summary Revoke a bot gateway permission tag from a user
 */
export const revokePermissionBotGatewayManagement = (
  botGatewayRevokePermissionRequest: BotGatewayRevokePermissionRequest,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<void>(
    {
      url: `/back-api/api/v3/bot-gateway/permission/revoke`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: botGatewayRevokePermissionRequest,
    },
    options
  );
};

export const getRevokePermissionBotGatewayManagementMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof revokePermissionBotGatewayManagement>>,
    TError,
    { data: BotGatewayRevokePermissionRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof revokePermissionBotGatewayManagement>>,
  TError,
  { data: BotGatewayRevokePermissionRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof revokePermissionBotGatewayManagement>>,
    { data: BotGatewayRevokePermissionRequest }
  > = props => {
    const { data } = props ?? {};

    return revokePermissionBotGatewayManagement(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RevokePermissionBotGatewayManagementMutationResult = NonNullable<
  Awaited<ReturnType<typeof revokePermissionBotGatewayManagement>>
>;
export type RevokePermissionBotGatewayManagementMutationBody = BotGatewayRevokePermissionRequest;
export type RevokePermissionBotGatewayManagementMutationError = ErrorType<void>;

/**
 * @summary Revoke a bot gateway permission tag from a user
 */
export const useRevokePermissionBotGatewayManagement = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof revokePermissionBotGatewayManagement>>,
    TError,
    { data: BotGatewayRevokePermissionRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof revokePermissionBotGatewayManagement>>,
  TError,
  { data: BotGatewayRevokePermissionRequest },
  TContext
> => {
  const mutationOptions = getRevokePermissionBotGatewayManagementMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Roles: Admin
 * @summary Get a paginated list of bot gateway users
 */
export const getUsersBotGatewayManagement = (
  params?: GetUsersBotGatewayManagementParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<BotGatewayUsersPageViewModel>(
    { url: `/back-api/api/v3/bot-gateway/users`, method: 'GET', params, signal },
    options
  );
};

export const getGetUsersBotGatewayManagementQueryKey = (params?: GetUsersBotGatewayManagementParams) => {
  return [`/back-api/api/v3/bot-gateway/users`, ...(params ? [params] : [])] as const;
};

export const getGetUsersBotGatewayManagementQueryOptions = <
  TData = Awaited<ReturnType<typeof getUsersBotGatewayManagement>>,
  TError = ErrorType<void>
>(
  params?: GetUsersBotGatewayManagementParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getUsersBotGatewayManagement>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetUsersBotGatewayManagementQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getUsersBotGatewayManagement>>> = ({ signal }) =>
    getUsersBotGatewayManagement(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUsersBotGatewayManagement>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetUsersBotGatewayManagementQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUsersBotGatewayManagement>>
>;
export type GetUsersBotGatewayManagementQueryError = ErrorType<void>;

/**
 * @summary Get a paginated list of bot gateway users
 */

export function useGetUsersBotGatewayManagement<
  TData = Awaited<ReturnType<typeof getUsersBotGatewayManagement>>,
  TError = ErrorType<void>
>(
  params?: GetUsersBotGatewayManagementParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getUsersBotGatewayManagement>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetUsersBotGatewayManagementQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Roles: Admin
 * @summary Get bot gateway account details and access history for a single user
 */
export const getUserBotGatewayManagement = (
  userId: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<BotGatewayAccountHistoryViewModel>(
    { url: `/back-api/api/v3/bot-gateway/users/${userId}`, method: 'GET', signal },
    options
  );
};

export const getGetUserBotGatewayManagementQueryKey = (userId: string) => {
  return [`/back-api/api/v3/bot-gateway/users/${userId}`] as const;
};

export const getGetUserBotGatewayManagementQueryOptions = <
  TData = Awaited<ReturnType<typeof getUserBotGatewayManagement>>,
  TError = ErrorType<void | ProblemDetails>
>(
  userId: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getUserBotGatewayManagement>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetUserBotGatewayManagementQueryKey(userId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserBotGatewayManagement>>> = ({ signal }) =>
    getUserBotGatewayManagement(userId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!userId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUserBotGatewayManagement>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetUserBotGatewayManagementQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUserBotGatewayManagement>>
>;
export type GetUserBotGatewayManagementQueryError = ErrorType<void | ProblemDetails>;

/**
 * @summary Get bot gateway account details and access history for a single user
 */

export function useGetUserBotGatewayManagement<
  TData = Awaited<ReturnType<typeof getUserBotGatewayManagement>>,
  TError = ErrorType<void | ProblemDetails>
>(
  userId: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getUserBotGatewayManagement>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetUserBotGatewayManagementQueryOptions(userId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create a campaign with nested prize tiers and JSON rules configuration.
 */
export const createCampaignAdmin = (
  createCampaignRequest: CreateCampaignRequest,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<CampaignAdminResponse>(
    {
      url: `/back-api/admin/campaigns`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: createCampaignRequest,
    },
    options
  );
};

export const getCreateCampaignAdminMutationOptions = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCampaignAdmin>>,
    TError,
    { data: CreateCampaignRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createCampaignAdmin>>,
  TError,
  { data: CreateCampaignRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createCampaignAdmin>>,
    { data: CreateCampaignRequest }
  > = props => {
    const { data } = props ?? {};

    return createCampaignAdmin(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateCampaignAdminMutationResult = NonNullable<Awaited<ReturnType<typeof createCampaignAdmin>>>;
export type CreateCampaignAdminMutationBody = CreateCampaignRequest;
export type CreateCampaignAdminMutationError = ErrorType<void>;

/**
 * @summary Create a campaign with nested prize tiers and JSON rules configuration.
 */
export const useCreateCampaignAdmin = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCampaignAdmin>>,
    TError,
    { data: CreateCampaignRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createCampaignAdmin>>,
  TError,
  { data: CreateCampaignRequest },
  TContext
> => {
  const mutationOptions = getCreateCampaignAdminMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary List campaigns for admin management (newest first).
 */
export const listCampaignAdmin = (
  params?: ListCampaignAdminParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<CampaignAdminResponse[]>(
    { url: `/back-api/admin/campaigns`, method: 'GET', params, signal },
    options
  );
};

export const getListCampaignAdminQueryKey = (params?: ListCampaignAdminParams) => {
  return [`/back-api/admin/campaigns`, ...(params ? [params] : [])] as const;
};

export const getListCampaignAdminQueryOptions = <
  TData = Awaited<ReturnType<typeof listCampaignAdmin>>,
  TError = ErrorType<void>
>(
  params?: ListCampaignAdminParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof listCampaignAdmin>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListCampaignAdminQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listCampaignAdmin>>> = ({ signal }) =>
    listCampaignAdmin(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listCampaignAdmin>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListCampaignAdminQueryResult = NonNullable<Awaited<ReturnType<typeof listCampaignAdmin>>>;
export type ListCampaignAdminQueryError = ErrorType<void>;

/**
 * @summary List campaigns for admin management (newest first).
 */

export function useListCampaignAdmin<TData = Awaited<ReturnType<typeof listCampaignAdmin>>, TError = ErrorType<void>>(
  params?: ListCampaignAdminParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof listCampaignAdmin>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListCampaignAdminQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Campaign detail with prize tiers for draw control.
 */
export const getByIdCampaignAdmin = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<CampaignAdminResponse>(
    { url: `/back-api/admin/campaigns/${id}`, method: 'GET', signal },
    options
  );
};

export const getGetByIdCampaignAdminQueryKey = (id: string) => {
  return [`/back-api/admin/campaigns/${id}`] as const;
};

export const getGetByIdCampaignAdminQueryOptions = <
  TData = Awaited<ReturnType<typeof getByIdCampaignAdmin>>,
  TError = ErrorType<void>
>(
  id: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getByIdCampaignAdmin>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetByIdCampaignAdminQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getByIdCampaignAdmin>>> = ({ signal }) =>
    getByIdCampaignAdmin(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getByIdCampaignAdmin>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetByIdCampaignAdminQueryResult = NonNullable<Awaited<ReturnType<typeof getByIdCampaignAdmin>>>;
export type GetByIdCampaignAdminQueryError = ErrorType<void>;

/**
 * @summary Campaign detail with prize tiers for draw control.
 */

export function useGetByIdCampaignAdmin<
  TData = Awaited<ReturnType<typeof getByIdCampaignAdmin>>,
  TError = ErrorType<void>
>(
  id: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getByIdCampaignAdmin>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetByIdCampaignAdminQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Update campaign details, entry rules, and prize tiers (Draft/Scheduled/Active only).
 */
export const updateCampaignAdmin = (
  id: string,
  createCampaignRequest: CreateCampaignRequest,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<CampaignAdminResponse>(
    {
      url: `/back-api/admin/campaigns/${id}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: createCampaignRequest,
    },
    options
  );
};

export const getUpdateCampaignAdminMutationOptions = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCampaignAdmin>>,
    TError,
    { id: string; data: CreateCampaignRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateCampaignAdmin>>,
  TError,
  { id: string; data: CreateCampaignRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateCampaignAdmin>>,
    { id: string; data: CreateCampaignRequest }
  > = props => {
    const { id, data } = props ?? {};

    return updateCampaignAdmin(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateCampaignAdminMutationResult = NonNullable<Awaited<ReturnType<typeof updateCampaignAdmin>>>;
export type UpdateCampaignAdminMutationBody = CreateCampaignRequest;
export type UpdateCampaignAdminMutationError = ErrorType<void>;

/**
 * @summary Update campaign details, entry rules, and prize tiers (Draft/Scheduled/Active only).
 */
export const useUpdateCampaignAdmin = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCampaignAdmin>>,
    TError,
    { id: string; data: CreateCampaignRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateCampaignAdmin>>,
  TError,
  { id: string; data: CreateCampaignRequest },
  TContext
> => {
  const mutationOptions = getUpdateCampaignAdminMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Paginated participant list with user details and entry weights.
 */
export const listParticipantsCampaignAdmin = (
  id: string,
  params?: ListParticipantsCampaignAdminParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<CampaignParticipantsListResponse>(
    { url: `/back-api/admin/campaigns/${id}/participants`, method: 'GET', params, signal },
    options
  );
};

export const getListParticipantsCampaignAdminQueryKey = (id: string, params?: ListParticipantsCampaignAdminParams) => {
  return [`/back-api/admin/campaigns/${id}/participants`, ...(params ? [params] : [])] as const;
};

export const getListParticipantsCampaignAdminQueryOptions = <
  TData = Awaited<ReturnType<typeof listParticipantsCampaignAdmin>>,
  TError = ErrorType<void>
>(
  id: string,
  params?: ListParticipantsCampaignAdminParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof listParticipantsCampaignAdmin>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListParticipantsCampaignAdminQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listParticipantsCampaignAdmin>>> = ({ signal }) =>
    listParticipantsCampaignAdmin(id, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listParticipantsCampaignAdmin>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListParticipantsCampaignAdminQueryResult = NonNullable<
  Awaited<ReturnType<typeof listParticipantsCampaignAdmin>>
>;
export type ListParticipantsCampaignAdminQueryError = ErrorType<void>;

/**
 * @summary Paginated participant list with user details and entry weights.
 */

export function useListParticipantsCampaignAdmin<
  TData = Awaited<ReturnType<typeof listParticipantsCampaignAdmin>>,
  TError = ErrorType<void>
>(
  id: string,
  params?: ListParticipantsCampaignAdminParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof listParticipantsCampaignAdmin>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListParticipantsCampaignAdminQueryOptions(id, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Participant detail snapshot for admin drill-down.
 */
export const getParticipantCampaignAdmin = (
  id: string,
  participantId: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<CampaignParticipantDetailAdminResponse>(
    { url: `/back-api/admin/campaigns/${id}/participants/${participantId}`, method: 'GET', signal },
    options
  );
};

export const getGetParticipantCampaignAdminQueryKey = (id: string, participantId: string) => {
  return [`/back-api/admin/campaigns/${id}/participants/${participantId}`] as const;
};

export const getGetParticipantCampaignAdminQueryOptions = <
  TData = Awaited<ReturnType<typeof getParticipantCampaignAdmin>>,
  TError = ErrorType<void>
>(
  id: string,
  participantId: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getParticipantCampaignAdmin>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetParticipantCampaignAdminQueryKey(id, participantId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getParticipantCampaignAdmin>>> = ({ signal }) =>
    getParticipantCampaignAdmin(id, participantId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!(id && participantId), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getParticipantCampaignAdmin>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetParticipantCampaignAdminQueryResult = NonNullable<
  Awaited<ReturnType<typeof getParticipantCampaignAdmin>>
>;
export type GetParticipantCampaignAdminQueryError = ErrorType<void>;

/**
 * @summary Participant detail snapshot for admin drill-down.
 */

export function useGetParticipantCampaignAdmin<
  TData = Awaited<ReturnType<typeof getParticipantCampaignAdmin>>,
  TError = ErrorType<void>
>(
  id: string,
  participantId: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getParticipantCampaignAdmin>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetParticipantCampaignAdminQueryOptions(id, participantId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Chronological participant activity timeline for admin review.
 */
export const getParticipantActivityCampaignAdmin = (
  id: string,
  participantId: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<CampaignParticipantActivityAdminResponse>(
    { url: `/back-api/admin/campaigns/${id}/participants/${participantId}/activity`, method: 'GET', signal },
    options
  );
};

export const getGetParticipantActivityCampaignAdminQueryKey = (id: string, participantId: string) => {
  return [`/back-api/admin/campaigns/${id}/participants/${participantId}/activity`] as const;
};

export const getGetParticipantActivityCampaignAdminQueryOptions = <
  TData = Awaited<ReturnType<typeof getParticipantActivityCampaignAdmin>>,
  TError = ErrorType<void>
>(
  id: string,
  participantId: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getParticipantActivityCampaignAdmin>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetParticipantActivityCampaignAdminQueryKey(id, participantId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getParticipantActivityCampaignAdmin>>> = ({ signal }) =>
    getParticipantActivityCampaignAdmin(id, participantId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!(id && participantId), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getParticipantActivityCampaignAdmin>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetParticipantActivityCampaignAdminQueryResult = NonNullable<
  Awaited<ReturnType<typeof getParticipantActivityCampaignAdmin>>
>;
export type GetParticipantActivityCampaignAdminQueryError = ErrorType<void>;

/**
 * @summary Chronological participant activity timeline for admin review.
 */

export function useGetParticipantActivityCampaignAdmin<
  TData = Awaited<ReturnType<typeof getParticipantActivityCampaignAdmin>>,
  TError = ErrorType<void>
>(
  id: string,
  participantId: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getParticipantActivityCampaignAdmin>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetParticipantActivityCampaignAdminQueryOptions(id, participantId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Download a PDF report of the participant activity timeline.
 */
export const downloadParticipantActivityReportCampaignAdmin = (
  id: string,
  participantId: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<void>(
    { url: `/back-api/admin/campaigns/${id}/participants/${participantId}/activity/report.pdf`, method: 'GET', signal },
    options
  );
};

export const getDownloadParticipantActivityReportCampaignAdminQueryKey = (id: string, participantId: string) => {
  return [`/back-api/admin/campaigns/${id}/participants/${participantId}/activity/report.pdf`] as const;
};

export const getDownloadParticipantActivityReportCampaignAdminQueryOptions = <
  TData = Awaited<ReturnType<typeof downloadParticipantActivityReportCampaignAdmin>>,
  TError = ErrorType<void>
>(
  id: string,
  participantId: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof downloadParticipantActivityReportCampaignAdmin>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getDownloadParticipantActivityReportCampaignAdminQueryKey(id, participantId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadParticipantActivityReportCampaignAdmin>>> = ({
    signal,
  }) => downloadParticipantActivityReportCampaignAdmin(id, participantId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!(id && participantId), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof downloadParticipantActivityReportCampaignAdmin>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type DownloadParticipantActivityReportCampaignAdminQueryResult = NonNullable<
  Awaited<ReturnType<typeof downloadParticipantActivityReportCampaignAdmin>>
>;
export type DownloadParticipantActivityReportCampaignAdminQueryError = ErrorType<void>;

/**
 * @summary Download a PDF report of the participant activity timeline.
 */

export function useDownloadParticipantActivityReportCampaignAdmin<
  TData = Awaited<ReturnType<typeof downloadParticipantActivityReportCampaignAdmin>>,
  TError = ErrorType<void>
>(
  id: string,
  participantId: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof downloadParticipantActivityReportCampaignAdmin>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getDownloadParticipantActivityReportCampaignAdminQueryOptions(id, participantId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Campaign winners with identity details and prize tier metadata, ordered by tier.
 */
export const listWinnersCampaignAdmin = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<CampaignWinnerAdminResponse[]>(
    { url: `/back-api/admin/campaigns/${id}/winners`, method: 'GET', signal },
    options
  );
};

export const getListWinnersCampaignAdminQueryKey = (id: string) => {
  return [`/back-api/admin/campaigns/${id}/winners`] as const;
};

export const getListWinnersCampaignAdminQueryOptions = <
  TData = Awaited<ReturnType<typeof listWinnersCampaignAdmin>>,
  TError = ErrorType<void>
>(
  id: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof listWinnersCampaignAdmin>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListWinnersCampaignAdminQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listWinnersCampaignAdmin>>> = ({ signal }) =>
    listWinnersCampaignAdmin(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listWinnersCampaignAdmin>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListWinnersCampaignAdminQueryResult = NonNullable<Awaited<ReturnType<typeof listWinnersCampaignAdmin>>>;
export type ListWinnersCampaignAdminQueryError = ErrorType<void>;

/**
 * @summary Campaign winners with identity details and prize tier metadata, ordered by tier.
 */

export function useListWinnersCampaignAdmin<
  TData = Awaited<ReturnType<typeof listWinnersCampaignAdmin>>,
  TError = ErrorType<void>
>(
  id: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof listWinnersCampaignAdmin>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListWinnersCampaignAdminQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Cancelled campaign winners with cancellation metadata, ordered by cancellation time (newest first).
 */
export const listCancelledWinnersCampaignAdmin = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<CampaignCancelledWinnerAdminResponse[]>(
    { url: `/back-api/admin/campaigns/${id}/winners/cancelled`, method: 'GET', signal },
    options
  );
};

export const getListCancelledWinnersCampaignAdminQueryKey = (id: string) => {
  return [`/back-api/admin/campaigns/${id}/winners/cancelled`] as const;
};

export const getListCancelledWinnersCampaignAdminQueryOptions = <
  TData = Awaited<ReturnType<typeof listCancelledWinnersCampaignAdmin>>,
  TError = ErrorType<void>
>(
  id: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof listCancelledWinnersCampaignAdmin>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListCancelledWinnersCampaignAdminQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listCancelledWinnersCampaignAdmin>>> = ({ signal }) =>
    listCancelledWinnersCampaignAdmin(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listCancelledWinnersCampaignAdmin>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListCancelledWinnersCampaignAdminQueryResult = NonNullable<
  Awaited<ReturnType<typeof listCancelledWinnersCampaignAdmin>>
>;
export type ListCancelledWinnersCampaignAdminQueryError = ErrorType<void>;

/**
 * @summary Cancelled campaign winners with cancellation metadata, ordered by cancellation time (newest first).
 */

export function useListCancelledWinnersCampaignAdmin<
  TData = Awaited<ReturnType<typeof listCancelledWinnersCampaignAdmin>>,
  TError = ErrorType<void>
>(
  id: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof listCancelledWinnersCampaignAdmin>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListCancelledWinnersCampaignAdminQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Update embedded videos for a campaign (allowed in any campaign status).
 */
export const updateEmbeddedVideosCampaignAdmin = (
  id: string,
  updateCampaignEmbeddedVideosRequest: UpdateCampaignEmbeddedVideosRequest,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<CampaignAdminResponse>(
    {
      url: `/back-api/admin/campaigns/${id}/embedded-videos`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: updateCampaignEmbeddedVideosRequest,
    },
    options
  );
};

export const getUpdateEmbeddedVideosCampaignAdminMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateEmbeddedVideosCampaignAdmin>>,
    TError,
    { id: string; data: UpdateCampaignEmbeddedVideosRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateEmbeddedVideosCampaignAdmin>>,
  TError,
  { id: string; data: UpdateCampaignEmbeddedVideosRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateEmbeddedVideosCampaignAdmin>>,
    { id: string; data: UpdateCampaignEmbeddedVideosRequest }
  > = props => {
    const { id, data } = props ?? {};

    return updateEmbeddedVideosCampaignAdmin(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateEmbeddedVideosCampaignAdminMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateEmbeddedVideosCampaignAdmin>>
>;
export type UpdateEmbeddedVideosCampaignAdminMutationBody = UpdateCampaignEmbeddedVideosRequest;
export type UpdateEmbeddedVideosCampaignAdminMutationError = ErrorType<void>;

/**
 * @summary Update embedded videos for a campaign (allowed in any campaign status).
 */
export const useUpdateEmbeddedVideosCampaignAdmin = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateEmbeddedVideosCampaignAdmin>>,
    TError,
    { id: string; data: UpdateCampaignEmbeddedVideosRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateEmbeddedVideosCampaignAdmin>>,
  TError,
  { id: string; data: UpdateCampaignEmbeddedVideosRequest },
  TContext
> => {
  const mutationOptions = getUpdateEmbeddedVideosCampaignAdminMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Publish a draft or scheduled campaign so users can join (Draft/Scheduled → Active).
 */
export const publishCampaignAdmin = (id: string, options?: SecondParameter<typeof customInstance>) => {
  return customInstance<CampaignAdminResponse>(
    { url: `/back-api/admin/campaigns/${id}/publish`, method: 'POST' },
    options
  );
};

export const getPublishCampaignAdminMutationOptions = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof publishCampaignAdmin>>, TError, { id: string }, TContext>;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<Awaited<ReturnType<typeof publishCampaignAdmin>>, TError, { id: string }, TContext> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof publishCampaignAdmin>>, { id: string }> = props => {
    const { id } = props ?? {};

    return publishCampaignAdmin(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PublishCampaignAdminMutationResult = NonNullable<Awaited<ReturnType<typeof publishCampaignAdmin>>>;

export type PublishCampaignAdminMutationError = ErrorType<void>;

/**
 * @summary Publish a draft or scheduled campaign so users can join (Draft/Scheduled → Active).
 */
export const usePublishCampaignAdmin = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof publishCampaignAdmin>>, TError, { id: string }, TContext>;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<Awaited<ReturnType<typeof publishCampaignAdmin>>, TError, { id: string }, TContext> => {
  const mutationOptions = getPublishCampaignAdminMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Close campaign entry before running a draw (Active → EntryClosed).
 */
export const closeEntryCampaignAdmin = (id: string, options?: SecondParameter<typeof customInstance>) => {
  return customInstance<CampaignAdminResponse>(
    { url: `/back-api/admin/campaigns/${id}/close-entry`, method: 'POST' },
    options
  );
};

export const getCloseEntryCampaignAdminMutationOptions = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof closeEntryCampaignAdmin>>, TError, { id: string }, TContext>;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<Awaited<ReturnType<typeof closeEntryCampaignAdmin>>, TError, { id: string }, TContext> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof closeEntryCampaignAdmin>>, { id: string }> = props => {
    const { id } = props ?? {};

    return closeEntryCampaignAdmin(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CloseEntryCampaignAdminMutationResult = NonNullable<Awaited<ReturnType<typeof closeEntryCampaignAdmin>>>;

export type CloseEntryCampaignAdminMutationError = ErrorType<void>;

/**
 * @summary Close campaign entry before running a draw (Active → EntryClosed).
 */
export const useCloseEntryCampaignAdmin = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof closeEntryCampaignAdmin>>, TError, { id: string }, TContext>;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<Awaited<ReturnType<typeof closeEntryCampaignAdmin>>, TError, { id: string }, TContext> => {
  const mutationOptions = getCloseEntryCampaignAdminMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Manually select winners for all remaining prize slots (Selected status; no public reveal).
 */
export const drawCampaignAdmin = (id: string, options?: SecondParameter<typeof customInstance>) => {
  return customInstance<DrawCampaignFullResponse>(
    { url: `/back-api/admin/campaigns/${id}/draw`, method: 'POST' },
    options
  );
};

export const getDrawCampaignAdminMutationOptions = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof drawCampaignAdmin>>, TError, { id: string }, TContext>;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<Awaited<ReturnType<typeof drawCampaignAdmin>>, TError, { id: string }, TContext> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof drawCampaignAdmin>>, { id: string }> = props => {
    const { id } = props ?? {};

    return drawCampaignAdmin(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DrawCampaignAdminMutationResult = NonNullable<Awaited<ReturnType<typeof drawCampaignAdmin>>>;

export type DrawCampaignAdminMutationError = ErrorType<void>;

/**
 * @summary Manually select winners for all remaining prize slots (Selected status; no public reveal).
 */
export const useDrawCampaignAdmin = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof drawCampaignAdmin>>, TError, { id: string }, TContext>;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<Awaited<ReturnType<typeof drawCampaignAdmin>>, TError, { id: string }, TContext> => {
  const mutationOptions = getDrawCampaignAdminMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Reveal Selected winners for a prize tier (public notify + Kafka side effects).
 */
export const revealPrizeCampaignAdmin = (
  id: string,
  prizeId: string,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<RevealCampaignPrizeResponse>(
    { url: `/back-api/admin/campaigns/${id}/prizes/${prizeId}/reveal`, method: 'POST' },
    options
  );
};

export const getRevealPrizeCampaignAdminMutationOptions = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof revealPrizeCampaignAdmin>>,
    TError,
    { id: string; prizeId: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof revealPrizeCampaignAdmin>>,
  TError,
  { id: string; prizeId: string },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof revealPrizeCampaignAdmin>>,
    { id: string; prizeId: string }
  > = props => {
    const { id, prizeId } = props ?? {};

    return revealPrizeCampaignAdmin(id, prizeId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RevealPrizeCampaignAdminMutationResult = NonNullable<Awaited<ReturnType<typeof revealPrizeCampaignAdmin>>>;

export type RevealPrizeCampaignAdminMutationError = ErrorType<void>;

/**
 * @summary Reveal Selected winners for a prize tier (public notify + Kafka side effects).
 */
export const useRevealPrizeCampaignAdmin = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof revealPrizeCampaignAdmin>>,
    TError,
    { id: string; prizeId: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof revealPrizeCampaignAdmin>>,
  TError,
  { id: string; prizeId: string },
  TContext
> => {
  const mutationOptions = getRevealPrizeCampaignAdminMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Mark a manual campaign draw complete when no eligible participants remain but prize slots are unfilled.
 */
export const completeDrawCampaignAdmin = (id: string, options?: SecondParameter<typeof customInstance>) => {
  return customInstance<CampaignAdminResponse>(
    { url: `/back-api/admin/campaigns/${id}/complete-draw`, method: 'POST' },
    options
  );
};

export const getCompleteDrawCampaignAdminMutationOptions = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof completeDrawCampaignAdmin>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<Awaited<ReturnType<typeof completeDrawCampaignAdmin>>, TError, { id: string }, TContext> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof completeDrawCampaignAdmin>>, { id: string }> = props => {
    const { id } = props ?? {};

    return completeDrawCampaignAdmin(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CompleteDrawCampaignAdminMutationResult = NonNullable<
  Awaited<ReturnType<typeof completeDrawCampaignAdmin>>
>;

export type CompleteDrawCampaignAdminMutationError = ErrorType<void>;

/**
 * @summary Mark a manual campaign draw complete when no eligible participants remain but prize slots are unfilled.
 */
export const useCompleteDrawCampaignAdmin = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof completeDrawCampaignAdmin>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<Awaited<ReturnType<typeof completeDrawCampaignAdmin>>, TError, { id: string }, TContext> => {
  const mutationOptions = getCompleteDrawCampaignAdminMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary List prize slots vacated by cancelled winners that have not yet been redrawn.
 */
export const listVacatedPrizesCampaignAdmin = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<CampaignRedrawVacatedPrizeResponse[]>(
    { url: `/back-api/admin/campaigns/${id}/redraw/vacated-prizes`, method: 'GET', signal },
    options
  );
};

export const getListVacatedPrizesCampaignAdminQueryKey = (id: string) => {
  return [`/back-api/admin/campaigns/${id}/redraw/vacated-prizes`] as const;
};

export const getListVacatedPrizesCampaignAdminQueryOptions = <
  TData = Awaited<ReturnType<typeof listVacatedPrizesCampaignAdmin>>,
  TError = ErrorType<void>
>(
  id: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof listVacatedPrizesCampaignAdmin>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListVacatedPrizesCampaignAdminQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listVacatedPrizesCampaignAdmin>>> = ({ signal }) =>
    listVacatedPrizesCampaignAdmin(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listVacatedPrizesCampaignAdmin>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListVacatedPrizesCampaignAdminQueryResult = NonNullable<
  Awaited<ReturnType<typeof listVacatedPrizesCampaignAdmin>>
>;
export type ListVacatedPrizesCampaignAdminQueryError = ErrorType<void>;

/**
 * @summary List prize slots vacated by cancelled winners that have not yet been redrawn.
 */

export function useListVacatedPrizesCampaignAdmin<
  TData = Awaited<ReturnType<typeof listVacatedPrizesCampaignAdmin>>,
  TError = ErrorType<void>
>(
  id: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof listVacatedPrizesCampaignAdmin>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListVacatedPrizesCampaignAdminQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Manually execute redraw for vacated prize slots during the redraw window.
 */
export const executeRedrawCampaignAdmin = (
  id: string,
  executeCampaignRedrawRequest: ExecuteCampaignRedrawRequest,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<ExecuteCampaignRedrawResponse>(
    {
      url: `/back-api/admin/campaigns/${id}/redraw`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: executeCampaignRedrawRequest,
    },
    options
  );
};

export const getExecuteRedrawCampaignAdminMutationOptions = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof executeRedrawCampaignAdmin>>,
    TError,
    { id: string; data: ExecuteCampaignRedrawRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof executeRedrawCampaignAdmin>>,
  TError,
  { id: string; data: ExecuteCampaignRedrawRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof executeRedrawCampaignAdmin>>,
    { id: string; data: ExecuteCampaignRedrawRequest }
  > = props => {
    const { id, data } = props ?? {};

    return executeRedrawCampaignAdmin(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExecuteRedrawCampaignAdminMutationResult = NonNullable<
  Awaited<ReturnType<typeof executeRedrawCampaignAdmin>>
>;
export type ExecuteRedrawCampaignAdminMutationBody = ExecuteCampaignRedrawRequest;
export type ExecuteRedrawCampaignAdminMutationError = ErrorType<void>;

/**
 * @summary Manually execute redraw for vacated prize slots during the redraw window.
 */
export const useExecuteRedrawCampaignAdmin = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof executeRedrawCampaignAdmin>>,
    TError,
    { id: string; data: ExecuteCampaignRedrawRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof executeRedrawCampaignAdmin>>,
  TError,
  { id: string; data: ExecuteCampaignRedrawRequest },
  TContext
> => {
  const mutationOptions = getExecuteRedrawCampaignAdminMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Participant counts grouped by marketing channel.
 */
export const getMarketingChannelStatsCampaignAdmin = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<CampaignMarketingChannelStatResponse[]>(
    { url: `/back-api/admin/campaigns/${id}/marketing-channel-stats`, method: 'GET', signal },
    options
  );
};

export const getGetMarketingChannelStatsCampaignAdminQueryKey = (id: string) => {
  return [`/back-api/admin/campaigns/${id}/marketing-channel-stats`] as const;
};

export const getGetMarketingChannelStatsCampaignAdminQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingChannelStatsCampaignAdmin>>,
  TError = ErrorType<void>
>(
  id: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getMarketingChannelStatsCampaignAdmin>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingChannelStatsCampaignAdminQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingChannelStatsCampaignAdmin>>> = ({ signal }) =>
    getMarketingChannelStatsCampaignAdmin(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMarketingChannelStatsCampaignAdmin>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMarketingChannelStatsCampaignAdminQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingChannelStatsCampaignAdmin>>
>;
export type GetMarketingChannelStatsCampaignAdminQueryError = ErrorType<void>;

/**
 * @summary Participant counts grouped by marketing channel.
 */

export function useGetMarketingChannelStatsCampaignAdmin<
  TData = Awaited<ReturnType<typeof getMarketingChannelStatsCampaignAdmin>>,
  TError = ErrorType<void>
>(
  id: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getMarketingChannelStatsCampaignAdmin>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetMarketingChannelStatsCampaignAdminQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Issue a digital reward for a single campaign winner.
 */
export const issueDigitalRewardCampaignAdmin = (
  id: string,
  participantId: string,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<CampaignWinnerAdminResponse>(
    { url: `/back-api/admin/campaigns/${id}/winners/${participantId}/issue-digital-reward`, method: 'POST' },
    options
  );
};

export const getIssueDigitalRewardCampaignAdminMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof issueDigitalRewardCampaignAdmin>>,
    TError,
    { id: string; participantId: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof issueDigitalRewardCampaignAdmin>>,
  TError,
  { id: string; participantId: string },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof issueDigitalRewardCampaignAdmin>>,
    { id: string; participantId: string }
  > = props => {
    const { id, participantId } = props ?? {};

    return issueDigitalRewardCampaignAdmin(id, participantId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type IssueDigitalRewardCampaignAdminMutationResult = NonNullable<
  Awaited<ReturnType<typeof issueDigitalRewardCampaignAdmin>>
>;

export type IssueDigitalRewardCampaignAdminMutationError = ErrorType<void>;

/**
 * @summary Issue a digital reward for a single campaign winner.
 */
export const useIssueDigitalRewardCampaignAdmin = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof issueDigitalRewardCampaignAdmin>>,
    TError,
    { id: string; participantId: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof issueDigitalRewardCampaignAdmin>>,
  TError,
  { id: string; participantId: string },
  TContext
> => {
  const mutationOptions = getIssueDigitalRewardCampaignAdminMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Issue digital rewards for all pending digital-asset winners in a campaign.
 */
export const issueAllDigitalRewardsCampaignAdmin = (id: string, options?: SecondParameter<typeof customInstance>) => {
  return customInstance<IssueDigitalRewardsResponse>(
    { url: `/back-api/admin/campaigns/${id}/winners/issue-digital-rewards`, method: 'POST' },
    options
  );
};

export const getIssueAllDigitalRewardsCampaignAdminMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof issueAllDigitalRewardsCampaignAdmin>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof issueAllDigitalRewardsCampaignAdmin>>,
  TError,
  { id: string },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof issueAllDigitalRewardsCampaignAdmin>>,
    { id: string }
  > = props => {
    const { id } = props ?? {};

    return issueAllDigitalRewardsCampaignAdmin(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type IssueAllDigitalRewardsCampaignAdminMutationResult = NonNullable<
  Awaited<ReturnType<typeof issueAllDigitalRewardsCampaignAdmin>>
>;

export type IssueAllDigitalRewardsCampaignAdminMutationError = ErrorType<void>;

/**
 * @summary Issue digital rewards for all pending digital-asset winners in a campaign.
 */
export const useIssueAllDigitalRewardsCampaignAdmin = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof issueAllDigitalRewardsCampaignAdmin>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof issueAllDigitalRewardsCampaignAdmin>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getIssueAllDigitalRewardsCampaignAdminMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Set manual fulfillment for voucher/other prize winners.
 */
export const setWinnerFulfillmentCampaignAdmin = (
  id: string,
  participantId: string,
  setWinnerFulfillmentAdminRequest: SetWinnerFulfillmentAdminRequest,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<CampaignWinnerAdminResponse>(
    {
      url: `/back-api/admin/campaigns/${id}/winners/${participantId}/fulfillment`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: setWinnerFulfillmentAdminRequest,
    },
    options
  );
};

export const getSetWinnerFulfillmentCampaignAdminMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setWinnerFulfillmentCampaignAdmin>>,
    TError,
    { id: string; participantId: string; data: SetWinnerFulfillmentAdminRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof setWinnerFulfillmentCampaignAdmin>>,
  TError,
  { id: string; participantId: string; data: SetWinnerFulfillmentAdminRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setWinnerFulfillmentCampaignAdmin>>,
    { id: string; participantId: string; data: SetWinnerFulfillmentAdminRequest }
  > = props => {
    const { id, participantId, data } = props ?? {};

    return setWinnerFulfillmentCampaignAdmin(id, participantId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SetWinnerFulfillmentCampaignAdminMutationResult = NonNullable<
  Awaited<ReturnType<typeof setWinnerFulfillmentCampaignAdmin>>
>;
export type SetWinnerFulfillmentCampaignAdminMutationBody = SetWinnerFulfillmentAdminRequest;
export type SetWinnerFulfillmentCampaignAdminMutationError = ErrorType<void>;

/**
 * @summary Set manual fulfillment for voucher/other prize winners.
 */
export const useSetWinnerFulfillmentCampaignAdmin = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setWinnerFulfillmentCampaignAdmin>>,
    TError,
    { id: string; participantId: string; data: SetWinnerFulfillmentAdminRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof setWinnerFulfillmentCampaignAdmin>>,
  TError,
  { id: string; participantId: string; data: SetWinnerFulfillmentAdminRequest },
  TContext
> => {
  const mutationOptions = getSetWinnerFulfillmentCampaignAdminMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Cancel an active campaign winner. Fails if the linked reward has already been claimed.
 */
export const cancelWinnerCampaignAdmin = (
  id: string,
  participantId: string,
  cancelWinnerAdminRequest: CancelWinnerAdminRequest,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<CampaignCancelledWinnerAdminResponse>(
    {
      url: `/back-api/admin/campaigns/${id}/winners/${participantId}/cancel`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: cancelWinnerAdminRequest,
    },
    options
  );
};

export const getCancelWinnerCampaignAdminMutationOptions = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cancelWinnerCampaignAdmin>>,
    TError,
    { id: string; participantId: string; data: CancelWinnerAdminRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof cancelWinnerCampaignAdmin>>,
  TError,
  { id: string; participantId: string; data: CancelWinnerAdminRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof cancelWinnerCampaignAdmin>>,
    { id: string; participantId: string; data: CancelWinnerAdminRequest }
  > = props => {
    const { id, participantId, data } = props ?? {};

    return cancelWinnerCampaignAdmin(id, participantId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CancelWinnerCampaignAdminMutationResult = NonNullable<
  Awaited<ReturnType<typeof cancelWinnerCampaignAdmin>>
>;
export type CancelWinnerCampaignAdminMutationBody = CancelWinnerAdminRequest;
export type CancelWinnerCampaignAdminMutationError = ErrorType<void>;

/**
 * @summary Cancel an active campaign winner. Fails if the linked reward has already been claimed.
 */
export const useCancelWinnerCampaignAdmin = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cancelWinnerCampaignAdmin>>,
    TError,
    { id: string; participantId: string; data: CancelWinnerAdminRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof cancelWinnerCampaignAdmin>>,
  TError,
  { id: string; participantId: string; data: CancelWinnerAdminRequest },
  TContext
> => {
  const mutationOptions = getCancelWinnerCampaignAdminMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Read linked digital reward details for a campaign winner.
 */
export const getWinnerRewardDetailCampaignAdmin = (
  id: string,
  participantId: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<CampaignWinnerRewardDetailResponse>(
    { url: `/back-api/admin/campaigns/${id}/winners/${participantId}/reward-detail`, method: 'GET', signal },
    options
  );
};

export const getGetWinnerRewardDetailCampaignAdminQueryKey = (id: string, participantId: string) => {
  return [`/back-api/admin/campaigns/${id}/winners/${participantId}/reward-detail`] as const;
};

export const getGetWinnerRewardDetailCampaignAdminQueryOptions = <
  TData = Awaited<ReturnType<typeof getWinnerRewardDetailCampaignAdmin>>,
  TError = ErrorType<void>
>(
  id: string,
  participantId: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getWinnerRewardDetailCampaignAdmin>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetWinnerRewardDetailCampaignAdminQueryKey(id, participantId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getWinnerRewardDetailCampaignAdmin>>> = ({ signal }) =>
    getWinnerRewardDetailCampaignAdmin(id, participantId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!(id && participantId), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getWinnerRewardDetailCampaignAdmin>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetWinnerRewardDetailCampaignAdminQueryResult = NonNullable<
  Awaited<ReturnType<typeof getWinnerRewardDetailCampaignAdmin>>
>;
export type GetWinnerRewardDetailCampaignAdminQueryError = ErrorType<void>;

/**
 * @summary Read linked digital reward details for a campaign winner.
 */

export function useGetWinnerRewardDetailCampaignAdmin<
  TData = Awaited<ReturnType<typeof getWinnerRewardDetailCampaignAdmin>>,
  TError = ErrorType<void>
>(
  id: string,
  participantId: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getWinnerRewardDetailCampaignAdmin>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetWinnerRewardDetailCampaignAdminQueryOptions(id, participantId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getDashboardCampaignAnalyticsAdmin = (
  params?: GetDashboardCampaignAnalyticsAdminParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<CampaignAnalyticsDashboardResponse>(
    { url: `/back-api/admin/campaign-analytics`, method: 'GET', params, signal },
    options
  );
};

export const getGetDashboardCampaignAnalyticsAdminQueryKey = (params?: GetDashboardCampaignAnalyticsAdminParams) => {
  return [`/back-api/admin/campaign-analytics`, ...(params ? [params] : [])] as const;
};

export const getGetDashboardCampaignAnalyticsAdminQueryOptions = <
  TData = Awaited<ReturnType<typeof getDashboardCampaignAnalyticsAdmin>>,
  TError = ErrorType<void>
>(
  params?: GetDashboardCampaignAnalyticsAdminParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getDashboardCampaignAnalyticsAdmin>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetDashboardCampaignAnalyticsAdminQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getDashboardCampaignAnalyticsAdmin>>> = ({ signal }) =>
    getDashboardCampaignAnalyticsAdmin(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getDashboardCampaignAnalyticsAdmin>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetDashboardCampaignAnalyticsAdminQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDashboardCampaignAnalyticsAdmin>>
>;
export type GetDashboardCampaignAnalyticsAdminQueryError = ErrorType<void>;

export function useGetDashboardCampaignAnalyticsAdmin<
  TData = Awaited<ReturnType<typeof getDashboardCampaignAnalyticsAdmin>>,
  TError = ErrorType<void>
>(
  params?: GetDashboardCampaignAnalyticsAdminParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getDashboardCampaignAnalyticsAdmin>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetDashboardCampaignAnalyticsAdminQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const listCctpRoute = (options?: SecondParameter<typeof customInstance>, signal?: AbortSignal) => {
  return customInstance<CctpRouteResponse[]>({ url: `/back-api/api/v1/cctp/routes`, method: 'GET', signal }, options);
};

export const getListCctpRouteQueryKey = () => {
  return [`/back-api/api/v1/cctp/routes`] as const;
};

export const getListCctpRouteQueryOptions = <
  TData = Awaited<ReturnType<typeof listCctpRoute>>,
  TError = ErrorType<void>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof listCctpRoute>>, TError, TData>;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListCctpRouteQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listCctpRoute>>> = ({ signal }) =>
    listCctpRoute(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listCctpRoute>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListCctpRouteQueryResult = NonNullable<Awaited<ReturnType<typeof listCctpRoute>>>;
export type ListCctpRouteQueryError = ErrorType<void>;

export function useListCctpRoute<
  TData = Awaited<ReturnType<typeof listCctpRoute>>,
  TError = ErrorType<void>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof listCctpRoute>>, TError, TData>;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListCctpRouteQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const createCctpRoute = (
  upsertCctpRouteRequest: UpsertCctpRouteRequest,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<CctpRouteResponse>(
    {
      url: `/back-api/api/v1/cctp/routes`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: upsertCctpRouteRequest,
    },
    options
  );
};

export const getCreateCctpRouteMutationOptions = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCctpRoute>>,
    TError,
    { data: UpsertCctpRouteRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createCctpRoute>>,
  TError,
  { data: UpsertCctpRouteRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createCctpRoute>>,
    { data: UpsertCctpRouteRequest }
  > = props => {
    const { data } = props ?? {};

    return createCctpRoute(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateCctpRouteMutationResult = NonNullable<Awaited<ReturnType<typeof createCctpRoute>>>;
export type CreateCctpRouteMutationBody = UpsertCctpRouteRequest;
export type CreateCctpRouteMutationError = ErrorType<void>;

export const useCreateCctpRoute = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCctpRoute>>,
    TError,
    { data: UpsertCctpRouteRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createCctpRoute>>,
  TError,
  { data: UpsertCctpRouteRequest },
  TContext
> => {
  const mutationOptions = getCreateCctpRouteMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getByIdCctpRoute = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<CctpRouteResponse>(
    { url: `/back-api/api/v1/cctp/routes/${id}`, method: 'GET', signal },
    options
  );
};

export const getGetByIdCctpRouteQueryKey = (id: string) => {
  return [`/back-api/api/v1/cctp/routes/${id}`] as const;
};

export const getGetByIdCctpRouteQueryOptions = <
  TData = Awaited<ReturnType<typeof getByIdCctpRoute>>,
  TError = ErrorType<void>
>(
  id: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getByIdCctpRoute>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetByIdCctpRouteQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getByIdCctpRoute>>> = ({ signal }) =>
    getByIdCctpRoute(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getByIdCctpRoute>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetByIdCctpRouteQueryResult = NonNullable<Awaited<ReturnType<typeof getByIdCctpRoute>>>;
export type GetByIdCctpRouteQueryError = ErrorType<void>;

export function useGetByIdCctpRoute<TData = Awaited<ReturnType<typeof getByIdCctpRoute>>, TError = ErrorType<void>>(
  id: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getByIdCctpRoute>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetByIdCctpRouteQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const updateCctpRoute = (
  id: string,
  upsertCctpRouteRequest: UpsertCctpRouteRequest,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<CctpRouteResponse>(
    {
      url: `/back-api/api/v1/cctp/routes/${id}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: upsertCctpRouteRequest,
    },
    options
  );
};

export const getUpdateCctpRouteMutationOptions = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCctpRoute>>,
    TError,
    { id: string; data: UpsertCctpRouteRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateCctpRoute>>,
  TError,
  { id: string; data: UpsertCctpRouteRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateCctpRoute>>,
    { id: string; data: UpsertCctpRouteRequest }
  > = props => {
    const { id, data } = props ?? {};

    return updateCctpRoute(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateCctpRouteMutationResult = NonNullable<Awaited<ReturnType<typeof updateCctpRoute>>>;
export type UpdateCctpRouteMutationBody = UpsertCctpRouteRequest;
export type UpdateCctpRouteMutationError = ErrorType<void>;

export const useUpdateCctpRoute = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCctpRoute>>,
    TError,
    { id: string; data: UpsertCctpRouteRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateCctpRoute>>,
  TError,
  { id: string; data: UpsertCctpRouteRequest },
  TContext
> => {
  const mutationOptions = getUpdateCctpRouteMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteCctpRoute = (id: string, options?: SecondParameter<typeof customInstance>) => {
  return customInstance<void>({ url: `/back-api/api/v1/cctp/routes/${id}`, method: 'DELETE' }, options);
};

export const getDeleteCctpRouteMutationOptions = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof deleteCctpRoute>>, TError, { id: string }, TContext>;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<Awaited<ReturnType<typeof deleteCctpRoute>>, TError, { id: string }, TContext> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCctpRoute>>, { id: string }> = props => {
    const { id } = props ?? {};

    return deleteCctpRoute(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteCctpRouteMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCctpRoute>>>;

export type DeleteCctpRouteMutationError = ErrorType<void>;

export const useDeleteCctpRoute = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof deleteCctpRoute>>, TError, { id: string }, TContext>;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<Awaited<ReturnType<typeof deleteCctpRoute>>, TError, { id: string }, TContext> => {
  const mutationOptions = getDeleteCctpRouteMutationOptions(options);

  return useMutation(mutationOptions);
};

export const resolveCompliance = (
  userReviewResolveRequest: UserReviewResolveRequest,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<void>(
    {
      url: `/back-api/backoffice/compliance/resolve`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: userReviewResolveRequest,
    },
    options
  );
};

export const getResolveComplianceMutationOptions = <
  TError = ErrorType<ApiErrorResponse | void>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resolveCompliance>>,
    TError,
    { data: UserReviewResolveRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof resolveCompliance>>,
  TError,
  { data: UserReviewResolveRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof resolveCompliance>>,
    { data: UserReviewResolveRequest }
  > = props => {
    const { data } = props ?? {};

    return resolveCompliance(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ResolveComplianceMutationResult = NonNullable<Awaited<ReturnType<typeof resolveCompliance>>>;
export type ResolveComplianceMutationBody = UserReviewResolveRequest;
export type ResolveComplianceMutationError = ErrorType<ApiErrorResponse | void>;

export const useResolveCompliance = <TError = ErrorType<ApiErrorResponse | void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resolveCompliance>>,
    TError,
    { data: UserReviewResolveRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof resolveCompliance>>,
  TError,
  { data: UserReviewResolveRequest },
  TContext
> => {
  const mutationOptions = getResolveComplianceMutationOptions(options);

  return useMutation(mutationOptions);
};

export const changeUserStatusCompliance = (
  complianceChangeUserStatusRequest: ComplianceChangeUserStatusRequest,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<string[]>(
    {
      url: `/back-api/backoffice/compliance/changeUserStatus`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: complianceChangeUserStatusRequest,
    },
    options
  );
};

export const getChangeUserStatusComplianceMutationOptions = <
  TError = ErrorType<ApiErrorResponse | void>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof changeUserStatusCompliance>>,
    TError,
    { data: ComplianceChangeUserStatusRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof changeUserStatusCompliance>>,
  TError,
  { data: ComplianceChangeUserStatusRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof changeUserStatusCompliance>>,
    { data: ComplianceChangeUserStatusRequest }
  > = props => {
    const { data } = props ?? {};

    return changeUserStatusCompliance(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ChangeUserStatusComplianceMutationResult = NonNullable<
  Awaited<ReturnType<typeof changeUserStatusCompliance>>
>;
export type ChangeUserStatusComplianceMutationBody = ComplianceChangeUserStatusRequest;
export type ChangeUserStatusComplianceMutationError = ErrorType<ApiErrorResponse | void>;

export const useChangeUserStatusCompliance = <
  TError = ErrorType<ApiErrorResponse | void>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof changeUserStatusCompliance>>,
    TError,
    { data: ComplianceChangeUserStatusRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof changeUserStatusCompliance>>,
  TError,
  { data: ComplianceChangeUserStatusRequest },
  TContext
> => {
  const mutationOptions = getChangeUserStatusComplianceMutationOptions(options);

  return useMutation(mutationOptions);
};

export const complianceUsers = (
  params?: ComplianceUsersParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ComplianceUsersResponse>(
    { url: `/back-api/backoffice/compliance/users`, method: 'GET', params, signal },
    options
  );
};

export const getComplianceUsersQueryKey = (params?: ComplianceUsersParams) => {
  return [`/back-api/backoffice/compliance/users`, ...(params ? [params] : [])] as const;
};

export const getComplianceUsersQueryOptions = <
  TData = Awaited<ReturnType<typeof complianceUsers>>,
  TError = ErrorType<void>
>(
  params?: ComplianceUsersParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof complianceUsers>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getComplianceUsersQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof complianceUsers>>> = ({ signal }) =>
    complianceUsers(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof complianceUsers>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ComplianceUsersQueryResult = NonNullable<Awaited<ReturnType<typeof complianceUsers>>>;
export type ComplianceUsersQueryError = ErrorType<void>;

export function useComplianceUsers<TData = Awaited<ReturnType<typeof complianceUsers>>, TError = ErrorType<void>>(
  params?: ComplianceUsersParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof complianceUsers>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getComplianceUsersQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Gets compliance user details
 */
export const complianceUserDetails = (
  complianceUserDetailsRequest: ComplianceUserDetailsRequest,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<ComplianceUserDetailsResponse>(
    {
      url: `/back-api/backoffice/compliance/userDetails`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: complianceUserDetailsRequest,
    },
    options
  );
};

export const getComplianceUserDetailsMutationOptions = <
  TError = ErrorType<void | ProblemDetails | ApiErrorResponse>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof complianceUserDetails>>,
    TError,
    { data: ComplianceUserDetailsRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof complianceUserDetails>>,
  TError,
  { data: ComplianceUserDetailsRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof complianceUserDetails>>,
    { data: ComplianceUserDetailsRequest }
  > = props => {
    const { data } = props ?? {};

    return complianceUserDetails(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ComplianceUserDetailsMutationResult = NonNullable<Awaited<ReturnType<typeof complianceUserDetails>>>;
export type ComplianceUserDetailsMutationBody = ComplianceUserDetailsRequest;
export type ComplianceUserDetailsMutationError = ErrorType<void | ProblemDetails | ApiErrorResponse>;

/**
 * @summary Gets compliance user details
 */
export const useComplianceUserDetails = <
  TError = ErrorType<void | ProblemDetails | ApiErrorResponse>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof complianceUserDetails>>,
    TError,
    { data: ComplianceUserDetailsRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof complianceUserDetails>>,
  TError,
  { data: ComplianceUserDetailsRequest },
  TContext
> => {
  const mutationOptions = getComplianceUserDetailsMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Sets the compliance tier of the user to one lower level (If it's Tier1 we return an error that this is the minimum level). Only accessible from the admin and compliance officer
 */
export const downgradeUserTierCompliance = (
  complianceTierDowngradeRequest: ComplianceTierDowngradeRequest,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<void>(
    {
      url: `/back-api/backoffice/compliance/downgrade`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: complianceTierDowngradeRequest,
    },
    options
  );
};

export const getDowngradeUserTierComplianceMutationOptions = <
  TError = ErrorType<void | ApiErrorResponse>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof downgradeUserTierCompliance>>,
    TError,
    { data: ComplianceTierDowngradeRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof downgradeUserTierCompliance>>,
  TError,
  { data: ComplianceTierDowngradeRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof downgradeUserTierCompliance>>,
    { data: ComplianceTierDowngradeRequest }
  > = props => {
    const { data } = props ?? {};

    return downgradeUserTierCompliance(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DowngradeUserTierComplianceMutationResult = NonNullable<
  Awaited<ReturnType<typeof downgradeUserTierCompliance>>
>;
export type DowngradeUserTierComplianceMutationBody = ComplianceTierDowngradeRequest;
export type DowngradeUserTierComplianceMutationError = ErrorType<void | ApiErrorResponse>;

/**
 * @summary Sets the compliance tier of the user to one lower level (If it's Tier1 we return an error that this is the minimum level). Only accessible from the admin and compliance officer
 */
export const useDowngradeUserTierCompliance = <
  TError = ErrorType<void | ApiErrorResponse>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof downgradeUserTierCompliance>>,
    TError,
    { data: ComplianceTierDowngradeRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof downgradeUserTierCompliance>>,
  TError,
  { data: ComplianceTierDowngradeRequest },
  TContext
> => {
  const mutationOptions = getDowngradeUserTierComplianceMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getOverviewComplianceDashboard = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ComplianceDashboardOverviewResponse>(
    { url: `/back-api/backoffice/compliance/dashboard/overview`, method: 'GET', signal },
    options
  );
};

export const getGetOverviewComplianceDashboardQueryKey = () => {
  return [`/back-api/backoffice/compliance/dashboard/overview`] as const;
};

export const getGetOverviewComplianceDashboardQueryOptions = <
  TData = Awaited<ReturnType<typeof getOverviewComplianceDashboard>>,
  TError = ErrorType<void>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getOverviewComplianceDashboard>>, TError, TData>;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOverviewComplianceDashboardQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOverviewComplianceDashboard>>> = ({ signal }) =>
    getOverviewComplianceDashboard(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getOverviewComplianceDashboard>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetOverviewComplianceDashboardQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOverviewComplianceDashboard>>
>;
export type GetOverviewComplianceDashboardQueryError = ErrorType<void>;

export function useGetOverviewComplianceDashboard<
  TData = Awaited<ReturnType<typeof getOverviewComplianceDashboard>>,
  TError = ErrorType<void>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getOverviewComplianceDashboard>>, TError, TData>;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetOverviewComplianceDashboardQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGeographicComplianceDashboard = (
  params?: GetGeographicComplianceDashboardParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ComplianceGeographicDistributionResponse>(
    { url: `/back-api/backoffice/compliance/dashboard/geographic`, method: 'GET', params, signal },
    options
  );
};

export const getGetGeographicComplianceDashboardQueryKey = (params?: GetGeographicComplianceDashboardParams) => {
  return [`/back-api/backoffice/compliance/dashboard/geographic`, ...(params ? [params] : [])] as const;
};

export const getGetGeographicComplianceDashboardQueryOptions = <
  TData = Awaited<ReturnType<typeof getGeographicComplianceDashboard>>,
  TError = ErrorType<void>
>(
  params?: GetGeographicComplianceDashboardParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getGeographicComplianceDashboard>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetGeographicComplianceDashboardQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getGeographicComplianceDashboard>>> = ({ signal }) =>
    getGeographicComplianceDashboard(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getGeographicComplianceDashboard>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetGeographicComplianceDashboardQueryResult = NonNullable<
  Awaited<ReturnType<typeof getGeographicComplianceDashboard>>
>;
export type GetGeographicComplianceDashboardQueryError = ErrorType<void>;

export function useGetGeographicComplianceDashboard<
  TData = Awaited<ReturnType<typeof getGeographicComplianceDashboard>>,
  TError = ErrorType<void>
>(
  params?: GetGeographicComplianceDashboardParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getGeographicComplianceDashboard>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetGeographicComplianceDashboardQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getRegistrationTrendComplianceDashboard = (
  params?: GetRegistrationTrendComplianceDashboardParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ComplianceRegistrationTrendResponse>(
    { url: `/back-api/backoffice/compliance/dashboard/registration-trend`, method: 'GET', params, signal },
    options
  );
};

export const getGetRegistrationTrendComplianceDashboardQueryKey = (
  params?: GetRegistrationTrendComplianceDashboardParams
) => {
  return [`/back-api/backoffice/compliance/dashboard/registration-trend`, ...(params ? [params] : [])] as const;
};

export const getGetRegistrationTrendComplianceDashboardQueryOptions = <
  TData = Awaited<ReturnType<typeof getRegistrationTrendComplianceDashboard>>,
  TError = ErrorType<void>
>(
  params?: GetRegistrationTrendComplianceDashboardParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getRegistrationTrendComplianceDashboard>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetRegistrationTrendComplianceDashboardQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getRegistrationTrendComplianceDashboard>>> = ({ signal }) =>
    getRegistrationTrendComplianceDashboard(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getRegistrationTrendComplianceDashboard>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetRegistrationTrendComplianceDashboardQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRegistrationTrendComplianceDashboard>>
>;
export type GetRegistrationTrendComplianceDashboardQueryError = ErrorType<void>;

export function useGetRegistrationTrendComplianceDashboard<
  TData = Awaited<ReturnType<typeof getRegistrationTrendComplianceDashboard>>,
  TError = ErrorType<void>
>(
  params?: GetRegistrationTrendComplianceDashboardParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getRegistrationTrendComplianceDashboard>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetRegistrationTrendComplianceDashboardQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGeographicUsersComplianceDashboard = (
  params?: GetGeographicUsersComplianceDashboardParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ComplianceGeographicUsersResponse>(
    { url: `/back-api/backoffice/compliance/dashboard/users`, method: 'GET', params, signal },
    options
  );
};

export const getGetGeographicUsersComplianceDashboardQueryKey = (
  params?: GetGeographicUsersComplianceDashboardParams
) => {
  return [`/back-api/backoffice/compliance/dashboard/users`, ...(params ? [params] : [])] as const;
};

export const getGetGeographicUsersComplianceDashboardQueryOptions = <
  TData = Awaited<ReturnType<typeof getGeographicUsersComplianceDashboard>>,
  TError = ErrorType<void>
>(
  params?: GetGeographicUsersComplianceDashboardParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getGeographicUsersComplianceDashboard>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetGeographicUsersComplianceDashboardQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getGeographicUsersComplianceDashboard>>> = ({ signal }) =>
    getGeographicUsersComplianceDashboard(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getGeographicUsersComplianceDashboard>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetGeographicUsersComplianceDashboardQueryResult = NonNullable<
  Awaited<ReturnType<typeof getGeographicUsersComplianceDashboard>>
>;
export type GetGeographicUsersComplianceDashboardQueryError = ErrorType<void>;

export function useGetGeographicUsersComplianceDashboard<
  TData = Awaited<ReturnType<typeof getGeographicUsersComplianceDashboard>>,
  TError = ErrorType<void>
>(
  params?: GetGeographicUsersComplianceDashboardParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getGeographicUsersComplianceDashboard>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetGeographicUsersComplianceDashboardQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Roles: ComplianceReviewer
 * @summary Gets the aggregated compliance detail of a single user: account, questionnaire, flags, reviews,
KYC fields snapshot, business status and risk assessment.
 */
export const getComplianceUserDetails = (
  userId: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ComplianceUserResponse>(
    { url: `/back-api/backoffice/compliance/users/${userId}/details`, method: 'GET', signal },
    options
  );
};

export const getGetComplianceUserDetailsQueryKey = (userId: string) => {
  return [`/back-api/backoffice/compliance/users/${userId}/details`] as const;
};

export const getGetComplianceUserDetailsQueryOptions = <
  TData = Awaited<ReturnType<typeof getComplianceUserDetails>>,
  TError = ErrorType<ApiErrorResponse | void>
>(
  userId: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getComplianceUserDetails>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetComplianceUserDetailsQueryKey(userId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getComplianceUserDetails>>> = ({ signal }) =>
    getComplianceUserDetails(userId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!userId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getComplianceUserDetails>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetComplianceUserDetailsQueryResult = NonNullable<Awaited<ReturnType<typeof getComplianceUserDetails>>>;
export type GetComplianceUserDetailsQueryError = ErrorType<ApiErrorResponse | void>;

/**
 * @summary Gets the aggregated compliance detail of a single user: account, questionnaire, flags, reviews,
KYC fields snapshot, business status and risk assessment.
 */

export function useGetComplianceUserDetails<
  TData = Awaited<ReturnType<typeof getComplianceUserDetails>>,
  TError = ErrorType<ApiErrorResponse | void>
>(
  userId: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getComplianceUserDetails>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetComplianceUserDetailsQueryOptions(userId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Roles: ComplianceReviewer
 * @summary Gets the withdrawal usage and limits of a single user.
 */
export const getWithdrawalLimitsComplianceUserDetails = (
  userId: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ComplianceUserWithdrawalLimitsResponse>(
    { url: `/back-api/backoffice/compliance/users/${userId}/withdrawal-limits`, method: 'GET', signal },
    options
  );
};

export const getGetWithdrawalLimitsComplianceUserDetailsQueryKey = (userId: string) => {
  return [`/back-api/backoffice/compliance/users/${userId}/withdrawal-limits`] as const;
};

export const getGetWithdrawalLimitsComplianceUserDetailsQueryOptions = <
  TData = Awaited<ReturnType<typeof getWithdrawalLimitsComplianceUserDetails>>,
  TError = ErrorType<ApiErrorResponse | void>
>(
  userId: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getWithdrawalLimitsComplianceUserDetails>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetWithdrawalLimitsComplianceUserDetailsQueryKey(userId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getWithdrawalLimitsComplianceUserDetails>>> = ({ signal }) =>
    getWithdrawalLimitsComplianceUserDetails(userId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!userId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getWithdrawalLimitsComplianceUserDetails>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetWithdrawalLimitsComplianceUserDetailsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getWithdrawalLimitsComplianceUserDetails>>
>;
export type GetWithdrawalLimitsComplianceUserDetailsQueryError = ErrorType<ApiErrorResponse | void>;

/**
 * @summary Gets the withdrawal usage and limits of a single user.
 */

export function useGetWithdrawalLimitsComplianceUserDetails<
  TData = Awaited<ReturnType<typeof getWithdrawalLimitsComplianceUserDetails>>,
  TError = ErrorType<ApiErrorResponse | void>
>(
  userId: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getWithdrawalLimitsComplianceUserDetails>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetWithdrawalLimitsComplianceUserDetailsQueryOptions(userId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get information about managed hot wallets.
 */
export const getInfoHotWallet = (
  params?: GetInfoHotWalletParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<HotWalletResponse[]>(
    { url: `/back-api/api/v2/wallets/hot`, method: 'GET', params, signal },
    options
  );
};

export const getGetInfoHotWalletQueryKey = (params?: GetInfoHotWalletParams) => {
  return [`/back-api/api/v2/wallets/hot`, ...(params ? [params] : [])] as const;
};

export const getGetInfoHotWalletQueryOptions = <
  TData = Awaited<ReturnType<typeof getInfoHotWallet>>,
  TError = ErrorType<void>
>(
  params?: GetInfoHotWalletParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getInfoHotWallet>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetInfoHotWalletQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getInfoHotWallet>>> = ({ signal }) =>
    getInfoHotWallet(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getInfoHotWallet>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetInfoHotWalletQueryResult = NonNullable<Awaited<ReturnType<typeof getInfoHotWallet>>>;
export type GetInfoHotWalletQueryError = ErrorType<void>;

/**
 * @summary Get information about managed hot wallets.
 */

export function useGetInfoHotWallet<TData = Awaited<ReturnType<typeof getInfoHotWallet>>, TError = ErrorType<void>>(
  params?: GetInfoHotWalletParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getInfoHotWallet>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetInfoHotWalletQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const transferToColdWalletHotWallet = (
  coldWalletTransferRequest: ColdWalletTransferRequest,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<TransactionEventData>(
    {
      url: `/back-api/api/v2/wallets/hot/withdrawal`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: coldWalletTransferRequest,
    },
    options
  );
};

export const getTransferToColdWalletHotWalletMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof transferToColdWalletHotWallet>>,
    TError,
    { data: ColdWalletTransferRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof transferToColdWalletHotWallet>>,
  TError,
  { data: ColdWalletTransferRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof transferToColdWalletHotWallet>>,
    { data: ColdWalletTransferRequest }
  > = props => {
    const { data } = props ?? {};

    return transferToColdWalletHotWallet(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TransferToColdWalletHotWalletMutationResult = NonNullable<
  Awaited<ReturnType<typeof transferToColdWalletHotWallet>>
>;
export type TransferToColdWalletHotWalletMutationBody = ColdWalletTransferRequest;
export type TransferToColdWalletHotWalletMutationError = ErrorType<void>;

export const useTransferToColdWalletHotWallet = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof transferToColdWalletHotWallet>>,
    TError,
    { data: ColdWalletTransferRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof transferToColdWalletHotWallet>>,
  TError,
  { data: ColdWalletTransferRequest },
  TContext
> => {
  const mutationOptions = getTransferToColdWalletHotWalletMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getTransferBalanceHotWallet = (
  params?: GetTransferBalanceHotWalletParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<number>(
    { url: `/back-api/api/v2/wallets/hot/transfers-balance`, method: 'GET', params, signal },
    options
  );
};

export const getGetTransferBalanceHotWalletQueryKey = (params?: GetTransferBalanceHotWalletParams) => {
  return [`/back-api/api/v2/wallets/hot/transfers-balance`, ...(params ? [params] : [])] as const;
};

export const getGetTransferBalanceHotWalletQueryOptions = <
  TData = Awaited<ReturnType<typeof getTransferBalanceHotWallet>>,
  TError = ErrorType<void>
>(
  params?: GetTransferBalanceHotWalletParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getTransferBalanceHotWallet>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTransferBalanceHotWalletQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTransferBalanceHotWallet>>> = ({ signal }) =>
    getTransferBalanceHotWallet(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTransferBalanceHotWallet>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetTransferBalanceHotWalletQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTransferBalanceHotWallet>>
>;
export type GetTransferBalanceHotWalletQueryError = ErrorType<void>;

export function useGetTransferBalanceHotWallet<
  TData = Awaited<ReturnType<typeof getTransferBalanceHotWallet>>,
  TError = ErrorType<void>
>(
  params?: GetTransferBalanceHotWalletParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getTransferBalanceHotWallet>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetTransferBalanceHotWalletQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Try to recover a not included transaction
 */
export const recoverHotWallet = (
  walletTransactionRecoverRequest: WalletTransactionRecoverRequest,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<TransactionEmergencyRecoverResult>(
    {
      url: `/back-api/api/v2/wallets/recover`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: walletTransactionRecoverRequest,
    },
    options
  );
};

export const getRecoverHotWalletMutationOptions = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof recoverHotWallet>>,
    TError,
    { data: WalletTransactionRecoverRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof recoverHotWallet>>,
  TError,
  { data: WalletTransactionRecoverRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof recoverHotWallet>>,
    { data: WalletTransactionRecoverRequest }
  > = props => {
    const { data } = props ?? {};

    return recoverHotWallet(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RecoverHotWalletMutationResult = NonNullable<Awaited<ReturnType<typeof recoverHotWallet>>>;
export type RecoverHotWalletMutationBody = WalletTransactionRecoverRequest;
export type RecoverHotWalletMutationError = ErrorType<void>;

/**
 * @summary Try to recover a not included transaction
 */
export const useRecoverHotWallet = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof recoverHotWallet>>,
    TError,
    { data: WalletTransactionRecoverRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof recoverHotWallet>>,
  TError,
  { data: WalletTransactionRecoverRequest },
  TContext
> => {
  const mutationOptions = getRecoverHotWalletMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Roles: Admin
Lists via FrontOffice {GetUsersByAccountTag} (account_tags live on the FO database).
 * @summary Paginated list of accounts with InternalExchangeAccess granted.
 */
export const getUsersInternalExchangeAccess = (
  params?: GetUsersInternalExchangeAccessParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<InternalExchangeAccessUsersPageViewModel>(
    { url: `/back-api/api/v3/internal-exchange-access/users`, method: 'GET', params, signal },
    options
  );
};

export const getGetUsersInternalExchangeAccessQueryKey = (params?: GetUsersInternalExchangeAccessParams) => {
  return [`/back-api/api/v3/internal-exchange-access/users`, ...(params ? [params] : [])] as const;
};

export const getGetUsersInternalExchangeAccessQueryOptions = <
  TData = Awaited<ReturnType<typeof getUsersInternalExchangeAccess>>,
  TError = ErrorType<void>
>(
  params?: GetUsersInternalExchangeAccessParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getUsersInternalExchangeAccess>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetUsersInternalExchangeAccessQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getUsersInternalExchangeAccess>>> = ({ signal }) =>
    getUsersInternalExchangeAccess(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUsersInternalExchangeAccess>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetUsersInternalExchangeAccessQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUsersInternalExchangeAccess>>
>;
export type GetUsersInternalExchangeAccessQueryError = ErrorType<void>;

/**
 * @summary Paginated list of accounts with InternalExchangeAccess granted.
 */

export function useGetUsersInternalExchangeAccess<
  TData = Awaited<ReturnType<typeof getUsersInternalExchangeAccess>>,
  TError = ErrorType<void>
>(
  params?: GetUsersInternalExchangeAccessParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getUsersInternalExchangeAccess>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetUsersInternalExchangeAccessQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Roles: Admin
 * @summary Grant InternalExchangeAccess to a user.
 */
export const grantInternalExchangeAccess = (
  internalExchangeAccessGrantRequest: InternalExchangeAccessGrantRequest,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<void>(
    {
      url: `/back-api/api/v3/internal-exchange-access/grant`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: internalExchangeAccessGrantRequest,
    },
    options
  );
};

export const getGrantInternalExchangeAccessMutationOptions = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof grantInternalExchangeAccess>>,
    TError,
    { data: InternalExchangeAccessGrantRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof grantInternalExchangeAccess>>,
  TError,
  { data: InternalExchangeAccessGrantRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof grantInternalExchangeAccess>>,
    { data: InternalExchangeAccessGrantRequest }
  > = props => {
    const { data } = props ?? {};

    return grantInternalExchangeAccess(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GrantInternalExchangeAccessMutationResult = NonNullable<
  Awaited<ReturnType<typeof grantInternalExchangeAccess>>
>;
export type GrantInternalExchangeAccessMutationBody = InternalExchangeAccessGrantRequest;
export type GrantInternalExchangeAccessMutationError = ErrorType<void>;

/**
 * @summary Grant InternalExchangeAccess to a user.
 */
export const useGrantInternalExchangeAccess = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof grantInternalExchangeAccess>>,
    TError,
    { data: InternalExchangeAccessGrantRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof grantInternalExchangeAccess>>,
  TError,
  { data: InternalExchangeAccessGrantRequest },
  TContext
> => {
  const mutationOptions = getGrantInternalExchangeAccessMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Roles: Admin
 * @summary Revoke InternalExchangeAccess from a user.
 */
export const revokeInternalExchangeAccess = (
  internalExchangeAccessRevokeRequest: InternalExchangeAccessRevokeRequest,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<void>(
    {
      url: `/back-api/api/v3/internal-exchange-access/revoke`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: internalExchangeAccessRevokeRequest,
    },
    options
  );
};

export const getRevokeInternalExchangeAccessMutationOptions = <
  TError = ErrorType<void | ProblemDetails>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof revokeInternalExchangeAccess>>,
    TError,
    { data: InternalExchangeAccessRevokeRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof revokeInternalExchangeAccess>>,
  TError,
  { data: InternalExchangeAccessRevokeRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof revokeInternalExchangeAccess>>,
    { data: InternalExchangeAccessRevokeRequest }
  > = props => {
    const { data } = props ?? {};

    return revokeInternalExchangeAccess(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RevokeInternalExchangeAccessMutationResult = NonNullable<
  Awaited<ReturnType<typeof revokeInternalExchangeAccess>>
>;
export type RevokeInternalExchangeAccessMutationBody = InternalExchangeAccessRevokeRequest;
export type RevokeInternalExchangeAccessMutationError = ErrorType<void | ProblemDetails>;

/**
 * @summary Revoke InternalExchangeAccess from a user.
 */
export const useRevokeInternalExchangeAccess = <
  TError = ErrorType<void | ProblemDetails>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof revokeInternalExchangeAccess>>,
    TError,
    { data: InternalExchangeAccessRevokeRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof revokeInternalExchangeAccess>>,
  TError,
  { data: InternalExchangeAccessRevokeRequest },
  TContext
> => {
  const mutationOptions = getRevokeInternalExchangeAccessMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Gets list of all markets (admin). Returns every visibility, including Internal and Invisible.
 */
export const getAdminMarkets = (options?: SecondParameter<typeof customInstance>, signal?: AbortSignal) => {
  return customInstance<MarketResponse[]>({ url: `/back-api/backoffice/market-list`, method: 'GET', signal }, options);
};

export const getGetAdminMarketsQueryKey = () => {
  return [`/back-api/backoffice/market-list`] as const;
};

export const getGetAdminMarketsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAdminMarkets>>,
  TError = ErrorType<void>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getAdminMarkets>>, TError, TData>;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAdminMarketsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminMarkets>>> = ({ signal }) =>
    getAdminMarkets(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAdminMarkets>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAdminMarketsQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminMarkets>>>;
export type GetAdminMarketsQueryError = ErrorType<void>;

/**
 * @summary Gets list of all markets (admin). Returns every visibility, including Internal and Invisible.
 */

export function useGetAdminMarkets<
  TData = Awaited<ReturnType<typeof getAdminMarkets>>,
  TError = ErrorType<void>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getAdminMarkets>>, TError, TData>;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetAdminMarketsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * <br>
  <b>Behavior</b>

<br>- Persists a new market and emits a market update event (via service layer).
<br>- Validates that referenced assets exist and constraints are satisfied.
<br>- For commodity markets, quote_asset must be "usdx".
<br>- Instrument must match format: base_asset_quote_asset.
<br></para>
<para>
  <b>Parameters (CreateMarketRequest)</b>

<br>- instrument (string, required): unique market identifier; lowercase letters, numbers, underscores; length 1-16; must match base_asset_quote_asset format.
<br>- base_asset (string, required): existing asset id used as base; lowercase letters and numbers only; length 1-8.
<br>- quote_asset (string, required): existing asset id used as quote; lowercase letters and numbers only; length 1-8; must be "usdx" for commodity markets.
<br>- min_amount (decimal, required): > 0.
<br>- min_price (long, required): ≥ 0.
<br>- max_price (long, required): ≥ 0.
<br>- base_fee (decimal, required): ≥ 0.
<br>- quote_fee (decimal, required): ≥ 0.
<br>- maker_fee (decimal, required): ≥ 0 and < 1.
<br>- maker_fee_limit (decimal, required): ≥ 0.
<br>- taker_fee (decimal, required): ≥ 0 and < 1.
<br>- taker_fee_limit (decimal, required): ≥ 0.
<br>- price_scale (int, required): 1-18 (price precision).
<br>- amount_scale (int, required): 0-18 (amount precision).
<br>- hidden (bool, required): whether market is hidden from public view.
<br>- is_stable (bool, required): whether market is considered stable.
<br>- min_buy_price_variation_percent (int, required): ≥ 0.
<br>- max_sell_price_variation_percent (int, required): ≥ 0.
<br>- allow_market_order (bool, required): whether market orders are allowed.
<br>- is_fixed_ratio (bool, required): whether market uses fixed ratio pricing.
<br>- market_type (enum, required): Cryptocurrency, Commodity, etc.
<br>- prevent_market_makers_match (bool, required): When true, prevent MarketMaker-to-MarketMaker matching; keep both orders resting.
 * @summary Creates a new market.
 */
export const createMarket = (
  createMarketRequest: CreateMarketRequest,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<MarketResponse>(
    {
      url: `/back-api/backoffice/market`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: createMarketRequest,
    },
    options
  );
};

export const getCreateMarketMutationOptions = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createMarket>>,
    TError,
    { data: CreateMarketRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<Awaited<ReturnType<typeof createMarket>>, TError, { data: CreateMarketRequest }, TContext> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createMarket>>,
    { data: CreateMarketRequest }
  > = props => {
    const { data } = props ?? {};

    return createMarket(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateMarketMutationResult = NonNullable<Awaited<ReturnType<typeof createMarket>>>;
export type CreateMarketMutationBody = CreateMarketRequest;
export type CreateMarketMutationError = ErrorType<void>;

/**
 * @summary Creates a new market.
 */
export const useCreateMarket = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createMarket>>,
    TError,
    { data: CreateMarketRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<Awaited<ReturnType<typeof createMarket>>, TError, { data: CreateMarketRequest }, TContext> => {
  const mutationOptions = getCreateMarketMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary This method can be used to update all market properties
if market is stoped we change the market status to pause to prevent new orders then wait for order matcher
cancelation result then we change the market status to stoped
if market request is pause we send the request to order matcher and we wait for order cancelation result then
we change the status to paused
 */
export const updateMarket = (
  marketId: string,
  updateMarketRequest: UpdateMarketRequest,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<MarketResponse>(
    {
      url: `/back-api/backoffice/market/${marketId}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: updateMarketRequest,
    },
    options
  );
};

export const getUpdateMarketMutationOptions = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMarket>>,
    TError,
    { marketId: string; data: UpdateMarketRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateMarket>>,
  TError,
  { marketId: string; data: UpdateMarketRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateMarket>>,
    { marketId: string; data: UpdateMarketRequest }
  > = props => {
    const { marketId, data } = props ?? {};

    return updateMarket(marketId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateMarketMutationResult = NonNullable<Awaited<ReturnType<typeof updateMarket>>>;
export type UpdateMarketMutationBody = UpdateMarketRequest;
export type UpdateMarketMutationError = ErrorType<void>;

/**
 * @summary This method can be used to update all market properties
if market is stoped we change the market status to pause to prevent new orders then wait for order matcher
cancelation result then we change the market status to stoped
if market request is pause we send the request to order matcher and we wait for order cancelation result then
we change the status to paused
 */
export const useUpdateMarket = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMarket>>,
    TError,
    { marketId: string; data: UpdateMarketRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateMarket>>,
  TError,
  { marketId: string; data: UpdateMarketRequest },
  TContext
> => {
  const mutationOptions = getUpdateMarketMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Returns market by market instrument
 */
export const getMarket = (marketId: string, options?: SecondParameter<typeof customInstance>, signal?: AbortSignal) => {
  return customInstance<MarketResponse>(
    { url: `/back-api/backoffice/market/${marketId}`, method: 'GET', signal },
    options
  );
};

export const getGetMarketQueryKey = (marketId: string) => {
  return [`/back-api/backoffice/market/${marketId}`] as const;
};

export const getGetMarketQueryOptions = <TData = Awaited<ReturnType<typeof getMarket>>, TError = ErrorType<void>>(
  marketId: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getMarket>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketQueryKey(marketId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarket>>> = ({ signal }) =>
    getMarket(marketId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!marketId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMarket>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMarketQueryResult = NonNullable<Awaited<ReturnType<typeof getMarket>>>;
export type GetMarketQueryError = ErrorType<void>;

/**
 * @summary Returns market by market instrument
 */

export function useGetMarket<TData = Awaited<ReturnType<typeof getMarket>>, TError = ErrorType<void>>(
  marketId: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getMarket>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetMarketQueryOptions(marketId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const deleteMarket = (marketId: number, options?: SecondParameter<typeof customInstance>) => {
  return customInstance<void>({ url: `/back-api/backoffice/market/${marketId}`, method: 'DELETE' }, options);
};

export const getDeleteMarketMutationOptions = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof deleteMarket>>, TError, { marketId: number }, TContext>;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<Awaited<ReturnType<typeof deleteMarket>>, TError, { marketId: number }, TContext> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteMarket>>, { marketId: number }> = props => {
    const { marketId } = props ?? {};

    return deleteMarket(marketId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteMarketMutationResult = NonNullable<Awaited<ReturnType<typeof deleteMarket>>>;

export type DeleteMarketMutationError = ErrorType<void>;

export const useDeleteMarket = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof deleteMarket>>, TError, { marketId: number }, TContext>;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<Awaited<ReturnType<typeof deleteMarket>>, TError, { marketId: number }, TContext> => {
  const mutationOptions = getDeleteMarketMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary This method is called to make a market stable by marketId
 */
export const updateMarketStable = (
  marketStableRequest: MarketStableRequest,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<MarketResponse>(
    {
      url: `/back-api/backoffice/market/stable`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: marketStableRequest,
    },
    options
  );
};

export const getUpdateMarketStableMutationOptions = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMarketStable>>,
    TError,
    { data: MarketStableRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateMarketStable>>,
  TError,
  { data: MarketStableRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateMarketStable>>,
    { data: MarketStableRequest }
  > = props => {
    const { data } = props ?? {};

    return updateMarketStable(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateMarketStableMutationResult = NonNullable<Awaited<ReturnType<typeof updateMarketStable>>>;
export type UpdateMarketStableMutationBody = MarketStableRequest;
export type UpdateMarketStableMutationError = ErrorType<void>;

/**
 * @summary This method is called to make a market stable by marketId
 */
export const useUpdateMarketStable = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMarketStable>>,
    TError,
    { data: MarketStableRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateMarketStable>>,
  TError,
  { data: MarketStableRequest },
  TContext
> => {
  const mutationOptions = getUpdateMarketStableMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary This method can be used to update only type of markets if possible(use it with caution)
 */
export const updateMarketType = (
  marketInstrument: string,
  marketType: MarketType,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<MarketResponse>(
    { url: `/back-api/backoffice/market/${marketInstrument}/${marketType}`, method: 'PUT' },
    options
  );
};

export const getUpdateMarketTypeMutationOptions = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMarketType>>,
    TError,
    { marketInstrument: string; marketType: MarketType },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateMarketType>>,
  TError,
  { marketInstrument: string; marketType: MarketType },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateMarketType>>,
    { marketInstrument: string; marketType: MarketType }
  > = props => {
    const { marketInstrument, marketType } = props ?? {};

    return updateMarketType(marketInstrument, marketType, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateMarketTypeMutationResult = NonNullable<Awaited<ReturnType<typeof updateMarketType>>>;

export type UpdateMarketTypeMutationError = ErrorType<void>;

/**
 * @summary This method can be used to update only type of markets if possible(use it with caution)
 */
export const useUpdateMarketType = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMarketType>>,
    TError,
    { marketInstrument: string; marketType: MarketType },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateMarketType>>,
  TError,
  { marketInstrument: string; marketType: MarketType },
  TContext
> => {
  const mutationOptions = getUpdateMarketTypeMutationOptions(options);

  return useMutation(mutationOptions);
};

export const listMarketingChannelAdmin = (options?: SecondParameter<typeof customInstance>, signal?: AbortSignal) => {
  return customInstance<MarketingChannelResponse[]>(
    { url: `/back-api/admin/marketing-channels`, method: 'GET', signal },
    options
  );
};

export const getListMarketingChannelAdminQueryKey = () => {
  return [`/back-api/admin/marketing-channels`] as const;
};

export const getListMarketingChannelAdminQueryOptions = <
  TData = Awaited<ReturnType<typeof listMarketingChannelAdmin>>,
  TError = ErrorType<void>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof listMarketingChannelAdmin>>, TError, TData>;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListMarketingChannelAdminQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listMarketingChannelAdmin>>> = ({ signal }) =>
    listMarketingChannelAdmin(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listMarketingChannelAdmin>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListMarketingChannelAdminQueryResult = NonNullable<Awaited<ReturnType<typeof listMarketingChannelAdmin>>>;
export type ListMarketingChannelAdminQueryError = ErrorType<void>;

export function useListMarketingChannelAdmin<
  TData = Awaited<ReturnType<typeof listMarketingChannelAdmin>>,
  TError = ErrorType<void>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof listMarketingChannelAdmin>>, TError, TData>;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListMarketingChannelAdminQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const createMarketingChannelAdmin = (
  createMarketingChannelRequest: CreateMarketingChannelRequest,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<MarketingChannelResponse>(
    {
      url: `/back-api/admin/marketing-channels`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: createMarketingChannelRequest,
    },
    options
  );
};

export const getCreateMarketingChannelAdminMutationOptions = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createMarketingChannelAdmin>>,
    TError,
    { data: CreateMarketingChannelRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createMarketingChannelAdmin>>,
  TError,
  { data: CreateMarketingChannelRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createMarketingChannelAdmin>>,
    { data: CreateMarketingChannelRequest }
  > = props => {
    const { data } = props ?? {};

    return createMarketingChannelAdmin(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateMarketingChannelAdminMutationResult = NonNullable<
  Awaited<ReturnType<typeof createMarketingChannelAdmin>>
>;
export type CreateMarketingChannelAdminMutationBody = CreateMarketingChannelRequest;
export type CreateMarketingChannelAdminMutationError = ErrorType<void>;

export const useCreateMarketingChannelAdmin = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createMarketingChannelAdmin>>,
    TError,
    { data: CreateMarketingChannelRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createMarketingChannelAdmin>>,
  TError,
  { data: CreateMarketingChannelRequest },
  TContext
> => {
  const mutationOptions = getCreateMarketingChannelAdminMutationOptions(options);

  return useMutation(mutationOptions);
};

export const updateMarketingChannelAdmin = (
  channelId: string,
  updateMarketingChannelRequest: UpdateMarketingChannelRequest,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<MarketingChannelResponse>(
    {
      url: `/back-api/admin/marketing-channels/${channelId}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: updateMarketingChannelRequest,
    },
    options
  );
};

export const getUpdateMarketingChannelAdminMutationOptions = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMarketingChannelAdmin>>,
    TError,
    { channelId: string; data: UpdateMarketingChannelRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateMarketingChannelAdmin>>,
  TError,
  { channelId: string; data: UpdateMarketingChannelRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateMarketingChannelAdmin>>,
    { channelId: string; data: UpdateMarketingChannelRequest }
  > = props => {
    const { channelId, data } = props ?? {};

    return updateMarketingChannelAdmin(channelId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateMarketingChannelAdminMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateMarketingChannelAdmin>>
>;
export type UpdateMarketingChannelAdminMutationBody = UpdateMarketingChannelRequest;
export type UpdateMarketingChannelAdminMutationError = ErrorType<void>;

export const useUpdateMarketingChannelAdmin = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMarketingChannelAdmin>>,
    TError,
    { channelId: string; data: UpdateMarketingChannelRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateMarketingChannelAdmin>>,
  TError,
  { channelId: string; data: UpdateMarketingChannelRequest },
  TContext
> => {
  const mutationOptions = getUpdateMarketingChannelAdminMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteMarketingChannelAdmin = (channelId: string, options?: SecondParameter<typeof customInstance>) => {
  return customInstance<void>({ url: `/back-api/admin/marketing-channels/${channelId}`, method: 'DELETE' }, options);
};

export const getDeleteMarketingChannelAdminMutationOptions = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteMarketingChannelAdmin>>,
    TError,
    { channelId: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteMarketingChannelAdmin>>,
  TError,
  { channelId: string },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteMarketingChannelAdmin>>,
    { channelId: string }
  > = props => {
    const { channelId } = props ?? {};

    return deleteMarketingChannelAdmin(channelId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteMarketingChannelAdminMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteMarketingChannelAdmin>>
>;

export type DeleteMarketingChannelAdminMutationError = ErrorType<void>;

export const useDeleteMarketingChannelAdmin = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteMarketingChannelAdmin>>,
    TError,
    { channelId: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteMarketingChannelAdmin>>,
  TError,
  { channelId: string },
  TContext
> => {
  const mutationOptions = getDeleteMarketingChannelAdminMutationOptions(options);

  return useMutation(mutationOptions);
};

export const createMarketRegistration = (
  createMarketRegistrationRequest: CreateMarketRegistrationRequest,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<MarketRegistrationResponse>(
    {
      url: `/back-api/api/v1/market-registration`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: createMarketRegistrationRequest,
    },
    options
  );
};

export const getCreateMarketRegistrationMutationOptions = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createMarketRegistration>>,
    TError,
    { data: CreateMarketRegistrationRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createMarketRegistration>>,
  TError,
  { data: CreateMarketRegistrationRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createMarketRegistration>>,
    { data: CreateMarketRegistrationRequest }
  > = props => {
    const { data } = props ?? {};

    return createMarketRegistration(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateMarketRegistrationMutationResult = NonNullable<Awaited<ReturnType<typeof createMarketRegistration>>>;
export type CreateMarketRegistrationMutationBody = CreateMarketRegistrationRequest;
export type CreateMarketRegistrationMutationError = ErrorType<unknown>;

export const useCreateMarketRegistration = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createMarketRegistration>>,
    TError,
    { data: CreateMarketRegistrationRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createMarketRegistration>>,
  TError,
  { data: CreateMarketRegistrationRequest },
  TContext
> => {
  const mutationOptions = getCreateMarketRegistrationMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getListMarketRegistration = (
  params?: GetListMarketRegistrationParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<MarketRegistrationResponseFilteredResponse>(
    { url: `/back-api/api/v1/market-registration`, method: 'GET', params, signal },
    options
  );
};

export const getGetListMarketRegistrationQueryKey = (params?: GetListMarketRegistrationParams) => {
  return [`/back-api/api/v1/market-registration`, ...(params ? [params] : [])] as const;
};

export const getGetListMarketRegistrationQueryOptions = <
  TData = Awaited<ReturnType<typeof getListMarketRegistration>>,
  TError = ErrorType<unknown>
>(
  params?: GetListMarketRegistrationParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getListMarketRegistration>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetListMarketRegistrationQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getListMarketRegistration>>> = ({ signal }) =>
    getListMarketRegistration(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getListMarketRegistration>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetListMarketRegistrationQueryResult = NonNullable<Awaited<ReturnType<typeof getListMarketRegistration>>>;
export type GetListMarketRegistrationQueryError = ErrorType<unknown>;

export function useGetListMarketRegistration<
  TData = Awaited<ReturnType<typeof getListMarketRegistration>>,
  TError = ErrorType<unknown>
>(
  params?: GetListMarketRegistrationParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getListMarketRegistration>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetListMarketRegistrationQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getMarketRegistration = (
  id: string,
  params?: GetMarketRegistrationParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<MarketRegistrationResponse>(
    { url: `/back-api/api/v1/market-registration/${id}`, method: 'GET', params, signal },
    options
  );
};

export const getGetMarketRegistrationQueryKey = (id: string, params?: GetMarketRegistrationParams) => {
  return [`/back-api/api/v1/market-registration/${id}`, ...(params ? [params] : [])] as const;
};

export const getGetMarketRegistrationQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketRegistration>>,
  TError = ErrorType<unknown>
>(
  id: string,
  params?: GetMarketRegistrationParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getMarketRegistration>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketRegistrationQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketRegistration>>> = ({ signal }) =>
    getMarketRegistration(id, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMarketRegistration>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMarketRegistrationQueryResult = NonNullable<Awaited<ReturnType<typeof getMarketRegistration>>>;
export type GetMarketRegistrationQueryError = ErrorType<unknown>;

export function useGetMarketRegistration<
  TData = Awaited<ReturnType<typeof getMarketRegistration>>,
  TError = ErrorType<unknown>
>(
  id: string,
  params?: GetMarketRegistrationParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getMarketRegistration>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetMarketRegistrationQueryOptions(id, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const approveMarketRegistration = (
  id: string,
  approveMarketRegistrationRequest: ApproveMarketRegistrationRequest,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<MarketResponse>(
    {
      url: `/back-api/api/v1/market-registration/approve/${id}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: approveMarketRegistrationRequest,
    },
    options
  );
};

export const getApproveMarketRegistrationMutationOptions = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof approveMarketRegistration>>,
    TError,
    { id: string; data: ApproveMarketRegistrationRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof approveMarketRegistration>>,
  TError,
  { id: string; data: ApproveMarketRegistrationRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof approveMarketRegistration>>,
    { id: string; data: ApproveMarketRegistrationRequest }
  > = props => {
    const { id, data } = props ?? {};

    return approveMarketRegistration(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApproveMarketRegistrationMutationResult = NonNullable<
  Awaited<ReturnType<typeof approveMarketRegistration>>
>;
export type ApproveMarketRegistrationMutationBody = ApproveMarketRegistrationRequest;
export type ApproveMarketRegistrationMutationError = ErrorType<unknown>;

export const useApproveMarketRegistration = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof approveMarketRegistration>>,
    TError,
    { id: string; data: ApproveMarketRegistrationRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof approveMarketRegistration>>,
  TError,
  { id: string; data: ApproveMarketRegistrationRequest },
  TContext
> => {
  const mutationOptions = getApproveMarketRegistrationMutationOptions(options);

  return useMutation(mutationOptions);
};

export const rejectMarketRegistration = (
  id: string,
  rejectMarketRegistrationRequest: RejectMarketRegistrationRequest,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<MarketRegistrationResponse>(
    {
      url: `/back-api/api/v1/market-registration/reject/${id}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: rejectMarketRegistrationRequest,
    },
    options
  );
};

export const getRejectMarketRegistrationMutationOptions = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof rejectMarketRegistration>>,
    TError,
    { id: string; data: RejectMarketRegistrationRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof rejectMarketRegistration>>,
  TError,
  { id: string; data: RejectMarketRegistrationRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof rejectMarketRegistration>>,
    { id: string; data: RejectMarketRegistrationRequest }
  > = props => {
    const { id, data } = props ?? {};

    return rejectMarketRegistration(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RejectMarketRegistrationMutationResult = NonNullable<Awaited<ReturnType<typeof rejectMarketRegistration>>>;
export type RejectMarketRegistrationMutationBody = RejectMarketRegistrationRequest;
export type RejectMarketRegistrationMutationError = ErrorType<unknown>;

export const useRejectMarketRegistration = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof rejectMarketRegistration>>,
    TError,
    { id: string; data: RejectMarketRegistrationRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof rejectMarketRegistration>>,
  TError,
  { id: string; data: RejectMarketRegistrationRequest },
  TContext
> => {
  const mutationOptions = getRejectMarketRegistrationMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Query a single order by id
 */
export const getOrderByIdOrders = (
  orderId: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<OrderDetails>({ url: `/back-api/api/v2/orders/${orderId}`, method: 'GET', signal }, options);
};

export const getGetOrderByIdOrdersQueryKey = (orderId: string) => {
  return [`/back-api/api/v2/orders/${orderId}`] as const;
};

export const getGetOrderByIdOrdersQueryOptions = <
  TData = Awaited<ReturnType<typeof getOrderByIdOrders>>,
  TError = ErrorType<ApiErrorResponse | void>
>(
  orderId: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getOrderByIdOrders>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOrderByIdOrdersQueryKey(orderId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrderByIdOrders>>> = ({ signal }) =>
    getOrderByIdOrders(orderId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!orderId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getOrderByIdOrders>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetOrderByIdOrdersQueryResult = NonNullable<Awaited<ReturnType<typeof getOrderByIdOrders>>>;
export type GetOrderByIdOrdersQueryError = ErrorType<ApiErrorResponse | void>;

/**
 * @summary Query a single order by id
 */

export function useGetOrderByIdOrders<
  TData = Awaited<ReturnType<typeof getOrderByIdOrders>>,
  TError = ErrorType<ApiErrorResponse | void>
>(
  orderId: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getOrderByIdOrders>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetOrderByIdOrdersQueryOptions(orderId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Query orders that match the filter.
Cursor to fetch the data; in request next is current page ex: {next:0,Prev:-1}.
In response If the next is 0 means there is no more data to fetch; if Prev is -1, there is not any previous data
 */
export const ordersGetOrders = (ordersRequest: OrdersRequest, options?: SecondParameter<typeof customInstance>) => {
  return customInstance<OrdersResponse>(
    {
      url: `/back-api/api/v2/orders`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: ordersRequest,
    },
    options
  );
};

export const getOrdersGetOrdersMutationOptions = <
  TError = ErrorType<ApiErrorResponse | void>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof ordersGetOrders>>, TError, { data: OrdersRequest }, TContext>;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<Awaited<ReturnType<typeof ordersGetOrders>>, TError, { data: OrdersRequest }, TContext> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof ordersGetOrders>>, { data: OrdersRequest }> = props => {
    const { data } = props ?? {};

    return ordersGetOrders(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type OrdersGetOrdersMutationResult = NonNullable<Awaited<ReturnType<typeof ordersGetOrders>>>;
export type OrdersGetOrdersMutationBody = OrdersRequest;
export type OrdersGetOrdersMutationError = ErrorType<ApiErrorResponse | void>;

/**
 * @summary Query orders that match the filter.
Cursor to fetch the data; in request next is current page ex: {next:0,Prev:-1}.
In response If the next is 0 means there is no more data to fetch; if Prev is -1, there is not any previous data
 */
export const useOrdersGetOrders = <TError = ErrorType<ApiErrorResponse | void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof ordersGetOrders>>, TError, { data: OrdersRequest }, TContext>;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<Awaited<ReturnType<typeof ordersGetOrders>>, TError, { data: OrdersRequest }, TContext> => {
  const mutationOptions = getOrdersGetOrdersMutationOptions(options);

  return useMutation(mutationOptions);
};

export const ordersGetOrdersAsCsv = (
  ordersRequest: OrdersRequest,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<OrdersResponse>(
    {
      url: `/back-api/api/v2/orders.csv`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: ordersRequest,
    },
    options
  );
};

export const getOrdersGetOrdersAsCsvMutationOptions = <
  TError = ErrorType<ApiErrorResponse | void>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof ordersGetOrdersAsCsv>>,
    TError,
    { data: OrdersRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<Awaited<ReturnType<typeof ordersGetOrdersAsCsv>>, TError, { data: OrdersRequest }, TContext> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof ordersGetOrdersAsCsv>>,
    { data: OrdersRequest }
  > = props => {
    const { data } = props ?? {};

    return ordersGetOrdersAsCsv(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type OrdersGetOrdersAsCsvMutationResult = NonNullable<Awaited<ReturnType<typeof ordersGetOrdersAsCsv>>>;
export type OrdersGetOrdersAsCsvMutationBody = OrdersRequest;
export type OrdersGetOrdersAsCsvMutationError = ErrorType<ApiErrorResponse | void>;

export const useOrdersGetOrdersAsCsv = <TError = ErrorType<ApiErrorResponse | void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof ordersGetOrdersAsCsv>>,
    TError,
    { data: OrdersRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<Awaited<ReturnType<typeof ordersGetOrdersAsCsv>>, TError, { data: OrdersRequest }, TContext> => {
  const mutationOptions = getOrdersGetOrdersAsCsvMutationOptions(options);

  return useMutation(mutationOptions);
};

export const cancelOrderOrders = (orderId: string, options?: SecondParameter<typeof customInstance>) => {
  return customInstance<void>({ url: `/back-api/api/v2/orders/cancel/${orderId}`, method: 'DELETE' }, options);
};

export const getCancelOrderOrdersMutationOptions = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof cancelOrderOrders>>, TError, { orderId: string }, TContext>;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<Awaited<ReturnType<typeof cancelOrderOrders>>, TError, { orderId: string }, TContext> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelOrderOrders>>, { orderId: string }> = props => {
    const { orderId } = props ?? {};

    return cancelOrderOrders(orderId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CancelOrderOrdersMutationResult = NonNullable<Awaited<ReturnType<typeof cancelOrderOrders>>>;

export type CancelOrderOrdersMutationError = ErrorType<void>;

export const useCancelOrderOrders = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof cancelOrderOrders>>, TError, { orderId: string }, TContext>;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<Awaited<ReturnType<typeof cancelOrderOrders>>, TError, { orderId: string }, TContext> => {
  const mutationOptions = getCancelOrderOrdersMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getOrderTradesOrders = (
  orderId: string,
  userId: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<OrderTradesViewModel>(
    { url: `/back-api/api/v2/orders/${orderId}/trades/${userId}`, method: 'GET', signal },
    options
  );
};

export const getGetOrderTradesOrdersQueryKey = (orderId: string, userId: string) => {
  return [`/back-api/api/v2/orders/${orderId}/trades/${userId}`] as const;
};

export const getGetOrderTradesOrdersQueryOptions = <
  TData = Awaited<ReturnType<typeof getOrderTradesOrders>>,
  TError = ErrorType<void>
>(
  orderId: string,
  userId: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getOrderTradesOrders>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOrderTradesOrdersQueryKey(orderId, userId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrderTradesOrders>>> = ({ signal }) =>
    getOrderTradesOrders(orderId, userId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!(orderId && userId), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getOrderTradesOrders>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetOrderTradesOrdersQueryResult = NonNullable<Awaited<ReturnType<typeof getOrderTradesOrders>>>;
export type GetOrderTradesOrdersQueryError = ErrorType<void>;

export function useGetOrderTradesOrders<
  TData = Awaited<ReturnType<typeof getOrderTradesOrders>>,
  TError = ErrorType<void>
>(
  orderId: string,
  userId: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getOrderTradesOrders>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetOrderTradesOrdersQueryOptions(orderId, userId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getUserOrderTradesDocumentOrders = (
  getUserOrderTradesDocumentRequest: GetUserOrderTradesDocumentRequest,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<void>(
    {
      url: `/back-api/api/v2/order/trade/confirmation-document`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: getUserOrderTradesDocumentRequest,
    },
    options
  );
};

export const getGetUserOrderTradesDocumentOrdersMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getUserOrderTradesDocumentOrders>>,
    TError,
    { data: GetUserOrderTradesDocumentRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getUserOrderTradesDocumentOrders>>,
  TError,
  { data: GetUserOrderTradesDocumentRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getUserOrderTradesDocumentOrders>>,
    { data: GetUserOrderTradesDocumentRequest }
  > = props => {
    const { data } = props ?? {};

    return getUserOrderTradesDocumentOrders(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetUserOrderTradesDocumentOrdersMutationResult = NonNullable<
  Awaited<ReturnType<typeof getUserOrderTradesDocumentOrders>>
>;
export type GetUserOrderTradesDocumentOrdersMutationBody = GetUserOrderTradesDocumentRequest;
export type GetUserOrderTradesDocumentOrdersMutationError = ErrorType<void>;

export const useGetUserOrderTradesDocumentOrders = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getUserOrderTradesDocumentOrders>>,
    TError,
    { data: GetUserOrderTradesDocumentRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof getUserOrderTradesDocumentOrders>>,
  TError,
  { data: GetUserOrderTradesDocumentRequest },
  TContext
> => {
  const mutationOptions = getGetUserOrderTradesDocumentOrdersMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getPaymentsPaymentsAdmin = (
  getPaymentsRequest: GetPaymentsRequest,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<PaymentsResponse>(
    {
      url: `/back-api/api/v1/payment/payments/list`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: getPaymentsRequest,
    },
    options
  );
};

export const getGetPaymentsPaymentsAdminMutationOptions = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getPaymentsPaymentsAdmin>>,
    TError,
    { data: GetPaymentsRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getPaymentsPaymentsAdmin>>,
  TError,
  { data: GetPaymentsRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getPaymentsPaymentsAdmin>>,
    { data: GetPaymentsRequest }
  > = props => {
    const { data } = props ?? {};

    return getPaymentsPaymentsAdmin(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetPaymentsPaymentsAdminMutationResult = NonNullable<Awaited<ReturnType<typeof getPaymentsPaymentsAdmin>>>;
export type GetPaymentsPaymentsAdminMutationBody = GetPaymentsRequest;
export type GetPaymentsPaymentsAdminMutationError = ErrorType<void>;

export const useGetPaymentsPaymentsAdmin = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getPaymentsPaymentsAdmin>>,
    TError,
    { data: GetPaymentsRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof getPaymentsPaymentsAdmin>>,
  TError,
  { data: GetPaymentsRequest },
  TContext
> => {
  const mutationOptions = getGetPaymentsPaymentsAdminMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getPaymentExecutionsByPaymentIdPaymentsAdmin = (
  getPaymentExecutionsByPaymentIdRequest: GetPaymentExecutionsByPaymentIdRequest,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<PaymentExecutionsResponse>(
    {
      url: `/back-api/api/v1/payment/payments/executions/list`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: getPaymentExecutionsByPaymentIdRequest,
    },
    options
  );
};

export const getGetPaymentExecutionsByPaymentIdPaymentsAdminMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getPaymentExecutionsByPaymentIdPaymentsAdmin>>,
    TError,
    { data: GetPaymentExecutionsByPaymentIdRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getPaymentExecutionsByPaymentIdPaymentsAdmin>>,
  TError,
  { data: GetPaymentExecutionsByPaymentIdRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getPaymentExecutionsByPaymentIdPaymentsAdmin>>,
    { data: GetPaymentExecutionsByPaymentIdRequest }
  > = props => {
    const { data } = props ?? {};

    return getPaymentExecutionsByPaymentIdPaymentsAdmin(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetPaymentExecutionsByPaymentIdPaymentsAdminMutationResult = NonNullable<
  Awaited<ReturnType<typeof getPaymentExecutionsByPaymentIdPaymentsAdmin>>
>;
export type GetPaymentExecutionsByPaymentIdPaymentsAdminMutationBody = GetPaymentExecutionsByPaymentIdRequest;
export type GetPaymentExecutionsByPaymentIdPaymentsAdminMutationError = ErrorType<void>;

export const useGetPaymentExecutionsByPaymentIdPaymentsAdmin = <
  TError = ErrorType<void>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getPaymentExecutionsByPaymentIdPaymentsAdmin>>,
    TError,
    { data: GetPaymentExecutionsByPaymentIdRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof getPaymentExecutionsByPaymentIdPaymentsAdmin>>,
  TError,
  { data: GetPaymentExecutionsByPaymentIdRequest },
  TContext
> => {
  const mutationOptions = getGetPaymentExecutionsByPaymentIdPaymentsAdminMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getPaymentWebhookNotificationsPaymentsAdmin = (
  getPaymentWebhookNotificationsRequest: GetPaymentWebhookNotificationsRequest,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<PaymentWebhookNotificationsResponse>(
    {
      url: `/back-api/api/v1/payment/payments/webhook-notifications/list`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: getPaymentWebhookNotificationsRequest,
    },
    options
  );
};

export const getGetPaymentWebhookNotificationsPaymentsAdminMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getPaymentWebhookNotificationsPaymentsAdmin>>,
    TError,
    { data: GetPaymentWebhookNotificationsRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getPaymentWebhookNotificationsPaymentsAdmin>>,
  TError,
  { data: GetPaymentWebhookNotificationsRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getPaymentWebhookNotificationsPaymentsAdmin>>,
    { data: GetPaymentWebhookNotificationsRequest }
  > = props => {
    const { data } = props ?? {};

    return getPaymentWebhookNotificationsPaymentsAdmin(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetPaymentWebhookNotificationsPaymentsAdminMutationResult = NonNullable<
  Awaited<ReturnType<typeof getPaymentWebhookNotificationsPaymentsAdmin>>
>;
export type GetPaymentWebhookNotificationsPaymentsAdminMutationBody = GetPaymentWebhookNotificationsRequest;
export type GetPaymentWebhookNotificationsPaymentsAdminMutationError = ErrorType<void>;

export const useGetPaymentWebhookNotificationsPaymentsAdmin = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getPaymentWebhookNotificationsPaymentsAdmin>>,
    TError,
    { data: GetPaymentWebhookNotificationsRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof getPaymentWebhookNotificationsPaymentsAdmin>>,
  TError,
  { data: GetPaymentWebhookNotificationsRequest },
  TContext
> => {
  const mutationOptions = getGetPaymentWebhookNotificationsPaymentsAdminMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getPaymentDigitizedCurrencyMappingsPaymentsAdmin = (
  getPaymentDigitizedCurrencyMappingsRequest: GetPaymentDigitizedCurrencyMappingsRequest,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<PaymentDigitizedCurrencyMappingsResponse>(
    {
      url: `/back-api/api/v1/payment/payments/digitized-currency-mappings/list`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: getPaymentDigitizedCurrencyMappingsRequest,
    },
    options
  );
};

export const getGetPaymentDigitizedCurrencyMappingsPaymentsAdminMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getPaymentDigitizedCurrencyMappingsPaymentsAdmin>>,
    TError,
    { data: GetPaymentDigitizedCurrencyMappingsRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getPaymentDigitizedCurrencyMappingsPaymentsAdmin>>,
  TError,
  { data: GetPaymentDigitizedCurrencyMappingsRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getPaymentDigitizedCurrencyMappingsPaymentsAdmin>>,
    { data: GetPaymentDigitizedCurrencyMappingsRequest }
  > = props => {
    const { data } = props ?? {};

    return getPaymentDigitizedCurrencyMappingsPaymentsAdmin(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetPaymentDigitizedCurrencyMappingsPaymentsAdminMutationResult = NonNullable<
  Awaited<ReturnType<typeof getPaymentDigitizedCurrencyMappingsPaymentsAdmin>>
>;
export type GetPaymentDigitizedCurrencyMappingsPaymentsAdminMutationBody = GetPaymentDigitizedCurrencyMappingsRequest;
export type GetPaymentDigitizedCurrencyMappingsPaymentsAdminMutationError = ErrorType<void>;

export const useGetPaymentDigitizedCurrencyMappingsPaymentsAdmin = <
  TError = ErrorType<void>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getPaymentDigitizedCurrencyMappingsPaymentsAdmin>>,
    TError,
    { data: GetPaymentDigitizedCurrencyMappingsRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof getPaymentDigitizedCurrencyMappingsPaymentsAdmin>>,
  TError,
  { data: GetPaymentDigitizedCurrencyMappingsRequest },
  TContext
> => {
  const mutationOptions = getGetPaymentDigitizedCurrencyMappingsPaymentsAdminMutationOptions(options);

  return useMutation(mutationOptions);
};

export const createPaymentDigitizedCurrencyMappingPaymentsAdmin = (
  createPaymentDigitizedCurrencyMappingRequest: CreatePaymentDigitizedCurrencyMappingRequest,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<CreatePaymentDigitizedCurrencyMappingResponse>(
    {
      url: `/back-api/api/v1/payment/payments/digitized-currency-mappings/create`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: createPaymentDigitizedCurrencyMappingRequest,
    },
    options
  );
};

export const getCreatePaymentDigitizedCurrencyMappingPaymentsAdminMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createPaymentDigitizedCurrencyMappingPaymentsAdmin>>,
    TError,
    { data: CreatePaymentDigitizedCurrencyMappingRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createPaymentDigitizedCurrencyMappingPaymentsAdmin>>,
  TError,
  { data: CreatePaymentDigitizedCurrencyMappingRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createPaymentDigitizedCurrencyMappingPaymentsAdmin>>,
    { data: CreatePaymentDigitizedCurrencyMappingRequest }
  > = props => {
    const { data } = props ?? {};

    return createPaymentDigitizedCurrencyMappingPaymentsAdmin(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreatePaymentDigitizedCurrencyMappingPaymentsAdminMutationResult = NonNullable<
  Awaited<ReturnType<typeof createPaymentDigitizedCurrencyMappingPaymentsAdmin>>
>;
export type CreatePaymentDigitizedCurrencyMappingPaymentsAdminMutationBody =
  CreatePaymentDigitizedCurrencyMappingRequest;
export type CreatePaymentDigitizedCurrencyMappingPaymentsAdminMutationError = ErrorType<void>;

export const useCreatePaymentDigitizedCurrencyMappingPaymentsAdmin = <
  TError = ErrorType<void>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createPaymentDigitizedCurrencyMappingPaymentsAdmin>>,
    TError,
    { data: CreatePaymentDigitizedCurrencyMappingRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createPaymentDigitizedCurrencyMappingPaymentsAdmin>>,
  TError,
  { data: CreatePaymentDigitizedCurrencyMappingRequest },
  TContext
> => {
  const mutationOptions = getCreatePaymentDigitizedCurrencyMappingPaymentsAdminMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deletePaymentDigitizedCurrencyMappingPaymentsAdmin = (
  deletePaymentDigitizedCurrencyMappingRequest: DeletePaymentDigitizedCurrencyMappingRequest,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<void>(
    {
      url: `/back-api/api/v1/payment/payments/digitized-currency-mappings/delete`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: deletePaymentDigitizedCurrencyMappingRequest,
    },
    options
  );
};

export const getDeletePaymentDigitizedCurrencyMappingPaymentsAdminMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deletePaymentDigitizedCurrencyMappingPaymentsAdmin>>,
    TError,
    { data: DeletePaymentDigitizedCurrencyMappingRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deletePaymentDigitizedCurrencyMappingPaymentsAdmin>>,
  TError,
  { data: DeletePaymentDigitizedCurrencyMappingRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deletePaymentDigitizedCurrencyMappingPaymentsAdmin>>,
    { data: DeletePaymentDigitizedCurrencyMappingRequest }
  > = props => {
    const { data } = props ?? {};

    return deletePaymentDigitizedCurrencyMappingPaymentsAdmin(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeletePaymentDigitizedCurrencyMappingPaymentsAdminMutationResult = NonNullable<
  Awaited<ReturnType<typeof deletePaymentDigitizedCurrencyMappingPaymentsAdmin>>
>;
export type DeletePaymentDigitizedCurrencyMappingPaymentsAdminMutationBody =
  DeletePaymentDigitizedCurrencyMappingRequest;
export type DeletePaymentDigitizedCurrencyMappingPaymentsAdminMutationError = ErrorType<void>;

export const useDeletePaymentDigitizedCurrencyMappingPaymentsAdmin = <
  TError = ErrorType<void>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deletePaymentDigitizedCurrencyMappingPaymentsAdmin>>,
    TError,
    { data: DeletePaymentDigitizedCurrencyMappingRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deletePaymentDigitizedCurrencyMappingPaymentsAdmin>>,
  TError,
  { data: DeletePaymentDigitizedCurrencyMappingRequest },
  TContext
> => {
  const mutationOptions = getDeletePaymentDigitizedCurrencyMappingPaymentsAdminMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getProfit = (
  params: GetProfitParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ProfitResponse>({ url: `/back-api/backoffice/profit`, method: 'GET', params, signal }, options);
};

export const getGetProfitQueryKey = (params: GetProfitParams) => {
  return [`/back-api/backoffice/profit`, ...(params ? [params] : [])] as const;
};

export const getGetProfitQueryOptions = <TData = Awaited<ReturnType<typeof getProfit>>, TError = ErrorType<void>>(
  params: GetProfitParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getProfit>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetProfitQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProfit>>> = ({ signal }) =>
    getProfit(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getProfit>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetProfitQueryResult = NonNullable<Awaited<ReturnType<typeof getProfit>>>;
export type GetProfitQueryError = ErrorType<void>;

export function useGetProfit<TData = Awaited<ReturnType<typeof getProfit>>, TError = ErrorType<void>>(
  params: GetProfitParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getProfit>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetProfitQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getSummaryRevenue = (
  params?: GetSummaryRevenueParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<RevenueSummaryResponse>(
    { url: `/back-api/api/v1/revenue/summary`, method: 'GET', params, signal },
    options
  );
};

export const getGetSummaryRevenueQueryKey = (params?: GetSummaryRevenueParams) => {
  return [`/back-api/api/v1/revenue/summary`, ...(params ? [params] : [])] as const;
};

export const getGetSummaryRevenueQueryOptions = <
  TData = Awaited<ReturnType<typeof getSummaryRevenue>>,
  TError = ErrorType<void>
>(
  params?: GetSummaryRevenueParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getSummaryRevenue>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSummaryRevenueQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSummaryRevenue>>> = ({ signal }) =>
    getSummaryRevenue(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSummaryRevenue>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetSummaryRevenueQueryResult = NonNullable<Awaited<ReturnType<typeof getSummaryRevenue>>>;
export type GetSummaryRevenueQueryError = ErrorType<void>;

export function useGetSummaryRevenue<TData = Awaited<ReturnType<typeof getSummaryRevenue>>, TError = ErrorType<void>>(
  params?: GetSummaryRevenueParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getSummaryRevenue>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetSummaryRevenueQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getTrendRevenue = (
  params?: GetTrendRevenueParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<RevenueTrendPointResponse[]>(
    { url: `/back-api/api/v1/revenue/trend`, method: 'GET', params, signal },
    options
  );
};

export const getGetTrendRevenueQueryKey = (params?: GetTrendRevenueParams) => {
  return [`/back-api/api/v1/revenue/trend`, ...(params ? [params] : [])] as const;
};

export const getGetTrendRevenueQueryOptions = <
  TData = Awaited<ReturnType<typeof getTrendRevenue>>,
  TError = ErrorType<void>
>(
  params?: GetTrendRevenueParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getTrendRevenue>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTrendRevenueQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTrendRevenue>>> = ({ signal }) =>
    getTrendRevenue(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTrendRevenue>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetTrendRevenueQueryResult = NonNullable<Awaited<ReturnType<typeof getTrendRevenue>>>;
export type GetTrendRevenueQueryError = ErrorType<void>;

export function useGetTrendRevenue<TData = Awaited<ReturnType<typeof getTrendRevenue>>, TError = ErrorType<void>>(
  params?: GetTrendRevenueParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getTrendRevenue>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetTrendRevenueQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getTrendBySourceRevenue = (
  params?: GetTrendBySourceRevenueParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<RevenueTrendBySourcePointResponse[]>(
    { url: `/back-api/api/v1/revenue/trend/by-source`, method: 'GET', params, signal },
    options
  );
};

export const getGetTrendBySourceRevenueQueryKey = (params?: GetTrendBySourceRevenueParams) => {
  return [`/back-api/api/v1/revenue/trend/by-source`, ...(params ? [params] : [])] as const;
};

export const getGetTrendBySourceRevenueQueryOptions = <
  TData = Awaited<ReturnType<typeof getTrendBySourceRevenue>>,
  TError = ErrorType<void>
>(
  params?: GetTrendBySourceRevenueParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getTrendBySourceRevenue>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTrendBySourceRevenueQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTrendBySourceRevenue>>> = ({ signal }) =>
    getTrendBySourceRevenue(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTrendBySourceRevenue>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetTrendBySourceRevenueQueryResult = NonNullable<Awaited<ReturnType<typeof getTrendBySourceRevenue>>>;
export type GetTrendBySourceRevenueQueryError = ErrorType<void>;

export function useGetTrendBySourceRevenue<
  TData = Awaited<ReturnType<typeof getTrendBySourceRevenue>>,
  TError = ErrorType<void>
>(
  params?: GetTrendBySourceRevenueParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getTrendBySourceRevenue>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetTrendBySourceRevenueQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getBySourceRevenue = (
  params?: GetBySourceRevenueParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<RevenueBySourceResponse[]>(
    { url: `/back-api/api/v1/revenue/by-source`, method: 'GET', params, signal },
    options
  );
};

export const getGetBySourceRevenueQueryKey = (params?: GetBySourceRevenueParams) => {
  return [`/back-api/api/v1/revenue/by-source`, ...(params ? [params] : [])] as const;
};

export const getGetBySourceRevenueQueryOptions = <
  TData = Awaited<ReturnType<typeof getBySourceRevenue>>,
  TError = ErrorType<void>
>(
  params?: GetBySourceRevenueParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getBySourceRevenue>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetBySourceRevenueQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getBySourceRevenue>>> = ({ signal }) =>
    getBySourceRevenue(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getBySourceRevenue>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetBySourceRevenueQueryResult = NonNullable<Awaited<ReturnType<typeof getBySourceRevenue>>>;
export type GetBySourceRevenueQueryError = ErrorType<void>;

export function useGetBySourceRevenue<TData = Awaited<ReturnType<typeof getBySourceRevenue>>, TError = ErrorType<void>>(
  params?: GetBySourceRevenueParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getBySourceRevenue>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetBySourceRevenueQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getByChainRevenue = (
  params?: GetByChainRevenueParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<RevenueByChainResponse[]>(
    { url: `/back-api/api/v1/revenue/by-chain`, method: 'GET', params, signal },
    options
  );
};

export const getGetByChainRevenueQueryKey = (params?: GetByChainRevenueParams) => {
  return [`/back-api/api/v1/revenue/by-chain`, ...(params ? [params] : [])] as const;
};

export const getGetByChainRevenueQueryOptions = <
  TData = Awaited<ReturnType<typeof getByChainRevenue>>,
  TError = ErrorType<void>
>(
  params?: GetByChainRevenueParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getByChainRevenue>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetByChainRevenueQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getByChainRevenue>>> = ({ signal }) =>
    getByChainRevenue(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getByChainRevenue>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetByChainRevenueQueryResult = NonNullable<Awaited<ReturnType<typeof getByChainRevenue>>>;
export type GetByChainRevenueQueryError = ErrorType<void>;

export function useGetByChainRevenue<TData = Awaited<ReturnType<typeof getByChainRevenue>>, TError = ErrorType<void>>(
  params?: GetByChainRevenueParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getByChainRevenue>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetByChainRevenueQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getByAssetRevenue = (
  params?: GetByAssetRevenueParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<RevenueByAssetResponse[]>(
    { url: `/back-api/api/v1/revenue/by-asset`, method: 'GET', params, signal },
    options
  );
};

export const getGetByAssetRevenueQueryKey = (params?: GetByAssetRevenueParams) => {
  return [`/back-api/api/v1/revenue/by-asset`, ...(params ? [params] : [])] as const;
};

export const getGetByAssetRevenueQueryOptions = <
  TData = Awaited<ReturnType<typeof getByAssetRevenue>>,
  TError = ErrorType<void>
>(
  params?: GetByAssetRevenueParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getByAssetRevenue>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetByAssetRevenueQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getByAssetRevenue>>> = ({ signal }) =>
    getByAssetRevenue(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getByAssetRevenue>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetByAssetRevenueQueryResult = NonNullable<Awaited<ReturnType<typeof getByAssetRevenue>>>;
export type GetByAssetRevenueQueryError = ErrorType<void>;

export function useGetByAssetRevenue<TData = Awaited<ReturnType<typeof getByAssetRevenue>>, TError = ErrorType<void>>(
  params?: GetByAssetRevenueParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getByAssetRevenue>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetByAssetRevenueQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getByAssetTypeRevenue = (
  params?: GetByAssetTypeRevenueParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<RevenueByAssetTypeResponse[]>(
    { url: `/back-api/api/v1/revenue/by-asset-type`, method: 'GET', params, signal },
    options
  );
};

export const getGetByAssetTypeRevenueQueryKey = (params?: GetByAssetTypeRevenueParams) => {
  return [`/back-api/api/v1/revenue/by-asset-type`, ...(params ? [params] : [])] as const;
};

export const getGetByAssetTypeRevenueQueryOptions = <
  TData = Awaited<ReturnType<typeof getByAssetTypeRevenue>>,
  TError = ErrorType<void>
>(
  params?: GetByAssetTypeRevenueParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getByAssetTypeRevenue>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetByAssetTypeRevenueQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getByAssetTypeRevenue>>> = ({ signal }) =>
    getByAssetTypeRevenue(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getByAssetTypeRevenue>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetByAssetTypeRevenueQueryResult = NonNullable<Awaited<ReturnType<typeof getByAssetTypeRevenue>>>;
export type GetByAssetTypeRevenueQueryError = ErrorType<void>;

export function useGetByAssetTypeRevenue<
  TData = Awaited<ReturnType<typeof getByAssetTypeRevenue>>,
  TError = ErrorType<void>
>(
  params?: GetByAssetTypeRevenueParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getByAssetTypeRevenue>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetByAssetTypeRevenueQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getWithdrawalEconomicsRevenue = (
  params?: GetWithdrawalEconomicsRevenueParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<WithdrawalEconomicsResponse[]>(
    { url: `/back-api/api/v1/revenue/withdrawal-economics`, method: 'GET', params, signal },
    options
  );
};

export const getGetWithdrawalEconomicsRevenueQueryKey = (params?: GetWithdrawalEconomicsRevenueParams) => {
  return [`/back-api/api/v1/revenue/withdrawal-economics`, ...(params ? [params] : [])] as const;
};

export const getGetWithdrawalEconomicsRevenueQueryOptions = <
  TData = Awaited<ReturnType<typeof getWithdrawalEconomicsRevenue>>,
  TError = ErrorType<void>
>(
  params?: GetWithdrawalEconomicsRevenueParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getWithdrawalEconomicsRevenue>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetWithdrawalEconomicsRevenueQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getWithdrawalEconomicsRevenue>>> = ({ signal }) =>
    getWithdrawalEconomicsRevenue(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getWithdrawalEconomicsRevenue>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetWithdrawalEconomicsRevenueQueryResult = NonNullable<
  Awaited<ReturnType<typeof getWithdrawalEconomicsRevenue>>
>;
export type GetWithdrawalEconomicsRevenueQueryError = ErrorType<void>;

export function useGetWithdrawalEconomicsRevenue<
  TData = Awaited<ReturnType<typeof getWithdrawalEconomicsRevenue>>,
  TError = ErrorType<void>
>(
  params?: GetWithdrawalEconomicsRevenueParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getWithdrawalEconomicsRevenue>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetWithdrawalEconomicsRevenueQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getCostEfficiencyRevenue = (
  params?: GetCostEfficiencyRevenueParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<CostEfficiencyResponse>(
    { url: `/back-api/api/v1/revenue/cost-efficiency`, method: 'GET', params, signal },
    options
  );
};

export const getGetCostEfficiencyRevenueQueryKey = (params?: GetCostEfficiencyRevenueParams) => {
  return [`/back-api/api/v1/revenue/cost-efficiency`, ...(params ? [params] : [])] as const;
};

export const getGetCostEfficiencyRevenueQueryOptions = <
  TData = Awaited<ReturnType<typeof getCostEfficiencyRevenue>>,
  TError = ErrorType<void>
>(
  params?: GetCostEfficiencyRevenueParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getCostEfficiencyRevenue>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCostEfficiencyRevenueQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCostEfficiencyRevenue>>> = ({ signal }) =>
    getCostEfficiencyRevenue(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCostEfficiencyRevenue>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCostEfficiencyRevenueQueryResult = NonNullable<Awaited<ReturnType<typeof getCostEfficiencyRevenue>>>;
export type GetCostEfficiencyRevenueQueryError = ErrorType<void>;

export function useGetCostEfficiencyRevenue<
  TData = Awaited<ReturnType<typeof getCostEfficiencyRevenue>>,
  TError = ErrorType<void>
>(
  params?: GetCostEfficiencyRevenueParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getCostEfficiencyRevenue>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetCostEfficiencyRevenueQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getMarketTypeProfitabilityRevenue = (
  params?: GetMarketTypeProfitabilityRevenueParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<MarketTypeProfitabilityResponse[]>(
    { url: `/back-api/api/v1/revenue/market-profitability`, method: 'GET', params, signal },
    options
  );
};

export const getGetMarketTypeProfitabilityRevenueQueryKey = (params?: GetMarketTypeProfitabilityRevenueParams) => {
  return [`/back-api/api/v1/revenue/market-profitability`, ...(params ? [params] : [])] as const;
};

export const getGetMarketTypeProfitabilityRevenueQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketTypeProfitabilityRevenue>>,
  TError = ErrorType<void>
>(
  params?: GetMarketTypeProfitabilityRevenueParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getMarketTypeProfitabilityRevenue>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketTypeProfitabilityRevenueQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketTypeProfitabilityRevenue>>> = ({ signal }) =>
    getMarketTypeProfitabilityRevenue(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMarketTypeProfitabilityRevenue>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMarketTypeProfitabilityRevenueQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketTypeProfitabilityRevenue>>
>;
export type GetMarketTypeProfitabilityRevenueQueryError = ErrorType<void>;

export function useGetMarketTypeProfitabilityRevenue<
  TData = Awaited<ReturnType<typeof getMarketTypeProfitabilityRevenue>>,
  TError = ErrorType<void>
>(
  params?: GetMarketTypeProfitabilityRevenueParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getMarketTypeProfitabilityRevenue>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetMarketTypeProfitabilityRevenueQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getCostBreakdownRevenue = (
  params?: GetCostBreakdownRevenueParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<CostBreakdownItemResponse[]>(
    { url: `/back-api/api/v1/revenue/costs/breakdown`, method: 'GET', params, signal },
    options
  );
};

export const getGetCostBreakdownRevenueQueryKey = (params?: GetCostBreakdownRevenueParams) => {
  return [`/back-api/api/v1/revenue/costs/breakdown`, ...(params ? [params] : [])] as const;
};

export const getGetCostBreakdownRevenueQueryOptions = <
  TData = Awaited<ReturnType<typeof getCostBreakdownRevenue>>,
  TError = ErrorType<void>
>(
  params?: GetCostBreakdownRevenueParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getCostBreakdownRevenue>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCostBreakdownRevenueQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCostBreakdownRevenue>>> = ({ signal }) =>
    getCostBreakdownRevenue(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCostBreakdownRevenue>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCostBreakdownRevenueQueryResult = NonNullable<Awaited<ReturnType<typeof getCostBreakdownRevenue>>>;
export type GetCostBreakdownRevenueQueryError = ErrorType<void>;

export function useGetCostBreakdownRevenue<
  TData = Awaited<ReturnType<typeof getCostBreakdownRevenue>>,
  TError = ErrorType<void>
>(
  params?: GetCostBreakdownRevenueParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getCostBreakdownRevenue>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetCostBreakdownRevenueQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getCostTrendRevenue = (
  params?: GetCostTrendRevenueParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<CostTrendPointResponse[]>(
    { url: `/back-api/api/v1/revenue/costs/trend`, method: 'GET', params, signal },
    options
  );
};

export const getGetCostTrendRevenueQueryKey = (params?: GetCostTrendRevenueParams) => {
  return [`/back-api/api/v1/revenue/costs/trend`, ...(params ? [params] : [])] as const;
};

export const getGetCostTrendRevenueQueryOptions = <
  TData = Awaited<ReturnType<typeof getCostTrendRevenue>>,
  TError = ErrorType<void>
>(
  params?: GetCostTrendRevenueParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getCostTrendRevenue>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCostTrendRevenueQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCostTrendRevenue>>> = ({ signal }) =>
    getCostTrendRevenue(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCostTrendRevenue>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCostTrendRevenueQueryResult = NonNullable<Awaited<ReturnType<typeof getCostTrendRevenue>>>;
export type GetCostTrendRevenueQueryError = ErrorType<void>;

export function useGetCostTrendRevenue<
  TData = Awaited<ReturnType<typeof getCostTrendRevenue>>,
  TError = ErrorType<void>
>(
  params?: GetCostTrendRevenueParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getCostTrendRevenue>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetCostTrendRevenueQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getRewardRoiRevenue = (
  params?: GetRewardRoiRevenueParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<RewardRoiResponse>(
    { url: `/back-api/api/v1/revenue/costs/reward-roi`, method: 'GET', params, signal },
    options
  );
};

export const getGetRewardRoiRevenueQueryKey = (params?: GetRewardRoiRevenueParams) => {
  return [`/back-api/api/v1/revenue/costs/reward-roi`, ...(params ? [params] : [])] as const;
};

export const getGetRewardRoiRevenueQueryOptions = <
  TData = Awaited<ReturnType<typeof getRewardRoiRevenue>>,
  TError = ErrorType<void>
>(
  params?: GetRewardRoiRevenueParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getRewardRoiRevenue>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetRewardRoiRevenueQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getRewardRoiRevenue>>> = ({ signal }) =>
    getRewardRoiRevenue(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getRewardRoiRevenue>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetRewardRoiRevenueQueryResult = NonNullable<Awaited<ReturnType<typeof getRewardRoiRevenue>>>;
export type GetRewardRoiRevenueQueryError = ErrorType<void>;

export function useGetRewardRoiRevenue<
  TData = Awaited<ReturnType<typeof getRewardRoiRevenue>>,
  TError = ErrorType<void>
>(
  params?: GetRewardRoiRevenueParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getRewardRoiRevenue>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetRewardRoiRevenueQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getFeeBalancesRevenue = (
  params?: GetFeeBalancesRevenueParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<FeeBalancesResponse>(
    { url: `/back-api/api/v1/revenue/fees/balances`, method: 'GET', params, signal },
    options
  );
};

export const getGetFeeBalancesRevenueQueryKey = (params?: GetFeeBalancesRevenueParams) => {
  return [`/back-api/api/v1/revenue/fees/balances`, ...(params ? [params] : [])] as const;
};

export const getGetFeeBalancesRevenueQueryOptions = <
  TData = Awaited<ReturnType<typeof getFeeBalancesRevenue>>,
  TError = ErrorType<void>
>(
  params?: GetFeeBalancesRevenueParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getFeeBalancesRevenue>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetFeeBalancesRevenueQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getFeeBalancesRevenue>>> = ({ signal }) =>
    getFeeBalancesRevenue(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getFeeBalancesRevenue>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetFeeBalancesRevenueQueryResult = NonNullable<Awaited<ReturnType<typeof getFeeBalancesRevenue>>>;
export type GetFeeBalancesRevenueQueryError = ErrorType<void>;

export function useGetFeeBalancesRevenue<
  TData = Awaited<ReturnType<typeof getFeeBalancesRevenue>>,
  TError = ErrorType<void>
>(
  params?: GetFeeBalancesRevenueParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getFeeBalancesRevenue>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetFeeBalancesRevenueQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getFeeWithdrawalsRevenue = (
  params?: GetFeeWithdrawalsRevenueParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<FeeWithdrawalRecordResponseRevenuePagedResponse>(
    { url: `/back-api/api/v1/revenue/fees/withdrawals`, method: 'GET', params, signal },
    options
  );
};

export const getGetFeeWithdrawalsRevenueQueryKey = (params?: GetFeeWithdrawalsRevenueParams) => {
  return [`/back-api/api/v1/revenue/fees/withdrawals`, ...(params ? [params] : [])] as const;
};

export const getGetFeeWithdrawalsRevenueQueryOptions = <
  TData = Awaited<ReturnType<typeof getFeeWithdrawalsRevenue>>,
  TError = ErrorType<void>
>(
  params?: GetFeeWithdrawalsRevenueParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getFeeWithdrawalsRevenue>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetFeeWithdrawalsRevenueQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getFeeWithdrawalsRevenue>>> = ({ signal }) =>
    getFeeWithdrawalsRevenue(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getFeeWithdrawalsRevenue>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetFeeWithdrawalsRevenueQueryResult = NonNullable<Awaited<ReturnType<typeof getFeeWithdrawalsRevenue>>>;
export type GetFeeWithdrawalsRevenueQueryError = ErrorType<void>;

export function useGetFeeWithdrawalsRevenue<
  TData = Awaited<ReturnType<typeof getFeeWithdrawalsRevenue>>,
  TError = ErrorType<void>
>(
  params?: GetFeeWithdrawalsRevenueParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getFeeWithdrawalsRevenue>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetFeeWithdrawalsRevenueQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const createFeeWithdrawalRevenue = (
  createFeeWithdrawalRequest: CreateFeeWithdrawalRequest,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<FeeWithdrawalRecordResponse>(
    {
      url: `/back-api/api/v1/revenue/fees/withdrawals`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: createFeeWithdrawalRequest,
    },
    options
  );
};

export const getCreateFeeWithdrawalRevenueMutationOptions = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createFeeWithdrawalRevenue>>,
    TError,
    { data: CreateFeeWithdrawalRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createFeeWithdrawalRevenue>>,
  TError,
  { data: CreateFeeWithdrawalRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createFeeWithdrawalRevenue>>,
    { data: CreateFeeWithdrawalRequest }
  > = props => {
    const { data } = props ?? {};

    return createFeeWithdrawalRevenue(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateFeeWithdrawalRevenueMutationResult = NonNullable<
  Awaited<ReturnType<typeof createFeeWithdrawalRevenue>>
>;
export type CreateFeeWithdrawalRevenueMutationBody = CreateFeeWithdrawalRequest;
export type CreateFeeWithdrawalRevenueMutationError = ErrorType<void>;

export const useCreateFeeWithdrawalRevenue = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createFeeWithdrawalRevenue>>,
    TError,
    { data: CreateFeeWithdrawalRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createFeeWithdrawalRevenue>>,
  TError,
  { data: CreateFeeWithdrawalRequest },
  TContext
> => {
  const mutationOptions = getCreateFeeWithdrawalRevenueMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getInvestmentsRevenue = (
  params?: GetInvestmentsRevenueParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<InvestmentRecordResponseRevenuePagedResponse>(
    { url: `/back-api/api/v1/revenue/investments`, method: 'GET', params, signal },
    options
  );
};

export const getGetInvestmentsRevenueQueryKey = (params?: GetInvestmentsRevenueParams) => {
  return [`/back-api/api/v1/revenue/investments`, ...(params ? [params] : [])] as const;
};

export const getGetInvestmentsRevenueQueryOptions = <
  TData = Awaited<ReturnType<typeof getInvestmentsRevenue>>,
  TError = ErrorType<void>
>(
  params?: GetInvestmentsRevenueParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getInvestmentsRevenue>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetInvestmentsRevenueQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getInvestmentsRevenue>>> = ({ signal }) =>
    getInvestmentsRevenue(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getInvestmentsRevenue>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetInvestmentsRevenueQueryResult = NonNullable<Awaited<ReturnType<typeof getInvestmentsRevenue>>>;
export type GetInvestmentsRevenueQueryError = ErrorType<void>;

export function useGetInvestmentsRevenue<
  TData = Awaited<ReturnType<typeof getInvestmentsRevenue>>,
  TError = ErrorType<void>
>(
  params?: GetInvestmentsRevenueParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getInvestmentsRevenue>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetInvestmentsRevenueQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const createInvestmentRevenue = (
  createInvestmentRequest: CreateInvestmentRequest,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<InvestmentRecordResponse>(
    {
      url: `/back-api/api/v1/revenue/investments`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: createInvestmentRequest,
    },
    options
  );
};

export const getCreateInvestmentRevenueMutationOptions = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createInvestmentRevenue>>,
    TError,
    { data: CreateInvestmentRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createInvestmentRevenue>>,
  TError,
  { data: CreateInvestmentRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createInvestmentRevenue>>,
    { data: CreateInvestmentRequest }
  > = props => {
    const { data } = props ?? {};

    return createInvestmentRevenue(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateInvestmentRevenueMutationResult = NonNullable<Awaited<ReturnType<typeof createInvestmentRevenue>>>;
export type CreateInvestmentRevenueMutationBody = CreateInvestmentRequest;
export type CreateInvestmentRevenueMutationError = ErrorType<void>;

export const useCreateInvestmentRevenue = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createInvestmentRevenue>>,
    TError,
    { data: CreateInvestmentRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createInvestmentRevenue>>,
  TError,
  { data: CreateInvestmentRequest },
  TContext
> => {
  const mutationOptions = getCreateInvestmentRevenueMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getCashFlowRevenue = (
  params?: GetCashFlowRevenueParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<CashFlowPointResponse[]>(
    { url: `/back-api/api/v1/revenue/cash-flow`, method: 'GET', params, signal },
    options
  );
};

export const getGetCashFlowRevenueQueryKey = (params?: GetCashFlowRevenueParams) => {
  return [`/back-api/api/v1/revenue/cash-flow`, ...(params ? [params] : [])] as const;
};

export const getGetCashFlowRevenueQueryOptions = <
  TData = Awaited<ReturnType<typeof getCashFlowRevenue>>,
  TError = ErrorType<void>
>(
  params?: GetCashFlowRevenueParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getCashFlowRevenue>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCashFlowRevenueQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCashFlowRevenue>>> = ({ signal }) =>
    getCashFlowRevenue(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCashFlowRevenue>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCashFlowRevenueQueryResult = NonNullable<Awaited<ReturnType<typeof getCashFlowRevenue>>>;
export type GetCashFlowRevenueQueryError = ErrorType<void>;

export function useGetCashFlowRevenue<TData = Awaited<ReturnType<typeof getCashFlowRevenue>>, TError = ErrorType<void>>(
  params?: GetCashFlowRevenueParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getCashFlowRevenue>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetCashFlowRevenueQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getCfoInsightsRevenue = (
  params?: GetCfoInsightsRevenueParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<RevenueInsightResponse[]>(
    { url: `/back-api/api/v1/revenue/insights/cfo`, method: 'GET', params, signal },
    options
  );
};

export const getGetCfoInsightsRevenueQueryKey = (params?: GetCfoInsightsRevenueParams) => {
  return [`/back-api/api/v1/revenue/insights/cfo`, ...(params ? [params] : [])] as const;
};

export const getGetCfoInsightsRevenueQueryOptions = <
  TData = Awaited<ReturnType<typeof getCfoInsightsRevenue>>,
  TError = ErrorType<void>
>(
  params?: GetCfoInsightsRevenueParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getCfoInsightsRevenue>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCfoInsightsRevenueQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCfoInsightsRevenue>>> = ({ signal }) =>
    getCfoInsightsRevenue(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCfoInsightsRevenue>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCfoInsightsRevenueQueryResult = NonNullable<Awaited<ReturnType<typeof getCfoInsightsRevenue>>>;
export type GetCfoInsightsRevenueQueryError = ErrorType<void>;

export function useGetCfoInsightsRevenue<
  TData = Awaited<ReturnType<typeof getCfoInsightsRevenue>>,
  TError = ErrorType<void>
>(
  params?: GetCfoInsightsRevenueParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getCfoInsightsRevenue>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetCfoInsightsRevenueQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getNotificationCatalogRevenue = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<RevenueNotificationCatalogResponse>(
    { url: `/back-api/api/v1/revenue/notifications/catalog`, method: 'GET', signal },
    options
  );
};

export const getGetNotificationCatalogRevenueQueryKey = () => {
  return [`/back-api/api/v1/revenue/notifications/catalog`] as const;
};

export const getGetNotificationCatalogRevenueQueryOptions = <
  TData = Awaited<ReturnType<typeof getNotificationCatalogRevenue>>,
  TError = ErrorType<void>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getNotificationCatalogRevenue>>, TError, TData>;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetNotificationCatalogRevenueQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getNotificationCatalogRevenue>>> = ({ signal }) =>
    getNotificationCatalogRevenue(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getNotificationCatalogRevenue>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetNotificationCatalogRevenueQueryResult = NonNullable<
  Awaited<ReturnType<typeof getNotificationCatalogRevenue>>
>;
export type GetNotificationCatalogRevenueQueryError = ErrorType<void>;

export function useGetNotificationCatalogRevenue<
  TData = Awaited<ReturnType<typeof getNotificationCatalogRevenue>>,
  TError = ErrorType<void>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getNotificationCatalogRevenue>>, TError, TData>;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetNotificationCatalogRevenueQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const listNotificationAdminRecipientsRevenue = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<RevenueNotificationAdminRecipientsResponse>(
    { url: `/back-api/api/v1/revenue/notifications/admin-recipients`, method: 'GET', signal },
    options
  );
};

export const getListNotificationAdminRecipientsRevenueQueryKey = () => {
  return [`/back-api/api/v1/revenue/notifications/admin-recipients`] as const;
};

export const getListNotificationAdminRecipientsRevenueQueryOptions = <
  TData = Awaited<ReturnType<typeof listNotificationAdminRecipientsRevenue>>,
  TError = ErrorType<void>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof listNotificationAdminRecipientsRevenue>>, TError, TData>;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListNotificationAdminRecipientsRevenueQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listNotificationAdminRecipientsRevenue>>> = ({ signal }) =>
    listNotificationAdminRecipientsRevenue(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listNotificationAdminRecipientsRevenue>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListNotificationAdminRecipientsRevenueQueryResult = NonNullable<
  Awaited<ReturnType<typeof listNotificationAdminRecipientsRevenue>>
>;
export type ListNotificationAdminRecipientsRevenueQueryError = ErrorType<void>;

export function useListNotificationAdminRecipientsRevenue<
  TData = Awaited<ReturnType<typeof listNotificationAdminRecipientsRevenue>>,
  TError = ErrorType<void>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof listNotificationAdminRecipientsRevenue>>, TError, TData>;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListNotificationAdminRecipientsRevenueQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getNotificationPreferencesRevenue = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<RevenueNotificationPreferencesResponse>(
    { url: `/back-api/api/v1/revenue/notifications/preferences`, method: 'GET', signal },
    options
  );
};

export const getGetNotificationPreferencesRevenueQueryKey = () => {
  return [`/back-api/api/v1/revenue/notifications/preferences`] as const;
};

export const getGetNotificationPreferencesRevenueQueryOptions = <
  TData = Awaited<ReturnType<typeof getNotificationPreferencesRevenue>>,
  TError = ErrorType<void>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getNotificationPreferencesRevenue>>, TError, TData>;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetNotificationPreferencesRevenueQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getNotificationPreferencesRevenue>>> = ({ signal }) =>
    getNotificationPreferencesRevenue(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getNotificationPreferencesRevenue>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetNotificationPreferencesRevenueQueryResult = NonNullable<
  Awaited<ReturnType<typeof getNotificationPreferencesRevenue>>
>;
export type GetNotificationPreferencesRevenueQueryError = ErrorType<void>;

export function useGetNotificationPreferencesRevenue<
  TData = Awaited<ReturnType<typeof getNotificationPreferencesRevenue>>,
  TError = ErrorType<void>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getNotificationPreferencesRevenue>>, TError, TData>;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetNotificationPreferencesRevenueQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const updateNotificationPreferencesRevenue = (
  updateRevenueNotificationPreferencesRequest: UpdateRevenueNotificationPreferencesRequest,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<RevenueNotificationPreferencesResponse>(
    {
      url: `/back-api/api/v1/revenue/notifications/preferences`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: updateRevenueNotificationPreferencesRequest,
    },
    options
  );
};

export const getUpdateNotificationPreferencesRevenueMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateNotificationPreferencesRevenue>>,
    TError,
    { data: UpdateRevenueNotificationPreferencesRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateNotificationPreferencesRevenue>>,
  TError,
  { data: UpdateRevenueNotificationPreferencesRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateNotificationPreferencesRevenue>>,
    { data: UpdateRevenueNotificationPreferencesRequest }
  > = props => {
    const { data } = props ?? {};

    return updateNotificationPreferencesRevenue(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateNotificationPreferencesRevenueMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateNotificationPreferencesRevenue>>
>;
export type UpdateNotificationPreferencesRevenueMutationBody = UpdateRevenueNotificationPreferencesRequest;
export type UpdateNotificationPreferencesRevenueMutationError = ErrorType<void>;

export const useUpdateNotificationPreferencesRevenue = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateNotificationPreferencesRevenue>>,
    TError,
    { data: UpdateRevenueNotificationPreferencesRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateNotificationPreferencesRevenue>>,
  TError,
  { data: UpdateRevenueNotificationPreferencesRequest },
  TContext
> => {
  const mutationOptions = getUpdateNotificationPreferencesRevenueMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getNotificationDeliveryLogRevenue = (
  params?: GetNotificationDeliveryLogRevenueParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<RevenueNotificationDeliveryLogResponse>(
    { url: `/back-api/api/v1/revenue/notifications/delivery-log`, method: 'GET', params, signal },
    options
  );
};

export const getGetNotificationDeliveryLogRevenueQueryKey = (params?: GetNotificationDeliveryLogRevenueParams) => {
  return [`/back-api/api/v1/revenue/notifications/delivery-log`, ...(params ? [params] : [])] as const;
};

export const getGetNotificationDeliveryLogRevenueQueryOptions = <
  TData = Awaited<ReturnType<typeof getNotificationDeliveryLogRevenue>>,
  TError = ErrorType<void>
>(
  params?: GetNotificationDeliveryLogRevenueParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getNotificationDeliveryLogRevenue>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetNotificationDeliveryLogRevenueQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getNotificationDeliveryLogRevenue>>> = ({ signal }) =>
    getNotificationDeliveryLogRevenue(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getNotificationDeliveryLogRevenue>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetNotificationDeliveryLogRevenueQueryResult = NonNullable<
  Awaited<ReturnType<typeof getNotificationDeliveryLogRevenue>>
>;
export type GetNotificationDeliveryLogRevenueQueryError = ErrorType<void>;

export function useGetNotificationDeliveryLogRevenue<
  TData = Awaited<ReturnType<typeof getNotificationDeliveryLogRevenue>>,
  TError = ErrorType<void>
>(
  params?: GetNotificationDeliveryLogRevenueParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getNotificationDeliveryLogRevenue>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetNotificationDeliveryLogRevenueQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const sendTestAlertRevenue = (options?: SecondParameter<typeof customInstance>) => {
  return customInstance<RevenueNotificationPayloadResponse>(
    { url: `/back-api/api/v1/revenue/notifications/test-alert`, method: 'POST' },
    options
  );
};

export const getSendTestAlertRevenueMutationOptions = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof sendTestAlertRevenue>>, TError, void, TContext>;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<Awaited<ReturnType<typeof sendTestAlertRevenue>>, TError, void, TContext> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendTestAlertRevenue>>, void> = () => {
    return sendTestAlertRevenue(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SendTestAlertRevenueMutationResult = NonNullable<Awaited<ReturnType<typeof sendTestAlertRevenue>>>;

export type SendTestAlertRevenueMutationError = ErrorType<void>;

export const useSendTestAlertRevenue = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof sendTestAlertRevenue>>, TError, void, TContext>;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<Awaited<ReturnType<typeof sendTestAlertRevenue>>, TError, void, TContext> => {
  const mutationOptions = getSendTestAlertRevenueMutationOptions(options);

  return useMutation(mutationOptions);
};

export const sendTestReportRevenue = (
  params?: SendTestReportRevenueParams,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<RevenueNotificationPayloadResponse>(
    { url: `/back-api/api/v1/revenue/notifications/test-report`, method: 'POST', params },
    options
  );
};

export const getSendTestReportRevenueMutationOptions = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendTestReportRevenue>>,
    TError,
    { params?: SendTestReportRevenueParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sendTestReportRevenue>>,
  TError,
  { params?: SendTestReportRevenueParams },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sendTestReportRevenue>>,
    { params?: SendTestReportRevenueParams }
  > = props => {
    const { params } = props ?? {};

    return sendTestReportRevenue(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SendTestReportRevenueMutationResult = NonNullable<Awaited<ReturnType<typeof sendTestReportRevenue>>>;

export type SendTestReportRevenueMutationError = ErrorType<void>;

export const useSendTestReportRevenue = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendTestReportRevenue>>,
    TError,
    { params?: SendTestReportRevenueParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof sendTestReportRevenue>>,
  TError,
  { params?: SendTestReportRevenueParams },
  TContext
> => {
  const mutationOptions = getSendTestReportRevenueMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Lists rewards for admin with optional filters and pagination.
 */
export const listReward = (
  params?: ListRewardParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<RewardAdminResponseFilteredResponse>(
    { url: `/back-api/api/rewards`, method: 'GET', params, signal },
    options
  );
};

export const getListRewardQueryKey = (params?: ListRewardParams) => {
  return [`/back-api/api/rewards`, ...(params ? [params] : [])] as const;
};

export const getListRewardQueryOptions = <TData = Awaited<ReturnType<typeof listReward>>, TError = ErrorType<void>>(
  params?: ListRewardParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof listReward>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListRewardQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listReward>>> = ({ signal }) =>
    listReward(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listReward>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListRewardQueryResult = NonNullable<Awaited<ReturnType<typeof listReward>>>;
export type ListRewardQueryError = ErrorType<void>;

/**
 * @summary Lists rewards for admin with optional filters and pagination.
 */

export function useListReward<TData = Awaited<ReturnType<typeof listReward>>, TError = ErrorType<void>>(
  params?: ListRewardParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof listReward>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListRewardQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Adds rewards by admin.
 */
export const addRewardByAdmin = (
  rewardRequestModel: RewardRequestModel[],
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<void>(
    {
      url: `/back-api/api/rewards/add`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: rewardRequestModel,
    },
    options
  );
};

export const getAddRewardByAdminMutationOptions = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addRewardByAdmin>>,
    TError,
    { data: RewardRequestModel[] },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof addRewardByAdmin>>,
  TError,
  { data: RewardRequestModel[] },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof addRewardByAdmin>>,
    { data: RewardRequestModel[] }
  > = props => {
    const { data } = props ?? {};

    return addRewardByAdmin(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AddRewardByAdminMutationResult = NonNullable<Awaited<ReturnType<typeof addRewardByAdmin>>>;
export type AddRewardByAdminMutationBody = RewardRequestModel[];
export type AddRewardByAdminMutationError = ErrorType<void>;

/**
 * @summary Adds rewards by admin.
 */
export const useAddRewardByAdmin = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addRewardByAdmin>>,
    TError,
    { data: RewardRequestModel[] },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof addRewardByAdmin>>,
  TError,
  { data: RewardRequestModel[] },
  TContext
> => {
  const mutationOptions = getAddRewardByAdminMutationOptions(options);

  return useMutation(mutationOptions);
};

export const updateRole = (roleRequest: RoleRequest, options?: SecondParameter<typeof customInstance>) => {
  return customInstance<void>(
    {
      url: `/back-api/api/v2/roles`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: roleRequest,
    },
    options
  );
};

export const getUpdateRoleMutationOptions = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof updateRole>>, TError, { data: RoleRequest }, TContext>;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<Awaited<ReturnType<typeof updateRole>>, TError, { data: RoleRequest }, TContext> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateRole>>, { data: RoleRequest }> = props => {
    const { data } = props ?? {};

    return updateRole(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateRoleMutationResult = NonNullable<Awaited<ReturnType<typeof updateRole>>>;
export type UpdateRoleMutationBody = RoleRequest;
export type UpdateRoleMutationError = ErrorType<void>;

export const useUpdateRole = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof updateRole>>, TError, { data: RoleRequest }, TContext>;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<Awaited<ReturnType<typeof updateRole>>, TError, { data: RoleRequest }, TContext> => {
  const mutationOptions = getUpdateRoleMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Adds role(s) to user
 */
export const addRole = (roleRequest: RoleRequest, options?: SecondParameter<typeof customInstance>) => {
  return customInstance<void>(
    {
      url: `/back-api/api/v2/roles/add`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: roleRequest,
    },
    options
  );
};

export const getAddRoleMutationOptions = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof addRole>>, TError, { data: RoleRequest }, TContext>;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<Awaited<ReturnType<typeof addRole>>, TError, { data: RoleRequest }, TContext> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof addRole>>, { data: RoleRequest }> = props => {
    const { data } = props ?? {};

    return addRole(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AddRoleMutationResult = NonNullable<Awaited<ReturnType<typeof addRole>>>;
export type AddRoleMutationBody = RoleRequest;
export type AddRoleMutationError = ErrorType<void>;

/**
 * @summary Adds role(s) to user
 */
export const useAddRole = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof addRole>>, TError, { data: RoleRequest }, TContext>;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<Awaited<ReturnType<typeof addRole>>, TError, { data: RoleRequest }, TContext> => {
  const mutationOptions = getAddRoleMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Removes all user's roles, if any.
 */
export const removeRoles = (roleRequest: RoleRequest, options?: SecondParameter<typeof customInstance>) => {
  return customInstance<void>(
    {
      url: `/back-api/api/v2/roles/remove`,
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: roleRequest,
    },
    options
  );
};

export const getRemoveRolesMutationOptions = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof removeRoles>>, TError, { data: RoleRequest }, TContext>;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<Awaited<ReturnType<typeof removeRoles>>, TError, { data: RoleRequest }, TContext> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeRoles>>, { data: RoleRequest }> = props => {
    const { data } = props ?? {};

    return removeRoles(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RemoveRolesMutationResult = NonNullable<Awaited<ReturnType<typeof removeRoles>>>;
export type RemoveRolesMutationBody = RoleRequest;
export type RemoveRolesMutationError = ErrorType<void>;

/**
 * @summary Removes all user's roles, if any.
 */
export const useRemoveRoles = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof removeRoles>>, TError, { data: RoleRequest }, TContext>;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<Awaited<ReturnType<typeof removeRoles>>, TError, { data: RoleRequest }, TContext> => {
  const mutationOptions = getRemoveRolesMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Query trades that match the filter.
 */
export const tradesGetOrders = (
  params: TradesGetOrdersParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<TradesResponse>({ url: `/back-api/api/v2/trades`, method: 'GET', params, signal }, options);
};

export const getTradesGetOrdersQueryKey = (params: TradesGetOrdersParams) => {
  return [`/back-api/api/v2/trades`, ...(params ? [params] : [])] as const;
};

export const getTradesGetOrdersQueryOptions = <
  TData = Awaited<ReturnType<typeof tradesGetOrders>>,
  TError = ErrorType<void>
>(
  params: TradesGetOrdersParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof tradesGetOrders>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getTradesGetOrdersQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof tradesGetOrders>>> = ({ signal }) =>
    tradesGetOrders(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof tradesGetOrders>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type TradesGetOrdersQueryResult = NonNullable<Awaited<ReturnType<typeof tradesGetOrders>>>;
export type TradesGetOrdersQueryError = ErrorType<void>;

/**
 * @summary Query trades that match the filter.
 */

export function useTradesGetOrders<TData = Awaited<ReturnType<typeof tradesGetOrders>>, TError = ErrorType<void>>(
  params: TradesGetOrdersParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof tradesGetOrders>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getTradesGetOrdersQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getAllTransfer = (
  accountId: number,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<TransferRecord[]>(
    { url: `/back-api/backoffice/transfers/${accountId}`, method: 'GET', signal },
    options
  );
};

export const getGetAllTransferQueryKey = (accountId: number) => {
  return [`/back-api/backoffice/transfers/${accountId}`] as const;
};

export const getGetAllTransferQueryOptions = <
  TData = Awaited<ReturnType<typeof getAllTransfer>>,
  TError = ErrorType<void>
>(
  accountId: number,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getAllTransfer>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAllTransferQueryKey(accountId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllTransfer>>> = ({ signal }) =>
    getAllTransfer(accountId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!accountId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAllTransfer>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAllTransferQueryResult = NonNullable<Awaited<ReturnType<typeof getAllTransfer>>>;
export type GetAllTransferQueryError = ErrorType<void>;

export function useGetAllTransfer<TData = Awaited<ReturnType<typeof getAllTransfer>>, TError = ErrorType<void>>(
  accountId: number,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getAllTransfer>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetAllTransferQueryOptions(accountId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Query deposit/withdrawal details.
 */
export const getTransfers = (
  params?: GetTransfersParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<TransfersResponse>(
    { url: `/back-api/api/v2/transfers`, method: 'GET', params, signal },
    options
  );
};

export const getGetTransfersQueryKey = (params?: GetTransfersParams) => {
  return [`/back-api/api/v2/transfers`, ...(params ? [params] : [])] as const;
};

export const getGetTransfersQueryOptions = <
  TData = Awaited<ReturnType<typeof getTransfers>>,
  TError = ErrorType<ApiErrorResponse | void>
>(
  params?: GetTransfersParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getTransfers>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTransfersQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTransfers>>> = ({ signal }) =>
    getTransfers(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTransfers>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetTransfersQueryResult = NonNullable<Awaited<ReturnType<typeof getTransfers>>>;
export type GetTransfersQueryError = ErrorType<ApiErrorResponse | void>;

/**
 * @summary Query deposit/withdrawal details.
 */

export function useGetTransfers<
  TData = Awaited<ReturnType<typeof getTransfers>>,
  TError = ErrorType<ApiErrorResponse | void>
>(
  params?: GetTransfersParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getTransfers>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetTransfersQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Adds custom transfer to specified user account which allows to manually modify user balance.
After entering invalid code for 3 times you should create a new request.
 */
export const transferTransfers = (
  manualTransferRequest: ManualTransferRequest,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<AdminManualTransferResponse>(
    {
      url: `/back-api/api/v2/transfers`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: manualTransferRequest,
    },
    options
  );
};

export const getTransferTransfersMutationOptions = <
  TError = ErrorType<void | ApiErrorResponse>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof transferTransfers>>,
    TError,
    { data: ManualTransferRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof transferTransfers>>,
  TError,
  { data: ManualTransferRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof transferTransfers>>,
    { data: ManualTransferRequest }
  > = props => {
    const { data } = props ?? {};

    return transferTransfers(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TransferTransfersMutationResult = NonNullable<Awaited<ReturnType<typeof transferTransfers>>>;
export type TransferTransfersMutationBody = ManualTransferRequest;
export type TransferTransfersMutationError = ErrorType<void | ApiErrorResponse>;

/**
 * @summary Adds custom transfer to specified user account which allows to manually modify user balance.
After entering invalid code for 3 times you should create a new request.
 */
export const useTransferTransfers = <TError = ErrorType<void | ApiErrorResponse>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof transferTransfers>>,
    TError,
    { data: ManualTransferRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof transferTransfers>>,
  TError,
  { data: ManualTransferRequest },
  TContext
> => {
  const mutationOptions = getTransferTransfersMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getTransfersAsCsv = (
  params?: GetTransfersAsCsvParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<TransfersResponse>(
    { url: `/back-api/api/v2/transfers.csv`, method: 'GET', params, signal },
    options
  );
};

export const getGetTransfersAsCsvQueryKey = (params?: GetTransfersAsCsvParams) => {
  return [`/back-api/api/v2/transfers.csv`, ...(params ? [params] : [])] as const;
};

export const getGetTransfersAsCsvQueryOptions = <
  TData = Awaited<ReturnType<typeof getTransfersAsCsv>>,
  TError = ErrorType<ApiErrorResponse | void>
>(
  params?: GetTransfersAsCsvParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getTransfersAsCsv>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTransfersAsCsvQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTransfersAsCsv>>> = ({ signal }) =>
    getTransfersAsCsv(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTransfersAsCsv>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetTransfersAsCsvQueryResult = NonNullable<Awaited<ReturnType<typeof getTransfersAsCsv>>>;
export type GetTransfersAsCsvQueryError = ErrorType<ApiErrorResponse | void>;

export function useGetTransfersAsCsv<
  TData = Awaited<ReturnType<typeof getTransfersAsCsv>>,
  TError = ErrorType<ApiErrorResponse | void>
>(
  params?: GetTransfersAsCsvParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getTransfersAsCsv>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetTransfersAsCsvQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Approves a specific deposit that is in the PendingReview status.
 */
export const approvePendingReviewDepositTransfers = (
  approvePendingReviewDepositRequest: ApprovePendingReviewDepositRequest,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<void>(
    {
      url: `/back-api/api/v2/approve-pending-review`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: approvePendingReviewDepositRequest,
    },
    options
  );
};

export const getApprovePendingReviewDepositTransfersMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof approvePendingReviewDepositTransfers>>,
    TError,
    { data: ApprovePendingReviewDepositRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof approvePendingReviewDepositTransfers>>,
  TError,
  { data: ApprovePendingReviewDepositRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof approvePendingReviewDepositTransfers>>,
    { data: ApprovePendingReviewDepositRequest }
  > = props => {
    const { data } = props ?? {};

    return approvePendingReviewDepositTransfers(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApprovePendingReviewDepositTransfersMutationResult = NonNullable<
  Awaited<ReturnType<typeof approvePendingReviewDepositTransfers>>
>;
export type ApprovePendingReviewDepositTransfersMutationBody = ApprovePendingReviewDepositRequest;
export type ApprovePendingReviewDepositTransfersMutationError = ErrorType<void>;

/**
 * @summary Approves a specific deposit that is in the PendingReview status.
 */
export const useApprovePendingReviewDepositTransfers = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof approvePendingReviewDepositTransfers>>,
    TError,
    { data: ApprovePendingReviewDepositRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof approvePendingReviewDepositTransfers>>,
  TError,
  { data: ApprovePendingReviewDepositRequest },
  TContext
> => {
  const mutationOptions = getApprovePendingReviewDepositTransfersMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getSnapshotTreasury = (options?: SecondParameter<typeof customInstance>, signal?: AbortSignal) => {
  return customInstance<TreasurySnapshotResponse>(
    { url: `/back-api/api/v1/treasury/snapshot`, method: 'GET', signal },
    options
  );
};

export const getGetSnapshotTreasuryQueryKey = () => {
  return [`/back-api/api/v1/treasury/snapshot`] as const;
};

export const getGetSnapshotTreasuryQueryOptions = <
  TData = Awaited<ReturnType<typeof getSnapshotTreasury>>,
  TError = ErrorType<void>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getSnapshotTreasury>>, TError, TData>;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSnapshotTreasuryQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSnapshotTreasury>>> = ({ signal }) =>
    getSnapshotTreasury(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSnapshotTreasury>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetSnapshotTreasuryQueryResult = NonNullable<Awaited<ReturnType<typeof getSnapshotTreasury>>>;
export type GetSnapshotTreasuryQueryError = ErrorType<void>;

export function useGetSnapshotTreasury<
  TData = Awaited<ReturnType<typeof getSnapshotTreasury>>,
  TError = ErrorType<void>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getSnapshotTreasury>>, TError, TData>;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetSnapshotTreasuryQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getAnalyticsTreasury = (
  params?: GetAnalyticsTreasuryParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<TreasuryAnalyticsResponse>(
    { url: `/back-api/api/v1/treasury/analytics`, method: 'GET', params, signal },
    options
  );
};

export const getGetAnalyticsTreasuryQueryKey = (params?: GetAnalyticsTreasuryParams) => {
  return [`/back-api/api/v1/treasury/analytics`, ...(params ? [params] : [])] as const;
};

export const getGetAnalyticsTreasuryQueryOptions = <
  TData = Awaited<ReturnType<typeof getAnalyticsTreasury>>,
  TError = ErrorType<void>
>(
  params?: GetAnalyticsTreasuryParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsTreasury>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAnalyticsTreasuryQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAnalyticsTreasury>>> = ({ signal }) =>
    getAnalyticsTreasury(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAnalyticsTreasury>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAnalyticsTreasuryQueryResult = NonNullable<Awaited<ReturnType<typeof getAnalyticsTreasury>>>;
export type GetAnalyticsTreasuryQueryError = ErrorType<void>;

export function useGetAnalyticsTreasury<
  TData = Awaited<ReturnType<typeof getAnalyticsTreasury>>,
  TError = ErrorType<void>
>(
  params?: GetAnalyticsTreasuryParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsTreasury>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetAnalyticsTreasuryQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const listChainPoliciesTreasury = (options?: SecondParameter<typeof customInstance>, signal?: AbortSignal) => {
  return customInstance<TreasuryChainPolicyResponse[]>(
    { url: `/back-api/api/v1/treasury/chains`, method: 'GET', signal },
    options
  );
};

export const getListChainPoliciesTreasuryQueryKey = () => {
  return [`/back-api/api/v1/treasury/chains`] as const;
};

export const getListChainPoliciesTreasuryQueryOptions = <
  TData = Awaited<ReturnType<typeof listChainPoliciesTreasury>>,
  TError = ErrorType<void>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof listChainPoliciesTreasury>>, TError, TData>;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListChainPoliciesTreasuryQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listChainPoliciesTreasury>>> = ({ signal }) =>
    listChainPoliciesTreasury(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listChainPoliciesTreasury>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListChainPoliciesTreasuryQueryResult = NonNullable<Awaited<ReturnType<typeof listChainPoliciesTreasury>>>;
export type ListChainPoliciesTreasuryQueryError = ErrorType<void>;

export function useListChainPoliciesTreasury<
  TData = Awaited<ReturnType<typeof listChainPoliciesTreasury>>,
  TError = ErrorType<void>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof listChainPoliciesTreasury>>, TError, TData>;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListChainPoliciesTreasuryQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getChainPolicyTreasury = (
  paymentSystem: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<TreasuryChainPolicyResponse>(
    { url: `/back-api/api/v1/treasury/chains/${paymentSystem}`, method: 'GET', signal },
    options
  );
};

export const getGetChainPolicyTreasuryQueryKey = (paymentSystem: string) => {
  return [`/back-api/api/v1/treasury/chains/${paymentSystem}`] as const;
};

export const getGetChainPolicyTreasuryQueryOptions = <
  TData = Awaited<ReturnType<typeof getChainPolicyTreasury>>,
  TError = ErrorType<void>
>(
  paymentSystem: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getChainPolicyTreasury>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetChainPolicyTreasuryQueryKey(paymentSystem);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getChainPolicyTreasury>>> = ({ signal }) =>
    getChainPolicyTreasury(paymentSystem, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!paymentSystem, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getChainPolicyTreasury>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetChainPolicyTreasuryQueryResult = NonNullable<Awaited<ReturnType<typeof getChainPolicyTreasury>>>;
export type GetChainPolicyTreasuryQueryError = ErrorType<void>;

export function useGetChainPolicyTreasury<
  TData = Awaited<ReturnType<typeof getChainPolicyTreasury>>,
  TError = ErrorType<void>
>(
  paymentSystem: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getChainPolicyTreasury>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetChainPolicyTreasuryQueryOptions(paymentSystem, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const updateChainPolicyTreasury = (
  paymentSystem: string,
  updateTreasuryChainPolicyRequest: UpdateTreasuryChainPolicyRequest,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<TreasuryChainPolicyResponse>(
    {
      url: `/back-api/api/v1/treasury/chains/${paymentSystem}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: updateTreasuryChainPolicyRequest,
    },
    options
  );
};

export const getUpdateChainPolicyTreasuryMutationOptions = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateChainPolicyTreasury>>,
    TError,
    { paymentSystem: string; data: UpdateTreasuryChainPolicyRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateChainPolicyTreasury>>,
  TError,
  { paymentSystem: string; data: UpdateTreasuryChainPolicyRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateChainPolicyTreasury>>,
    { paymentSystem: string; data: UpdateTreasuryChainPolicyRequest }
  > = props => {
    const { paymentSystem, data } = props ?? {};

    return updateChainPolicyTreasury(paymentSystem, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateChainPolicyTreasuryMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateChainPolicyTreasury>>
>;
export type UpdateChainPolicyTreasuryMutationBody = UpdateTreasuryChainPolicyRequest;
export type UpdateChainPolicyTreasuryMutationError = ErrorType<void>;

export const useUpdateChainPolicyTreasury = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateChainPolicyTreasury>>,
    TError,
    { paymentSystem: string; data: UpdateTreasuryChainPolicyRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateChainPolicyTreasury>>,
  TError,
  { paymentSystem: string; data: UpdateTreasuryChainPolicyRequest },
  TContext
> => {
  const mutationOptions = getUpdateChainPolicyTreasuryMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getRebalancePolicyTreasury = (options?: SecondParameter<typeof customInstance>, signal?: AbortSignal) => {
  return customInstance<TreasuryRebalancePolicyResponse>(
    { url: `/back-api/api/v1/treasury/rebalance-policy`, method: 'GET', signal },
    options
  );
};

export const getGetRebalancePolicyTreasuryQueryKey = () => {
  return [`/back-api/api/v1/treasury/rebalance-policy`] as const;
};

export const getGetRebalancePolicyTreasuryQueryOptions = <
  TData = Awaited<ReturnType<typeof getRebalancePolicyTreasury>>,
  TError = ErrorType<void>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getRebalancePolicyTreasury>>, TError, TData>;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetRebalancePolicyTreasuryQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getRebalancePolicyTreasury>>> = ({ signal }) =>
    getRebalancePolicyTreasury(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getRebalancePolicyTreasury>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetRebalancePolicyTreasuryQueryResult = NonNullable<Awaited<ReturnType<typeof getRebalancePolicyTreasury>>>;
export type GetRebalancePolicyTreasuryQueryError = ErrorType<void>;

export function useGetRebalancePolicyTreasury<
  TData = Awaited<ReturnType<typeof getRebalancePolicyTreasury>>,
  TError = ErrorType<void>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getRebalancePolicyTreasury>>, TError, TData>;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetRebalancePolicyTreasuryQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const updateRebalancePolicyTreasury = (
  updateTreasuryRebalancePolicyRequest: UpdateTreasuryRebalancePolicyRequest,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<TreasuryRebalancePolicyResponse>(
    {
      url: `/back-api/api/v1/treasury/rebalance-policy`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: updateTreasuryRebalancePolicyRequest,
    },
    options
  );
};

export const getUpdateRebalancePolicyTreasuryMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateRebalancePolicyTreasury>>,
    TError,
    { data: UpdateTreasuryRebalancePolicyRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateRebalancePolicyTreasury>>,
  TError,
  { data: UpdateTreasuryRebalancePolicyRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateRebalancePolicyTreasury>>,
    { data: UpdateTreasuryRebalancePolicyRequest }
  > = props => {
    const { data } = props ?? {};

    return updateRebalancePolicyTreasury(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateRebalancePolicyTreasuryMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateRebalancePolicyTreasury>>
>;
export type UpdateRebalancePolicyTreasuryMutationBody = UpdateTreasuryRebalancePolicyRequest;
export type UpdateRebalancePolicyTreasuryMutationError = ErrorType<void>;

export const useUpdateRebalancePolicyTreasury = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateRebalancePolicyTreasury>>,
    TError,
    { data: UpdateTreasuryRebalancePolicyRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateRebalancePolicyTreasury>>,
  TError,
  { data: UpdateTreasuryRebalancePolicyRequest },
  TContext
> => {
  const mutationOptions = getUpdateRebalancePolicyTreasuryMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getWithdrawalLiquidityHintTreasury = (
  params?: GetWithdrawalLiquidityHintTreasuryParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<TreasuryWithdrawalLiquidityHintResponse>(
    { url: `/back-api/api/v1/treasury/withdrawal-liquidity-hints`, method: 'GET', params, signal },
    options
  );
};

export const getGetWithdrawalLiquidityHintTreasuryQueryKey = (params?: GetWithdrawalLiquidityHintTreasuryParams) => {
  return [`/back-api/api/v1/treasury/withdrawal-liquidity-hints`, ...(params ? [params] : [])] as const;
};

export const getGetWithdrawalLiquidityHintTreasuryQueryOptions = <
  TData = Awaited<ReturnType<typeof getWithdrawalLiquidityHintTreasury>>,
  TError = ErrorType<void>
>(
  params?: GetWithdrawalLiquidityHintTreasuryParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getWithdrawalLiquidityHintTreasury>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetWithdrawalLiquidityHintTreasuryQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getWithdrawalLiquidityHintTreasury>>> = ({ signal }) =>
    getWithdrawalLiquidityHintTreasury(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getWithdrawalLiquidityHintTreasury>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetWithdrawalLiquidityHintTreasuryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getWithdrawalLiquidityHintTreasury>>
>;
export type GetWithdrawalLiquidityHintTreasuryQueryError = ErrorType<void>;

export function useGetWithdrawalLiquidityHintTreasury<
  TData = Awaited<ReturnType<typeof getWithdrawalLiquidityHintTreasury>>,
  TError = ErrorType<void>
>(
  params?: GetWithdrawalLiquidityHintTreasuryParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getWithdrawalLiquidityHintTreasury>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetWithdrawalLiquidityHintTreasuryQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const listAuditLogTreasury = (
  params?: ListAuditLogTreasuryParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<TreasuryAuditLogResponseFilteredResponse>(
    { url: `/back-api/api/v1/treasury/audit-log`, method: 'GET', params, signal },
    options
  );
};

export const getListAuditLogTreasuryQueryKey = (params?: ListAuditLogTreasuryParams) => {
  return [`/back-api/api/v1/treasury/audit-log`, ...(params ? [params] : [])] as const;
};

export const getListAuditLogTreasuryQueryOptions = <
  TData = Awaited<ReturnType<typeof listAuditLogTreasury>>,
  TError = ErrorType<void>
>(
  params?: ListAuditLogTreasuryParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof listAuditLogTreasury>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListAuditLogTreasuryQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listAuditLogTreasury>>> = ({ signal }) =>
    listAuditLogTreasury(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listAuditLogTreasury>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListAuditLogTreasuryQueryResult = NonNullable<Awaited<ReturnType<typeof listAuditLogTreasury>>>;
export type ListAuditLogTreasuryQueryError = ErrorType<void>;

export function useListAuditLogTreasury<
  TData = Awaited<ReturnType<typeof listAuditLogTreasury>>,
  TError = ErrorType<void>
>(
  params?: ListAuditLogTreasuryParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof listAuditLogTreasury>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListAuditLogTreasuryQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const listSuggestionsTreasury = (
  params?: ListSuggestionsTreasuryParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<TreasurySuggestionResponseFilteredResponse>(
    { url: `/back-api/api/v1/treasury/suggestions`, method: 'GET', params, signal },
    options
  );
};

export const getListSuggestionsTreasuryQueryKey = (params?: ListSuggestionsTreasuryParams) => {
  return [`/back-api/api/v1/treasury/suggestions`, ...(params ? [params] : [])] as const;
};

export const getListSuggestionsTreasuryQueryOptions = <
  TData = Awaited<ReturnType<typeof listSuggestionsTreasury>>,
  TError = ErrorType<void>
>(
  params?: ListSuggestionsTreasuryParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof listSuggestionsTreasury>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListSuggestionsTreasuryQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listSuggestionsTreasury>>> = ({ signal }) =>
    listSuggestionsTreasury(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listSuggestionsTreasury>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListSuggestionsTreasuryQueryResult = NonNullable<Awaited<ReturnType<typeof listSuggestionsTreasury>>>;
export type ListSuggestionsTreasuryQueryError = ErrorType<void>;

export function useListSuggestionsTreasury<
  TData = Awaited<ReturnType<typeof listSuggestionsTreasury>>,
  TError = ErrorType<void>
>(
  params?: ListSuggestionsTreasuryParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof listSuggestionsTreasury>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListSuggestionsTreasuryQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getSuggestionTreasury = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<TreasurySuggestionResponse>(
    { url: `/back-api/api/v1/treasury/suggestions/${id}`, method: 'GET', signal },
    options
  );
};

export const getGetSuggestionTreasuryQueryKey = (id: string) => {
  return [`/back-api/api/v1/treasury/suggestions/${id}`] as const;
};

export const getGetSuggestionTreasuryQueryOptions = <
  TData = Awaited<ReturnType<typeof getSuggestionTreasury>>,
  TError = ErrorType<void>
>(
  id: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getSuggestionTreasury>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSuggestionTreasuryQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSuggestionTreasury>>> = ({ signal }) =>
    getSuggestionTreasury(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSuggestionTreasury>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetSuggestionTreasuryQueryResult = NonNullable<Awaited<ReturnType<typeof getSuggestionTreasury>>>;
export type GetSuggestionTreasuryQueryError = ErrorType<void>;

export function useGetSuggestionTreasury<
  TData = Awaited<ReturnType<typeof getSuggestionTreasury>>,
  TError = ErrorType<void>
>(
  id: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getSuggestionTreasury>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetSuggestionTreasuryQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const runIntelligenceTreasury = (options?: SecondParameter<typeof customInstance>) => {
  return customInstance<TreasuryIntelligenceRunResult>(
    { url: `/back-api/api/v1/treasury/suggestions/run`, method: 'POST' },
    options
  );
};

export const getRunIntelligenceTreasuryMutationOptions = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof runIntelligenceTreasury>>, TError, void, TContext>;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<Awaited<ReturnType<typeof runIntelligenceTreasury>>, TError, void, TContext> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof runIntelligenceTreasury>>, void> = () => {
    return runIntelligenceTreasury(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RunIntelligenceTreasuryMutationResult = NonNullable<Awaited<ReturnType<typeof runIntelligenceTreasury>>>;

export type RunIntelligenceTreasuryMutationError = ErrorType<void>;

export const useRunIntelligenceTreasury = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof runIntelligenceTreasury>>, TError, void, TContext>;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<Awaited<ReturnType<typeof runIntelligenceTreasury>>, TError, void, TContext> => {
  const mutationOptions = getRunIntelligenceTreasuryMutationOptions(options);

  return useMutation(mutationOptions);
};

export const approveSuggestionTreasury = (id: string, options?: SecondParameter<typeof customInstance>) => {
  return customInstance<TreasuryRebalanceExecutionResponse>(
    { url: `/back-api/api/v1/treasury/suggestions/${id}/approve`, method: 'POST' },
    options
  );
};

export const getApproveSuggestionTreasuryMutationOptions = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof approveSuggestionTreasury>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<Awaited<ReturnType<typeof approveSuggestionTreasury>>, TError, { id: string }, TContext> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof approveSuggestionTreasury>>, { id: string }> = props => {
    const { id } = props ?? {};

    return approveSuggestionTreasury(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApproveSuggestionTreasuryMutationResult = NonNullable<
  Awaited<ReturnType<typeof approveSuggestionTreasury>>
>;

export type ApproveSuggestionTreasuryMutationError = ErrorType<void>;

export const useApproveSuggestionTreasury = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof approveSuggestionTreasury>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<Awaited<ReturnType<typeof approveSuggestionTreasury>>, TError, { id: string }, TContext> => {
  const mutationOptions = getApproveSuggestionTreasuryMutationOptions(options);

  return useMutation(mutationOptions);
};

export const rejectSuggestionTreasury = (id: string, options?: SecondParameter<typeof customInstance>) => {
  return customInstance<TreasurySuggestionResponse>(
    { url: `/back-api/api/v1/treasury/suggestions/${id}/reject`, method: 'POST' },
    options
  );
};

export const getRejectSuggestionTreasuryMutationOptions = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof rejectSuggestionTreasury>>, TError, { id: string }, TContext>;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<Awaited<ReturnType<typeof rejectSuggestionTreasury>>, TError, { id: string }, TContext> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof rejectSuggestionTreasury>>, { id: string }> = props => {
    const { id } = props ?? {};

    return rejectSuggestionTreasury(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RejectSuggestionTreasuryMutationResult = NonNullable<Awaited<ReturnType<typeof rejectSuggestionTreasury>>>;

export type RejectSuggestionTreasuryMutationError = ErrorType<void>;

export const useRejectSuggestionTreasury = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof rejectSuggestionTreasury>>, TError, { id: string }, TContext>;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<Awaited<ReturnType<typeof rejectSuggestionTreasury>>, TError, { id: string }, TContext> => {
  const mutationOptions = getRejectSuggestionTreasuryMutationOptions(options);

  return useMutation(mutationOptions);
};

export const listExecutionsTreasury = (
  params?: ListExecutionsTreasuryParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<TreasuryRebalanceExecutionResponseFilteredResponse>(
    { url: `/back-api/api/v1/treasury/executions`, method: 'GET', params, signal },
    options
  );
};

export const getListExecutionsTreasuryQueryKey = (params?: ListExecutionsTreasuryParams) => {
  return [`/back-api/api/v1/treasury/executions`, ...(params ? [params] : [])] as const;
};

export const getListExecutionsTreasuryQueryOptions = <
  TData = Awaited<ReturnType<typeof listExecutionsTreasury>>,
  TError = ErrorType<void>
>(
  params?: ListExecutionsTreasuryParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof listExecutionsTreasury>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListExecutionsTreasuryQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listExecutionsTreasury>>> = ({ signal }) =>
    listExecutionsTreasury(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listExecutionsTreasury>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListExecutionsTreasuryQueryResult = NonNullable<Awaited<ReturnType<typeof listExecutionsTreasury>>>;
export type ListExecutionsTreasuryQueryError = ErrorType<void>;

export function useListExecutionsTreasury<
  TData = Awaited<ReturnType<typeof listExecutionsTreasury>>,
  TError = ErrorType<void>
>(
  params?: ListExecutionsTreasuryParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof listExecutionsTreasury>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListExecutionsTreasuryQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const listColdReplenishmentsTreasury = (
  params?: ListColdReplenishmentsTreasuryParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<TreasuryColdReplenishmentIntentResponseFilteredResponse>(
    { url: `/back-api/api/v1/treasury/cold-replenishments`, method: 'GET', params, signal },
    options
  );
};

export const getListColdReplenishmentsTreasuryQueryKey = (params?: ListColdReplenishmentsTreasuryParams) => {
  return [`/back-api/api/v1/treasury/cold-replenishments`, ...(params ? [params] : [])] as const;
};

export const getListColdReplenishmentsTreasuryQueryOptions = <
  TData = Awaited<ReturnType<typeof listColdReplenishmentsTreasury>>,
  TError = ErrorType<void>
>(
  params?: ListColdReplenishmentsTreasuryParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof listColdReplenishmentsTreasury>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListColdReplenishmentsTreasuryQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listColdReplenishmentsTreasury>>> = ({ signal }) =>
    listColdReplenishmentsTreasury(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listColdReplenishmentsTreasury>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListColdReplenishmentsTreasuryQueryResult = NonNullable<
  Awaited<ReturnType<typeof listColdReplenishmentsTreasury>>
>;
export type ListColdReplenishmentsTreasuryQueryError = ErrorType<void>;

export function useListColdReplenishmentsTreasury<
  TData = Awaited<ReturnType<typeof listColdReplenishmentsTreasury>>,
  TError = ErrorType<void>
>(
  params?: ListColdReplenishmentsTreasuryParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof listColdReplenishmentsTreasury>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListColdReplenishmentsTreasuryQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const createColdReplenishmentTreasury = (
  createTreasuryColdReplenishmentIntentRequest: CreateTreasuryColdReplenishmentIntentRequest,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<TreasuryColdReplenishmentIntentResponse>(
    {
      url: `/back-api/api/v1/treasury/cold-replenishments`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: createTreasuryColdReplenishmentIntentRequest,
    },
    options
  );
};

export const getCreateColdReplenishmentTreasuryMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createColdReplenishmentTreasury>>,
    TError,
    { data: CreateTreasuryColdReplenishmentIntentRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createColdReplenishmentTreasury>>,
  TError,
  { data: CreateTreasuryColdReplenishmentIntentRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createColdReplenishmentTreasury>>,
    { data: CreateTreasuryColdReplenishmentIntentRequest }
  > = props => {
    const { data } = props ?? {};

    return createColdReplenishmentTreasury(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateColdReplenishmentTreasuryMutationResult = NonNullable<
  Awaited<ReturnType<typeof createColdReplenishmentTreasury>>
>;
export type CreateColdReplenishmentTreasuryMutationBody = CreateTreasuryColdReplenishmentIntentRequest;
export type CreateColdReplenishmentTreasuryMutationError = ErrorType<void>;

export const useCreateColdReplenishmentTreasury = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createColdReplenishmentTreasury>>,
    TError,
    { data: CreateTreasuryColdReplenishmentIntentRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createColdReplenishmentTreasury>>,
  TError,
  { data: CreateTreasuryColdReplenishmentIntentRequest },
  TContext
> => {
  const mutationOptions = getCreateColdReplenishmentTreasuryMutationOptions(options);

  return useMutation(mutationOptions);
};

export const confirmColdReplenishmentTreasury = (
  id: string,
  confirmTreasuryColdReplenishmentIntentRequest: ConfirmTreasuryColdReplenishmentIntentRequest,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<TreasuryColdReplenishmentIntentResponse>(
    {
      url: `/back-api/api/v1/treasury/cold-replenishments/${id}/confirm`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: confirmTreasuryColdReplenishmentIntentRequest,
    },
    options
  );
};

export const getConfirmColdReplenishmentTreasuryMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof confirmColdReplenishmentTreasury>>,
    TError,
    { id: string; data: ConfirmTreasuryColdReplenishmentIntentRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof confirmColdReplenishmentTreasury>>,
  TError,
  { id: string; data: ConfirmTreasuryColdReplenishmentIntentRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof confirmColdReplenishmentTreasury>>,
    { id: string; data: ConfirmTreasuryColdReplenishmentIntentRequest }
  > = props => {
    const { id, data } = props ?? {};

    return confirmColdReplenishmentTreasury(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ConfirmColdReplenishmentTreasuryMutationResult = NonNullable<
  Awaited<ReturnType<typeof confirmColdReplenishmentTreasury>>
>;
export type ConfirmColdReplenishmentTreasuryMutationBody = ConfirmTreasuryColdReplenishmentIntentRequest;
export type ConfirmColdReplenishmentTreasuryMutationError = ErrorType<void>;

export const useConfirmColdReplenishmentTreasury = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof confirmColdReplenishmentTreasury>>,
    TError,
    { id: string; data: ConfirmTreasuryColdReplenishmentIntentRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof confirmColdReplenishmentTreasury>>,
  TError,
  { id: string; data: ConfirmTreasuryColdReplenishmentIntentRequest },
  TContext
> => {
  const mutationOptions = getConfirmColdReplenishmentTreasuryMutationOptions(options);

  return useMutation(mutationOptions);
};

export const cancelColdReplenishmentTreasury = (id: string, options?: SecondParameter<typeof customInstance>) => {
  return customInstance<TreasuryColdReplenishmentIntentResponse>(
    { url: `/back-api/api/v1/treasury/cold-replenishments/${id}/cancel`, method: 'POST' },
    options
  );
};

export const getCancelColdReplenishmentTreasuryMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cancelColdReplenishmentTreasury>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof cancelColdReplenishmentTreasury>>,
  TError,
  { id: string },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof cancelColdReplenishmentTreasury>>,
    { id: string }
  > = props => {
    const { id } = props ?? {};

    return cancelColdReplenishmentTreasury(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CancelColdReplenishmentTreasuryMutationResult = NonNullable<
  Awaited<ReturnType<typeof cancelColdReplenishmentTreasury>>
>;

export type CancelColdReplenishmentTreasuryMutationError = ErrorType<void>;

export const useCancelColdReplenishmentTreasury = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cancelColdReplenishmentTreasury>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof cancelColdReplenishmentTreasury>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getCancelColdReplenishmentTreasuryMutationOptions(options);

  return useMutation(mutationOptions);
};

export const listColdAggregationsTreasury = (
  params?: ListColdAggregationsTreasuryParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<TreasuryColdAggregationBatchResponseFilteredResponse>(
    { url: `/back-api/api/v1/treasury/cold-aggregations`, method: 'GET', params, signal },
    options
  );
};

export const getListColdAggregationsTreasuryQueryKey = (params?: ListColdAggregationsTreasuryParams) => {
  return [`/back-api/api/v1/treasury/cold-aggregations`, ...(params ? [params] : [])] as const;
};

export const getListColdAggregationsTreasuryQueryOptions = <
  TData = Awaited<ReturnType<typeof listColdAggregationsTreasury>>,
  TError = ErrorType<void>
>(
  params?: ListColdAggregationsTreasuryParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof listColdAggregationsTreasury>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListColdAggregationsTreasuryQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listColdAggregationsTreasury>>> = ({ signal }) =>
    listColdAggregationsTreasury(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listColdAggregationsTreasury>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListColdAggregationsTreasuryQueryResult = NonNullable<
  Awaited<ReturnType<typeof listColdAggregationsTreasury>>
>;
export type ListColdAggregationsTreasuryQueryError = ErrorType<void>;

export function useListColdAggregationsTreasury<
  TData = Awaited<ReturnType<typeof listColdAggregationsTreasury>>,
  TError = ErrorType<void>
>(
  params?: ListColdAggregationsTreasuryParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof listColdAggregationsTreasury>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListColdAggregationsTreasuryQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Download the unsigned aggregate transfers in the format accepted by ColdStorage.Signer.
 */
export const downloadColdAggregationTreasury = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<void>(
    { url: `/back-api/api/v1/treasury/cold-aggregations/${id}/download`, method: 'GET', signal },
    options
  );
};

export const getDownloadColdAggregationTreasuryQueryKey = (id: string) => {
  return [`/back-api/api/v1/treasury/cold-aggregations/${id}/download`] as const;
};

export const getDownloadColdAggregationTreasuryQueryOptions = <
  TData = Awaited<ReturnType<typeof downloadColdAggregationTreasury>>,
  TError = ErrorType<void | ProblemDetails>
>(
  id: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof downloadColdAggregationTreasury>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDownloadColdAggregationTreasuryQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadColdAggregationTreasury>>> = ({ signal }) =>
    downloadColdAggregationTreasury(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof downloadColdAggregationTreasury>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type DownloadColdAggregationTreasuryQueryResult = NonNullable<
  Awaited<ReturnType<typeof downloadColdAggregationTreasury>>
>;
export type DownloadColdAggregationTreasuryQueryError = ErrorType<void | ProblemDetails>;

/**
 * @summary Download the unsigned aggregate transfers in the format accepted by ColdStorage.Signer.
 */

export function useDownloadColdAggregationTreasury<
  TData = Awaited<ReturnType<typeof downloadColdAggregationTreasury>>,
  TError = ErrorType<void | ProblemDetails>
>(
  id: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof downloadColdAggregationTreasury>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getDownloadColdAggregationTreasuryQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Submits this batch's prepared EVM aggregation payload for native-coin fuel injection.
 */
export const injectColdAggregationFuelTreasury = (id: string, options?: SecondParameter<typeof customInstance>) => {
  return customInstance<TreasuryColdAggregationBatchResponse>(
    { url: `/back-api/api/v1/treasury/cold-aggregations/${id}/inject-fuel`, method: 'POST' },
    options
  );
};

export const getInjectColdAggregationFuelTreasuryMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof injectColdAggregationFuelTreasury>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof injectColdAggregationFuelTreasury>>,
  TError,
  { id: string },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof injectColdAggregationFuelTreasury>>,
    { id: string }
  > = props => {
    const { id } = props ?? {};

    return injectColdAggregationFuelTreasury(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type InjectColdAggregationFuelTreasuryMutationResult = NonNullable<
  Awaited<ReturnType<typeof injectColdAggregationFuelTreasury>>
>;

export type InjectColdAggregationFuelTreasuryMutationError = ErrorType<void>;

/**
 * @summary Submits this batch's prepared EVM aggregation payload for native-coin fuel injection.
 */
export const useInjectColdAggregationFuelTreasury = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof injectColdAggregationFuelTreasury>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof injectColdAggregationFuelTreasury>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getInjectColdAggregationFuelTreasuryMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Upload the signed transfers produced by ColdStorage.Signer and broadcast them.
 */
export const uploadSignedColdAggregationTreasury = (
  id: string,
  uploadSignedColdAggregationTreasuryBody: unknown,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<TreasuryColdAggregationBatchResponse>(
    {
      url: `/back-api/api/v1/treasury/cold-aggregations/${id}/upload-signed`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: uploadSignedColdAggregationTreasuryBody,
    },
    options
  );
};

export const getUploadSignedColdAggregationTreasuryMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof uploadSignedColdAggregationTreasury>>,
    TError,
    { id: string; data: unknown },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof uploadSignedColdAggregationTreasury>>,
  TError,
  { id: string; data: unknown },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof uploadSignedColdAggregationTreasury>>,
    { id: string; data: unknown }
  > = props => {
    const { id, data } = props ?? {};

    return uploadSignedColdAggregationTreasury(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UploadSignedColdAggregationTreasuryMutationResult = NonNullable<
  Awaited<ReturnType<typeof uploadSignedColdAggregationTreasury>>
>;
export type UploadSignedColdAggregationTreasuryMutationBody = unknown;
export type UploadSignedColdAggregationTreasuryMutationError = ErrorType<void>;

/**
 * @summary Upload the signed transfers produced by ColdStorage.Signer and broadcast them.
 */
export const useUploadSignedColdAggregationTreasury = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof uploadSignedColdAggregationTreasury>>,
    TError,
    { id: string; data: unknown },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof uploadSignedColdAggregationTreasury>>,
  TError,
  { id: string; data: unknown },
  TContext
> => {
  const mutationOptions = getUploadSignedColdAggregationTreasuryMutationOptions(options);

  return useMutation(mutationOptions);
};

export const cancelColdAggregationTreasury = (id: string, options?: SecondParameter<typeof customInstance>) => {
  return customInstance<TreasuryColdAggregationBatchResponse>(
    { url: `/back-api/api/v1/treasury/cold-aggregations/${id}/cancel`, method: 'POST' },
    options
  );
};

export const getCancelColdAggregationTreasuryMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cancelColdAggregationTreasury>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<Awaited<ReturnType<typeof cancelColdAggregationTreasury>>, TError, { id: string }, TContext> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof cancelColdAggregationTreasury>>,
    { id: string }
  > = props => {
    const { id } = props ?? {};

    return cancelColdAggregationTreasury(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CancelColdAggregationTreasuryMutationResult = NonNullable<
  Awaited<ReturnType<typeof cancelColdAggregationTreasury>>
>;

export type CancelColdAggregationTreasuryMutationError = ErrorType<void>;

export const useCancelColdAggregationTreasury = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cancelColdAggregationTreasury>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<Awaited<ReturnType<typeof cancelColdAggregationTreasury>>, TError, { id: string }, TContext> => {
  const mutationOptions = getCancelColdAggregationTreasuryMutationOptions(options);

  return useMutation(mutationOptions);
};

export const runColdAggregationPreparationTreasury = (options?: SecondParameter<typeof customInstance>) => {
  return customInstance<TreasuryColdAggregationRunResult>(
    { url: `/back-api/api/v1/treasury/cold-aggregations/run`, method: 'POST' },
    options
  );
};

export const getRunColdAggregationPreparationTreasuryMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof runColdAggregationPreparationTreasury>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<Awaited<ReturnType<typeof runColdAggregationPreparationTreasury>>, TError, void, TContext> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof runColdAggregationPreparationTreasury>>, void> = () => {
    return runColdAggregationPreparationTreasury(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RunColdAggregationPreparationTreasuryMutationResult = NonNullable<
  Awaited<ReturnType<typeof runColdAggregationPreparationTreasury>>
>;

export type RunColdAggregationPreparationTreasuryMutationError = ErrorType<void>;

export const useRunColdAggregationPreparationTreasury = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof runColdAggregationPreparationTreasury>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<Awaited<ReturnType<typeof runColdAggregationPreparationTreasury>>, TError, void, TContext> => {
  const mutationOptions = getRunColdAggregationPreparationTreasuryMutationOptions(options);

  return useMutation(mutationOptions);
};

export const listLiquidityPlansTreasury = (
  params?: ListLiquidityPlansTreasuryParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<TreasuryLiquidityPlanResponseFilteredResponse>(
    { url: `/back-api/api/v1/treasury/liquidity-plans`, method: 'GET', params, signal },
    options
  );
};

export const getListLiquidityPlansTreasuryQueryKey = (params?: ListLiquidityPlansTreasuryParams) => {
  return [`/back-api/api/v1/treasury/liquidity-plans`, ...(params ? [params] : [])] as const;
};

export const getListLiquidityPlansTreasuryQueryOptions = <
  TData = Awaited<ReturnType<typeof listLiquidityPlansTreasury>>,
  TError = ErrorType<void>
>(
  params?: ListLiquidityPlansTreasuryParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof listLiquidityPlansTreasury>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListLiquidityPlansTreasuryQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listLiquidityPlansTreasury>>> = ({ signal }) =>
    listLiquidityPlansTreasury(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listLiquidityPlansTreasury>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListLiquidityPlansTreasuryQueryResult = NonNullable<Awaited<ReturnType<typeof listLiquidityPlansTreasury>>>;
export type ListLiquidityPlansTreasuryQueryError = ErrorType<void>;

export function useListLiquidityPlansTreasury<
  TData = Awaited<ReturnType<typeof listLiquidityPlansTreasury>>,
  TError = ErrorType<void>
>(
  params?: ListLiquidityPlansTreasuryParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof listLiquidityPlansTreasury>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListLiquidityPlansTreasuryQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getLiquidityPlanTreasury = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<TreasuryLiquidityPlanResponse>(
    { url: `/back-api/api/v1/treasury/liquidity-plans/${id}`, method: 'GET', signal },
    options
  );
};

export const getGetLiquidityPlanTreasuryQueryKey = (id: string) => {
  return [`/back-api/api/v1/treasury/liquidity-plans/${id}`] as const;
};

export const getGetLiquidityPlanTreasuryQueryOptions = <
  TData = Awaited<ReturnType<typeof getLiquidityPlanTreasury>>,
  TError = ErrorType<void>
>(
  id: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getLiquidityPlanTreasury>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetLiquidityPlanTreasuryQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getLiquidityPlanTreasury>>> = ({ signal }) =>
    getLiquidityPlanTreasury(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getLiquidityPlanTreasury>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetLiquidityPlanTreasuryQueryResult = NonNullable<Awaited<ReturnType<typeof getLiquidityPlanTreasury>>>;
export type GetLiquidityPlanTreasuryQueryError = ErrorType<void>;

export function useGetLiquidityPlanTreasury<
  TData = Awaited<ReturnType<typeof getLiquidityPlanTreasury>>,
  TError = ErrorType<void>
>(
  id: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getLiquidityPlanTreasury>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetLiquidityPlanTreasuryQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const simulateLiquidityPlanCycleTreasury = (options?: SecondParameter<typeof customInstance>) => {
  return customInstance<TreasuryLiquidityPlanSimulationResult>(
    { url: `/back-api/api/v1/treasury/liquidity-plans/simulate`, method: 'POST' },
    options
  );
};

export const getSimulateLiquidityPlanCycleTreasuryMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof simulateLiquidityPlanCycleTreasury>>, TError, void, TContext>;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<Awaited<ReturnType<typeof simulateLiquidityPlanCycleTreasury>>, TError, void, TContext> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof simulateLiquidityPlanCycleTreasury>>, void> = () => {
    return simulateLiquidityPlanCycleTreasury(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SimulateLiquidityPlanCycleTreasuryMutationResult = NonNullable<
  Awaited<ReturnType<typeof simulateLiquidityPlanCycleTreasury>>
>;

export type SimulateLiquidityPlanCycleTreasuryMutationError = ErrorType<void>;

export const useSimulateLiquidityPlanCycleTreasury = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof simulateLiquidityPlanCycleTreasury>>, TError, void, TContext>;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<Awaited<ReturnType<typeof simulateLiquidityPlanCycleTreasury>>, TError, void, TContext> => {
  const mutationOptions = getSimulateLiquidityPlanCycleTreasuryMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Runs a full liquidity planning cycle, or relief-only CCTP when reliefOnly is true.
 */
export const runLiquidityPlanCycleTreasury = (
  params?: RunLiquidityPlanCycleTreasuryParams,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<TreasuryLiquidityPlanRunResult>(
    { url: `/back-api/api/v1/treasury/liquidity-plans/run`, method: 'POST', params },
    options
  );
};

export const getRunLiquidityPlanCycleTreasuryMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof runLiquidityPlanCycleTreasury>>,
    TError,
    { params?: RunLiquidityPlanCycleTreasuryParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof runLiquidityPlanCycleTreasury>>,
  TError,
  { params?: RunLiquidityPlanCycleTreasuryParams },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof runLiquidityPlanCycleTreasury>>,
    { params?: RunLiquidityPlanCycleTreasuryParams }
  > = props => {
    const { params } = props ?? {};

    return runLiquidityPlanCycleTreasury(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RunLiquidityPlanCycleTreasuryMutationResult = NonNullable<
  Awaited<ReturnType<typeof runLiquidityPlanCycleTreasury>>
>;

export type RunLiquidityPlanCycleTreasuryMutationError = ErrorType<void>;

/**
 * @summary Runs a full liquidity planning cycle, or relief-only CCTP when reliefOnly is true.
 */
export const useRunLiquidityPlanCycleTreasury = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof runLiquidityPlanCycleTreasury>>,
    TError,
    { params?: RunLiquidityPlanCycleTreasuryParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof runLiquidityPlanCycleTreasury>>,
  TError,
  { params?: RunLiquidityPlanCycleTreasuryParams },
  TContext
> => {
  const mutationOptions = getRunLiquidityPlanCycleTreasuryMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getAdvisorStatusTreasury = (options?: SecondParameter<typeof customInstance>, signal?: AbortSignal) => {
  return customInstance<TreasuryAdvisorStatusResponse>(
    { url: `/back-api/api/v1/treasury/setup/advisor-status`, method: 'GET', signal },
    options
  );
};

export const getGetAdvisorStatusTreasuryQueryKey = () => {
  return [`/back-api/api/v1/treasury/setup/advisor-status`] as const;
};

export const getGetAdvisorStatusTreasuryQueryOptions = <
  TData = Awaited<ReturnType<typeof getAdvisorStatusTreasury>>,
  TError = ErrorType<void>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getAdvisorStatusTreasury>>, TError, TData>;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAdvisorStatusTreasuryQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdvisorStatusTreasury>>> = ({ signal }) =>
    getAdvisorStatusTreasury(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAdvisorStatusTreasury>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAdvisorStatusTreasuryQueryResult = NonNullable<Awaited<ReturnType<typeof getAdvisorStatusTreasury>>>;
export type GetAdvisorStatusTreasuryQueryError = ErrorType<void>;

export function useGetAdvisorStatusTreasury<
  TData = Awaited<ReturnType<typeof getAdvisorStatusTreasury>>,
  TError = ErrorType<void>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getAdvisorStatusTreasury>>, TError, TData>;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetAdvisorStatusTreasuryQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getSetupRecommendationsTreasury = (
  params?: GetSetupRecommendationsTreasuryParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<TreasurySetupRecommendationsResponse>(
    { url: `/back-api/api/v1/treasury/setup/recommendations`, method: 'GET', params, signal },
    options
  );
};

export const getGetSetupRecommendationsTreasuryQueryKey = (params?: GetSetupRecommendationsTreasuryParams) => {
  return [`/back-api/api/v1/treasury/setup/recommendations`, ...(params ? [params] : [])] as const;
};

export const getGetSetupRecommendationsTreasuryQueryOptions = <
  TData = Awaited<ReturnType<typeof getSetupRecommendationsTreasury>>,
  TError = ErrorType<void>
>(
  params?: GetSetupRecommendationsTreasuryParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getSetupRecommendationsTreasury>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSetupRecommendationsTreasuryQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSetupRecommendationsTreasury>>> = ({ signal }) =>
    getSetupRecommendationsTreasury(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSetupRecommendationsTreasury>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetSetupRecommendationsTreasuryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSetupRecommendationsTreasury>>
>;
export type GetSetupRecommendationsTreasuryQueryError = ErrorType<void>;

export function useGetSetupRecommendationsTreasury<
  TData = Awaited<ReturnType<typeof getSetupRecommendationsTreasury>>,
  TError = ErrorType<void>
>(
  params?: GetSetupRecommendationsTreasuryParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getSetupRecommendationsTreasury>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetSetupRecommendationsTreasuryQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const applySetupTreasury = (
  applyTreasurySetupRequest: ApplyTreasurySetupRequest,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<ApplyTreasurySetupResponse>(
    {
      url: `/back-api/api/v1/treasury/setup/apply`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: applyTreasurySetupRequest,
    },
    options
  );
};

export const getApplySetupTreasuryMutationOptions = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof applySetupTreasury>>,
    TError,
    { data: ApplyTreasurySetupRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof applySetupTreasury>>,
  TError,
  { data: ApplyTreasurySetupRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof applySetupTreasury>>,
    { data: ApplyTreasurySetupRequest }
  > = props => {
    const { data } = props ?? {};

    return applySetupTreasury(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApplySetupTreasuryMutationResult = NonNullable<Awaited<ReturnType<typeof applySetupTreasury>>>;
export type ApplySetupTreasuryMutationBody = ApplyTreasurySetupRequest;
export type ApplySetupTreasuryMutationError = ErrorType<void>;

export const useApplySetupTreasury = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof applySetupTreasury>>,
    TError,
    { data: ApplyTreasurySetupRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof applySetupTreasury>>,
  TError,
  { data: ApplyTreasurySetupRequest },
  TContext
> => {
  const mutationOptions = getApplySetupTreasuryMutationOptions(options);

  return useMutation(mutationOptions);
};

export const listPolicyOptimizationsTreasury = (
  params?: ListPolicyOptimizationsTreasuryParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<TreasuryPolicyOptimizationResponseFilteredResponse>(
    { url: `/back-api/api/v1/treasury/policy-optimizations`, method: 'GET', params, signal },
    options
  );
};

export const getListPolicyOptimizationsTreasuryQueryKey = (params?: ListPolicyOptimizationsTreasuryParams) => {
  return [`/back-api/api/v1/treasury/policy-optimizations`, ...(params ? [params] : [])] as const;
};

export const getListPolicyOptimizationsTreasuryQueryOptions = <
  TData = Awaited<ReturnType<typeof listPolicyOptimizationsTreasury>>,
  TError = ErrorType<void>
>(
  params?: ListPolicyOptimizationsTreasuryParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof listPolicyOptimizationsTreasury>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListPolicyOptimizationsTreasuryQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listPolicyOptimizationsTreasury>>> = ({ signal }) =>
    listPolicyOptimizationsTreasury(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listPolicyOptimizationsTreasury>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListPolicyOptimizationsTreasuryQueryResult = NonNullable<
  Awaited<ReturnType<typeof listPolicyOptimizationsTreasury>>
>;
export type ListPolicyOptimizationsTreasuryQueryError = ErrorType<void>;

export function useListPolicyOptimizationsTreasury<
  TData = Awaited<ReturnType<typeof listPolicyOptimizationsTreasury>>,
  TError = ErrorType<void>
>(
  params?: ListPolicyOptimizationsTreasuryParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof listPolicyOptimizationsTreasury>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListPolicyOptimizationsTreasuryQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getPolicyOptimizationTreasury = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<TreasuryPolicyOptimizationResponse>(
    { url: `/back-api/api/v1/treasury/policy-optimizations/${id}`, method: 'GET', signal },
    options
  );
};

export const getGetPolicyOptimizationTreasuryQueryKey = (id: string) => {
  return [`/back-api/api/v1/treasury/policy-optimizations/${id}`] as const;
};

export const getGetPolicyOptimizationTreasuryQueryOptions = <
  TData = Awaited<ReturnType<typeof getPolicyOptimizationTreasury>>,
  TError = ErrorType<void>
>(
  id: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getPolicyOptimizationTreasury>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPolicyOptimizationTreasuryQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPolicyOptimizationTreasury>>> = ({ signal }) =>
    getPolicyOptimizationTreasury(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPolicyOptimizationTreasury>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPolicyOptimizationTreasuryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPolicyOptimizationTreasury>>
>;
export type GetPolicyOptimizationTreasuryQueryError = ErrorType<void>;

export function useGetPolicyOptimizationTreasury<
  TData = Awaited<ReturnType<typeof getPolicyOptimizationTreasury>>,
  TError = ErrorType<void>
>(
  id: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getPolicyOptimizationTreasury>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetPolicyOptimizationTreasuryQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const runPolicyOptimizationTreasury = (
  params?: RunPolicyOptimizationTreasuryParams,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<TreasuryPolicyOptimizationRunResult>(
    { url: `/back-api/api/v1/treasury/policy-optimizations/run`, method: 'POST', params },
    options
  );
};

export const getRunPolicyOptimizationTreasuryMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof runPolicyOptimizationTreasury>>,
    TError,
    { params?: RunPolicyOptimizationTreasuryParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof runPolicyOptimizationTreasury>>,
  TError,
  { params?: RunPolicyOptimizationTreasuryParams },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof runPolicyOptimizationTreasury>>,
    { params?: RunPolicyOptimizationTreasuryParams }
  > = props => {
    const { params } = props ?? {};

    return runPolicyOptimizationTreasury(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RunPolicyOptimizationTreasuryMutationResult = NonNullable<
  Awaited<ReturnType<typeof runPolicyOptimizationTreasury>>
>;

export type RunPolicyOptimizationTreasuryMutationError = ErrorType<void>;

export const useRunPolicyOptimizationTreasury = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof runPolicyOptimizationTreasury>>,
    TError,
    { params?: RunPolicyOptimizationTreasuryParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof runPolicyOptimizationTreasury>>,
  TError,
  { params?: RunPolicyOptimizationTreasuryParams },
  TContext
> => {
  const mutationOptions = getRunPolicyOptimizationTreasuryMutationOptions(options);

  return useMutation(mutationOptions);
};

export const approvePolicyOptimizationTreasury = (id: string, options?: SecondParameter<typeof customInstance>) => {
  return customInstance<TreasuryChainPolicyResponse>(
    { url: `/back-api/api/v1/treasury/policy-optimizations/${id}/approve`, method: 'POST' },
    options
  );
};

export const getApprovePolicyOptimizationTreasuryMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof approvePolicyOptimizationTreasury>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof approvePolicyOptimizationTreasury>>,
  TError,
  { id: string },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof approvePolicyOptimizationTreasury>>,
    { id: string }
  > = props => {
    const { id } = props ?? {};

    return approvePolicyOptimizationTreasury(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApprovePolicyOptimizationTreasuryMutationResult = NonNullable<
  Awaited<ReturnType<typeof approvePolicyOptimizationTreasury>>
>;

export type ApprovePolicyOptimizationTreasuryMutationError = ErrorType<void>;

export const useApprovePolicyOptimizationTreasury = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof approvePolicyOptimizationTreasury>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof approvePolicyOptimizationTreasury>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getApprovePolicyOptimizationTreasuryMutationOptions(options);

  return useMutation(mutationOptions);
};

export const rejectPolicyOptimizationTreasury = (id: string, options?: SecondParameter<typeof customInstance>) => {
  return customInstance<TreasuryPolicyOptimizationResponse>(
    { url: `/back-api/api/v1/treasury/policy-optimizations/${id}/reject`, method: 'POST' },
    options
  );
};

export const getRejectPolicyOptimizationTreasuryMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof rejectPolicyOptimizationTreasury>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof rejectPolicyOptimizationTreasury>>,
  TError,
  { id: string },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof rejectPolicyOptimizationTreasury>>,
    { id: string }
  > = props => {
    const { id } = props ?? {};

    return rejectPolicyOptimizationTreasury(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RejectPolicyOptimizationTreasuryMutationResult = NonNullable<
  Awaited<ReturnType<typeof rejectPolicyOptimizationTreasury>>
>;

export type RejectPolicyOptimizationTreasuryMutationError = ErrorType<void>;

export const useRejectPolicyOptimizationTreasury = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof rejectPolicyOptimizationTreasury>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof rejectPolicyOptimizationTreasury>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getRejectPolicyOptimizationTreasuryMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getNotificationCatalogTreasury = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<TreasuryNotificationCatalogResponse>(
    { url: `/back-api/api/v1/treasury/notifications/catalog`, method: 'GET', signal },
    options
  );
};

export const getGetNotificationCatalogTreasuryQueryKey = () => {
  return [`/back-api/api/v1/treasury/notifications/catalog`] as const;
};

export const getGetNotificationCatalogTreasuryQueryOptions = <
  TData = Awaited<ReturnType<typeof getNotificationCatalogTreasury>>,
  TError = ErrorType<void>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getNotificationCatalogTreasury>>, TError, TData>;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetNotificationCatalogTreasuryQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getNotificationCatalogTreasury>>> = ({ signal }) =>
    getNotificationCatalogTreasury(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getNotificationCatalogTreasury>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetNotificationCatalogTreasuryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getNotificationCatalogTreasury>>
>;
export type GetNotificationCatalogTreasuryQueryError = ErrorType<void>;

export function useGetNotificationCatalogTreasury<
  TData = Awaited<ReturnType<typeof getNotificationCatalogTreasury>>,
  TError = ErrorType<void>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getNotificationCatalogTreasury>>, TError, TData>;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetNotificationCatalogTreasuryQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const listNotificationAdminRecipientsTreasury = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<TreasuryNotificationAdminRecipientsResponse>(
    { url: `/back-api/api/v1/treasury/notifications/admin-recipients`, method: 'GET', signal },
    options
  );
};

export const getListNotificationAdminRecipientsTreasuryQueryKey = () => {
  return [`/back-api/api/v1/treasury/notifications/admin-recipients`] as const;
};

export const getListNotificationAdminRecipientsTreasuryQueryOptions = <
  TData = Awaited<ReturnType<typeof listNotificationAdminRecipientsTreasury>>,
  TError = ErrorType<void>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof listNotificationAdminRecipientsTreasury>>, TError, TData>;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListNotificationAdminRecipientsTreasuryQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listNotificationAdminRecipientsTreasury>>> = ({ signal }) =>
    listNotificationAdminRecipientsTreasury(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listNotificationAdminRecipientsTreasury>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListNotificationAdminRecipientsTreasuryQueryResult = NonNullable<
  Awaited<ReturnType<typeof listNotificationAdminRecipientsTreasury>>
>;
export type ListNotificationAdminRecipientsTreasuryQueryError = ErrorType<void>;

export function useListNotificationAdminRecipientsTreasury<
  TData = Awaited<ReturnType<typeof listNotificationAdminRecipientsTreasury>>,
  TError = ErrorType<void>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof listNotificationAdminRecipientsTreasury>>, TError, TData>;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListNotificationAdminRecipientsTreasuryQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getNotificationPreferencesTreasury = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<TreasuryNotificationPreferencesResponse>(
    { url: `/back-api/api/v1/treasury/notifications/preferences`, method: 'GET', signal },
    options
  );
};

export const getGetNotificationPreferencesTreasuryQueryKey = () => {
  return [`/back-api/api/v1/treasury/notifications/preferences`] as const;
};

export const getGetNotificationPreferencesTreasuryQueryOptions = <
  TData = Awaited<ReturnType<typeof getNotificationPreferencesTreasury>>,
  TError = ErrorType<void>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getNotificationPreferencesTreasury>>, TError, TData>;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetNotificationPreferencesTreasuryQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getNotificationPreferencesTreasury>>> = ({ signal }) =>
    getNotificationPreferencesTreasury(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getNotificationPreferencesTreasury>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetNotificationPreferencesTreasuryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getNotificationPreferencesTreasury>>
>;
export type GetNotificationPreferencesTreasuryQueryError = ErrorType<void>;

export function useGetNotificationPreferencesTreasury<
  TData = Awaited<ReturnType<typeof getNotificationPreferencesTreasury>>,
  TError = ErrorType<void>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getNotificationPreferencesTreasury>>, TError, TData>;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetNotificationPreferencesTreasuryQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const updateNotificationPreferencesTreasury = (
  updateTreasuryNotificationPreferencesRequest: UpdateTreasuryNotificationPreferencesRequest,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<TreasuryNotificationPreferencesResponse>(
    {
      url: `/back-api/api/v1/treasury/notifications/preferences`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: updateTreasuryNotificationPreferencesRequest,
    },
    options
  );
};

export const getUpdateNotificationPreferencesTreasuryMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateNotificationPreferencesTreasury>>,
    TError,
    { data: UpdateTreasuryNotificationPreferencesRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateNotificationPreferencesTreasury>>,
  TError,
  { data: UpdateTreasuryNotificationPreferencesRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateNotificationPreferencesTreasury>>,
    { data: UpdateTreasuryNotificationPreferencesRequest }
  > = props => {
    const { data } = props ?? {};

    return updateNotificationPreferencesTreasury(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateNotificationPreferencesTreasuryMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateNotificationPreferencesTreasury>>
>;
export type UpdateNotificationPreferencesTreasuryMutationBody = UpdateTreasuryNotificationPreferencesRequest;
export type UpdateNotificationPreferencesTreasuryMutationError = ErrorType<void>;

export const useUpdateNotificationPreferencesTreasury = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateNotificationPreferencesTreasury>>,
    TError,
    { data: UpdateTreasuryNotificationPreferencesRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateNotificationPreferencesTreasury>>,
  TError,
  { data: UpdateTreasuryNotificationPreferencesRequest },
  TContext
> => {
  const mutationOptions = getUpdateNotificationPreferencesTreasuryMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getNotificationDeliveryLogTreasury = (
  params?: GetNotificationDeliveryLogTreasuryParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<TreasuryNotificationDeliveryLogResponse>(
    { url: `/back-api/api/v1/treasury/notifications/delivery-log`, method: 'GET', params, signal },
    options
  );
};

export const getGetNotificationDeliveryLogTreasuryQueryKey = (params?: GetNotificationDeliveryLogTreasuryParams) => {
  return [`/back-api/api/v1/treasury/notifications/delivery-log`, ...(params ? [params] : [])] as const;
};

export const getGetNotificationDeliveryLogTreasuryQueryOptions = <
  TData = Awaited<ReturnType<typeof getNotificationDeliveryLogTreasury>>,
  TError = ErrorType<void>
>(
  params?: GetNotificationDeliveryLogTreasuryParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getNotificationDeliveryLogTreasury>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetNotificationDeliveryLogTreasuryQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getNotificationDeliveryLogTreasury>>> = ({ signal }) =>
    getNotificationDeliveryLogTreasury(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getNotificationDeliveryLogTreasury>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetNotificationDeliveryLogTreasuryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getNotificationDeliveryLogTreasury>>
>;
export type GetNotificationDeliveryLogTreasuryQueryError = ErrorType<void>;

export function useGetNotificationDeliveryLogTreasury<
  TData = Awaited<ReturnType<typeof getNotificationDeliveryLogTreasury>>,
  TError = ErrorType<void>
>(
  params?: GetNotificationDeliveryLogTreasuryParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getNotificationDeliveryLogTreasury>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetNotificationDeliveryLogTreasuryQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const sendTestAlertTreasury = (options?: SecondParameter<typeof customInstance>) => {
  return customInstance<TreasuryNotificationPayloadResponse>(
    { url: `/back-api/api/v1/treasury/notifications/test-alert`, method: 'POST' },
    options
  );
};

export const getSendTestAlertTreasuryMutationOptions = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof sendTestAlertTreasury>>, TError, void, TContext>;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<Awaited<ReturnType<typeof sendTestAlertTreasury>>, TError, void, TContext> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendTestAlertTreasury>>, void> = () => {
    return sendTestAlertTreasury(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SendTestAlertTreasuryMutationResult = NonNullable<Awaited<ReturnType<typeof sendTestAlertTreasury>>>;

export type SendTestAlertTreasuryMutationError = ErrorType<void>;

export const useSendTestAlertTreasury = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof sendTestAlertTreasury>>, TError, void, TContext>;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<Awaited<ReturnType<typeof sendTestAlertTreasury>>, TError, void, TContext> => {
  const mutationOptions = getSendTestAlertTreasuryMutationOptions(options);

  return useMutation(mutationOptions);
};

export const sendTestReportTreasury = (
  params?: SendTestReportTreasuryParams,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<TreasuryNotificationPayloadResponse>(
    { url: `/back-api/api/v1/treasury/notifications/test-report`, method: 'POST', params },
    options
  );
};

export const getSendTestReportTreasuryMutationOptions = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendTestReportTreasury>>,
    TError,
    { params?: SendTestReportTreasuryParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sendTestReportTreasury>>,
  TError,
  { params?: SendTestReportTreasuryParams },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sendTestReportTreasury>>,
    { params?: SendTestReportTreasuryParams }
  > = props => {
    const { params } = props ?? {};

    return sendTestReportTreasury(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SendTestReportTreasuryMutationResult = NonNullable<Awaited<ReturnType<typeof sendTestReportTreasury>>>;

export type SendTestReportTreasuryMutationError = ErrorType<void>;

export const useSendTestReportTreasury = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendTestReportTreasury>>,
    TError,
    { params?: SendTestReportTreasuryParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof sendTestReportTreasury>>,
  TError,
  { params?: SendTestReportTreasuryParams },
  TContext
> => {
  const mutationOptions = getSendTestReportTreasuryMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getAllUser = (
  params?: GetAllUserParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<UserItemResponseFilteredResponse>(
    { url: `/back-api/backoffice/users`, method: 'GET', params, signal },
    options
  );
};

export const getGetAllUserQueryKey = (params?: GetAllUserParams) => {
  return [`/back-api/backoffice/users`, ...(params ? [params] : [])] as const;
};

export const getGetAllUserQueryOptions = <TData = Awaited<ReturnType<typeof getAllUser>>, TError = ErrorType<void>>(
  params?: GetAllUserParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getAllUser>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAllUserQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllUser>>> = ({ signal }) =>
    getAllUser(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAllUser>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAllUserQueryResult = NonNullable<Awaited<ReturnType<typeof getAllUser>>>;
export type GetAllUserQueryError = ErrorType<void>;

export function useGetAllUser<TData = Awaited<ReturnType<typeof getAllUser>>, TError = ErrorType<void>>(
  params?: GetAllUserParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getAllUser>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetAllUserQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getUser = (getUserRequest: GetUserRequest, options?: SecondParameter<typeof customInstance>) => {
  return customInstance<UserResponseResponse>(
    {
      url: `/back-api/backoffice/user`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: getUserRequest,
    },
    options
  );
};

export const getGetUserMutationOptions = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof getUser>>, TError, { data: GetUserRequest }, TContext>;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<Awaited<ReturnType<typeof getUser>>, TError, { data: GetUserRequest }, TContext> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof getUser>>, { data: GetUserRequest }> = props => {
    const { data } = props ?? {};

    return getUser(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetUserMutationResult = NonNullable<Awaited<ReturnType<typeof getUser>>>;
export type GetUserMutationBody = GetUserRequest;
export type GetUserMutationError = ErrorType<void>;

export const useGetUser = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof getUser>>, TError, { data: GetUserRequest }, TContext>;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<Awaited<ReturnType<typeof getUser>>, TError, { data: GetUserRequest }, TContext> => {
  const mutationOptions = getGetUserMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary This API is deprecated. Use api/v3/users/status OR api/v3/users/status/list
 */
export const updateUser = (updateUserRequest: UpdateUserRequest, options?: SecondParameter<typeof customInstance>) => {
  return customInstance<UserResponse>(
    {
      url: `/back-api/backoffice/user`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: updateUserRequest,
    },
    options
  );
};

export const getUpdateUserMutationOptions = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof updateUser>>, TError, { data: UpdateUserRequest }, TContext>;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<Awaited<ReturnType<typeof updateUser>>, TError, { data: UpdateUserRequest }, TContext> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateUser>>, { data: UpdateUserRequest }> = props => {
    const { data } = props ?? {};

    return updateUser(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateUserMutationResult = NonNullable<Awaited<ReturnType<typeof updateUser>>>;
export type UpdateUserMutationBody = UpdateUserRequest;
export type UpdateUserMutationError = ErrorType<void>;

/**
 * @summary This API is deprecated. Use api/v3/users/status OR api/v3/users/status/list
 */
export const useUpdateUser = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof updateUser>>, TError, { data: UpdateUserRequest }, TContext>;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<Awaited<ReturnType<typeof updateUser>>, TError, { data: UpdateUserRequest }, TContext> => {
  const mutationOptions = getUpdateUserMutationOptions(options);

  return useMutation(mutationOptions);
};

export const blockUser = (
  blockUserApiRequest: BlockUserApiRequest,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<void>(
    {
      url: `/back-api/backoffice/user/block`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: blockUserApiRequest,
    },
    options
  );
};

export const getBlockUserMutationOptions = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof blockUser>>, TError, { data: BlockUserApiRequest }, TContext>;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<Awaited<ReturnType<typeof blockUser>>, TError, { data: BlockUserApiRequest }, TContext> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof blockUser>>, { data: BlockUserApiRequest }> = props => {
    const { data } = props ?? {};

    return blockUser(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BlockUserMutationResult = NonNullable<Awaited<ReturnType<typeof blockUser>>>;
export type BlockUserMutationBody = BlockUserApiRequest;
export type BlockUserMutationError = ErrorType<void>;

export const useBlockUser = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof blockUser>>, TError, { data: BlockUserApiRequest }, TContext>;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<Awaited<ReturnType<typeof blockUser>>, TError, { data: BlockUserApiRequest }, TContext> => {
  const mutationOptions = getBlockUserMutationOptions(options);

  return useMutation(mutationOptions);
};

export const unlockUser = (
  unblockUserApiRequest: UnblockUserApiRequest,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<void>(
    {
      url: `/back-api/backoffice/user/unblock`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: unblockUserApiRequest,
    },
    options
  );
};

export const getUnlockUserMutationOptions = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unlockUser>>,
    TError,
    { data: UnblockUserApiRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<Awaited<ReturnType<typeof unlockUser>>, TError, { data: UnblockUserApiRequest }, TContext> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof unlockUser>>,
    { data: UnblockUserApiRequest }
  > = props => {
    const { data } = props ?? {};

    return unlockUser(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UnlockUserMutationResult = NonNullable<Awaited<ReturnType<typeof unlockUser>>>;
export type UnlockUserMutationBody = UnblockUserApiRequest;
export type UnlockUserMutationError = ErrorType<void>;

export const useUnlockUser = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unlockUser>>,
    TError,
    { data: UnblockUserApiRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<Awaited<ReturnType<typeof unlockUser>>, TError, { data: UnblockUserApiRequest }, TContext> => {
  const mutationOptions = getUnlockUserMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Returns balances of all user accounts.
 */
export const getUserBalance = (
  userPortfolioRequest: UserPortfolioRequest,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<PortfolioResponse>(
    {
      url: `/back-api/api/v2/users/balance`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: userPortfolioRequest,
    },
    options
  );
};

export const getGetUserBalanceMutationOptions = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getUserBalance>>,
    TError,
    { data: UserPortfolioRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getUserBalance>>,
  TError,
  { data: UserPortfolioRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getUserBalance>>,
    { data: UserPortfolioRequest }
  > = props => {
    const { data } = props ?? {};

    return getUserBalance(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetUserBalanceMutationResult = NonNullable<Awaited<ReturnType<typeof getUserBalance>>>;
export type GetUserBalanceMutationBody = UserPortfolioRequest;
export type GetUserBalanceMutationError = ErrorType<void>;

/**
 * @summary Returns balances of all user accounts.
 */
export const useGetUserBalance = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getUserBalance>>,
    TError,
    { data: UserPortfolioRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<Awaited<ReturnType<typeof getUserBalance>>, TError, { data: UserPortfolioRequest }, TContext> => {
  const mutationOptions = getGetUserBalanceMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Roles: Admin
 * @summary Get all users by filters
 */
export const getAllUsers = (userFilters: UserFilters, options?: SecondParameter<typeof customInstance>) => {
  return customInstance<UserItemResponseFilteredResponse>(
    {
      url: `/back-api/api/v3/users/list`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: userFilters,
    },
    options
  );
};

export const getGetAllUsersMutationOptions = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof getAllUsers>>, TError, { data: UserFilters }, TContext>;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<Awaited<ReturnType<typeof getAllUsers>>, TError, { data: UserFilters }, TContext> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof getAllUsers>>, { data: UserFilters }> = props => {
    const { data } = props ?? {};

    return getAllUsers(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetAllUsersMutationResult = NonNullable<Awaited<ReturnType<typeof getAllUsers>>>;
export type GetAllUsersMutationBody = UserFilters;
export type GetAllUsersMutationError = ErrorType<void>;

/**
 * @summary Get all users by filters
 */
export const useGetAllUsers = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof getAllUsers>>, TError, { data: UserFilters }, TContext>;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<Awaited<ReturnType<typeof getAllUsers>>, TError, { data: UserFilters }, TContext> => {
  const mutationOptions = getGetAllUsersMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Roles: Admin, ComplianceReviewer
 * @summary Get reviews for all users
 */
export const getAllUserReviewsUsers = (
  complianceUsersRequest: ComplianceUsersRequest,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<ComplianceUsersResponse>(
    {
      url: `/back-api/api/v3/users/reviews/list`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: complianceUsersRequest,
    },
    options
  );
};

export const getGetAllUserReviewsUsersMutationOptions = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getAllUserReviewsUsers>>,
    TError,
    { data: ComplianceUsersRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getAllUserReviewsUsers>>,
  TError,
  { data: ComplianceUsersRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getAllUserReviewsUsers>>,
    { data: ComplianceUsersRequest }
  > = props => {
    const { data } = props ?? {};

    return getAllUserReviewsUsers(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetAllUserReviewsUsersMutationResult = NonNullable<Awaited<ReturnType<typeof getAllUserReviewsUsers>>>;
export type GetAllUserReviewsUsersMutationBody = ComplianceUsersRequest;
export type GetAllUserReviewsUsersMutationError = ErrorType<void>;

/**
 * @summary Get reviews for all users
 */
export const useGetAllUserReviewsUsers = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getAllUserReviewsUsers>>,
    TError,
    { data: ComplianceUsersRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof getAllUserReviewsUsers>>,
  TError,
  { data: ComplianceUsersRequest },
  TContext
> => {
  const mutationOptions = getGetAllUserReviewsUsersMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Roles: Admin, ComplianceReviewer
 * @summary Get info for a single user
 */
export const getUserDetailsUsers = (
  getUserDetailsRequest: GetUserDetailsRequest,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<UserDetailsResponse>(
    {
      url: `/back-api/api/v3/users/get`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: getUserDetailsRequest,
    },
    options
  );
};

export const getGetUserDetailsUsersMutationOptions = <
  TError = ErrorType<void | ProblemDetails | ApiErrorResponse>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getUserDetailsUsers>>,
    TError,
    { data: GetUserDetailsRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getUserDetailsUsers>>,
  TError,
  { data: GetUserDetailsRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getUserDetailsUsers>>,
    { data: GetUserDetailsRequest }
  > = props => {
    const { data } = props ?? {};

    return getUserDetailsUsers(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetUserDetailsUsersMutationResult = NonNullable<Awaited<ReturnType<typeof getUserDetailsUsers>>>;
export type GetUserDetailsUsersMutationBody = GetUserDetailsRequest;
export type GetUserDetailsUsersMutationError = ErrorType<void | ProblemDetails | ApiErrorResponse>;

/**
 * @summary Get info for a single user
 */
export const useGetUserDetailsUsers = <
  TError = ErrorType<void | ProblemDetails | ApiErrorResponse>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getUserDetailsUsers>>,
    TError,
    { data: GetUserDetailsRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof getUserDetailsUsers>>,
  TError,
  { data: GetUserDetailsRequest },
  TContext
> => {
  const mutationOptions = getGetUserDetailsUsersMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Roles: Admin or ComplianceReviewer
 * @summary Update user status for a single user
 */
export const updateUserStatusUsers = (
  updateUserRequest: UpdateUserRequest,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<UserResponse>(
    {
      url: `/back-api/api/v3/users/status`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: updateUserRequest,
    },
    options
  );
};

export const getUpdateUserStatusUsersMutationOptions = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateUserStatusUsers>>,
    TError,
    { data: UpdateUserRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateUserStatusUsers>>,
  TError,
  { data: UpdateUserRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateUserStatusUsers>>,
    { data: UpdateUserRequest }
  > = props => {
    const { data } = props ?? {};

    return updateUserStatusUsers(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateUserStatusUsersMutationResult = NonNullable<Awaited<ReturnType<typeof updateUserStatusUsers>>>;
export type UpdateUserStatusUsersMutationBody = UpdateUserRequest;
export type UpdateUserStatusUsersMutationError = ErrorType<void>;

/**
 * @summary Update user status for a single user
 */
export const useUpdateUserStatusUsers = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateUserStatusUsers>>,
    TError,
    { data: UpdateUserRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateUserStatusUsers>>,
  TError,
  { data: UpdateUserRequest },
  TContext
> => {
  const mutationOptions = getUpdateUserStatusUsersMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Roles: Admin
 * @summary Update users status for a list of users
 */
export const updateUsersStatus = (
  updateUsersRequest: UpdateUsersRequest,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<string[]>(
    {
      url: `/back-api/api/v3/users/status/list`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: updateUsersRequest,
    },
    options
  );
};

export const getUpdateUsersStatusMutationOptions = <
  TError = ErrorType<ApiErrorResponse | void>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateUsersStatus>>,
    TError,
    { data: UpdateUsersRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateUsersStatus>>,
  TError,
  { data: UpdateUsersRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateUsersStatus>>,
    { data: UpdateUsersRequest }
  > = props => {
    const { data } = props ?? {};

    return updateUsersStatus(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateUsersStatusMutationResult = NonNullable<Awaited<ReturnType<typeof updateUsersStatus>>>;
export type UpdateUsersStatusMutationBody = UpdateUsersRequest;
export type UpdateUsersStatusMutationError = ErrorType<ApiErrorResponse | void>;

/**
 * @summary Update users status for a list of users
 */
export const useUpdateUsersStatus = <TError = ErrorType<ApiErrorResponse | void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateUsersStatus>>,
    TError,
    { data: UpdateUsersRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateUsersStatus>>,
  TError,
  { data: UpdateUsersRequest },
  TContext
> => {
  const mutationOptions = getUpdateUsersStatusMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Roles: Admin, ComplianceReviewer
 * @summary Update review request status for a single user
 */
export const changeUserReviewStatusUsers = (
  complianceChangeUserStatusRequest: ComplianceChangeUserStatusRequest,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<void>(
    {
      url: `/back-api/api/v3/users/mute`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: complianceChangeUserStatusRequest,
    },
    options
  );
};

export const getChangeUserReviewStatusUsersMutationOptions = <
  TError = ErrorType<ApiErrorResponse | void>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof changeUserReviewStatusUsers>>,
    TError,
    { data: ComplianceChangeUserStatusRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof changeUserReviewStatusUsers>>,
  TError,
  { data: ComplianceChangeUserStatusRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof changeUserReviewStatusUsers>>,
    { data: ComplianceChangeUserStatusRequest }
  > = props => {
    const { data } = props ?? {};

    return changeUserReviewStatusUsers(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ChangeUserReviewStatusUsersMutationResult = NonNullable<
  Awaited<ReturnType<typeof changeUserReviewStatusUsers>>
>;
export type ChangeUserReviewStatusUsersMutationBody = ComplianceChangeUserStatusRequest;
export type ChangeUserReviewStatusUsersMutationError = ErrorType<ApiErrorResponse | void>;

/**
 * @summary Update review request status for a single user
 */
export const useChangeUserReviewStatusUsers = <
  TError = ErrorType<ApiErrorResponse | void>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof changeUserReviewStatusUsers>>,
    TError,
    { data: ComplianceChangeUserStatusRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof changeUserReviewStatusUsers>>,
  TError,
  { data: ComplianceChangeUserStatusRequest },
  TContext
> => {
  const mutationOptions = getChangeUserReviewStatusUsersMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Roles: Admin, ComplianceReviewer
 * @summary Resolve review request for a single user
 */
export const resolveUsers = (
  userReviewResolveRequest: UserReviewResolveRequest,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<void>(
    {
      url: `/back-api/api/v3/users/resolve`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: userReviewResolveRequest,
    },
    options
  );
};

export const getResolveUsersMutationOptions = <
  TError = ErrorType<ApiErrorResponse | void>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resolveUsers>>,
    TError,
    { data: UserReviewResolveRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof resolveUsers>>,
  TError,
  { data: UserReviewResolveRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof resolveUsers>>,
    { data: UserReviewResolveRequest }
  > = props => {
    const { data } = props ?? {};

    return resolveUsers(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ResolveUsersMutationResult = NonNullable<Awaited<ReturnType<typeof resolveUsers>>>;
export type ResolveUsersMutationBody = UserReviewResolveRequest;
export type ResolveUsersMutationError = ErrorType<ApiErrorResponse | void>;

/**
 * @summary Resolve review request for a single user
 */
export const useResolveUsers = <TError = ErrorType<ApiErrorResponse | void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resolveUsers>>,
    TError,
    { data: UserReviewResolveRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof resolveUsers>>,
  TError,
  { data: UserReviewResolveRequest },
  TContext
> => {
  const mutationOptions = getResolveUsersMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Roles: Admin, ComplianceReviewer
 * @summary Get documents for a single user
 */
export const getDocumentsByUserUsers = (
  getDocumentsByUserRequest: GetDocumentsByUserRequest,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<void>(
    {
      url: `/back-api/api/v3/users/documents/list`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: getDocumentsByUserRequest,
    },
    options
  );
};

export const getGetDocumentsByUserUsersMutationOptions = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getDocumentsByUserUsers>>,
    TError,
    { data: GetDocumentsByUserRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getDocumentsByUserUsers>>,
  TError,
  { data: GetDocumentsByUserRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getDocumentsByUserUsers>>,
    { data: GetDocumentsByUserRequest }
  > = props => {
    const { data } = props ?? {};

    return getDocumentsByUserUsers(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetDocumentsByUserUsersMutationResult = NonNullable<Awaited<ReturnType<typeof getDocumentsByUserUsers>>>;
export type GetDocumentsByUserUsersMutationBody = GetDocumentsByUserRequest;
export type GetDocumentsByUserUsersMutationError = ErrorType<void>;

/**
 * @summary Get documents for a single user
 */
export const useGetDocumentsByUserUsers = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getDocumentsByUserUsers>>,
    TError,
    { data: GetDocumentsByUserRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof getDocumentsByUserUsers>>,
  TError,
  { data: GetDocumentsByUserRequest },
  TContext
> => {
  const mutationOptions = getGetDocumentsByUserUsersMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Roles: Admin, ComplianceReviewer
 * @summary Get orders for a single user
 */
export const usersGetOrdersByUser = (
  getOrdersByUserRequest: GetOrdersByUserRequest,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<UserOrdersResponse>(
    {
      url: `/back-api/api/v3/users/orders/list`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: getOrdersByUserRequest,
    },
    options
  );
};

export const getUsersGetOrdersByUserMutationOptions = <
  TError = ErrorType<ApiErrorResponse | void>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof usersGetOrdersByUser>>,
    TError,
    { data: GetOrdersByUserRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof usersGetOrdersByUser>>,
  TError,
  { data: GetOrdersByUserRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof usersGetOrdersByUser>>,
    { data: GetOrdersByUserRequest }
  > = props => {
    const { data } = props ?? {};

    return usersGetOrdersByUser(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UsersGetOrdersByUserMutationResult = NonNullable<Awaited<ReturnType<typeof usersGetOrdersByUser>>>;
export type UsersGetOrdersByUserMutationBody = GetOrdersByUserRequest;
export type UsersGetOrdersByUserMutationError = ErrorType<ApiErrorResponse | void>;

/**
 * @summary Get orders for a single user
 */
export const useUsersGetOrdersByUser = <TError = ErrorType<ApiErrorResponse | void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof usersGetOrdersByUser>>,
    TError,
    { data: GetOrdersByUserRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof usersGetOrdersByUser>>,
  TError,
  { data: GetOrdersByUserRequest },
  TContext
> => {
  const mutationOptions = getUsersGetOrdersByUserMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Roles: Admin, ComplianceReviewer
 * @summary Get portfolio for a single user
 */
export const getPortfolioByUserUsers = (
  userPortfolioRequest: UserPortfolioRequest,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<PortfolioResponse>(
    {
      url: `/back-api/api/v3/users/portfolio/get`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: userPortfolioRequest,
    },
    options
  );
};

export const getGetPortfolioByUserUsersMutationOptions = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getPortfolioByUserUsers>>,
    TError,
    { data: UserPortfolioRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getPortfolioByUserUsers>>,
  TError,
  { data: UserPortfolioRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getPortfolioByUserUsers>>,
    { data: UserPortfolioRequest }
  > = props => {
    const { data } = props ?? {};

    return getPortfolioByUserUsers(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetPortfolioByUserUsersMutationResult = NonNullable<Awaited<ReturnType<typeof getPortfolioByUserUsers>>>;
export type GetPortfolioByUserUsersMutationBody = UserPortfolioRequest;
export type GetPortfolioByUserUsersMutationError = ErrorType<void>;

/**
 * @summary Get portfolio for a single user
 */
export const useGetPortfolioByUserUsers = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getPortfolioByUserUsers>>,
    TError,
    { data: UserPortfolioRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof getPortfolioByUserUsers>>,
  TError,
  { data: UserPortfolioRequest },
  TContext
> => {
  const mutationOptions = getGetPortfolioByUserUsersMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Roles: Admin, ComplianceReviewer
 * @summary Get transfers for a single user
 */
export const getTransfersUsers = (
  getTransfersByUserRequest: GetTransfersByUserRequest,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<GetTransfersByUserResponse>(
    {
      url: `/back-api/api/v3/users/transfers/list`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: getTransfersByUserRequest,
    },
    options
  );
};

export const getGetTransfersUsersMutationOptions = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getTransfersUsers>>,
    TError,
    { data: GetTransfersByUserRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getTransfersUsers>>,
  TError,
  { data: GetTransfersByUserRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getTransfersUsers>>,
    { data: GetTransfersByUserRequest }
  > = props => {
    const { data } = props ?? {};

    return getTransfersUsers(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetTransfersUsersMutationResult = NonNullable<Awaited<ReturnType<typeof getTransfersUsers>>>;
export type GetTransfersUsersMutationBody = GetTransfersByUserRequest;
export type GetTransfersUsersMutationError = ErrorType<void>;

/**
 * @summary Get transfers for a single user
 */
export const useGetTransfersUsers = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getTransfersUsers>>,
    TError,
    { data: GetTransfersByUserRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof getTransfersUsers>>,
  TError,
  { data: GetTransfersByUserRequest },
  TContext
> => {
  const mutationOptions = getGetTransfersUsersMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Roles: Admin, ComplianceReviewer
 * @summary Get payments for a single user
 */
export const getPaymentsByUserUsers = (
  getPaymentsByUserRequest: GetPaymentsByUserRequest,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<PaymentsResponse>(
    {
      url: `/back-api/api/v3/users/payments/list`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: getPaymentsByUserRequest,
    },
    options
  );
};

export const getGetPaymentsByUserUsersMutationOptions = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getPaymentsByUserUsers>>,
    TError,
    { data: GetPaymentsByUserRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getPaymentsByUserUsers>>,
  TError,
  { data: GetPaymentsByUserRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getPaymentsByUserUsers>>,
    { data: GetPaymentsByUserRequest }
  > = props => {
    const { data } = props ?? {};

    return getPaymentsByUserUsers(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetPaymentsByUserUsersMutationResult = NonNullable<Awaited<ReturnType<typeof getPaymentsByUserUsers>>>;
export type GetPaymentsByUserUsersMutationBody = GetPaymentsByUserRequest;
export type GetPaymentsByUserUsersMutationError = ErrorType<void>;

/**
 * @summary Get payments for a single user
 */
export const useGetPaymentsByUserUsers = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getPaymentsByUserUsers>>,
    TError,
    { data: GetPaymentsByUserRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof getPaymentsByUserUsers>>,
  TError,
  { data: GetPaymentsByUserRequest },
  TContext
> => {
  const mutationOptions = getGetPaymentsByUserUsersMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Roles: Admin, ComplianceReviewer
 * @summary Sets the compliance tier of the user to one lower level (If it's Tier1 we return an error that this is the minimum level). Only accessible from the admin and compliance officer
 */
export const downgradeUserTierUsers = (
  complianceTierDowngradeRequest: ComplianceTierDowngradeRequest,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<void>(
    {
      url: `/back-api/api/v3/users/downgrade`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: complianceTierDowngradeRequest,
    },
    options
  );
};

export const getDowngradeUserTierUsersMutationOptions = <
  TError = ErrorType<void | ApiErrorResponse>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof downgradeUserTierUsers>>,
    TError,
    { data: ComplianceTierDowngradeRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof downgradeUserTierUsers>>,
  TError,
  { data: ComplianceTierDowngradeRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof downgradeUserTierUsers>>,
    { data: ComplianceTierDowngradeRequest }
  > = props => {
    const { data } = props ?? {};

    return downgradeUserTierUsers(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DowngradeUserTierUsersMutationResult = NonNullable<Awaited<ReturnType<typeof downgradeUserTierUsers>>>;
export type DowngradeUserTierUsersMutationBody = ComplianceTierDowngradeRequest;
export type DowngradeUserTierUsersMutationError = ErrorType<void | ApiErrorResponse>;

/**
 * @summary Sets the compliance tier of the user to one lower level (If it's Tier1 we return an error that this is the minimum level). Only accessible from the admin and compliance officer
 */
export const useDowngradeUserTierUsers = <TError = ErrorType<void | ApiErrorResponse>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof downgradeUserTierUsers>>,
    TError,
    { data: ComplianceTierDowngradeRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof downgradeUserTierUsers>>,
  TError,
  { data: ComplianceTierDowngradeRequest },
  TContext
> => {
  const mutationOptions = getDowngradeUserTierUsersMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Roles: Admin
 * @summary Get a list of account tags for a user
 */
export const getAccountTagsByUserUsers = (
  getAccountTagsByUserRequest: GetAccountTagsByUserRequest,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<void>(
    {
      url: `/back-api/api/v3/users/account-tags/list`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: getAccountTagsByUserRequest,
    },
    options
  );
};

export const getGetAccountTagsByUserUsersMutationOptions = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getAccountTagsByUserUsers>>,
    TError,
    { data: GetAccountTagsByUserRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getAccountTagsByUserUsers>>,
  TError,
  { data: GetAccountTagsByUserRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getAccountTagsByUserUsers>>,
    { data: GetAccountTagsByUserRequest }
  > = props => {
    const { data } = props ?? {};

    return getAccountTagsByUserUsers(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetAccountTagsByUserUsersMutationResult = NonNullable<
  Awaited<ReturnType<typeof getAccountTagsByUserUsers>>
>;
export type GetAccountTagsByUserUsersMutationBody = GetAccountTagsByUserRequest;
export type GetAccountTagsByUserUsersMutationError = ErrorType<void>;

/**
 * @summary Get a list of account tags for a user
 */
export const useGetAccountTagsByUserUsers = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getAccountTagsByUserUsers>>,
    TError,
    { data: GetAccountTagsByUserRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof getAccountTagsByUserUsers>>,
  TError,
  { data: GetAccountTagsByUserRequest },
  TContext
> => {
  const mutationOptions = getGetAccountTagsByUserUsersMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * For instance, assigning a MarketMaker tag to an account is beneficial as it allows for the placement of orders without incurring any fees.
Roles: Admin
 * @summary Add a tag to an account
 */
export const createAccountTagUsers = (
  createAccountTagRequest: CreateAccountTagRequest,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<void>(
    {
      url: `/back-api/api/v3/users/account-tags/create`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: createAccountTagRequest,
    },
    options
  );
};

export const getCreateAccountTagUsersMutationOptions = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAccountTagUsers>>,
    TError,
    { data: CreateAccountTagRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createAccountTagUsers>>,
  TError,
  { data: CreateAccountTagRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createAccountTagUsers>>,
    { data: CreateAccountTagRequest }
  > = props => {
    const { data } = props ?? {};

    return createAccountTagUsers(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateAccountTagUsersMutationResult = NonNullable<Awaited<ReturnType<typeof createAccountTagUsers>>>;
export type CreateAccountTagUsersMutationBody = CreateAccountTagRequest;
export type CreateAccountTagUsersMutationError = ErrorType<void>;

/**
 * @summary Add a tag to an account
 */
export const useCreateAccountTagUsers = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAccountTagUsers>>,
    TError,
    { data: CreateAccountTagRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createAccountTagUsers>>,
  TError,
  { data: CreateAccountTagRequest },
  TContext
> => {
  const mutationOptions = getCreateAccountTagUsersMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Roles: Admin
 * @summary Remove a tag from an account
 */
export const deleteAccountTagUsers = (
  deleteAccountTagRequest: DeleteAccountTagRequest,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<void>(
    {
      url: `/back-api/api/v3/users/account-tags/delete`,
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: deleteAccountTagRequest,
    },
    options
  );
};

export const getDeleteAccountTagUsersMutationOptions = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAccountTagUsers>>,
    TError,
    { data: DeleteAccountTagRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteAccountTagUsers>>,
  TError,
  { data: DeleteAccountTagRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteAccountTagUsers>>,
    { data: DeleteAccountTagRequest }
  > = props => {
    const { data } = props ?? {};

    return deleteAccountTagUsers(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteAccountTagUsersMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAccountTagUsers>>>;
export type DeleteAccountTagUsersMutationBody = DeleteAccountTagRequest;
export type DeleteAccountTagUsersMutationError = ErrorType<void>;

/**
 * @summary Remove a tag from an account
 */
export const useDeleteAccountTagUsers = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAccountTagUsers>>,
    TError,
    { data: DeleteAccountTagRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteAccountTagUsers>>,
  TError,
  { data: DeleteAccountTagRequest },
  TContext
> => {
  const mutationOptions = getDeleteAccountTagUsersMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Get All Instruments
 */
export const getAllInstrumentsCharting = (options?: SecondParameter<typeof customInstance>, signal?: AbortSignal) => {
  return customInstance<string[]>({ url: `/marketdata/instruments`, method: 'GET', signal }, options);
};

export const getGetAllInstrumentsChartingQueryKey = () => {
  return [`/marketdata/instruments`] as const;
};

export const getGetAllInstrumentsChartingQueryOptions = <
  TData = Awaited<ReturnType<typeof getAllInstrumentsCharting>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getAllInstrumentsCharting>>, TError, TData>;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAllInstrumentsChartingQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllInstrumentsCharting>>> = ({ signal }) =>
    getAllInstrumentsCharting(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAllInstrumentsCharting>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAllInstrumentsChartingQueryResult = NonNullable<Awaited<ReturnType<typeof getAllInstrumentsCharting>>>;
export type GetAllInstrumentsChartingQueryError = ErrorType<unknown>;

/**
 * @summary Get All Instruments
 */

export function useGetAllInstrumentsCharting<
  TData = Awaited<ReturnType<typeof getAllInstrumentsCharting>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getAllInstrumentsCharting>>, TError, TData>;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetAllInstrumentsChartingQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get All Instruments
 */
export const getAllInstrumentsV1Charting = (options?: SecondParameter<typeof customInstance>, signal?: AbortSignal) => {
  return customInstance<string[]>({ url: `/marketdata/api/v1/instruments`, method: 'GET', signal }, options);
};

export const getGetAllInstrumentsV1ChartingQueryKey = () => {
  return [`/marketdata/api/v1/instruments`] as const;
};

export const getGetAllInstrumentsV1ChartingQueryOptions = <
  TData = Awaited<ReturnType<typeof getAllInstrumentsV1Charting>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getAllInstrumentsV1Charting>>, TError, TData>;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAllInstrumentsV1ChartingQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllInstrumentsV1Charting>>> = ({ signal }) =>
    getAllInstrumentsV1Charting(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAllInstrumentsV1Charting>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAllInstrumentsV1ChartingQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAllInstrumentsV1Charting>>
>;
export type GetAllInstrumentsV1ChartingQueryError = ErrorType<unknown>;

/**
 * @summary Get All Instruments
 */

export function useGetAllInstrumentsV1Charting<
  TData = Awaited<ReturnType<typeof getAllInstrumentsV1Charting>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getAllInstrumentsV1Charting>>, TError, TData>;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetAllInstrumentsV1ChartingQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get recent history for a specified market(instrument).
 * @summary Recent History
 */
export const getRecentHistoryCharting = (
  instrument: string,
  params: GetRecentHistoryChartingParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ChartHistoryResponse>(
    { url: `/marketdata/instruments/${instrument}/limited_history`, method: 'GET', params, signal },
    options
  );
};

export const getGetRecentHistoryChartingQueryKey = (instrument: string, params: GetRecentHistoryChartingParams) => {
  return [`/marketdata/instruments/${instrument}/limited_history`, ...(params ? [params] : [])] as const;
};

export const getGetRecentHistoryChartingQueryOptions = <
  TData = Awaited<ReturnType<typeof getRecentHistoryCharting>>,
  TError = ErrorType<unknown>
>(
  instrument: string,
  params: GetRecentHistoryChartingParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getRecentHistoryCharting>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetRecentHistoryChartingQueryKey(instrument, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getRecentHistoryCharting>>> = ({ signal }) =>
    getRecentHistoryCharting(instrument, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!instrument, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getRecentHistoryCharting>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetRecentHistoryChartingQueryResult = NonNullable<Awaited<ReturnType<typeof getRecentHistoryCharting>>>;
export type GetRecentHistoryChartingQueryError = ErrorType<unknown>;

/**
 * @summary Recent History
 */

export function useGetRecentHistoryCharting<
  TData = Awaited<ReturnType<typeof getRecentHistoryCharting>>,
  TError = ErrorType<unknown>
>(
  instrument: string,
  params: GetRecentHistoryChartingParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getRecentHistoryCharting>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetRecentHistoryChartingQueryOptions(instrument, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get recent history for a specified market(instrument).
 * @summary Recent History
 */
export const getRecentHistoryV1Charting = (
  instrument: string,
  params: GetRecentHistoryV1ChartingParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ChartHistoryResponse>(
    { url: `/marketdata/api/v1/instruments/${instrument}/limited_history`, method: 'GET', params, signal },
    options
  );
};

export const getGetRecentHistoryV1ChartingQueryKey = (instrument: string, params: GetRecentHistoryV1ChartingParams) => {
  return [`/marketdata/api/v1/instruments/${instrument}/limited_history`, ...(params ? [params] : [])] as const;
};

export const getGetRecentHistoryV1ChartingQueryOptions = <
  TData = Awaited<ReturnType<typeof getRecentHistoryV1Charting>>,
  TError = ErrorType<unknown>
>(
  instrument: string,
  params: GetRecentHistoryV1ChartingParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getRecentHistoryV1Charting>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetRecentHistoryV1ChartingQueryKey(instrument, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getRecentHistoryV1Charting>>> = ({ signal }) =>
    getRecentHistoryV1Charting(instrument, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!instrument, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getRecentHistoryV1Charting>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetRecentHistoryV1ChartingQueryResult = NonNullable<Awaited<ReturnType<typeof getRecentHistoryV1Charting>>>;
export type GetRecentHistoryV1ChartingQueryError = ErrorType<unknown>;

/**
 * @summary Recent History
 */

export function useGetRecentHistoryV1Charting<
  TData = Awaited<ReturnType<typeof getRecentHistoryV1Charting>>,
  TError = ErrorType<unknown>
>(
  instrument: string,
  params: GetRecentHistoryV1ChartingParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getRecentHistoryV1Charting>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetRecentHistoryV1ChartingQueryOptions(instrument, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get order book for a specified market(instrument)
 * @summary Get Order Book
 */
export const getBookInfoCharting = (
  instrument: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<OrderBookInfo>(
    { url: `/marketdata/instruments/${instrument}/depth`, method: 'GET', signal },
    options
  );
};

export const getGetBookInfoChartingQueryKey = (instrument: string) => {
  return [`/marketdata/instruments/${instrument}/depth`] as const;
};

export const getGetBookInfoChartingQueryOptions = <
  TData = Awaited<ReturnType<typeof getBookInfoCharting>>,
  TError = ErrorType<unknown>
>(
  instrument: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getBookInfoCharting>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetBookInfoChartingQueryKey(instrument);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getBookInfoCharting>>> = ({ signal }) =>
    getBookInfoCharting(instrument, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!instrument, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getBookInfoCharting>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetBookInfoChartingQueryResult = NonNullable<Awaited<ReturnType<typeof getBookInfoCharting>>>;
export type GetBookInfoChartingQueryError = ErrorType<unknown>;

/**
 * @summary Get Order Book
 */

export function useGetBookInfoCharting<
  TData = Awaited<ReturnType<typeof getBookInfoCharting>>,
  TError = ErrorType<unknown>
>(
  instrument: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getBookInfoCharting>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetBookInfoChartingQueryOptions(instrument, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get order book for a specified market(instrument)
 * @summary Get Order Book
 */
export const getBookInfoV1Charting = (
  instrument: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<OrderBookInfo>(
    { url: `/marketdata/api/v1/instruments/${instrument}/depth`, method: 'GET', signal },
    options
  );
};

export const getGetBookInfoV1ChartingQueryKey = (instrument: string) => {
  return [`/marketdata/api/v1/instruments/${instrument}/depth`] as const;
};

export const getGetBookInfoV1ChartingQueryOptions = <
  TData = Awaited<ReturnType<typeof getBookInfoV1Charting>>,
  TError = ErrorType<unknown>
>(
  instrument: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getBookInfoV1Charting>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetBookInfoV1ChartingQueryKey(instrument);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getBookInfoV1Charting>>> = ({ signal }) =>
    getBookInfoV1Charting(instrument, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!instrument, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getBookInfoV1Charting>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetBookInfoV1ChartingQueryResult = NonNullable<Awaited<ReturnType<typeof getBookInfoV1Charting>>>;
export type GetBookInfoV1ChartingQueryError = ErrorType<unknown>;

/**
 * @summary Get Order Book
 */

export function useGetBookInfoV1Charting<
  TData = Awaited<ReturnType<typeof getBookInfoV1Charting>>,
  TError = ErrorType<unknown>
>(
  instrument: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getBookInfoV1Charting>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetBookInfoV1ChartingQueryOptions(instrument, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Tickers
 */
export const tickersV1Markets = (
  params?: TickersV1MarketsParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<Market24HourData[]>(
    { url: `/marketdata/api/v1/tickers`, method: 'GET', params, signal },
    options
  );
};

export const getTickersV1MarketsQueryKey = (params?: TickersV1MarketsParams) => {
  return [`/marketdata/api/v1/tickers`, ...(params ? [params] : [])] as const;
};

export const getTickersV1MarketsQueryOptions = <
  TData = Awaited<ReturnType<typeof tickersV1Markets>>,
  TError = ErrorType<unknown>
>(
  params?: TickersV1MarketsParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof tickersV1Markets>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getTickersV1MarketsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof tickersV1Markets>>> = ({ signal }) =>
    tickersV1Markets(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof tickersV1Markets>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type TickersV1MarketsQueryResult = NonNullable<Awaited<ReturnType<typeof tickersV1Markets>>>;
export type TickersV1MarketsQueryError = ErrorType<unknown>;

/**
 * @summary Tickers
 */

export function useTickersV1Markets<TData = Awaited<ReturnType<typeof tickersV1Markets>>, TError = ErrorType<unknown>>(
  params?: TickersV1MarketsParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof tickersV1Markets>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getTickersV1MarketsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Order Book
 */
export const orderbookV1Markets = (
  symbol: string,
  params?: OrderbookV1MarketsParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<OrderBookResponse>(
    { url: `/marketdata/api/v1/orderbook/${symbol}`, method: 'GET', params, signal },
    options
  );
};

export const getOrderbookV1MarketsQueryKey = (symbol: string, params?: OrderbookV1MarketsParams) => {
  return [`/marketdata/api/v1/orderbook/${symbol}`, ...(params ? [params] : [])] as const;
};

export const getOrderbookV1MarketsQueryOptions = <
  TData = Awaited<ReturnType<typeof orderbookV1Markets>>,
  TError = ErrorType<unknown>
>(
  symbol: string,
  params?: OrderbookV1MarketsParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof orderbookV1Markets>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getOrderbookV1MarketsQueryKey(symbol, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof orderbookV1Markets>>> = ({ signal }) =>
    orderbookV1Markets(symbol, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!symbol, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof orderbookV1Markets>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type OrderbookV1MarketsQueryResult = NonNullable<Awaited<ReturnType<typeof orderbookV1Markets>>>;
export type OrderbookV1MarketsQueryError = ErrorType<unknown>;

/**
 * @summary Order Book
 */

export function useOrderbookV1Markets<
  TData = Awaited<ReturnType<typeof orderbookV1Markets>>,
  TError = ErrorType<unknown>
>(
  symbol: string,
  params?: OrderbookV1MarketsParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof orderbookV1Markets>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getOrderbookV1MarketsQueryOptions(symbol, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Trade History
 */
export const tradeHistoryV1Markets = (
  symbol: string,
  params?: TradeHistoryV1MarketsParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<TradeHistoryResponse>(
    { url: `/marketdata/api/v1/history/${symbol}`, method: 'GET', params, signal },
    options
  );
};

export const getTradeHistoryV1MarketsQueryKey = (symbol: string, params?: TradeHistoryV1MarketsParams) => {
  return [`/marketdata/api/v1/history/${symbol}`, ...(params ? [params] : [])] as const;
};

export const getTradeHistoryV1MarketsQueryOptions = <
  TData = Awaited<ReturnType<typeof tradeHistoryV1Markets>>,
  TError = ErrorType<unknown>
>(
  symbol: string,
  params?: TradeHistoryV1MarketsParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof tradeHistoryV1Markets>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getTradeHistoryV1MarketsQueryKey(symbol, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof tradeHistoryV1Markets>>> = ({ signal }) =>
    tradeHistoryV1Markets(symbol, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!symbol, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof tradeHistoryV1Markets>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type TradeHistoryV1MarketsQueryResult = NonNullable<Awaited<ReturnType<typeof tradeHistoryV1Markets>>>;
export type TradeHistoryV1MarketsQueryError = ErrorType<unknown>;

/**
 * @summary Trade History
 */

export function useTradeHistoryV1Markets<
  TData = Awaited<ReturnType<typeof tradeHistoryV1Markets>>,
  TError = ErrorType<unknown>
>(
  symbol: string,
  params?: TradeHistoryV1MarketsParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof tradeHistoryV1Markets>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getTradeHistoryV1MarketsQueryOptions(symbol, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Market Summary
 */
export const summaryV1Markets = (options?: SecondParameter<typeof customInstance>, signal?: AbortSignal) => {
  return customInstance<MarketSummaryData[]>({ url: `/marketdata/api/v1/summary`, method: 'GET', signal }, options);
};

export const getSummaryV1MarketsQueryKey = () => {
  return [`/marketdata/api/v1/summary`] as const;
};

export const getSummaryV1MarketsQueryOptions = <
  TData = Awaited<ReturnType<typeof summaryV1Markets>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof summaryV1Markets>>, TError, TData>;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSummaryV1MarketsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof summaryV1Markets>>> = ({ signal }) =>
    summaryV1Markets(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof summaryV1Markets>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SummaryV1MarketsQueryResult = NonNullable<Awaited<ReturnType<typeof summaryV1Markets>>>;
export type SummaryV1MarketsQueryError = ErrorType<unknown>;

/**
 * @summary Market Summary
 */

export function useSummaryV1Markets<
  TData = Awaited<ReturnType<typeof summaryV1Markets>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof summaryV1Markets>>, TError, TData>;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getSummaryV1MarketsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Assets Summary
 */
export const getAssetsV1Markets = (options?: SecondParameter<typeof customInstance>, signal?: AbortSignal) => {
  return customInstance<AssetsResponse[]>({ url: `/marketdata/api/v1/assets`, method: 'GET', signal }, options);
};

export const getGetAssetsV1MarketsQueryKey = () => {
  return [`/marketdata/api/v1/assets`] as const;
};

export const getGetAssetsV1MarketsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAssetsV1Markets>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getAssetsV1Markets>>, TError, TData>;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAssetsV1MarketsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAssetsV1Markets>>> = ({ signal }) =>
    getAssetsV1Markets(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAssetsV1Markets>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAssetsV1MarketsQueryResult = NonNullable<Awaited<ReturnType<typeof getAssetsV1Markets>>>;
export type GetAssetsV1MarketsQueryError = ErrorType<unknown>;

/**
 * @summary Assets Summary
 */

export function useGetAssetsV1Markets<
  TData = Awaited<ReturnType<typeof getAssetsV1Markets>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getAssetsV1Markets>>, TError, TData>;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetAssetsV1MarketsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get the last fair price for provided market.
 * @summary Get market last fair price
 */
export const getLastFairPriceV1Markets = (
  params: GetLastFairPriceV1MarketsParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<LastFairPriceResponse>(
    { url: `/marketdata/api/v1/last-fair-price`, method: 'GET', params, signal },
    options
  );
};

export const getGetLastFairPriceV1MarketsQueryKey = (params: GetLastFairPriceV1MarketsParams) => {
  return [`/marketdata/api/v1/last-fair-price`, ...(params ? [params] : [])] as const;
};

export const getGetLastFairPriceV1MarketsQueryOptions = <
  TData = Awaited<ReturnType<typeof getLastFairPriceV1Markets>>,
  TError = ErrorType<void>
>(
  params: GetLastFairPriceV1MarketsParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getLastFairPriceV1Markets>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetLastFairPriceV1MarketsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getLastFairPriceV1Markets>>> = ({ signal }) =>
    getLastFairPriceV1Markets(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getLastFairPriceV1Markets>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetLastFairPriceV1MarketsQueryResult = NonNullable<Awaited<ReturnType<typeof getLastFairPriceV1Markets>>>;
export type GetLastFairPriceV1MarketsQueryError = ErrorType<void>;

/**
 * @summary Get market last fair price
 */

export function useGetLastFairPriceV1Markets<
  TData = Awaited<ReturnType<typeof getLastFairPriceV1Markets>>,
  TError = ErrorType<void>
>(
  params: GetLastFairPriceV1MarketsParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getLastFairPriceV1Markets>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetLastFairPriceV1MarketsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get top markets data for the last 24-hrs
 * @summary Top Markets
 */
export const getTopMarketsData = (options?: SecondParameter<typeof customInstance>, signal?: AbortSignal) => {
  return customInstance<Asset24HourData[]>({ url: `/marketdata/top_markets`, method: 'GET', signal }, options);
};

export const getGetTopMarketsDataQueryKey = () => {
  return [`/marketdata/top_markets`] as const;
};

export const getGetTopMarketsDataQueryOptions = <
  TData = Awaited<ReturnType<typeof getTopMarketsData>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getTopMarketsData>>, TError, TData>;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTopMarketsDataQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTopMarketsData>>> = ({ signal }) =>
    getTopMarketsData(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTopMarketsData>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetTopMarketsDataQueryResult = NonNullable<Awaited<ReturnType<typeof getTopMarketsData>>>;
export type GetTopMarketsDataQueryError = ErrorType<unknown>;

/**
 * @summary Top Markets
 */

export function useGetTopMarketsData<
  TData = Awaited<ReturnType<typeof getTopMarketsData>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getTopMarketsData>>, TError, TData>;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetTopMarketsDataQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get top markets data for the last 24-hrs
 * @summary Top Markets
 */
export const getTopMarketsDataV1 = (options?: SecondParameter<typeof customInstance>, signal?: AbortSignal) => {
  return customInstance<Asset24HourData[]>({ url: `/marketdata/api/v1/top_markets`, method: 'GET', signal }, options);
};

export const getGetTopMarketsDataV1QueryKey = () => {
  return [`/marketdata/api/v1/top_markets`] as const;
};

export const getGetTopMarketsDataV1QueryOptions = <
  TData = Awaited<ReturnType<typeof getTopMarketsDataV1>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getTopMarketsDataV1>>, TError, TData>;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTopMarketsDataV1QueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTopMarketsDataV1>>> = ({ signal }) =>
    getTopMarketsDataV1(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTopMarketsDataV1>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetTopMarketsDataV1QueryResult = NonNullable<Awaited<ReturnType<typeof getTopMarketsDataV1>>>;
export type GetTopMarketsDataV1QueryError = ErrorType<unknown>;

/**
 * @summary Top Markets
 */

export function useGetTopMarketsDataV1<
  TData = Awaited<ReturnType<typeof getTopMarketsDataV1>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getTopMarketsDataV1>>, TError, TData>;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetTopMarketsDataV1QueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get all trends for a specified market(symbol) within the last 24-hrs
 * @summary Get All Trends
 */
export const getAllTrends = (
  symbol: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<GetAllTrends200One | GetAllTrends200Two | GetAllTrends200Three>(
    { url: `/marketdata/trends/all/${symbol}`, method: 'GET', signal },
    options
  );
};

export const getGetAllTrendsQueryKey = (symbol: string) => {
  return [`/marketdata/trends/all/${symbol}`] as const;
};

export const getGetAllTrendsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAllTrends>>,
  TError = ErrorType<unknown>
>(
  symbol: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getAllTrends>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAllTrendsQueryKey(symbol);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllTrends>>> = ({ signal }) =>
    getAllTrends(symbol, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!symbol, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAllTrends>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAllTrendsQueryResult = NonNullable<Awaited<ReturnType<typeof getAllTrends>>>;
export type GetAllTrendsQueryError = ErrorType<unknown>;

/**
 * @summary Get All Trends
 */

export function useGetAllTrends<TData = Awaited<ReturnType<typeof getAllTrends>>, TError = ErrorType<unknown>>(
  symbol: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getAllTrends>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetAllTrendsQueryOptions(symbol, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get all trends for a specified market(symbol) within the last 24-hrs
 * @summary Get All Trends
 */
export const getAllTrendsV1 = (
  symbol: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<GetAllTrendsV1200One | GetAllTrendsV1200Two | GetAllTrendsV1200Three>(
    { url: `/marketdata/api/v1/trends/all/${symbol}`, method: 'GET', signal },
    options
  );
};

export const getGetAllTrendsV1QueryKey = (symbol: string) => {
  return [`/marketdata/api/v1/trends/all/${symbol}`] as const;
};

export const getGetAllTrendsV1QueryOptions = <
  TData = Awaited<ReturnType<typeof getAllTrendsV1>>,
  TError = ErrorType<unknown>
>(
  symbol: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getAllTrendsV1>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAllTrendsV1QueryKey(symbol);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllTrendsV1>>> = ({ signal }) =>
    getAllTrendsV1(symbol, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!symbol, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAllTrendsV1>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAllTrendsV1QueryResult = NonNullable<Awaited<ReturnType<typeof getAllTrendsV1>>>;
export type GetAllTrendsV1QueryError = ErrorType<unknown>;

/**
 * @summary Get All Trends
 */

export function useGetAllTrendsV1<TData = Awaited<ReturnType<typeof getAllTrendsV1>>, TError = ErrorType<unknown>>(
  symbol: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getAllTrendsV1>>, TError, TData>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetAllTrendsV1QueryOptions(symbol, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}
